
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire724f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire724f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("3B1VX", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Text = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $6wI3m = parcelRequire("6wI3m");
var Text = /** @class */ function(_super) {
    __extends(Text, _super);
    function Text(ref, transform) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = this;
        if (typeof ref === "string") ref = new $6wI3m.Ref(ref);
        _this = _super.call(this, "span", ref) || this;
        _this.transform = transform;
        _this.defaultText = "";
        _this.Refresh();
        return _this;
    }
    Text.prototype.DefaultText = function(text) {
        this.defaultText = text;
        this.SetText();
        return this;
    };
    Text.prototype.SetText = function() {
        var _a, _b;
        var text = (_b = (_a = this.transform) === null || _a === void 0 ? void 0 : _a.call(this, this.ref.value)) !== null && _b !== void 0 ? _b : this.ref.value != null ? String(this.ref.value) : "";
        if (this.defaultText != "" && text === "") text = this.defaultText;
        this.Text(text);
    };
    Text.prototype.Refresh = function() {
        this.SetText();
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    Text.Name = "Text";
    return Text;
}($k6KGm.RefComponentBase);
exports.Text = Text;

});
parcelRegister("k6KGm", function(module, exports) {
"use strict";
var $ea389448cd545331$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefComponentBase = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $ea389448cd545331$var$RefComponentBase = /** @class */ function(_super) {
    $ea389448cd545331$var$__extends(RefComponentBase, _super);
    function RefComponentBase(baseElement, ref) {
        var _this = _super.call(this, baseElement) || this;
        _this.ref = ref;
        _this.showThatChanged = RefComponentBase.ShowThatChanged;
        _this.IsRefComponent = true;
        if (ref) ref.AddSubscriber(_this);
        return _this;
    }
    Object.defineProperty(RefComponentBase.prototype, "Value", {
        get: function() {
            if (!this.ref) return undefined;
            return this.ref.value;
        },
        set: function(value) {
            if (!this.ref) return;
            this.ref.value = value;
        },
        enumerable: false,
        configurable: true
    });
    RefComponentBase.prototype.SetValue = function(value) {
        if (!value) return this;
        if (!this.ref) return this;
        this.ref.value = value;
        return this;
    };
    Object.defineProperty(RefComponentBase.prototype, "Ref", {
        get: function() {
            return this.ref;
        },
        enumerable: false,
        configurable: true
    });
    RefComponentBase.prototype.ShowThatChanged = function(showOrNot) {
        if (showOrNot === void 0) showOrNot = true;
        this.showThatChanged = showOrNot;
        return this;
    };
    RefComponentBase.prototype.Dispose = function() {
        var _a;
        (_a = this.ref) === null || _a === void 0 || _a.RemoveControl(this);
    };
    RefComponentBase.ShowThatChanged = false;
    return RefComponentBase;
}($aKtiT.ComponentBase);
module.exports.RefComponentBase = $ea389448cd545331$var$RefComponentBase;

});
parcelRegister("aKtiT", function(module, exports) {
"use strict";
var $7d34ee63d945b320$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7d34ee63d945b320$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComponentBase = void 0;

var $6wI3m = parcelRequire("6wI3m");
parcelRequire("fg7nO");

var $8lUZH = parcelRequire("8lUZH");

var $5uACL = parcelRequire("5uACL");
var $7d34ee63d945b320$var$ComponentBase = /** @class */ function() {
    function ComponentBase(baseElement) {
        this.baseElement = baseElement;
        this.id = -1;
        this.Name = "";
        this.IsRefComponent = false; // TODO: xxx
        this.Children = new $8lUZH.ChildrenCollection(this);
        this.displayAs = "";
        this.toggableStyles = {};
        this.isVisible = true;
        ComponentBase.Id += 1;
        this.id = ComponentBase.Id;
        this.element = ComponentBase.Create(baseElement);
        this.events = new $5uACL.EventsContainer(this.element);
        if (this.element instanceof HTMLElement) {
            var style = window === null || window === void 0 ? void 0 : window.getComputedStyle(this.element);
            this.displayAs = (style === null || style === void 0 ? void 0 : style.display) || "";
        }
    }
    ComponentBase.prototype.toString = function() {
        var _a;
        return "".concat(this.ID, ": parent=").concat((_a = this.Parent) === null || _a === void 0 ? void 0 : _a.ID, ", children=").concat(this.Children.toString());
    };
    Object.defineProperty(ComponentBase.prototype, "ID", {
        get: function() {
            return "[#".concat(this.id, ":").concat(this.baseElement).concat(this.Name ? ":" + this.Name : "").concat(this.IsRefComponent ? "(REF)" : "", "]");
        },
        enumerable: false,
        configurable: true
    });
    ComponentBase.prototype.LOG = function(str) {
        if (ComponentBase.LogEn) console.log(str);
    };
    ComponentBase.prototype.NameIt = function(name) {
        this.Name = name;
        return this;
    };
    //#endregion
    //#region CORE
    ComponentBase.prototype.React = function(valueOrRef, callback) {
        if (valueOrRef == undefined) return;
        if (!callback) throw new Error("Callback must be provided");
        else if (valueOrRef instanceof $6wI3m.Ref) valueOrRef.OnChange(function(v) {
            callback(v);
        }, true);
        else callback(valueOrRef);
    };
    ComponentBase.prototype.Reacts = function(valueOrRef, callback) {
        if (valueOrRef == undefined) return;
        if (!callback) throw new Error("Callback must be provided");
        if (valueOrRef instanceof Array) {
            var values_1 = [];
            valueOrRef.forEach(function(r, i) {
                values_1.push(r.value);
                r.OnChange(function(v) {
                    values_1[i] = v;
                    callback.apply(void 0, values_1);
                });
            });
            callback.apply(void 0, values_1);
        } else if (valueOrRef instanceof $6wI3m.Ref) valueOrRef.OnChange(function(v) {
            callback(v);
        }, true);
        else callback(valueOrRef);
    };
    ComponentBase.prototype.Clear = function() {
        var _this = this;
        this.Children.Clone.forEach(function(c) {
            _this.Remove(c);
        });
        return this;
    };
    ComponentBase.prototype.Dispose = function() {
    // this.LOG(`💥 Disposing ${this.ID}...`);
    };
    ComponentBase.prototype.Remove = function(component) {
        var _a;
        if (!component) throw new Error("Parameter is mandatory");
        // this.LOG(`➖ Removing ${component.ID} from ${this.ID} (children: ${this.Children.map(x=>"#"+x.Id)})...`);
        this.LOG("\u2796 ".concat(this.ID, " -= ").concat(component.ID));
        if (!this.Children.Has(component)) throw new Error("This is not your (".concat(this.ID, ") kid (").concat(component.ID, ")"));
        (_a = component.OnRemove) === null || _a === void 0 || _a.call(component); // czemu to jest jeszcze przed usunięciem a nie po?
        component.Children.Clone.forEach(function(c) {
            component.Remove(c);
        });
        if (this.Children.Remove(component)) {
            component.Dispose();
            this.element.Remove(component.element);
        }
        return this;
    };
    ComponentBase.prototype.AddComponent = function(component) {
        if (!component) throw new Error("[TRUFFLE] Parameter/component to add is mandatory (Forget return 'this' from your component method?)");
        if (component == this) throw new Error("[TRUFFLE] You can't be child of yourself");
        if (this.Children.Has(component)) throw new Error("[TRUFFLE] ".concat(component.ID, " was already added to ").concat(this.ID));
        component.Parent = this;
        // this.LOG(`➕ ${this.ID} += ${component.ID}`);
        this.Children.Add(component);
    };
    ComponentBase.prototype.Prepend = function() {
        var _this = this;
        var components = [];
        for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
        components.forEach(function(component) {
            var _a;
            if (component == undefined || component == null) ;
            else if (typeof component == "boolean") ;
            else if (typeof component == "number") {
                var num = component;
                var span = new ComponentBase("span");
                span.Text(num.toString());
                _this.AddComponent(span);
                _this.element.Append(span.Element);
            } else if (typeof component == "string") {
                var str = component;
                var splitted_1 = str.split("\n");
                if (splitted_1.length > 1) splitted_1.forEach(function(s, i) {
                    // We can't use Span (<span>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                    var span = new ComponentBase("span");
                    span.Text(s);
                    _this.AddComponent(span);
                    _this.element.Prepend(span.Element);
                    // Put NewLine (<br>) between strings except last one
                    if (i != splitted_1.length - 1) {
                        // We can't use NewLine (<br>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                        var br = new ComponentBase("br");
                        _this.AddComponent(br);
                        _this.element.Prepend(br.Element);
                    }
                });
                else {
                    // We can't use Span (<span>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                    var span = new ComponentBase("span");
                    span.Text(str);
                    _this.AddComponent(span);
                    _this.element.Prepend(span.Element);
                }
            } else {
                _this.AddComponent(component); // AddChild?
                _this.element.Prepend(component.Element);
                (_a = component.OnAppend) === null || _a === void 0 || _a.call(component);
            }
        });
        return this;
    };
    // public Append(...components: (string | boolean | number | undefined | null | ComponentBase<HTMLElement>)[]): this
    ComponentBase.prototype.Append = function() {
        var _this = this;
        var components = [];
        for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
        components.forEach(function(component) {
            var _a;
            if (component == undefined || component == null) ;
            else if (typeof component == "boolean") ;
            else if (typeof component == "number") {
                var num = component;
                var span = new ComponentBase("span");
                span.Text(num.toString());
                _this.AddComponent(span);
                _this.element.Append(span.Element);
            } else if (typeof component == "string") {
                var str = component;
                var splitted_2 = str.split("\n");
                if (splitted_2.length > 1) splitted_2.forEach(function(s, i) {
                    // We can't use Span (<span>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                    var span = new ComponentBase("span");
                    span.Text(s);
                    _this.AddComponent(span);
                    _this.element.Append(span.Element);
                    // Put NewLine between strings except last one
                    if (i != splitted_2.length - 1) {
                        // We can't use NewLine (<br>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                        var br = new ComponentBase("br");
                        _this.AddComponent(br);
                        _this.element.Append(br.Element);
                    }
                });
                else {
                    // We can't use Span (<span>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                    var span = new ComponentBase("span");
                    span.Text(str);
                    _this.AddComponent(span);
                    _this.element.Append(span.Element);
                }
            } else {
                _this.AddComponent(component);
                _this.element.Append(component.Element);
                if (_this.element instanceof HTMLElement) {
                    var style = window === null || window === void 0 ? void 0 : window.getComputedStyle(_this.element);
                    _this.displayAs = (style === null || style === void 0 ? void 0 : style.display) || "";
                }
                (_a = component.OnAppend) === null || _a === void 0 || _a.call(component);
            }
        });
        return this;
    };
    ComponentBase.prototype.LoadContent = function() {
        var _a;
        var content = [];
        for(var _i = 0; _i < arguments.length; _i++)content[_i] = arguments[_i];
        return (_a = this.Clear()).Append.apply(_a, content);
    };
    ComponentBase.prototype.RemoveSelf = function() {
        var _a, _b, _c;
        if ((_b = (_a = this.Parent) === null || _a === void 0 ? void 0 : _a.Children) === null || _b === void 0 ? void 0 : _b.Has(this)) (_c = this.Parent) === null || _c === void 0 || _c.Remove(this);
        return this;
    };
    ComponentBase.prototype.SearchUp = function(predicate) {
        var p = this.Parent;
        if (p == undefined) return undefined;
        while(!predicate(p)){
            p = p === null || p === void 0 ? void 0 : p.Parent;
            if (p == undefined) return undefined;
        }
        return p;
    };
    ComponentBase.prototype.SearchDown = function(predicate) {
        return this.Children.Search(predicate);
    };
    Object.defineProperty(ComponentBase.prototype, "HasAnyChildren", {
        get: function() {
            return this.Children.Count > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComponentBase.prototype, "Element", {
        get: function() {
            return this.element;
        },
        enumerable: false,
        configurable: true
    });
    ComponentBase.Create = function(htmlElement) {
        return document.createElement(htmlElement);
    };
    ComponentBase.prototype.DisplayAs = function(as) {
        this.displayAs = as;
        return this;
    };
    //#endregion CORE
    //#region STYLING-ATTRIBUTES
    ComponentBase.prototype.Attribute = function(key, value) {
        var _this = this;
        if (!key) return this;
        if (!value) {
            this.element.setAttribute(key, "");
            return this;
        }
        this.React(value, function(v) {
            return _this.element.setAttribute(key, v || "");
        });
        return this;
    };
    ComponentBase.prototype.GetAttribute = function(key) {
        return this.element.getAttribute(key);
    };
    ComponentBase.prototype.RemoveAttribute = function(key) {
        this.element.removeAttribute(key);
        return this;
    };
    ComponentBase.prototype.TestAttr = function(id) {
        return this.Attribute("data-test", id);
    };
    ComponentBase.prototype.SetStyle = function(property, value, postfix) {
        var _this = this;
        if (postfix === void 0) postfix = "";
        this.React(value, function(v) {
            return _this.SetSingleStyle(property, v.toString() + postfix);
        });
        return this;
    };
    //#endregion
    //#region STYLING-CLASS
    ComponentBase.prototype.Class = function(cssClassesToAdd) {
        var _this = this;
        this.React(cssClassesToAdd, function(v) {
            return v.split(" ").filter(function(x) {
                return x.length > 0;
            }).forEach(function(c) {
                return _this.element.classList.add(c);
            });
        });
        return this;
    };
    ComponentBase.prototype.RemoveAllClasses = function() {
        while(this.element.classList.length > 0)this.element.classList.remove(this.element.classList.item(0) || "");
        return this;
    };
    ComponentBase.prototype.RemoveClass = function(cssClassName) {
        if (cssClassName) this.element.classList.remove(cssClassName);
        return this;
    };
    // TODO: remove
    ComponentBase.prototype.AddClass = function(cssClassName) {
        if (cssClassName) this.element.classList.add(cssClassName);
        return this;
    };
    ComponentBase.prototype.ToggleClasses = function(classA, classB) {
        if (this.element.classList.contains(classA)) {
            this.element.classList.remove(classA);
            this.element.classList.add(classB);
        } else {
            this.element.classList.remove(classB);
            this.element.classList.add(classA);
        }
        return this;
    };
    //#endregion
    //#region STYLING-UTILS
    ComponentBase.prototype.Style = function(propertyOrCss, val) {
        var _this = this;
        if (!propertyOrCss) return this;
        else if (propertyOrCss instanceof $6wI3m.Ref) propertyOrCss.OnChange(function(v) {
            v.split(";").map(function(x) {
                return x.trim();
            }).forEach(function(x) {
                return _this.SetSingleStyle(x);
            });
        }, true);
        else if (propertyOrCss.includes(";")) propertyOrCss.split(";").map(function(x) {
            return x.trim();
        }).forEach(function(x) {
            return _this.SetSingleStyle(x);
        });
        else this.SetSingleStyle(propertyOrCss, val);
        return this;
    };
    ComponentBase.prototype.SetSingleStyle = function(propertyOrCss, val) {
        if (val !== undefined) this.element.style[propertyOrCss] = val;
        else {
            var _a = propertyOrCss.split(":").map(function(x) {
                return x.trim();
            }), key = _a[0], value = _a[1];
            this.element.style[key] = value;
        }
        return this;
    };
    ComponentBase.prototype.ApplyStyle = function(val, is, property, value, elseValue, callRightaway) {
        var _this = this;
        if (callRightaway === void 0) callRightaway = true;
        val.OnChange(function(v) {
            v == is ? _this.Style(property, value) : _this.Style(property, elseValue);
        }, callRightaway);
        return this;
    };
    ComponentBase.prototype.ApplyClass = function(val, predicate, className, callRightaway) {
        var _this = this;
        if (callRightaway === void 0) callRightaway = true;
        val.OnChange(function(v) {
            predicate(v, val, _this) ? _this.AddClass(className) : _this.RemoveClass(className);
        }, callRightaway);
        return this;
    };
    ComponentBase.prototype.When = function(ref, predicate, whenTrue, whenFalse, callRightaway) {
        var _this = this;
        if (callRightaway === void 0) callRightaway = true;
        ref.OnChange(function(v) {
            predicate(v, ref, _this) ? whenTrue(_this, ref) : whenFalse === null || whenFalse === void 0 || whenFalse(_this, ref);
        }, callRightaway);
        return this;
    };
    ComponentBase.prototype.ToggleStyle = function(prop, val, elseVal) {
        /* COMPUTED VALUE IS COMPLETELY DIFFERENT FROM SET. THAT'S WHY. */ if (this.toggableStyles[prop] !== val) this.toggableStyles[prop] = val;
        else this.toggableStyles[prop] = elseVal;
        this.element.style[prop] = this.toggableStyles[prop];
        return this;
    };
    //#endregion
    //#region STYLING-MISC
    ComponentBase.prototype.Cursor = function(cursor) {
        this.element.style.cursor = cursor;
        return this;
    };
    ComponentBase.prototype.CursorPointer = function() {
        return this.Cursor("pointer");
    };
    ComponentBase.prototype.CursorDefault = function() {
        return this.Cursor("default");
    };
    ComponentBase.prototype.Focus = function() {
        this.element.Focus();
        return this;
    };
    ComponentBase.prototype.ScrollToBottom = function() {
        this.element.scrollTop = this.element.scrollHeight;
        return this;
    };
    //#endregion
    //#region STYLING-VISUAL
    ComponentBase.prototype.ZIndex = function(index) {
        return this.SetStyle("zIndex", index);
    };
    ComponentBase.prototype.Opacity = function(opacity) {
        return this.SetStyle("opacity", opacity);
    };
    ComponentBase.prototype.Blur = function(value, unit) {
        var _this = this;
        if (unit === void 0) unit = "px";
        this.React(value, function(v) {
            return _this.SetSingleStyle("filter: blur(".concat(value).concat(unit, ")"));
        });
        return this;
    };
    //#endregion
    //#region STYLING-TEXT
    ComponentBase.prototype.Bold = function(enable) {
        var _this = this;
        if (enable === void 0) enable = true;
        this.React(enable, function(v) {
            return v ? _this.SetSingleStyle("font-weight", "bold") : _this.SetSingleStyle("font-weight", "normal");
        });
        return this;
    };
    ComponentBase.prototype.FontBold = function(enable) {
        if (enable === void 0) enable = true;
        return this.Bold(enable);
    };
    ComponentBase.prototype.Normal = function(enable) {
        if (enable === void 0) enable = true;
        return this.Style("font-weight: normal; font-style: normal");
    };
    ComponentBase.prototype.FontNormal = function() {
        return this.Style("font-weight: normal; font-style: normal");
    };
    ComponentBase.prototype.FontWeight = function(value) {
        return this.SetStyle("font-weight", value);
    };
    ComponentBase.prototype.FontWeightNormal = function() {
        return this.Style("font-weight", "normal");
    };
    ComponentBase.prototype.FontWeightBold = function() {
        return this.Style("font-weight", "bold");
    };
    ComponentBase.prototype.Italic = function(enable) {
        var _this = this;
        if (enable === void 0) enable = true;
        this.React(enable, function(v) {
            return v ? _this.SetSingleStyle("font-style", "italic") : _this.SetSingleStyle("font-style", "normal");
        });
        return this;
    };
    ComponentBase.prototype.FontItalic = function(enable) {
        if (enable === void 0) enable = true;
        return this.Italic(enable);
    };
    ComponentBase.prototype.FontSize = function(size, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("font-size", size, unit);
    };
    ComponentBase.prototype.TextAlign = function(align) {
        return this.SetStyle("text-align", align);
    };
    ComponentBase.prototype.TextAlignLeft = function() {
        this.element.style.textAlign = "left";
        return this;
    };
    ComponentBase.prototype.TextAlignRight = function() {
        this.element.style.textAlign = "right";
        return this;
    };
    ComponentBase.prototype.TextAlignCenter = function() {
        this.element.style.textAlign = "center";
        return this;
    };
    //#endregion STYLING-TEXT
    //#region STYLING-POSITION
    ComponentBase.prototype.Position = function(position) {
        this.element.style.position = position;
        return this;
    };
    ComponentBase.prototype.PositionAbsolute = function() {
        this.element.style.position = "absolute";
        return this;
    };
    ComponentBase.prototype.PositionRelative = function() {
        this.element.style.position = "relative";
        return this;
    };
    ComponentBase.prototype.PositionFixed = function() {
        this.element.style.position = "fixed";
        return this;
    };
    ComponentBase.prototype.Left = function(left, unit) {
        var _this = this;
        if (left === void 0) left = 0;
        if (unit === void 0) unit = "px";
        this.React(left, function(v) {
            return _this.element.style.left = v + unit;
        });
        return this;
    };
    ComponentBase.prototype.LeftPercent = function(left) {
        var _this = this;
        if (left === void 0) left = 0;
        this.React(left, function(v) {
            return _this.Left(v, "%");
        });
        return this;
    };
    ComponentBase.prototype.Right = function(right, unit) {
        var _this = this;
        if (right === void 0) right = 0;
        if (unit === void 0) unit = "px";
        this.React(right, function(v) {
            return _this.element.style.right = v + unit;
        });
        return this;
    };
    ComponentBase.prototype.RightPercent = function(right) {
        var _this = this;
        if (right === void 0) right = 0;
        this.React(right, function(v) {
            return _this.Right(v, "%");
        });
        return this;
    };
    ComponentBase.prototype.Top = function(top, unit) {
        var _this = this;
        if (top === void 0) top = 0;
        if (unit === void 0) unit = "px";
        this.React(top, function(v) {
            return _this.element.style.top = v + unit;
        });
        return this;
    };
    ComponentBase.prototype.TopPercent = function(top) {
        var _this = this;
        if (top === void 0) top = 0;
        this.React(top, function(v) {
            return _this.Top(v, "%");
        });
        return this;
    };
    ComponentBase.prototype.Bottom = function(bottom, unit) {
        var _this = this;
        if (bottom === void 0) bottom = 0;
        if (unit === void 0) unit = "px";
        this.React(bottom, function(v) {
            return _this.element.style.bottom = v + unit;
        });
        return this;
    };
    ComponentBase.prototype.BottomPercent = function(bottom) {
        var _this = this;
        if (bottom === void 0) bottom = 0;
        this.React(bottom, function(v) {
            return _this.Bottom(v, "%");
        });
        return this;
    };
    ComponentBase.prototype.FloatLeft = function() {
        this.element.style.float = "left";
        return this;
    };
    ComponentBase.prototype.FloatRight = function() {
        this.element.style.float = "right";
        return this;
    };
    ComponentBase.prototype.ClearBoth = function() {
        this.element.style.clear = "both";
        return this;
    };
    ComponentBase.prototype.ClearLeft = function() {
        this.element.style.clear = "left";
        return this;
    };
    ComponentBase.prototype.ClearRight = function() {
        this.element.style.clear = "right";
        return this;
    };
    //#endregion STYLING-POSITION
    //#region STYLING-DISPLAY
    ComponentBase.prototype.Display = function(as) {
        return this.SetSingleStyle("display: " + as);
    };
    ComponentBase.prototype.Inline = function() {
        return this.SetSingleStyle("display: inline");
    };
    ComponentBase.prototype.DisplayInline = function() {
        return this.SetSingleStyle("display: inline");
    };
    ComponentBase.prototype.Block = function() {
        return this.SetSingleStyle("display: block");
    };
    ComponentBase.prototype.DisplayBlock = function() {
        return this.SetSingleStyle("display: block");
    };
    ComponentBase.prototype.InlineBlock = function() {
        return this.SetSingleStyle("display: inline-block");
    };
    ComponentBase.prototype.DisplayInlineBlock = function() {
        return this.SetSingleStyle("display: inline-block");
    };
    //#endregion STYLING-DISPLAY
    //#region STYLING-BORDER
    ComponentBase.prototype.Border = function(width, color, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (radius === void 0) radius = 0;
        this.Style("border: ".concat(width, "px solid ").concat(color, "; border-radius: ").concat(radius, "px"));
        return this;
    };
    ComponentBase.prototype.BorderNone = function() {
        this.Style("border: none");
        return this;
    };
    ComponentBase.prototype.BorderStyling = function(edge, width, color, radius, style) {
        if (radius === void 0) radius = 0;
        if (style === void 0) style = "solid";
        this.Style("border-".concat(edge, ": ").concat(width, "px ").concat(style, " ").concat(color, "; border-").concat(edge, "-radius: ").concat(radius, "px"));
        return this;
    };
    ComponentBase.prototype.BorderBottom = function(width, color, style, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (style === void 0) style = "solid";
        if (radius === void 0) radius = 0;
        return this.BorderStyling("bottom", width, color, radius, style);
    };
    ComponentBase.prototype.BorderTop = function(width, color, style, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (style === void 0) style = "solid";
        if (radius === void 0) radius = 0;
        return this.BorderStyling("top", width, color, radius, style);
    };
    ComponentBase.prototype.BorderLeft = function(width, color, style, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (style === void 0) style = "solid";
        if (radius === void 0) radius = 0;
        return this.BorderStyling("left", width, color, radius, style);
    };
    ComponentBase.prototype.BorderRight = function(width, color, style, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (style === void 0) style = "solid";
        if (radius === void 0) radius = 0;
        return this.BorderStyling("right", width, color, radius, style);
    };
    ComponentBase.prototype.BorderWidth = function(width, unit) {
        var _this = this;
        if (unit === void 0) unit = "px";
        this.React(width, function(v) {
            return _this.Style("border-width: ".concat(v).concat(unit));
        });
        return this;
    };
    ComponentBase.prototype.BorderColor = function(color) {
        var _this = this;
        this.React(color, function(v) {
            return _this.Style("border-color: ".concat(v));
        });
        return this;
    };
    ComponentBase.prototype.BorderStyle = function(style) {
        var _this = this;
        this.React(style, function(v) {
            return _this.Style("border-style: ".concat(v));
        });
        return this;
    };
    ComponentBase.prototype.BorderStyleSolid = function() {
        return this.BorderStyle("solid");
    };
    ComponentBase.prototype.BorderStyleDotted = function() {
        return this.BorderStyle("dotted");
    };
    ComponentBase.prototype.BorderStyleDashed = function() {
        return this.BorderStyle("dashed");
    };
    ComponentBase.prototype.BorderRadius = function(radius, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("borderRadius", radius, unit);
    };
    //#endregion STYLING-BORDER
    //#region STYLING-SIZE
    ComponentBase.prototype.Width = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("width", val, unit);
    };
    ComponentBase.prototype.WidthPercent = function(val) {
        return this.SetStyle("width", val, "%");
    };
    ComponentBase.prototype.WidthAuto = function() {
        this.element.style.width = "auto";
        return this;
    };
    ComponentBase.prototype.HalfWidth = function() {
        this.element.style.width = "50%";
        return this;
    };
    ComponentBase.prototype.FullWidth = function() {
        this.element.style.width = "100%";
        return this;
    };
    ComponentBase.prototype.Height = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("height", val, unit);
    };
    ComponentBase.prototype.HeightPercent = function(val) {
        return this.SetStyle("height", val, "%");
    };
    ComponentBase.prototype.HeightAuto = function() {
        this.element.style.height = "auto";
        return this;
    };
    ComponentBase.prototype.MaxWidth = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.maxWidth = val + unit;
        return this;
    };
    ComponentBase.prototype.MinWidth = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.minWidth = val + unit;
        return this;
    };
    ComponentBase.prototype.MaxHeight = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.maxHeight = val + unit;
        return this;
    };
    ComponentBase.prototype.MinHeight = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.minHeight = val + unit;
        return this;
    };
    //#endregion STYLING-SIZE
    //#region STYLING-MARGIN
    ComponentBase.prototype.Margin = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("margin", val, unit);
    };
    ComponentBase.prototype.MarginAuto = function() {
        this.element.style.margin = "auto";
        return this;
    };
    ComponentBase.prototype.MarginTop = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("marginTop", val, unit);
    };
    ComponentBase.prototype.MarginBottom = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("marginBottom", val, unit);
    };
    ComponentBase.prototype.MarginTopBottom = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.marginTop = val + unit;
        this.element.style.marginBottom = val + unit;
        return this;
    };
    ComponentBase.prototype.MarginLeft = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("marginLeft", val, unit);
    };
    ComponentBase.prototype.MarginRight = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("marginRight", val, unit);
    };
    ComponentBase.prototype.MarginLeftRight = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.marginLeft = val + unit;
        this.element.style.marginRight = val + unit;
        return this;
    };
    //#endregion STYLING-MARGIN
    //#region STYLING-COLORS
    ComponentBase.prototype.Color = function(color) {
        return this.SetStyle("color", color);
    };
    ComponentBase.prototype.Background = function(color) {
        return this.SetStyle("background", color);
    };
    //#endregion STYLING-COLORS
    //#region STYLING-PADDING
    ComponentBase.prototype.Padding = function(val, secondVal) {
        if (!secondVal) this.SetStyle("padding", val, "px");
        else this.element.style.padding = "".concat(val, "px ").concat(secondVal, "px");
        return this;
    };
    ComponentBase.prototype.PaddingLeft = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("paddingLeft", val, unit);
    };
    ComponentBase.prototype.PaddingRight = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("paddingRight", val, unit);
    };
    ComponentBase.prototype.PaddingTop = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("paddingTop", val, unit);
    };
    ComponentBase.prototype.PaddingBottom = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("paddingBottom", val, unit);
    };
    //#endregion STYLING-PADDING
    //#region STYLING-OVERFLOW
    ComponentBase.prototype.OverflowX = function(val) {
        this.element.style.overflowX = val;
        return this;
    };
    ComponentBase.prototype.OverflowY = function(val) {
        this.element.style.overflowY = val;
        return this;
    };
    ComponentBase.prototype.OverflowYScroll = function() {
        return this.OverflowY("scroll");
    };
    //#endregion STYLING-OVERFLOW
    //#region PROPS
    ComponentBase.prototype.Id = function(id) {
        return this.Attribute("id", id);
    };
    ComponentBase.prototype.Text = function(text) {
        var _this = this;
        this.React(text, function(v) {
            return _this.element.innerText = v;
        });
        return this;
    };
    ComponentBase.prototype.GetText = function() {
        return this.element.innerText;
    };
    ComponentBase.prototype.Html = function(html) {
        var _this = this;
        this.React(html, function(v) {
            return _this.element.innerHTML = v;
        });
        return this;
    };
    ComponentBase.prototype.GetHtml = function() {
        return this.element.innerHTML;
    };
    ComponentBase.prototype.Enable = function(isEnabled) {
        var _this = this;
        this.React(isEnabled, function(v) {
            return v ? _this.RemoveAttribute("disabled") : _this.Attribute("disabled");
        });
        return this;
    };
    ComponentBase.prototype.EnableWhen = function(toWatch, predicate) {
        var _this = this;
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return _this.Enable(predicate.apply(void 0, vals));
        });
        return this;
    };
    ComponentBase.prototype.DisableWhen = function(toWatch, predicate) {
        var _this = this;
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return _this.Disable(predicate.apply(void 0, vals));
        });
        return this;
    };
    ComponentBase.prototype.Disable = function(isDisabled) {
        var _this = this;
        this.React(isDisabled, function(v) {
            return v ? _this.Attribute("disabled") : _this.RemoveAttribute("disabled");
        });
        return this;
    };
    ComponentBase.prototype.Enabled = function() {
        return this.Enable(true);
    };
    ComponentBase.prototype.Disabled = function() {
        return this.Enable(false);
    };
    Object.defineProperty(ComponentBase.prototype, "Events", {
        get: function() {
            return this.events;
        },
        enumerable: false,
        configurable: true
    });
    ComponentBase.prototype.On = function(event, handler) {
        this.events.Add(event, handler);
        return this;
    };
    ComponentBase.prototype.Off = function(event) {
        this.events.Off(event);
        return this;
    };
    ComponentBase.prototype.CallEvent = function(event) {
        this.events.Call(event);
        return this;
    };
    ComponentBase.prototype.OnClick = function(handler, preventDefault, stopPropagation) {
        var _this = this;
        if (preventDefault === void 0) preventDefault = true;
        if (stopPropagation === void 0) stopPropagation = true;
        this.On("click", function(e) {
            if (e) {
                if (preventDefault) e.preventDefault();
                if (stopPropagation) e.stopPropagation();
            }
            handler(_this, e);
        });
        return this;
    };
    ComponentBase.prototype.OffClick = function() {
        this.Off("click");
        return this;
    };
    ComponentBase.prototype.Click = function() {
        this.events.Call("click");
        return this;
    };
    ComponentBase.prototype.ClickAsync = function() {
        return $7d34ee63d945b320$var$__awaiter(this, void 0, void 0, function() {
            return $7d34ee63d945b320$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.events.CallAsync("click")
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ComponentBase.prototype.OnHover = function(handler) {
        var _this = this;
        return this.On("mouseover", function() {
            return handler(_this);
        });
    };
    ComponentBase.prototype.OnMouseOut = function(handler) {
        var _this = this;
        return this.On("mouseout", function() {
            return handler(_this);
        });
    };
    ComponentBase.prototype.OnRightClick = function(handler) {
        var _this = this;
        this.On("contextmenu", function(e) {
            e.preventDefault();
            handler(_this);
        });
        return this;
    };
    ComponentBase.prototype.OnFocus = function(handler) {
        var _this = this;
        return this.On("focus", function() {
            return handler(_this);
        });
    };
    ComponentBase.prototype.OnBlur = function(handler) {
        var _this = this;
        return this.On("blur", function() {
            return handler(_this);
        });
    };
    ComponentBase.prototype.OnEnterKeyPressed = function(handler) {
        var _this = this;
        return this.On("keyup", function(ke) {
            if (ke.key === "Enter") handler(_this, ke);
        });
    };
    ComponentBase.prototype.OnKeyUp = function(handler) {
        var _this = this;
        return this.On("keyup", function(ke) {
            return handler(_this, ke);
        });
    };
    ComponentBase.prototype.OnKeyDown = function(handler) {
        var _this = this;
        return this.On("keydown", function(ke) {
            return handler(_this, ke);
        });
    };
    ComponentBase.prototype.OnKeyPress = function(handler) {
        var _this = this;
        return this.On("keypress", function(ke) {
            return handler(_this, ke);
        });
    };
    //#endregion EVENTS
    //#region VISIBILITY
    ComponentBase.prototype.Exist = function(component) {
        return this.element.Exist(component.Element);
    };
    ComponentBase.prototype.Visible = function(toWatch, showAs) {
        var _this = this;
        if (showAs === void 0) showAs = "inline-block";
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return vals.every(function(v) {
                return v == true;
            }) ? _this.Show(showAs) : _this.Hide();
        });
        return this;
    };
    ComponentBase.prototype.Invisible = function(toWatch, showAs) {
        var _this = this;
        if (showAs === void 0) showAs = "inline-block";
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return vals.every(function(v) {
                return v == true;
            }) ? _this.Hide() : _this.Show(showAs);
        });
        return this;
    };
    ComponentBase.prototype.VisibleWhen = function(toWatch, predicate, showAs) {
        var _this = this;
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        if (showAs === void 0) showAs = "inline-block";
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return predicate.apply(void 0, vals) ? _this.Show(showAs) : _this.Hide();
        });
        return this;
    };
    ComponentBase.prototype.InvisibleWhen = function(toWatch, predicate, showAs) {
        var _this = this;
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        if (showAs === void 0) showAs = "inline-block";
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return predicate.apply(void 0, vals) ? _this.Hide() : _this.Show(showAs);
        });
        return this;
    };
    ComponentBase.prototype.Hide = function() {
        var _a;
        if (this.element instanceof HTMLElement) {
            var style = window === null || window === void 0 ? void 0 : window.getComputedStyle(this.element);
            if ((style === null || style === void 0 ? void 0 : style.display) && (style === null || style === void 0 ? void 0 : style.display) != "none") this.displayAs = (style === null || style === void 0 ? void 0 : style.display) || "";
        }
        (_a = this.OnHide) === null || _a === void 0 || _a.call(this);
        this.element.Hide();
        this.isVisible = false;
        return this;
    };
    ComponentBase.prototype.IsVisible = function() {
        return this.isVisible;
    // return this.element.IsVisible();
    };
    // private showAs;
    ComponentBase.prototype.Show = function(as) {
        var _a;
        if (as === void 0) as = this.displayAs || "block";
        // this.showAs = as;
        // console.log(as, ' on show');
        this.isVisible = true;
        // this.element.Show(as);
        this.element.Show(as);
        (_a = this.OnShow) === null || _a === void 0 || _a.call(this);
        return this;
    };
    ComponentBase.prototype.Toggle = function(as) {
        // if (as)
        //     this.showAs = as;
        // this.isVisible = !this.isVisible;
        this.isVisible ? this.Hide() : this.Show();
        // this.isVisible ? this.Hide() : this.Show(this.showAs)
        // this.element.Toggle();
        return this;
    };
    //#region LOGS
    ComponentBase.LogEn = false;
    ComponentBase.Id = 0;
    return ComponentBase;
}();
module.exports.ComponentBase = $7d34ee63d945b320$var$ComponentBase;

});
parcelRegister("6wI3m", function(module, exports) {
"use strict";
var $4c07e745af36d0f8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Ref = void 0;
parcelRequire("fg7nO");

var $22Wrn = parcelRequire("22Wrn");
var $4c07e745af36d0f8$var$Ref = /** @class */ function(_super) {
    $4c07e745af36d0f8$var$__extends(Ref, _super);
    function Ref(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        _this.initialValue = _value;
        return _this;
    }
    Ref.prototype.Storable = function(key, storage) {
        if (storage === void 0) storage = "local";
        if (!key) return this;
        var stor;
        switch(storage){
            case "local":
                stor = window.localStorage;
                break;
            case "session":
                stor = window.sessionStorage;
                break;
        }
        this.OnChange(function(v) {
            return stor.setItem(key, v.toString());
        });
        var valueInStorage = stor.getItem(key);
        if (!valueInStorage) return this;
        if (this._value instanceof Date) this.Set(new Date(valueInStorage || this._value || 0));
        else if (typeof this._value == "string") this.Set(valueInStorage || this._value || "");
        else if (typeof this._value == "number") this.Set(+(valueInStorage || 0) || +this._value || 0);
        else if (typeof this._value == "boolean") switch(valueInStorage){
            case "true":
                this.Set(true);
                break;
            default:
            case null:
            case "":
            case "false":
                this.Set(false);
                break;
        }
        return this;
    };
    Ref.prototype.Compare = function(ref, valueOrRef, op) {
        if (valueOrRef instanceof Ref) return op(ref.value, valueOrRef.value);
        return op(ref.value, valueOrRef);
    };
    Ref.prototype.Is = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a == b;
        });
    };
    Ref.prototype.IsNot = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a != b;
        });
    };
    Object.defineProperty(Ref.prototype, "IsSet", {
        get: function() {
            if (this._value instanceof Date) return +this._value !== +this.ZeroValue;
            return this._value !== this.ZeroValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ref.prototype, "IsNotSet", {
        get: function() {
            return !this.IsSet;
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.IsInitial = function() {
        return this.value == this.initialValue;
    };
    Ref.prototype.IsNotInitial = function() {
        return this.value != this.initialValue;
    };
    Object.defineProperty(Ref.prototype, "HasChanged", {
        get: function() {
            return this._value !== this.initialValue;
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.IsEqual = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a === b;
        });
    };
    Ref.prototype.IsIn = function(values) {
        return values.includes(this.value);
    };
    Ref.prototype.IsNotEqual = function(value) {
        return this.value !== value;
    };
    Ref.prototype.Set = function(val, excludeControlForRefresh) {
        if (this.value === val) return false;
        this._value = val;
        this.RefreshSubscribers(excludeControlForRefresh);
        this.onChangeHandler.Call(this._value);
        return true;
    };
    Ref.prototype.SetValue = function(val) {
        if (val === undefined) return this;
        if (this.value === val) return this;
        this._value = val;
        this.RefreshSubscribers();
        // NOTICE: no onChangeHandler call
        return this;
    };
    Ref.prototype.SetTo = function(valueOrRef) {
        if (valueOrRef instanceof Ref) this.value = valueOrRef.value;
        else this.value = valueOrRef;
        return this;
    };
    Ref.prototype.ForceOnChange = function() {
        this.RefreshSubscribers();
        this.onChangeHandler.Call(this._value);
        return this;
    };
    Object.defineProperty(Ref.prototype, "value", {
        get: function() {
            return this._value;
        },
        set: function(val) {
            this.Set(val);
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.Restore = function() {
        this.value = this.initialValue;
        return this;
    };
    Ref.prototype.OverrideInitialValue = function(val) {
        this.initialValue = val;
        return this;
    };
    Ref.prototype.Initialize = function(val) {
        this.initialValue = val;
        this._value = val;
        return this;
    };
    Object.defineProperty(Ref.prototype, "ZeroValue", {
        get: function() {
            if (this._value instanceof Date) return new Date(0);
            else if (typeof this._value == "string") return "";
            else if (typeof this._value == "number") return 0; // TODO: 0? not infinity or something?
            else if (typeof this._value == "boolean") return false;
            throw new Error("No zero value for given type");
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.Clear = function() {
        if (typeof this._value == "string") this.Set("");
        else if (typeof this._value == "number") this.Set(0);
        else if (typeof this._value == "boolean") this.Set(false);
        else if (this._value instanceof Date) this.Set(new Date(0));
        return this;
    };
    Ref.prototype.ToString = function() {
        var _a, _b;
        // console.log('ttt');
        // return `${this._value?.toString()} [${this.watchers?.map(w=>w.Id)?.join(", ")}]`;
        // if (typeof this._value === "string")
        //     return `Ref<${typeof this._value}>#${this.Id}${this.Name ? ":" + this.Name : ""} = "${this._value}" [${this.watchers?.map(w => w.Id)?.join(", ")}]`;
        // else
        // if (typeof this._value === "Date")
        // return `Ref<${typeof this._value}> = "${this._value?.toString()}" [${this.watchers?.map(w => w.Id)?.join(", ")}]`;
        // else
        // if (typeof this._value === "boolean")
        //     return `Ref<${typeof this._value}> = ${this._value?.toString() ? "true" : "false"} [${this.watchers?.map(w => w.Id)?.join(", ")}]`;
        // else
        return "Ref<".concat(typeof this._value, ">#").concat(this.Id).concat(this.Name ? ":" + this.Name : "", " = ").concat(this._value != null ? String(this._value) : "null", " [watchers: ").concat(((_b = (_a = this.Watchers) === null || _a === void 0 ? void 0 : _a.map(function(w) {
            return w.Id;
        })) === null || _b === void 0 ? void 0 : _b.join(", ")) || "none", "][").concat(this.onChangeHandler.Count, " subs]");
    };
    Ref.prototype.Combine = function(anotherRef, operation) {
        var _this = this;
        var result = new Ref(operation(this.value, anotherRef.value));
        this.OnChange(function(v) {
            return result.value = operation(_this.value, anotherRef.value);
        });
        anotherRef.OnChange(function(v) {
            return result.value = operation(_this.value, anotherRef.value);
        });
        return result;
    };
    Ref.prototype.CombineValue = function(anotherValue, operation) {
        var result = new Ref(operation(this.value, anotherValue));
        this.OnChange(function(v) {
            return result.value = operation(v, anotherValue);
        }, true);
        return result;
    };
    Ref.prototype.Mix = function(x, operation) {
        if (x instanceof Ref) return this.Combine(x, operation);
        else return this.CombineValue(x, operation);
    };
    return Ref;
}($22Wrn.RefBase);
module.exports.Ref = $4c07e745af36d0f8$var$Ref;

});
parcelRegister("fg7nO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Array.prototype.ToString = function() {
    var _a;
    return (_a = this.join(", ")) !== null && _a !== void 0 ? _a : "(empty)";
};
Array.prototype.Remove = function(item) {
    var index = this.indexOf(item);
    if (index >= 0) {
        this.splice(index, 1);
        return true;
    }
    return false;
};

});

parcelRegister("22Wrn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefBase = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $8PO3e = parcelRequire("8PO3e");
var $17d919bca1bb95f0$var$RefBase = /** @class */ function() {
    function RefBase() {
        this.Id = -1;
        this.Name = "";
        this.onChangeHandler = new $8PO3e.HandlersCollection();
        this.watchers = new Set();
        $6wI3m.Ref.Id += 1;
        this.Id = $6wI3m.Ref.Id;
    }
    Object.defineProperty(RefBase.prototype, "OnChangeHandler", {
        get: function() {
            return this.onChangeHandler;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RefBase.prototype, "Watchers", {
        get: function() {
            return Array.from(this.watchers);
        },
        enumerable: false,
        configurable: true
    });
    RefBase.prototype.NameIt = function(name) {
        this.Name = name;
        return this;
    };
    RefBase.prototype.AddSubscriber = function(control) {
        this.watchers.add(control);
    };
    RefBase.prototype.RemoveControl = function(control) {
        this.watchers.delete(control);
    };
    RefBase.prototype.RefreshSubscribers = function(except) {
        for(var _i = 0, _a = this.Watchers; _i < _a.length; _i++){
            var watcher = _a[_i];
            if (watcher !== except) watcher.Refresh();
        }
    };
    RefBase.prototype.ClearHandlers = function() {
        this.onChangeHandler.Reset();
        return this;
    };
    RefBase.prototype.OnChange = function(handler, callThisCallbackRightAway) {
        if (callThisCallbackRightAway === void 0) callThisCallbackRightAway = false;
        this.onChangeHandler.Add(handler);
        if (callThisCallbackRightAway == true) handler(this._value, true);
        return this;
    };
    RefBase.Id = 0;
    return RefBase;
}();
module.exports.RefBase = $17d919bca1bb95f0$var$RefBase;

});
parcelRegister("8PO3e", function(module, exports) {
"use strict";
var $66e9e94085efdd7b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $66e9e94085efdd7b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HandlersCollection = void 0;
function $66e9e94085efdd7b$var$UniqueId() {
    return "id-" + Math.floor(Math.random() * 1e16).toString(36);
}
var $66e9e94085efdd7b$var$HandlersCollection = /** @class */ function() {
    function HandlersCollection() {
        this.handlers = new Map();
        this.serializedHandlers = [];
        this.inOnHold = false;
    }
    HandlersCollection.prototype.Add = function(handler, handlerId) {
        if (handlerId === void 0) handlerId = $66e9e94085efdd7b$var$UniqueId();
        if (this.handlers.has(handlerId)) {
            console.warn("Handler with this id (".concat(handlerId, ") was already added"));
            return this;
        }
        if (handler) this.handlers.set(handlerId, handler);
        if (HandlersCollection.MANY_HANDLERS_WARNING && this.Count > HandlersCollection.MANY_HANDLERS_LIMIT) {
            console.warn("Many handlers is not recommended, they might be set by mistake. Warning limit is ".concat(HandlersCollection.MANY_HANDLERS_LIMIT, ". You can change it or turn this message off by setting MANY_HANDLERS_WARNING to false. Remember to clear handlers when not needed anymore."));
            if (HandlersCollection.THROW_ON_MANY_HANDLERS_WARNING) throw new Error("Too many handlers! @ Add(handler, id=".concat(handlerId, ")"));
        }
        return this;
    };
    HandlersCollection.prototype.Subscribe = function(handler, handlerId) {
        if (handlerId === void 0) handlerId = $66e9e94085efdd7b$var$UniqueId();
        this.Add(handler, handlerId);
        return handlerId;
    };
    HandlersCollection.prototype.Unsubscribe = function(handlerId) {
        this.handlers.delete(handlerId);
        return this;
    };
    HandlersCollection.prototype.AddUnique = function(handler) {
        var serializedHandler = handler.toString();
        if (this.serializedHandlers.includes(serializedHandler)) return this;
        this.serializedHandlers.push(serializedHandler);
        this.Add(handler);
        return this;
    };
    HandlersCollection.prototype.Reset = function() {
        this.handlers.clear();
        return this;
    };
    Object.defineProperty(HandlersCollection.prototype, "AreAny", {
        get: function() {
            return this.handlers.size > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HandlersCollection.prototype, "Count", {
        get: function() {
            return this.handlers.size;
        },
        enumerable: false,
        configurable: true
    });
    HandlersCollection.prototype.Hold = function() {
        this.inOnHold = true;
        return this;
    };
    HandlersCollection.prototype.Release = function() {
        this.inOnHold = false;
        return this;
    };
    Object.defineProperty(HandlersCollection.prototype, "IsOnHold", {
        get: function() {
            return this.inOnHold;
        },
        enumerable: false,
        configurable: true
    });
    HandlersCollection.prototype.Call = function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        if (this.inOnHold) return this;
        this.handlers.forEach(function(h) {
            return h.apply(void 0, params);
        });
        return this;
    };
    HandlersCollection.prototype.CallAsync = function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        return $66e9e94085efdd7b$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b, handlerId, handler;
            return $66e9e94085efdd7b$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (this.inOnHold) return [
                            2 /*return*/ 
                        ];
                        _a = 0, _b = Array.from(this.handlers.keys());
                        _c.label = 1;
                    case 1:
                        if (!(_a < _b.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        handlerId = _b[_a];
                        handler = this.handlers.get(handlerId);
                        if (!handler) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            handler.apply(void 0, params)
                        ];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _a++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    HandlersCollection.prototype.CallAndGatherReturnValue = function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        if (this.inOnHold) return [];
        var returnValues = [];
        this.handlers.forEach(function(h) {
            var result = h.apply(void 0, params);
            returnValues.push(result);
        });
        return returnValues;
    };
    HandlersCollection.MANY_HANDLERS_WARNING = true;
    HandlersCollection.THROW_ON_MANY_HANDLERS_WARNING = false;
    HandlersCollection.MANY_HANDLERS_LIMIT = 10;
    return HandlersCollection;
}();
module.exports.HandlersCollection = $66e9e94085efdd7b$var$HandlersCollection;

});



parcelRegister("8lUZH", function(module, exports) {
"use strict";
var $614c7eb942e95d4e$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChildrenCollection = void 0;
var $614c7eb942e95d4e$var$ChildrenCollection = /** @class */ function() {
    function ChildrenCollection(Parent) {
        this.Parent = Parent;
        this.components = [];
        this.found = undefined;
        this.allFound = [];
    }
    ChildrenCollection.prototype.GetByTestAttr = function(id) {
        return this.All.find(function(x) {
            return x.GetAttribute("data-test") == id;
        });
    };
    ChildrenCollection.prototype.SearchByTestAttr = function(id) {
        var _this = this;
        this.found = undefined;
        this.components.forEach(function(c) {
            return _this.FindInComponentByTestAttr(c, id);
        });
        return this.found;
    };
    ChildrenCollection.prototype.SearchByPredicate = function(c, predicate) {
        var _this = this;
        if (predicate(c)) {
            this.found = c;
            return this.found;
        } else c.Children.All.forEach(function(c) {
            if (predicate(c)) {
                _this.found = c;
                return _this.found;
            } else _this.SearchByPredicate(c, predicate);
        });
    };
    ChildrenCollection.prototype.Search = function(predicate) {
        var _this = this;
        this.found = undefined;
        if (predicate(this.Parent)) return this.Parent;
        this.components.forEach(function(c) {
            return _this.SearchByPredicate(c, predicate);
        });
        return this.found;
    };
    ChildrenCollection.prototype.SearchByText = function(text, exact) {
        if (exact === void 0) exact = false;
        if (exact) return this.Search(function(x) {
            return x.GetText() == text;
        });
        else return this.Search(function(x) {
            var _a, _b;
            return (_b = (_a = x.GetText()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(text.toLowerCase());
        });
    };
    Object.defineProperty(ChildrenCollection.prototype, "All", {
        get: function() {
            return this.components;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChildrenCollection.prototype, "Count", {
        get: function() {
            return this.components.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChildrenCollection.prototype, "Clone", {
        get: function() {
            return $614c7eb942e95d4e$var$__spreadArray([], this.components, true);
        },
        enumerable: false,
        configurable: true
    });
    ChildrenCollection.prototype.Add = function(component) {
        this.components.push(component);
    };
    ChildrenCollection.prototype.Has = function(component) {
        return this.components.includes(component);
    };
    ChildrenCollection.prototype.Remove = function(component) {
        return this.components.Remove(component);
    };
    ChildrenCollection.prototype.FindInObj = function(component, type) {
        var _this = this;
        if (component instanceof type) {
            this.found = component;
            return this.found;
        } else component.Children.All.forEach(function(c) {
            if (c instanceof type) {
                _this.found = c;
                return _this.found;
            } else _this.FindInObj(c, type);
        });
    };
    ChildrenCollection.prototype.FindInComponentByTestAttr = function(component, id) {
        var _this = this;
        if (component.GetAttribute("data-test") == id) {
            this.found = component;
            return this.found;
        } else component.Children.All.forEach(function(c) {
            if (c.GetAttribute("data-test") == id) {
                _this.found = c;
                return _this.found;
            } else _this.FindInComponentByTestAttr(c, id);
        });
    };
    ChildrenCollection.prototype.FindFirstOfType = function(type) {
        var _this = this;
        this.found = undefined;
        this.components.forEach(function(c) {
            return _this.FindInObj(c, type);
        });
        return this.found;
    };
    ChildrenCollection.prototype.FindAllInObj = function(component, type) {
        var _this = this;
        if (component instanceof type) this.allFound.push(component);
        else component.Children.All.forEach(function(c) {
            if (c instanceof type) _this.allFound.push(c);
            else _this.FindAllInObj(c, type);
        });
    };
    ChildrenCollection.prototype.FindAllOfType = function(type) {
        var _this = this;
        this.allFound = [];
        this.components.forEach(function(c) {
            return _this.FindAllInObj(c, type);
        });
        return this.allFound;
    };
    ChildrenCollection.prototype.toString = function() {
        return this.components.map(function(x) {
            return "".concat(x.ID);
        });
    };
    return ChildrenCollection;
}();
module.exports.ChildrenCollection = $614c7eb942e95d4e$var$ChildrenCollection;

});

parcelRegister("5uACL", function(module, exports) {
"use strict";
var $3ffc29ebf0907b8e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3ffc29ebf0907b8e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventsContainer = void 0;

var $8PO3e = parcelRequire("8PO3e");
var $3ffc29ebf0907b8e$var$EventsContainer = /** @class */ function() {
    function EventsContainer(element) {
        this.element = element;
        this.events = {}; // string because TS does not allow GlobalEventHandlersEventMap as type
        this.listeners = {};
    }
    EventsContainer.prototype.Add = function(event, handler) {
        var _this = this;
        if (!handler) return;
        if (Array.isArray(event)) event.forEach(function(ev) {
            return _this.AddOne(ev, handler);
        });
        else this.AddOne(event, handler);
    };
    EventsContainer.prototype.AddOne = function(event, handler) {
        var _this = this;
        if (!this.events[event]) this.events[event] = new $8PO3e.HandlersCollection();
        this.events[event].Add(handler);
        if (this.listeners[event]) return;
        this.listeners[event] = function(e) {
            _this.Call(event, e);
        };
        this.element.addEventListener(event, function(e) {
            return _this.listeners[event](e);
        });
    };
    EventsContainer.prototype.Call = function(event) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        (_a = this.events[event]) === null || _a === void 0 || _a.Call.apply(_a, args);
    };
    EventsContainer.prototype.CallAsync = function(event) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        return $3ffc29ebf0907b8e$var$__awaiter(this, void 0, void 0, function() {
            var _a;
            return $3ffc29ebf0907b8e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (_a = this.events[event]) === null || _a === void 0 ? void 0 : _a.CallAsync.apply(_a, args)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    EventsContainer.prototype.Off = function(event) {
        var _a;
        if (!this.events.Keys().includes(event)) return;
        (_a = this.events[event]) === null || _a === void 0 || _a.Reset();
        this.element.addEventListener(event, this.listeners[event]);
    };
    Object.defineProperty(EventsContainer.prototype, "Info", {
        get: function() {
            var _this = this;
            var t = "";
            this.listeners.Keys().forEach(function(k) {
                t += "- " + k + ": " + _this.events[k].Count + " handlers\n";
            });
            return t;
        },
        enumerable: false,
        configurable: true
    });
    return EventsContainer;
}();
module.exports.EventsContainer = $3ffc29ebf0907b8e$var$EventsContainer;

});




parcelRegister("bOiUu", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Radio = exports.RadioConfig = exports.RadioOption = exports.RadioInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $joGvE = parcelRequire("joGvE");

var $k6KGm = parcelRequire("k6KGm");

var $fAOYH = parcelRequire("fAOYH");
var RadioInput = /** @class */ function(_super) {
    __extends(RadioInput, _super);
    function RadioInput(ref, value, uniqueId) {
        var _this = _super.call(this, "input", ref) || this;
        _this.value = value;
        _this.Attribute("type", "radio");
        _this.Attribute("name", uniqueId);
        _this.Attribute("value", value != null ? String(value) : "");
        _this.Refresh();
        return _this;
    }
    RadioInput.prototype.Refresh = function() {
        this.element.checked = this.ref.value == this.value;
    };
    return RadioInput;
}($k6KGm.RefComponentBase);
exports.RadioInput = RadioInput;
var RadioOption = /** @class */ function(_super) {
    __extends(RadioOption, _super);
    function RadioOption(ref, value, label, uniqueId, config) {
        var _a;
        var _this = _super.call(this, "radio-item") || this;
        _this.ref = ref;
        _this.value = value;
        _this.label = label;
        _this.uniqueId = uniqueId;
        _this.config = config;
        _this.isEnabled = true;
        _this.RadioInput = new RadioInput(_this.ref, _this.value, _this.uniqueId).Style(_this.config.RadioStyle);
        _this.Label = new $fAOYH.Label().Style(_this.config.LabelStyleWhenEnabled);
        var bondId = "input-label-bond-id-" + Math.random().toString().substring(2);
        _this.RadioInput.Id(bondId);
        _this.Label.Id(bondId);
        _this.Append(_this.RadioInput, _this.Label);
        if (Array.isArray(_this.label)) (_a = _this.Label).Append.apply(_a, _this.label);
        else _this.Label.Append(_this.label);
        _this.RadioInput.On("input", function(e) {
            if (_this.isEnabled) _this.ref.value = value;
        });
        _this.Label.OnClick(function() {
            if (_this.isEnabled) _this.ref.value = value;
        });
        return _this;
    }
    RadioOption.prototype.Enable = function(isEnabled) {
        var _this = this;
        this.React(isEnabled, function(v) {
            return v ? _this.Enabled() : _this.Disabled();
        });
        return this;
    };
    RadioOption.prototype.Disable = function(isDisabled) {
        var _this = this;
        this.React(isDisabled, function(v) {
            return v ? _this.Disabled() : _this.Enabled();
        });
        return this;
    };
    RadioOption.prototype.EnableWhen = function(watch, predicate) {
        var _this = this;
        if (predicate === void 0) predicate = function(value) {
            return !!value;
        };
        this.React(watch, function(v) {
            return _this.Enable(predicate(v));
        });
        return this;
    };
    RadioOption.prototype.DisableWhen = function(watch, predicate) {
        var _this = this;
        if (predicate === void 0) predicate = function(value) {
            return !!value;
        };
        this.React(watch, function(v) {
            return _this.Disable(predicate(v));
        });
        return this;
    };
    RadioOption.prototype.Disabled = function() {
        this.isEnabled = false;
        this.RadioInput.Disabled();
        this.Label.CursorDefault().Style(this.config.LabelStyleWhenDisabled);
        return this;
    };
    RadioOption.prototype.Enabled = function() {
        this.isEnabled = true;
        this.RadioInput.Enabled();
        this.Label.CursorPointer().Style(this.config.LabelStyleWhenEnabled);
        return this;
    };
    return RadioOption;
}($joGvE.Div);
exports.RadioOption = RadioOption;
var RadioConfig = /** @class */ function() {
    function RadioConfig() {
        this.RadioStyle = "";
        this.LabelStyleWhenEnabled = "color: #222";
        this.LabelStyleWhenDisabled = "color: #ccc";
    }
    return RadioConfig;
}();
exports.RadioConfig = RadioConfig;
var Radio = /** @class */ function(_super) {
    __extends(Radio, _super);
    function Radio(ref, config) {
        if (ref === void 0) ref = new $6wI3m.Ref(0);
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.Config = new RadioConfig();
        _this.uniqueName = "radio-id-" + Math.random().toString().substring(2);
        if (config) {
            var keys = Object.keys(config);
            keys.forEach(function(k) {
                _this.Add(config[k], k);
            });
        }
        return _this;
    }
    Radio.prototype.Add = function(value, label, thisOption) {
        var item = new RadioOption(this.ref, value, label, this.uniqueName, this.Config);
        thisOption === null || thisOption === void 0 || thisOption(item);
        this.Append(item);
        return this;
    };
    // public Add(value: primitive, content: appendable | appendable[], thisOption?: (input: RadioInput, label: Label) => void): this
    // {
    //     const uniqueId = "input-label-bond-id-" + Math.random().toString().substring(2);
    //     const input = new RadioInput(this.ref, value, this.uniqueName).Id(uniqueId)
    //     const label = new Label(content, uniqueId)
    //     input.On('input',e =>
    //     {
    //     //     // console.log("input")
    //     //     // e.element.preventDefault();
    //     //     // console.log("input clicked", this.ref.value, value)
    //     //     // e.element.checked = true;
    //         this.ref.value = value;
    //     })
    //     label.OnClick(e =>
    //     {
    //         // console.log("label clicked", this.ref.value, value)
    //         // input.element.checked = true;
    //         this.ref.value = value;
    //     })
    //     thisOption?.(input, label);
    //     this.Append(
    //         new Div().Class("radio-item").Append(
    //             input,
    //             label
    //         )
    //     )
    //     return this;
    // }
    Radio.prototype.Configure = function(callback) {
        callback(this.Config);
        return this;
    };
    Radio.Name = "Radio";
    return Radio;
}($joGvE.Div);
exports.Radio = Radio;

});
parcelRegister("joGvE", function(module, exports) {
"use strict";
var $e1f13bb48051effb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Div = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $e1f13bb48051effb$var$Div = /** @class */ function(_super) {
    $e1f13bb48051effb$var$__extends(Div, _super);
    function Div(classes) {
        var _this = _super.call(this, "div") || this;
        if (classes) _this.Class(classes);
        return _this;
    }
    Div.Name = "Div";
    return Div;
}($aKtiT.ComponentBase);
module.exports.Div = $e1f13bb48051effb$var$Div;

});

parcelRegister("fAOYH", function(module, exports) {
"use strict";
var $b5a1c2f6e538199d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Label = void 0;

var $2s69t = parcelRequire("2s69t");
var $b5a1c2f6e538199d$var$Label = /** @class */ function(_super) {
    $b5a1c2f6e538199d$var$__extends(Label, _super);
    function Label(content, forId) {
        var _this = _super.call(this, "label") || this;
        if (forId) _this.Attribute("for", forId);
        if (Array.isArray(content)) _this.Append.apply(_this, content);
        else _this.Append(content);
        return _this;
    }
    Label.Name = "Label";
    return Label;
}($2s69t.ComponentBase);
module.exports.Label = $b5a1c2f6e538199d$var$Label;

});
parcelRegister("2s69t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionPrinter = module.exports.CollectionViewer = module.exports.ListItem = module.exports.OrderedList = module.exports.UnorderedList = module.exports.Paragraph = module.exports.Line = module.exports.NewLine = module.exports.ClickableImage = module.exports.Canvas = module.exports.ImageSource = module.exports.ImageInfo = module.exports.Image = module.exports.Link = module.exports.Button = module.exports.TwoFloatingColumns = module.exports.TwinColumns = module.exports.AutoWidthTwoColumns = module.exports.Pre = module.exports.Span = module.exports.Label = module.exports.Div = module.exports.Root = module.exports.RefWatcher = module.exports.ValidationResult = module.exports.Validator = module.exports.PatternExtractor = module.exports.RegexExtractor = module.exports.HandlersCollection = module.exports.Filters = module.exports.CollectionTemplate = module.exports.ArrayTemplate = module.exports.RefSerializer = module.exports.RefReflector = module.exports.Sorter = module.exports.Dumper = module.exports.ComponentBase = module.exports.RefComponentBase = module.exports.CollectionView = module.exports.Collection = module.exports.HashRef = module.exports.RefObject = module.exports.RefNumber = module.exports.RefString = module.exports.RefBool = module.exports.RefDate = module.exports.RV = module.exports.RefBase = module.exports.Ref = module.exports.$ = void 0;
module.exports.TableHeaderCell = module.exports.TableHeaderV2 = module.exports.TableHeader = module.exports.TableCell = module.exports.TableBody = module.exports.Table = module.exports.TableBuilder = module.exports.ProgressBar = module.exports.BlinkMode = module.exports.Led = module.exports.VerticalButtonTabs = module.exports.ButtonTabs = module.exports.HidingContentSwitcher = module.exports.DestroyingPatternContentSwitcher = module.exports.DestroyingContentSwitcher = module.exports.RadioSwitchesBuilder = module.exports.ModalWindow = module.exports.SearchableItem = module.exports.ClearableTextInput = module.exports.TextCombo = module.exports.PopupMenu = module.exports.Menu = module.exports.MultipleFilesInput = module.exports.FileInput = module.exports.LabeledSelect = module.exports.LabeledNumberInput = module.exports.LabeledTextInput = module.exports.MultilineInput = module.exports.EditableTextarea = module.exports.EditableDateLabel = module.exports.DateTimeInput = module.exports.TimeInput = module.exports.DateInput = module.exports.RateStar = module.exports.RateConfig = module.exports.Rate = module.exports.Radio = module.exports.Checkbox = module.exports.SelectOption = module.exports.Select = module.exports.Range = module.exports.NumericRange = module.exports.NumberInput = module.exports.PasswordInput = module.exports.TextInput = module.exports.EditableLabel = module.exports.Text = module.exports.TabsSwitcher = module.exports.Tabs = module.exports.CopyIcon = void 0;
module.exports.Switch = module.exports.UploadResult = module.exports.OnlineStorage = module.exports.Pie = module.exports.Spinner = module.exports.CollectionPaginatorOptions = module.exports.CollectionPaginator = module.exports.PaginatorBrainOptions = module.exports.PaginatorBrain = module.exports.SimplePaginator = module.exports.BasicPaginator = module.exports.Snack = module.exports.RefJsonViewer = module.exports.JsonViewer = module.exports.JsonViewerConfig = module.exports.TableColumn = module.exports.TableRow = module.exports.TableHeaderRow = void 0;

var $iqyiC = parcelRequire("iqyiC");
Object.defineProperty(module.exports, "$", {
    enumerable: true,
    get: function() {
        return $iqyiC.$;
    }
});

var $6wI3m = parcelRequire("6wI3m");
Object.defineProperty(module.exports, "Ref", {
    enumerable: true,
    get: function() {
        return $6wI3m.Ref;
    }
});

var $22Wrn = parcelRequire("22Wrn");
Object.defineProperty(module.exports, "RefBase", {
    enumerable: true,
    get: function() {
        return $22Wrn.RefBase;
    }
});

var $afOau = parcelRequire("afOau");
Object.defineProperty(module.exports, "RV", {
    enumerable: true,
    get: function() {
        return $afOau.RV;
    }
});

var $2Vdhf = parcelRequire("2Vdhf");
Object.defineProperty(module.exports, "RefDate", {
    enumerable: true,
    get: function() {
        return $2Vdhf.RefDate;
    }
});

var $dzlP0 = parcelRequire("dzlP0");
Object.defineProperty(module.exports, "RefBool", {
    enumerable: true,
    get: function() {
        return $dzlP0.RefBool;
    }
});

var $brAEr = parcelRequire("brAEr");
Object.defineProperty(module.exports, "RefString", {
    enumerable: true,
    get: function() {
        return $brAEr.RefString;
    }
});

var $epBKP = parcelRequire("epBKP");
Object.defineProperty(module.exports, "RefNumber", {
    enumerable: true,
    get: function() {
        return $epBKP.RefNumber;
    }
});

var $9JbVp = parcelRequire("9JbVp");
Object.defineProperty(module.exports, "RefObject", {
    enumerable: true,
    get: function() {
        return $9JbVp.RefObject;
    }
});

var $8OWnY = parcelRequire("8OWnY");
Object.defineProperty(module.exports, "HashRef", {
    enumerable: true,
    get: function() {
        return $8OWnY.HashRef;
    }
});

var $6IcxB = parcelRequire("6IcxB");
Object.defineProperty(module.exports, "Collection", {
    enumerable: true,
    get: function() {
        return $6IcxB.Collection;
    }
});

var $8y6Fd = parcelRequire("8y6Fd");
Object.defineProperty(module.exports, "CollectionView", {
    enumerable: true,
    get: function() {
        return $8y6Fd.CollectionView;
    }
});

var $k6KGm = parcelRequire("k6KGm");
Object.defineProperty(module.exports, "RefComponentBase", {
    enumerable: true,
    get: function() {
        return $k6KGm.RefComponentBase;
    }
});

var $aKtiT = parcelRequire("aKtiT");
Object.defineProperty(module.exports, "ComponentBase", {
    enumerable: true,
    get: function() {
        return $aKtiT.ComponentBase;
    }
});

var $hiDht = parcelRequire("hiDht");
Object.defineProperty(module.exports, "Dumper", {
    enumerable: true,
    get: function() {
        return $hiDht.Dumper;
    }
});

var $4Og3n = parcelRequire("4Og3n");
Object.defineProperty(module.exports, "Sorter", {
    enumerable: true,
    get: function() {
        return $4Og3n.Sorter;
    }
});

var $6krno = parcelRequire("6krno");
Object.defineProperty(module.exports, "RefReflector", {
    enumerable: true,
    get: function() {
        return $6krno.RefReflector;
    }
});

var $9Fnts = parcelRequire("9Fnts");
Object.defineProperty(module.exports, "RefSerializer", {
    enumerable: true,
    get: function() {
        return $9Fnts.RefSerializer;
    }
});

var $9ngW8 = parcelRequire("9ngW8");
Object.defineProperty(module.exports, "ArrayTemplate", {
    enumerable: true,
    get: function() {
        return $9ngW8.ArrayTemplate;
    }
});

var $k4rJZ = parcelRequire("k4rJZ");
Object.defineProperty(module.exports, "CollectionTemplate", {
    enumerable: true,
    get: function() {
        return $k4rJZ.CollectionTemplate;
    }
});

var $3Z5yA = parcelRequire("3Z5yA");
Object.defineProperty(module.exports, "Filters", {
    enumerable: true,
    get: function() {
        return $3Z5yA.Filters;
    }
});

var $8PO3e = parcelRequire("8PO3e");
Object.defineProperty(module.exports, "HandlersCollection", {
    enumerable: true,
    get: function() {
        return $8PO3e.HandlersCollection;
    }
});

var $2UVc2 = parcelRequire("2UVc2");
Object.defineProperty(module.exports, "RegexExtractor", {
    enumerable: true,
    get: function() {
        return $2UVc2.RegexExtractor;
    }
});

var $3CTSE = parcelRequire("3CTSE");
Object.defineProperty(module.exports, "PatternExtractor", {
    enumerable: true,
    get: function() {
        return $3CTSE.PatternExtractor;
    }
});

var $8B6cm = parcelRequire("8B6cm");
Object.defineProperty(module.exports, "Validator", {
    enumerable: true,
    get: function() {
        return $8B6cm.Validator;
    }
});
Object.defineProperty(module.exports, "ValidationResult", {
    enumerable: true,
    get: function() {
        return $8B6cm.ValidationResult;
    }
});

var $iwAjC = parcelRequire("iwAjC");
Object.defineProperty(module.exports, "RefWatcher", {
    enumerable: true,
    get: function() {
        return $iwAjC.RefWatcher;
    }
});

var $7mcBr = parcelRequire("7mcBr");
Object.defineProperty(module.exports, "Root", {
    enumerable: true,
    get: function() {
        return $7mcBr.Root;
    }
});

var $joGvE = parcelRequire("joGvE");
Object.defineProperty(module.exports, "Div", {
    enumerable: true,
    get: function() {
        return $joGvE.Div;
    }
});

var $fAOYH = parcelRequire("fAOYH");
Object.defineProperty(module.exports, "Label", {
    enumerable: true,
    get: function() {
        return $fAOYH.Label;
    }
});

var $gkD0R = parcelRequire("gkD0R");
Object.defineProperty(module.exports, "Span", {
    enumerable: true,
    get: function() {
        return $gkD0R.Span;
    }
});

var $aUfnT = parcelRequire("aUfnT");
Object.defineProperty(module.exports, "Pre", {
    enumerable: true,
    get: function() {
        return $aUfnT.Pre;
    }
});

var $1h8RE = parcelRequire("1h8RE");
Object.defineProperty(module.exports, "AutoWidthTwoColumns", {
    enumerable: true,
    get: function() {
        return $1h8RE.AutoWidthTwoColumns;
    }
});

var $gOMMX = parcelRequire("gOMMX");
Object.defineProperty(module.exports, "TwinColumns", {
    enumerable: true,
    get: function() {
        return $gOMMX.TwinColumns;
    }
});

var $hPtm1 = parcelRequire("hPtm1");
Object.defineProperty(module.exports, "TwoFloatingColumns", {
    enumerable: true,
    get: function() {
        return $hPtm1.TwoFloatingColumns;
    }
});

var $2S24U = parcelRequire("2S24U");
Object.defineProperty(module.exports, "Button", {
    enumerable: true,
    get: function() {
        return $2S24U.Button;
    }
});

var $5PIlt = parcelRequire("5PIlt");
Object.defineProperty(module.exports, "Link", {
    enumerable: true,
    get: function() {
        return $5PIlt.Link;
    }
});

var $eONQW = parcelRequire("eONQW");
Object.defineProperty(module.exports, "Image", {
    enumerable: true,
    get: function() {
        return $eONQW.Image;
    }
});

var $d5iKF = parcelRequire("d5iKF");
Object.defineProperty(module.exports, "ImageInfo", {
    enumerable: true,
    get: function() {
        return $d5iKF.ImageInfo;
    }
});

var $CJCrq = parcelRequire("CJCrq");
Object.defineProperty(module.exports, "ImageSource", {
    enumerable: true,
    get: function() {
        return $CJCrq.ImageSource;
    }
});

var $iuQir = parcelRequire("iuQir");
Object.defineProperty(module.exports, "Canvas", {
    enumerable: true,
    get: function() {
        return $iuQir.Canvas;
    }
});

var $8a2qt = parcelRequire("8a2qt");
Object.defineProperty(module.exports, "ClickableImage", {
    enumerable: true,
    get: function() {
        return $8a2qt.ClickableImage;
    }
});

var $gyVEa = parcelRequire("gyVEa");
Object.defineProperty(module.exports, "NewLine", {
    enumerable: true,
    get: function() {
        return $gyVEa.NewLine;
    }
});

var $gwSD4 = parcelRequire("gwSD4");
Object.defineProperty(module.exports, "Line", {
    enumerable: true,
    get: function() {
        return $gwSD4.Line;
    }
});

var $bQA5y = parcelRequire("bQA5y");
Object.defineProperty(module.exports, "Paragraph", {
    enumerable: true,
    get: function() {
        return $bQA5y.Paragraph;
    }
});

var $8fPhC = parcelRequire("8fPhC");
Object.defineProperty(module.exports, "UnorderedList", {
    enumerable: true,
    get: function() {
        return $8fPhC.UnorderedList;
    }
});

var $2yjo2 = parcelRequire("2yjo2");
Object.defineProperty(module.exports, "OrderedList", {
    enumerable: true,
    get: function() {
        return $2yjo2.OrderedList;
    }
});

var $2MZa4 = parcelRequire("2MZa4");
Object.defineProperty(module.exports, "ListItem", {
    enumerable: true,
    get: function() {
        return $2MZa4.ListItem;
    }
});

var $9ewxt = parcelRequire("9ewxt");
Object.defineProperty(module.exports, "CollectionViewer", {
    enumerable: true,
    get: function() {
        return $9ewxt.CollectionViewer;
    }
});

var $4TgXd = parcelRequire("4TgXd");
Object.defineProperty(module.exports, "CollectionPrinter", {
    enumerable: true,
    get: function() {
        return $4TgXd.CollectionPrinter;
    }
});

var $8UMl5 = parcelRequire("8UMl5");
Object.defineProperty(module.exports, "CopyIcon", {
    enumerable: true,
    get: function() {
        return $8UMl5.CopyIcon;
    }
});

var $7LfyP = parcelRequire("7LfyP");
Object.defineProperty(module.exports, "Tabs", {
    enumerable: true,
    get: function() {
        return $7LfyP.Tabs;
    }
});

var $gYRyj = parcelRequire("gYRyj");
Object.defineProperty(module.exports, "TabsSwitcher", {
    enumerable: true,
    get: function() {
        return $gYRyj.TabsSwitcher;
    }
});

var $3B1VX = parcelRequire("3B1VX");
Object.defineProperty(module.exports, "Text", {
    enumerable: true,
    get: function() {
        return $3B1VX.Text;
    }
});

var $hIO35 = parcelRequire("hIO35");
Object.defineProperty(module.exports, "EditableLabel", {
    enumerable: true,
    get: function() {
        return $hIO35.EditableLabel;
    }
});

var $etGN3 = parcelRequire("etGN3");
Object.defineProperty(module.exports, "TextInput", {
    enumerable: true,
    get: function() {
        return $etGN3.TextInput;
    }
});

var $jCElc = parcelRequire("jCElc");
Object.defineProperty(module.exports, "PasswordInput", {
    enumerable: true,
    get: function() {
        return $jCElc.PasswordInput;
    }
});

var $4ytZ3 = parcelRequire("4ytZ3");
Object.defineProperty(module.exports, "NumberInput", {
    enumerable: true,
    get: function() {
        return $4ytZ3.NumberInput;
    }
});

var $2Q6Ax = parcelRequire("2Q6Ax");
Object.defineProperty(module.exports, "NumericRange", {
    enumerable: true,
    get: function() {
        return $2Q6Ax.NumericRange;
    }
});

var $2OnCU = parcelRequire("2OnCU");
Object.defineProperty(module.exports, "Range", {
    enumerable: true,
    get: function() {
        return $2OnCU.Range;
    }
});

var $bGQX2 = parcelRequire("bGQX2");
Object.defineProperty(module.exports, "Select", {
    enumerable: true,
    get: function() {
        return $bGQX2.Select;
    }
});

var $eBSeP = parcelRequire("eBSeP");
Object.defineProperty(module.exports, "SelectOption", {
    enumerable: true,
    get: function() {
        return $eBSeP.SelectOption;
    }
});

var $7fnxp = parcelRequire("7fnxp");
Object.defineProperty(module.exports, "Checkbox", {
    enumerable: true,
    get: function() {
        return $7fnxp.Checkbox;
    }
});

var $bOiUu = parcelRequire("bOiUu");
Object.defineProperty(module.exports, "Radio", {
    enumerable: true,
    get: function() {
        return $bOiUu.Radio;
    }
});

var $5duNI = parcelRequire("5duNI");
Object.defineProperty(module.exports, "Rate", {
    enumerable: true,
    get: function() {
        return $5duNI.Rate;
    }
});

var $85QoO = parcelRequire("85QoO");
Object.defineProperty(module.exports, "RateConfig", {
    enumerable: true,
    get: function() {
        return $85QoO.RateConfig;
    }
});

var $1gg6H = parcelRequire("1gg6H");
Object.defineProperty(module.exports, "RateStar", {
    enumerable: true,
    get: function() {
        return $1gg6H.RateStar;
    }
});

var $8Q6S6 = parcelRequire("8Q6S6");
Object.defineProperty(module.exports, "DateInput", {
    enumerable: true,
    get: function() {
        return $8Q6S6.DateInput;
    }
});

var $5ACZp = parcelRequire("5ACZp");
Object.defineProperty(module.exports, "TimeInput", {
    enumerable: true,
    get: function() {
        return $5ACZp.TimeInput;
    }
});

var $3UiF9 = parcelRequire("3UiF9");
Object.defineProperty(module.exports, "DateTimeInput", {
    enumerable: true,
    get: function() {
        return $3UiF9.DateTimeInput;
    }
});

var $2Tv9C = parcelRequire("2Tv9C");
Object.defineProperty(module.exports, "EditableDateLabel", {
    enumerable: true,
    get: function() {
        return $2Tv9C.EditableDateLabel;
    }
});

var $fGn1O = parcelRequire("fGn1O");
Object.defineProperty(module.exports, "EditableTextarea", {
    enumerable: true,
    get: function() {
        return $fGn1O.EditableTextarea;
    }
});

var $37QPp = parcelRequire("37QPp");
Object.defineProperty(module.exports, "MultilineInput", {
    enumerable: true,
    get: function() {
        return $37QPp.MultilineInput;
    }
});

var $hEMp0 = parcelRequire("hEMp0");
Object.defineProperty(module.exports, "LabeledTextInput", {
    enumerable: true,
    get: function() {
        return $hEMp0.LabeledTextInput;
    }
});

var $kUDwd = parcelRequire("kUDwd");
Object.defineProperty(module.exports, "LabeledNumberInput", {
    enumerable: true,
    get: function() {
        return $kUDwd.LabeledNumberInput;
    }
});

var $iBXy5 = parcelRequire("iBXy5");
Object.defineProperty(module.exports, "LabeledSelect", {
    enumerable: true,
    get: function() {
        return $iBXy5.LabeledSelect;
    }
});

var $6dx9g = parcelRequire("6dx9g");
Object.defineProperty(module.exports, "FileInput", {
    enumerable: true,
    get: function() {
        return $6dx9g.FileInput;
    }
});
Object.defineProperty(module.exports, "MultipleFilesInput", {
    enumerable: true,
    get: function() {
        return $6dx9g.MultipleFilesInput;
    }
});

var $bL1Ff = parcelRequire("bL1Ff");
Object.defineProperty(module.exports, "Menu", {
    enumerable: true,
    get: function() {
        return $bL1Ff.Menu;
    }
});
Object.defineProperty(module.exports, "PopupMenu", {
    enumerable: true,
    get: function() {
        return $bL1Ff.PopupMenu;
    }
});

var $5BSVz = parcelRequire("5BSVz");
Object.defineProperty(module.exports, "TextCombo", {
    enumerable: true,
    get: function() {
        return $5BSVz.TextCombo;
    }
});

var $azQFq = parcelRequire("azQFq");
Object.defineProperty(module.exports, "ClearableTextInput", {
    enumerable: true,
    get: function() {
        return $azQFq.ClearableTextInput;
    }
});

var $7Kd03 = parcelRequire("7Kd03");
Object.defineProperty(module.exports, "SearchableItem", {
    enumerable: true,
    get: function() {
        return $7Kd03.SearchableItem;
    }
});

var $bEnZu = parcelRequire("bEnZu");
Object.defineProperty(module.exports, "ModalWindow", {
    enumerable: true,
    get: function() {
        return $bEnZu.ModalWindow;
    }
});

var $fMKT6 = parcelRequire("fMKT6");
Object.defineProperty(module.exports, "RadioSwitchesBuilder", {
    enumerable: true,
    get: function() {
        return $fMKT6.RadioSwitchesBuilder;
    }
});

var $a9HcF = parcelRequire("a9HcF");
Object.defineProperty(module.exports, "DestroyingContentSwitcher", {
    enumerable: true,
    get: function() {
        return $a9HcF.DestroyingContentSwitcher;
    }
});

var $3slAG = parcelRequire("3slAG");
Object.defineProperty(module.exports, "DestroyingPatternContentSwitcher", {
    enumerable: true,
    get: function() {
        return $3slAG.DestroyingPatternContentSwitcher;
    }
});

var $4yfSX = parcelRequire("4yfSX");
Object.defineProperty(module.exports, "HidingContentSwitcher", {
    enumerable: true,
    get: function() {
        return $4yfSX.HidingContentSwitcher;
    }
});

var $3700g = parcelRequire("3700g");
Object.defineProperty(module.exports, "ButtonTabs", {
    enumerable: true,
    get: function() {
        return $3700g.ButtonTabs;
    }
});

var $fhrT0 = parcelRequire("fhrT0");
Object.defineProperty(module.exports, "VerticalButtonTabs", {
    enumerable: true,
    get: function() {
        return $fhrT0.VerticalButtonTabs;
    }
});

var $4YE9f = parcelRequire("4YE9f");
Object.defineProperty(module.exports, "Led", {
    enumerable: true,
    get: function() {
        return $4YE9f.Led;
    }
});
Object.defineProperty(module.exports, "BlinkMode", {
    enumerable: true,
    get: function() {
        return $4YE9f.BlinkMode;
    }
});

var $1bL1j = parcelRequire("1bL1j");
Object.defineProperty(module.exports, "ProgressBar", {
    enumerable: true,
    get: function() {
        return $1bL1j.ProgressBar;
    }
});

var $8BrJA = parcelRequire("8BrJA");
Object.defineProperty(module.exports, "TableBuilder", {
    enumerable: true,
    get: function() {
        return $8BrJA.TableBuilder;
    }
});

var $1lG8E = parcelRequire("1lG8E");
Object.defineProperty(module.exports, "Table", {
    enumerable: true,
    get: function() {
        return $1lG8E.Table;
    }
});

var $1lIsG = parcelRequire("1lIsG");
Object.defineProperty(module.exports, "TableBody", {
    enumerable: true,
    get: function() {
        return $1lIsG.TableBody;
    }
});

var $pCapU = parcelRequire("pCapU");
Object.defineProperty(module.exports, "TableCell", {
    enumerable: true,
    get: function() {
        return $pCapU.TableCell;
    }
});

var $bdjAM = parcelRequire("bdjAM");
Object.defineProperty(module.exports, "TableHeader", {
    enumerable: true,
    get: function() {
        return $bdjAM.TableHeader;
    }
});

var $3lnvs = parcelRequire("3lnvs");
Object.defineProperty(module.exports, "TableHeaderV2", {
    enumerable: true,
    get: function() {
        return $3lnvs.TableHeaderV2;
    }
});

var $kWKxK = parcelRequire("kWKxK");
Object.defineProperty(module.exports, "TableHeaderCell", {
    enumerable: true,
    get: function() {
        return $kWKxK.TableHeaderCell;
    }
});

var $dLmKH = parcelRequire("dLmKH");
Object.defineProperty(module.exports, "TableHeaderRow", {
    enumerable: true,
    get: function() {
        return $dLmKH.TableHeaderRow;
    }
});

var $cUBMo = parcelRequire("cUBMo");
Object.defineProperty(module.exports, "TableRow", {
    enumerable: true,
    get: function() {
        return $cUBMo.TableRow;
    }
});

var $7Fc9Q = parcelRequire("7Fc9Q");
Object.defineProperty(module.exports, "TableColumn", {
    enumerable: true,
    get: function() {
        return $7Fc9Q.TableColumn;
    }
});

var $2ZZKK = parcelRequire("2ZZKK");
Object.defineProperty(module.exports, "JsonViewerConfig", {
    enumerable: true,
    get: function() {
        return $2ZZKK.JsonViewerConfig;
    }
});

var $eBKPc = parcelRequire("eBKPc");
Object.defineProperty(module.exports, "JsonViewer", {
    enumerable: true,
    get: function() {
        return $eBKPc.JsonViewer;
    }
});
Object.defineProperty(module.exports, "RefJsonViewer", {
    enumerable: true,
    get: function() {
        return $eBKPc.RefJsonViewer;
    }
});

var $e6E17 = parcelRequire("e6E17");
Object.defineProperty(module.exports, "Snack", {
    enumerable: true,
    get: function() {
        return $e6E17.Snack;
    }
});

var $50yqK = parcelRequire("50yqK");
Object.defineProperty(module.exports, "BasicPaginator", {
    enumerable: true,
    get: function() {
        return $50yqK.BasicPaginator;
    }
});

var $et3h1 = parcelRequire("et3h1");
Object.defineProperty(module.exports, "SimplePaginator", {
    enumerable: true,
    get: function() {
        return $et3h1.SimplePaginator;
    }
});

var $kanmU = parcelRequire("kanmU");
Object.defineProperty(module.exports, "PaginatorBrain", {
    enumerable: true,
    get: function() {
        return $kanmU.PaginatorBrain;
    }
});
Object.defineProperty(module.exports, "PaginatorBrainOptions", {
    enumerable: true,
    get: function() {
        return $kanmU.PaginatorBrainOptions;
    }
});

var $5snGY = parcelRequire("5snGY");
Object.defineProperty(module.exports, "CollectionPaginator", {
    enumerable: true,
    get: function() {
        return $5snGY.CollectionPaginator;
    }
});
Object.defineProperty(module.exports, "CollectionPaginatorOptions", {
    enumerable: true,
    get: function() {
        return $5snGY.CollectionPaginatorOptions;
    }
});

var $bjWq6 = parcelRequire("bjWq6");
Object.defineProperty(module.exports, "Spinner", {
    enumerable: true,
    get: function() {
        return $bjWq6.Spinner;
    }
});

var $ckMZV = parcelRequire("ckMZV");
Object.defineProperty(module.exports, "Pie", {
    enumerable: true,
    get: function() {
        return $ckMZV.Pie;
    }
});

var $djLWA = parcelRequire("djLWA");
Object.defineProperty(module.exports, "OnlineStorage", {
    enumerable: true,
    get: function() {
        return $djLWA.OnlineStorage;
    }
});

var $cOIL8 = parcelRequire("cOIL8");
Object.defineProperty(module.exports, "UploadResult", {
    enumerable: true,
    get: function() {
        return $cOIL8.UploadResult;
    }
});

var $aq9Em = parcelRequire("aq9Em");
Object.defineProperty(module.exports, "Switch", {
    enumerable: true,
    get: function() {
        return $aq9Em.Switch;
    }
});

});
parcelRegister("iqyiC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.$ = void 0;
function $d6a542d33b147c1c$var$$(query) {
    return document.querySelector(query);
}
module.exports.$ = $d6a542d33b147c1c$var$$;
Object.prototype.Keys = function() {
    if (this === undefined) return [];
    return Object.keys(this);
};
Object.prototype.Values = function() {
    if (this === undefined) return [];
    return Object.values(this);
};
HTMLElement.prototype.Hide = function() {
    this.style.display = "none";
};
HTMLElement.prototype.Show = function(as) {
    if (as === void 0) as = "inline-block";
    this.style.display = as;
};
HTMLElement.prototype.Visibility = function(show, as) {
    if (as === void 0) as = "inline-block";
    if (show) this.Show(as);
    else this.Hide();
};
HTMLElement.prototype.IsVisible = function() {
    var bounding = this.getBoundingClientRect();
    return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= window.innerHeight && bounding.right <= window.innerWidth;
};
HTMLElement.prototype.Toggle = function() {
    this.IsVisible() ? this.Hide() : this.Show();
};
HTMLElement.prototype.Append = function(child) {
    this.appendChild(child);
    return this;
};
HTMLElement.prototype.Prepend = function(child) {
    this.prepend(child);
    return this;
};
HTMLElement.prototype.Exist = function(child) {
    var ch = Array.from(this.children);
    return !!ch.find(function(c) {
        return c === child;
    });
};
HTMLElement.prototype.Remove = function(child) {
    this.removeChild(child);
    return this;
};
HTMLElement.prototype.Clear = function() {
    this.innerHTML = "";
    return this;
};
HTMLInputElement.prototype.Enabled = function() {
    this.disabled = false;
    return this;
};
HTMLInputElement.prototype.Disabled = function() {
    this.disabled = true;
    return this;
};
HTMLButtonElement.prototype.Enabled = function() {
    this.disabled = false;
    return this;
};
HTMLButtonElement.prototype.Disabled = function() {
    this.disabled = true;
    return this;
};
HTMLElement.prototype.Text = function(text) {
    this.innerText = text;
    return this;
};
HTMLElement.prototype.GetText = function() {
    return this.innerText;
};
HTMLInputElement.prototype.Value = function(text) {
    this.value = text;
};
HTMLInputElement.prototype.Focus = function() {
    this.focus();
    return this;
};

});

parcelRegister("afOau", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RV = void 0;

var $6wI3m = parcelRequire("6wI3m");
/*
    Ref or Value

    DLACZEGO TO NIE JEST ZASZYTE W KLASACH BAZOWYCH?????????????
*/ var $7772386e437c2b55$var$RV = /** @class */ function() {
    function RV() {}
    RV.Use = function(valueOrRef, callback) {
        if (valueOrRef == undefined) // throw new Error("Value or Ref must be provided");
        return;
        if (!callback) throw new Error("Callback must be provided");
        if (valueOrRef instanceof $6wI3m.Ref) valueOrRef.OnChange(function(v) {
            callback(v);
        }, true);
        else callback(valueOrRef);
    };
    return RV;
}();
module.exports.RV = $7772386e437c2b55$var$RV;

});

parcelRegister("2Vdhf", function(module, exports) {
"use strict";
var $220b34358cb60465$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefDate = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $220b34358cb60465$var$RefDate = /** @class */ function(_super) {
    $220b34358cb60465$var$__extends(RefDate, _super);
    function RefDate(initialDate) {
        if (initialDate === void 0) initialDate = new Date(0);
        var _this = this;
        if (initialDate instanceof Date) _this = _super.call(this, initialDate) || this;
        else if (typeof initialDate === "number") _this = _super.call(this, new Date(initialDate)) || this;
        else if (typeof initialDate === "string") _this = _super.call(this, new Date(initialDate)) || this;
        return _this;
    }
    Object.defineProperty(RefDate.prototype, "IsToday", {
        get: function() {
            var now = new Date();
            return this.value.getFullYear() === now.getFullYear() && this.value.getMonth() === now.getMonth() && this.value.getDate() === now.getDate();
        },
        enumerable: false,
        configurable: true
    });
    return RefDate;
}($6wI3m.Ref);
module.exports.RefDate = $220b34358cb60465$var$RefDate;

});

parcelRegister("dzlP0", function(module, exports) {
"use strict";
var $9e0f7898db26d6f1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefBool = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $9e0f7898db26d6f1$var$RefBool = /** @class */ function(_super) {
    $9e0f7898db26d6f1$var$__extends(RefBool, _super);
    function RefBool(initialBool) {
        if (initialBool === void 0) initialBool = false;
        return _super.call(this, initialBool) || this;
    }
    RefBool.prototype.CombineRefBool = function(anotherRef, operation) {
        var _this = this;
        var result = new RefBool(operation(this.value, anotherRef.value));
        this.OnChange(function(v) {
            return result.value = operation(_this.value, anotherRef.value);
        });
        anotherRef.OnChange(function(v) {
            return result.value = operation(_this.value, anotherRef.value);
        });
        return result;
    };
    RefBool.prototype.CombineRefBoolValue = function(anotherValue, operation) {
        var result = new RefBool(operation(this.value, anotherValue));
        this.OnChange(function(v) {
            return result.value = operation(v, anotherValue);
        }, true);
        return result;
    };
    RefBool.prototype.MixRefBool = function(x, operation) {
        if (x instanceof $6wI3m.Ref) return this.CombineRefBool(x, operation);
        else return this.CombineRefBoolValue(x, operation);
    };
    RefBool.prototype.And = function(anotherRef) {
        return this.MixRefBool(anotherRef, function(a, b) {
            return a && b;
        });
    };
    RefBool.prototype.Or = function(anotherRef) {
        return this.MixRefBool(anotherRef, function(a, b) {
            return a || b;
        });
    };
    RefBool.prototype.Toggle = function() {
        this.value = !this.value;
        return this;
    };
    RefBool.prototype.True = function() {
        this.value = true;
        return this;
    };
    RefBool.prototype.IsTrue = function() {
        return this.value == true;
    };
    RefBool.prototype.IsFalse = function() {
        return this.value == false;
    };
    RefBool.prototype.False = function() {
        this.value = false;
        return this;
    };
    return RefBool;
}($6wI3m.Ref);
module.exports.RefBool = $9e0f7898db26d6f1$var$RefBool;

});

parcelRegister("brAEr", function(module, exports) {
"use strict";
var $854ea58599fdd688$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefString = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $854ea58599fdd688$var$RefString = /** @class */ function(_super) {
    $854ea58599fdd688$var$__extends(RefString, _super);
    function RefString(initialString) {
        if (initialString === void 0) initialString = "";
        return _super.call(this, initialString) || this;
    }
    RefString.prototype.Includes = function(toCompare) {
        // return value.includes(this.value as string);
        return this.Compare(this, toCompare, function(a, b) {
            return a.includes(b);
        });
    };
    return RefString;
}($6wI3m.Ref);
module.exports.RefString = $854ea58599fdd688$var$RefString;

});

parcelRegister("epBKP", function(module, exports) {
"use strict";
var $a7e0afb408ba02ac$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefNumber = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $a7e0afb408ba02ac$var$RefNumber = /** @class */ function(_super) {
    $a7e0afb408ba02ac$var$__extends(RefNumber, _super);
    function RefNumber(initialNumber) {
        if (initialNumber === void 0) initialNumber = 0;
        return _super.call(this, initialNumber) || this;
    }
    RefNumber.prototype.IsBigger = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a > b;
        });
    };
    RefNumber.prototype.IsBiggerOrEqual = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a >= b;
        });
    };
    RefNumber.prototype.IsSmaller = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a < b;
        });
    };
    RefNumber.prototype.IsSmallerrOrEqual = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a <= b;
        });
    };
    RefNumber.prototype.Plus = function(x) {
        return this.Mix(x, function(a, b) {
            return a + b;
        });
    };
    RefNumber.prototype.Minus = function(x) {
        return this.Mix(x, function(a, b) {
            return a - b;
        });
    };
    RefNumber.prototype.Multiply = function(x) {
        return this.Mix(x, function(a, b) {
            return a * b;
        });
    };
    RefNumber.prototype.Divide = function(x) {
        return this.Mix(x, function(a, b) {
            return a / b;
        });
    };
    return RefNumber;
}($6wI3m.Ref);
module.exports.RefNumber = $a7e0afb408ba02ac$var$RefNumber;

});

parcelRegister("9JbVp", function(module, exports) {
"use strict";
var $7151910ed7a0ffae$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefObject = void 0;

var $22Wrn = parcelRequire("22Wrn");
var $7151910ed7a0ffae$var$RefObject = /** @class */ function(_super) {
    $7151910ed7a0ffae$var$__extends(RefObject, _super);
    function RefObject(_obj) {
        var _this = _super.call(this) || this;
        _this._obj = _obj;
        return _this;
    }
    RefObject.prototype.Set = function(obj, excludeControlForRefresh) {
        this._obj = obj;
        this.RefreshSubscribers(excludeControlForRefresh);
        this.onChangeHandler.Call(this._obj);
    };
    RefObject.prototype.ForceOnChange = function() {
        this.RefreshSubscribers();
        this.onChangeHandler.Call(this._obj);
    };
    Object.defineProperty(RefObject.prototype, "object", {
        get: function() {
            return this._obj;
        },
        set: function(object) {
            this.Set(object);
        },
        enumerable: false,
        configurable: true
    });
    RefObject.prototype.Call = function(fn) {
        fn(this._obj);
        this.onChangeHandler.Call(this._obj);
        this.RefreshSubscribers();
        return this;
    };
    RefObject.prototype.OnChange = function(handler, callThisCallbackRightAway) {
        if (callThisCallbackRightAway === void 0) callThisCallbackRightAway = false;
        this.onChangeHandler.Add(handler);
        if (callThisCallbackRightAway == true) handler(this._obj, true);
        return this;
    };
    RefObject.prototype.toString = function() {
        if (this.Name) return "RefObject named ".concat(this.Name);
        else return "RefObject";
    };
    RefObject.prototype.Storable = function(key, storage) {
        if (storage === void 0) storage = "local";
        if (!key) return this;
        var stor;
        switch(storage){
            case "local":
                stor = window.localStorage;
                break;
            case "session":
                stor = window.sessionStorage;
                break;
        }
        var value = JSON.parse(stor.getItem(key));
        this.Set(value);
        this.OnChange(function(v) {
            return stor.setItem(key, JSON.stringify(v));
        });
        return this;
    };
    return RefObject;
}($22Wrn.RefBase);
module.exports.RefObject = $7151910ed7a0ffae$var$RefObject;

});

parcelRegister("8OWnY", function(module, exports) {
"use strict";
var $66c04871e0226872$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HashRef = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $66c04871e0226872$var$HashRef = /** @class */ function(_super) {
    $66c04871e0226872$var$__extends(HashRef, _super);
    function HashRef() {
        var _this = _super.call(this, window.location.hash.slice(1)) || this;
        _this.preventOnChange = false;
        window.onpopstate = function(e) {
            var hash = window.location.hash.split("#")[1];
            _this.Set(hash, _this);
        };
        window.onhashchange = function(e) {
            _this.preventOnChange = true;
            var hash = e.newURL.split("#")[1];
            _this.Set(hash, _this);
            _this.preventOnChange = false;
        };
        _this.OnChange(function(v) {
            if (_this.preventOnChange) return;
            window.location.hash = v;
        });
        return _this;
    }
    return HashRef;
}($6wI3m.Ref);
module.exports.HashRef = $66c04871e0226872$var$HashRef;

});

parcelRegister("6IcxB", function(module, exports) {
"use strict";
var $4e309485f53641b8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Collection = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $22Wrn = parcelRequire("22Wrn");

var $8PO3e = parcelRequire("8PO3e");
var $4e309485f53641b8$var$Collection = /** @class */ function(_super) {
    $4e309485f53641b8$var$__extends(Collection, _super);
    function Collection(items) {
        if (items === void 0) items = [];
        var _this = _super.call(this) || this;
        _this.items = items;
        _this.onAddHandlers = new $8PO3e.HandlersCollection();
        _this.onRemoveHandlers = new $8PO3e.HandlersCollection();
        _this.CountRef = new $6wI3m.Ref(_this.items.length);
        return _this;
    }
    Collection.prototype.Storable = function(key, storage, serialize, deserialize) {
        if (storage === void 0) storage = "local";
        if (!key) return this;
        var stor;
        switch(storage){
            case "local":
                stor = window.localStorage;
                break;
            case "session":
                stor = window.sessionStorage;
                break;
        }
        var valueFromStorage = stor.getItem(key);
        if (valueFromStorage) this.items = deserialize(valueFromStorage);
        this.OnChange(function(items) {
            var serialized = serialize(items);
            stor.setItem(key, serialized);
        });
        return this;
    };
    Object.defineProperty(Collection.prototype, "IsEmpty", {
        get: function() {
            return this.Count == 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "IsNotEmpty", {
        get: function() {
            return this.Count > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "Items", {
        get: function() {
            return this.items;
        },
        enumerable: false,
        configurable: true
    });
    Collection.prototype.OnAdd = function(handler) {
        this.onAddHandlers.Add(handler);
        return this;
    };
    Collection.prototype.Add = function() {
        var _this = this;
        var newItems = [];
        for(var _i = 0; _i < arguments.length; _i++)newItems[_i] = arguments[_i];
        newItems.forEach(function(x) {
            _this.items.push(x);
        });
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        this.onAddHandlers.Call(newItems);
        return this;
    };
    Collection.prototype.Load = function() {
        // TODO: jeśli pierwszy argument jest tablicą to traktuj jak tablice, tylko co z tablicą tablic wtedy?
        var items = [];
        for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
        this.items = [];
        return this.Add.apply(this, items);
    };
    Collection.prototype.OnRemove = function(handler) {
        this.onRemoveHandlers.Add(handler);
        return this;
    };
    Collection.prototype.Remove = function(item) {
        if (item == undefined) return this;
        this.onRemoveHandlers.Call(item);
        return this.Call(function(items) {
            return items.Remove(item);
        });
    };
    Collection.prototype.RemoveAll = function() {
        var _this = this;
        this.items.forEach(function(item) {
            return _this.onRemoveHandlers.Call(item);
        });
        return this.Modify(function(items) {
            return [];
        });
    };
    Collection.prototype.Clear = function() {
        return this.RemoveAll();
    };
    Collection.prototype.Contains = function(item) {
        return this.items.includes(item);
    };
    Collection.prototype.Modify = function(fn) {
        this.items = fn(this.items);
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        // TODO: a co z onRemoveHandlers?????
        return this;
    };
    Collection.prototype.ModifyOne = function(predicate, modify) {
        var found = this.items.find(predicate);
        if (!found) return this;
        modify(found);
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Collection.prototype.Call = function(fn) {
        fn(this.items);
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Collection.prototype.ForceOnChange = function() {
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Collection.prototype.ForEach = function(callback) {
        this.items.forEach(function(x, i, a) {
            callback(x, i, a);
        });
        return this;
    };
    Collection.prototype.Filter = function(callback) {
        return this.items.filter(callback);
    };
    Collection.prototype.Find = function(callback) {
        return this.items.find(callback);
    };
    Collection.prototype.Map = function(callback) {
        return this.items.map(callback);
    };
    Collection.prototype.Reduce = function(callback, initialValue) {
        return this.items.reduce(callback, initialValue);
    };
    Collection.prototype.First = function() {
        return this.items[0];
    };
    Collection.prototype.Last = function() {
        return this.items[this.Count - 1];
    };
    Collection.prototype.RemoveMany = function(items) {
        var _this = this;
        items.forEach(function(x) {
            _this.onRemoveHandlers.Call(x);
            _this.items.Remove(x);
        });
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Object.defineProperty(Collection.prototype, "Count", {
        get: function() {
            return this.items.length;
        },
        enumerable: false,
        configurable: true
    });
    Collection.prototype.Take = function(start, count) {
        if (count > 0) return this.items.slice(start, start + count);
        else return this.items.slice(start);
    };
    Collection.prototype.Swap = function(a, b) {
        var _a;
        if (a < 0 || b >= this.items.length) return this;
        _a = [
            this.items[b],
            this.items[a]
        ], this.items[a] = _a[0], this.items[b] = _a[1];
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Collection.prototype.SwapUp = function(item) {
        var itemIndex = this.items.findIndex(function(x) {
            return x == item;
        });
        if (itemIndex == -1) return this;
        var itemAbove = itemIndex - 1;
        if (itemAbove < 0) return this;
        this.Swap(itemIndex, itemAbove);
        return this;
    };
    Collection.prototype.SwapDown = function(item) {
        var itemIndex = this.items.findIndex(function(x) {
            return x == item;
        });
        if (itemIndex == -1) return this;
        var itemBelow = itemIndex + 1;
        if (itemBelow >= this.Count) return this;
        this.Swap(itemIndex, itemBelow);
        return this;
    };
    Collection.prototype.CanSwapUp = function(item) {
        return !this.IsFirst(item);
    };
    Collection.prototype.CanSwapDown = function(item) {
        return !this.IsLast(item);
    };
    Collection.prototype.IsFirst = function(item) {
        var itemIndex = this.items.findIndex(function(x) {
            return x == item;
        });
        return itemIndex == 0;
    };
    Collection.prototype.IsLast = function(item) {
        var itemIndex = this.items.findIndex(function(x) {
            return x == item;
        });
        return itemIndex == this.Count - 1;
    };
    Object.defineProperty(Collection.prototype, "FirstItem", {
        get: function() {
            return this.items[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "LastItem", {
        get: function() {
            return this.items[this.Count - 1];
        },
        enumerable: false,
        configurable: true
    });
    Collection.prototype.OnChange = function(handler, callThisCallbackRightAway) {
        if (callThisCallbackRightAway === void 0) callThisCallbackRightAway = false;
        this.onChangeHandler.Add(handler);
        if (callThisCallbackRightAway == true) handler(this.items, true);
        return this;
    };
    Collection.prototype.toString = function() {
        if (this.Name) return "Collection of ".concat(this.Name, " (").concat(this.Count, " items)");
        else return "Collection (".concat(this.Count, " items)");
    };
    return Collection;
}($22Wrn.RefBase);
module.exports.Collection = $4e309485f53641b8$var$Collection;

});

parcelRegister("8y6Fd", function(module, exports) {
"use strict";
var $6396aaf96491eb4a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionView = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $22Wrn = parcelRequire("22Wrn");

var $6IcxB = parcelRequire("6IcxB");
var $6396aaf96491eb4a$var$CollectionView = /** @class */ function(_super) {
    $6396aaf96491eb4a$var$__extends(CollectionView, _super);
    function CollectionView(data) {
        var _this = _super.call(this) || this;
        _this.Items = [];
        _this.filtersRefs = [];
        _this.filters = [];
        _this.FilteredCount = new $6wI3m.Ref(0);
        _this.collection = new $6IcxB.Collection();
        if (Array.isArray(data)) _this.collection = new $6IcxB.Collection(data);
        else if (data instanceof $6IcxB.Collection) _this.collection = data;
        _this.collection.AddSubscriber(_this);
        return _this;
    }
    Object.defineProperty(CollectionView.prototype, "Collection", {
        get: function() {
            return this.collection;
        },
        enumerable: false,
        configurable: true
    });
    CollectionView.prototype.OnChange = function(handler, callThisCallbackRightAway) {
        this.onChangeHandler.Add(handler);
        if (callThisCallbackRightAway == true) handler(this.Items, true);
        return this;
    };
    CollectionView.prototype.ForEach = function(fn) {
        this.onRefresh = fn; //???????
        return this;
    };
    CollectionView.prototype.Refresh = function() {
        var _this = this;
        this.Items = this.collection.Items;
        this.filters.forEach(function(filterPredicate, index) {
            var filterRef = _this.filtersRefs[index];
            var refValue = filterRef instanceof $6wI3m.Ref ? filterRef.value : filterRef.Items;
            _this.Items = _this.Items.filter(function(item) {
                return filterPredicate(item, refValue);
            });
        });
        this.FilteredCount.value = this.Items.length;
        if (this.start && this.count) this.Items = this.Items.slice(this.start.value, this.start.value + this.count.value);
        if (this.onRefresh) this.Items.forEach(function(record, index, array) {
            return _this.onRefresh(record, index, array);
        });
        this.onChangeHandler.Call(this.Items);
        this.RefreshSubscribers();
        return this;
    };
    CollectionView.prototype.Filter = function(ref, predicate) {
        ref.AddSubscriber(this);
        this.filtersRefs.push(ref);
        this.filters.push(predicate);
        return this;
    };
    CollectionView.prototype.Take = function(predicate) {
        this.Items = this.Items.filter(predicate);
        return this;
    };
    CollectionView.prototype.See = function(start, count) {
        start.AddSubscriber(this);
        count.AddSubscriber(this);
        this.start = start;
        this.count = count;
        return this;
    };
    return CollectionView;
}($22Wrn.RefBase);
module.exports.CollectionView = $6396aaf96491eb4a$var$CollectionView;

});

parcelRegister("hiDht", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dumper = void 0;

var $6IcxB = parcelRequire("6IcxB");

var $6wI3m = parcelRequire("6wI3m");
var $c982967191c09fe2$var$Dumper = /** @class */ function() {
    function Dumper() {}
    Dumper.Dump = function(obj) {
        var out = "";
        // obj.forEach(o=>  DumpObj(obj, o));
        out = Dumper.DumpObj2(obj, out);
        // console.log(out);
        return out;
    };
    Dumper.DumpObj2 = function(obj, out, prefix) {
        // console.log('DumpObj2');
        // if (prefix)
        //     out += prefix
        // out += `\n[[[[[${typeof obj}]]]]]\n`
        switch(typeof obj){
            case "string":
                out += ":string";
                break;
            case "number":
                out += ":number";
                break;
            case "boolean":
                out += ":boolean";
                break;
            case "object":
                if (obj instanceof $6wI3m.Ref) out += obj === null || obj === void 0 ? void 0 : obj.ToString();
                else if (obj instanceof $6IcxB.Collection) {
                    out += obj === null || obj === void 0 ? void 0 : obj.toString();
                    obj.Items.forEach(function(e, i) {
                        out += "\n[".concat(i, "]\n");
                        var cc = "";
                        cc = Dumper.DumpObj2(e, cc);
                        out += cc;
                    });
                } else Object.keys(obj).forEach(function(k, i) {
                    out += "__ ".concat(k);
                    var v = obj[k];
                    // switch (typeof v)
                    // {
                    //     case "string": out += `:string = "${v}"`; break;
                    //     case "number": out += `:number = ${v}`; break;
                    //     case "boolean": out += `:boolean = ${v ? "true" : "false"}`; break;
                    // default: out += `:unknown-type = ${v}`; break;
                    // }
                    out += ": ".concat(v);
                    out += "\n";
                // out += DumpObj2(obj[k], out)
                });
                break;
            default:
                out += "unknown type: " + typeof obj;
        }
        // console.log('DumpObj2 end');
        return out;
    };
    Dumper.DumpObj = function(obj, out) {
        // console.log(obj);
        // if ((typeof obj === "string") || (typeof obj === "number")
        // || (typeof obj === "boolean"))
        // {
        //     out += `${k}: ${v || "(empty)"}\n`;
        // }
        // else
        // out+=typeof(obj) + ": "
        var _this = this;
        Object.keys(obj).forEach(function(k, i) {
            var v = obj[k];
            // console.log(k, typeof v);
            out += "\uD83D\uDD38 ";
            // console.log(`#${i} k=${k} v=${v}`, 'isarr', Array.isArray(v));
            if (typeof v === "string" || typeof v === "number") out += "".concat(k, ": ").concat(v || "(empty)", "\n");
            else if (v instanceof $6wI3m.Ref) {
                // console.log(`REF ${k}: ${v.value}`);
                if (typeof v.value === "boolean") // console.log('V IS BOOL');
                out += "".concat(k, ":bool : ").concat(v.value ? "true" : "false", " ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
                else if (typeof v.value === "string") out += "".concat(k, ':string : "').concat(v.value, '" ').concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
                else if (typeof v.value === "number") out += "".concat(k, ":number : ").concat(v.value, " ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
                else // console.log('V IS NOT BOOL', typeof(v.value));
                out += "".concat(k, " (").concat(typeof v.value, "): ").concat(v.value || "(empty)", " ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
            } else if (v instanceof $6wI3m.Ref) // console.log(`REF ${k}: ${v.value}`);
            out += "".concat(k, ": ").concat(v.value || "(empty)", " ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
            else if (v instanceof $6IcxB.Collection) {
                // console.log('ARRAY');
                // out += "" + k + ": " + this.Dump(v)+"\n";
                out += "" + k + ":collection(" + v.Count + ")\n";
                out += "___" + _this.DumpObj(v.Items, out);
            } else if (Array.isArray(v)) {
                // console.log('ARRAY');
                // out += "" + k + ": " + this.Dump(v)+"\n";
                // out += "" + k + ": " + Dump(v);
                out += "" + k + ":array(" + v.length + ")\n";
                v.forEach(function(e, i) {
                    out += "___ [" + i + "]: " + _this.DumpObj(e, out);
                });
            } else if (Object.keys(v).length > 0) ;
            else // console.log('?????', k);  
            out += "" + k + ":" + typeof v + "\n";
        });
        out += "\n";
        // console.log(out);
        return out;
    };
    Dumper.WatchersInfo = function(v) {
        var _a, _b;
        return ((_b = (_a = v.Watchers) === null || _a === void 0 ? void 0 : _a.map(function(c) {
            return c.Id;
        })) === null || _b === void 0 ? void 0 : _b.join(", ")) || "no watchers";
    };
    return Dumper;
}();
module.exports.Dumper = $c982967191c09fe2$var$Dumper;

});

parcelRegister("4Og3n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sorter = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $380848d711c07323$var$Sorter = /** @class */ function() {
    function Sorter(collection, selected) {
        if (selected === void 0) selected = new $6wI3m.Ref("");
        var _this = this;
        this.collection = collection;
        this.selected = selected;
        this.sorts = [];
        this.selected.OnChange(function(_) {
            _this.Refresh();
        }); // second parameter of OnChange will not take action here cause sort functions are not registered (with Add) at this point yet
    }
    Sorter.prototype.Refresh = function() {
        var _this = this;
        this.collection.Call(function(items) {
            return _this.SortBySelectedFunction(items);
        });
        return this;
    };
    Sorter.prototype.Add = function(label, sortFunction) {
        this.sorts.push({
            label: label,
            sortFunction: sortFunction
        });
        return this;
    };
    Sorter.prototype.Reset = function() {
        this.selected.Restore();
        return this;
    };
    Object.defineProperty(Sorter.prototype, "SelectedValue", {
        get: function() {
            return this.selected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sorter.prototype, "Labels", {
        get: function() {
            return this.sorts.map(function(x) {
                return x.label;
            });
        },
        enumerable: false,
        configurable: true
    });
    Sorter.prototype.SortBySelectedFunction = function(items) {
        var _this = this;
        var _a;
        var sortingFunction = (_a = this.sorts.find(function(x) {
            return x.label === _this.selected.value;
        })) === null || _a === void 0 ? void 0 : _a.sortFunction;
        if (sortingFunction) return items.sort(sortingFunction);
        else return items;
    };
    return Sorter;
}();
module.exports.Sorter = $380848d711c07323$var$Sorter;

});

parcelRegister("6krno", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefReflector = void 0;

var $6IcxB = parcelRequire("6IcxB");

var $6wI3m = parcelRequire("6wI3m");
var $49b9d8b12639cf1e$var$RefReflector = /** @class */ function() {
    function RefReflector() {}
    RefReflector.FindAllRefs = function(record) {
        this.refs = [];
        this.FindAllRefsInObject(record);
        return this.refs;
    };
    RefReflector.FindAllRefsInObject = function(obj) {
        var _this = this;
        obj.Keys().forEach(function(k) {
            var v = obj[k];
            if (v instanceof $6wI3m.Ref) _this.refs.push(v);
            else if (v instanceof Object) _this.FindAllRefsInObject(v);
            else if (v instanceof Array) v.forEach(function(item) {
                return _this.FindAllRefsInObject(item);
            });
            else if (v instanceof $6IcxB.Collection) v.Items.forEach(function(item) {
                return _this.FindAllRefsInObject(item);
            });
        });
    };
    RefReflector.refs = [];
    return RefReflector;
}();
module.exports.RefReflector = $49b9d8b12639cf1e$var$RefReflector;

});

parcelRegister("9Fnts", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefSerializer = void 0;

var $1uOZx = parcelRequire("1uOZx");

var $gSLVI = parcelRequire("gSLVI");
var $709a26e2709195f3$var$RefSerializer = /** @class */ function() {
    function RefSerializer() {}
    RefSerializer.Serialize = function(source) {
        var flat = $gSLVI.RefFlattener.Flat(source);
        return JSON.stringify(flat);
    };
    RefSerializer.Deserialize = function(source, template) {
        var sourceAsObject = JSON.parse(source);
        var target = $1uOZx.RefDeflattener.Deflat(sourceAsObject, template);
        return target;
    };
    RefSerializer.Flatenize = function(source) {
        var flat = $gSLVI.RefFlattener.Flat(source);
        return flat;
    };
    RefSerializer.Deflatenize = function(source, template) {
        var target = $1uOZx.RefDeflattener.Deflat(source, template);
        return target;
    };
    return RefSerializer;
}();
module.exports.RefSerializer = $709a26e2709195f3$var$RefSerializer;

});
parcelRegister("1uOZx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefDeflattener = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $6IcxB = parcelRequire("6IcxB");

var $k4rJZ = parcelRequire("k4rJZ");

var $9ngW8 = parcelRequire("9ngW8");
var $117025a935c433a7$var$RefDeflattener = /** @class */ function() {
    function RefDeflattener() {}
    RefDeflattener.Deflat = function(source, target, options) {
        if (options === void 0) options = {
            throw: true
        };
        if (target instanceof $6wI3m.Ref) {
            if (target.value instanceof Date) target.value = new Date(source);
            else target.value = source;
        } else if (target instanceof Date) target = new Date(source);
        else if (target instanceof $9ngW8.ArrayTemplate) target = source.map(function(x) {
            return RefDeflattener.Deflat(x, target.CreateFn(), options);
        });
        else if (target instanceof Array) {
            if (target.length != 1) {
                if (options === null || options === void 0 ? void 0 : options.throw) throw new Error("You need to define array type by putting one item into array template (otherwise it won't know to what type deserialize). You can disable this message by setting third parameter of this method to { options.throw: false }");
            }
            if (target[0] instanceof Date) target = source.map(function(x) {
                return new Date(x);
            });
            else if (target[0] instanceof $6wI3m.Ref) {
                if (target[0].value instanceof Date) target = source.map(function(x) {
                    return new $6wI3m.Ref(x);
                });
                else if (typeof target[0].value == "string") target = source.map(function(x) {
                    return new $6wI3m.Ref(x);
                });
                else if (typeof target[0].value == "number") target = source.map(function(x) {
                    return new $6wI3m.Ref(x);
                });
                else if (typeof target[0].value == "boolean") target = source.map(function(x) {
                    return new $6wI3m.Ref(x);
                });
            } else if (target[0] instanceof Object) target = source.map(function(x) {
                return RefDeflattener.Deflat(x, target[0], options);
            });
            else target = source;
        } else if (target instanceof $k4rJZ.CollectionTemplate) target = new $6IcxB.Collection(source.map(function(x) {
            return RefDeflattener.Deflat(x, target.CreateFn(), options);
        }));
        else if (target instanceof $6IcxB.Collection) {
            if (options === null || options === void 0 ? void 0 : options.throw) throw new Error("PLEASE USE CollectionTemplate INSTEAD! This approach will work only for Collection<Ref> or Collection<primitive>, not for Collection<Object>!");
            if (target.Items.length != 1) {
                if (options === null || options === void 0 ? void 0 : options.throw) throw new Error("You need to define collection type by putting one item into collection (otherwise it won't know to what type deserialize). You can disable this message by setting third parameter of this method to { options.throw: false }");
            }
            if (target.Items[0] instanceof $6wI3m.Ref) {
                if (target.Items[0].value instanceof Date) {
                    var items = source.map(function(x) {
                        return new $6wI3m.Ref(x);
                    });
                    target.Load.apply(target, items);
                } else if (typeof target.Items[0].value == "string") {
                    var items = source.map(function(x) {
                        return new $6wI3m.Ref(x);
                    });
                    target.Load.apply(target, items);
                } else if (typeof target.Items[0].value == "number") {
                    var items = source.map(function(x) {
                        return new $6wI3m.Ref(x);
                    });
                    target.Load.apply(target, items);
                } else if (typeof target.Items[0].value == "boolean") {
                    var items = source.map(function(x) {
                        return new $6wI3m.Ref(x);
                    });
                    target.Load.apply(target, items);
                }
            } else if (target.Items[0] instanceof Object) {
                if (options === null || options === void 0 ? void 0 : options.throw) throw new Error("Sorry, but deserializing to Collection<Object> is not possible now. This is due to limitation of Javascript. Target like new Collection([new Foo()]) will always reference to the same Foo for every item of collection. You don't wanna this. You can disable this message by setting third parameter of this method to { options.throw: false }");
            } else {
                var items = source.map(function(x) {
                    if (x instanceof $6wI3m.Ref) return x.value;
                    else return x;
                });
                target.Load.apply(target, items);
            }
        } else if (target instanceof Object) Object.keys(target).forEach(function(k) {
            if (target[k] instanceof Date) target[k] = new Date(source[k]);
            else if (target[k] instanceof $6wI3m.Ref) {
                if (target[k].value instanceof Date) target[k].value = new Date(source[k]);
                else target[k].value = source[k];
            } else if (target[k] instanceof Object) target[k] = RefDeflattener.Deflat(source[k], target[k], options);
            else target[k] = source[k];
        });
        else target = source;
        return target;
    };
    return RefDeflattener;
}();
module.exports.RefDeflattener = $117025a935c433a7$var$RefDeflattener;

});
parcelRegister("k4rJZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionTemplate = void 0;
var $03c55157358e0895$var$CollectionTemplate = /** @class */ function() {
    function CollectionTemplate(CreateFn) {
        this.CreateFn = CreateFn;
    }
    return CollectionTemplate;
}();
module.exports.CollectionTemplate = $03c55157358e0895$var$CollectionTemplate;

});

parcelRegister("9ngW8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayTemplate = void 0;
var $6d33665475ad970d$var$ArrayTemplate = /** @class */ function() {
    function ArrayTemplate(CreateFn) {
        this.CreateFn = CreateFn;
    }
    return ArrayTemplate;
}();
module.exports.ArrayTemplate = $6d33665475ad970d$var$ArrayTemplate;

});


parcelRegister("gSLVI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefFlattener = void 0;

var $6IcxB = parcelRequire("6IcxB");

var $6wI3m = parcelRequire("6wI3m");

var $9JbVp = parcelRequire("9JbVp");
var $c4a6de63480f73c4$var$RefFlattener = /** @class */ function() {
    function RefFlattener() {}
    RefFlattener.Flat = function(obj) {
        if (obj instanceof $6IcxB.Collection) return this.FlatCollection(obj);
        else if (obj instanceof Array) return this.FlatArray(obj);
        else return this.FlatObject(obj);
    };
    RefFlattener.FlatArray = function(array) {
        var _this = this;
        var flat = [];
        if (array instanceof Array) flat = array.map(function(i) {
            return _this.FlatObject(i);
        });
        return flat;
    };
    RefFlattener.FlatCollection = function(collection) {
        var _this = this;
        var flat = [];
        if (collection instanceof $6IcxB.Collection) flat = collection.Items.map(function(i) {
            return _this.FlatObject(i);
        });
        return flat;
    };
    RefFlattener.IsDateValid = function(date) {
        return !isNaN(date.getTime());
    };
    RefFlattener.FlatObject = function(obj) {
        var _this = this;
        if (obj instanceof $6IcxB.Collection) return this.FlatCollection(obj);
        else if (obj instanceof Array) return this.FlatArray(obj);
        else if (obj instanceof Object) {
            var flat_1 = {};
            obj.Keys().forEach(function(k) {
                var v = obj[k];
                if (v instanceof $6wI3m.Ref && v.value instanceof Date) {
                    if (!_this.IsDateValid(v.value)) throw new Error('Date "'.concat(v.value, '" is invalid'));
                    flat_1[k] = v.value.toISOString();
                } else if (v instanceof Date) {
                    if (!_this.IsDateValid(v)) throw new Error('Date "'.concat(v, '" is invalid'));
                    flat_1[k] = v.toISOString();
                } else if (v instanceof $6wI3m.Ref) flat_1[k] = v.value;
                else if (v instanceof $6IcxB.Collection) flat_1[k] = v.Items.map(function(x) {
                    return _this.FlatObject(x);
                });
                else if (v instanceof $9JbVp.RefObject) flat_1[k] = v.object;
                else if (v instanceof Object) flat_1[k] = _this.FlatObject(v);
                else flat_1[k] = v;
            });
            return flat_1;
        } else return obj;
    };
    return RefFlattener;
}();
module.exports.RefFlattener = $c4a6de63480f73c4$var$RefFlattener;

});


parcelRegister("3Z5yA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Filters = void 0;
var $2e6b611460cd984f$var$Filters = /** @class */ function() {
    function Filters() {}
    Filters.TextContains = function(filter, field) {
        if (Array.isArray(field)) return filter.value.trim() ? field.some(function(f) {
            return f.trim().toLowerCase().includes(filter.value.trim().toLowerCase());
        }) : true;
        return filter.value.trim() ? field.trim().toLowerCase().includes(filter.value.trim().toLowerCase()) : true;
    };
    return Filters;
}();
module.exports.Filters = $2e6b611460cd984f$var$Filters;

});

parcelRegister("2UVc2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RegexExtractor = void 0;
var $21fd2d1778928b41$var$RegexExtractor = /** @class */ function() {
    function RegexExtractor(regex) {
        this.regex = regex;
    }
    RegexExtractor.prototype.Extract = function(str) {
        try {
            var m = this.regex.exec(str);
            return (m === null || m === void 0 ? void 0 : m[1]) || "";
        } catch (error) {
            throw new Error(error);
        }
    };
    RegexExtractor.prototype.ExtractAll = function(str) {
        var m;
        var matches = [];
        while((m = this.regex.exec(str)) !== null){
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === this.regex.lastIndex) this.regex.lastIndex++;
            // The result can be accessed through the `m`-variable.
            m.forEach(function(match, groupIndex) {
                if (groupIndex === 1) matches.push(match);
            });
        }
        return matches;
    };
    return RegexExtractor;
}();
module.exports.RegexExtractor = $21fd2d1778928b41$var$RegexExtractor;

});

parcelRegister("3CTSE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PatternExtractorV2 = module.exports.PatternExtractor = void 0;
var $2a404462d8fb984c$var$PatternExtractor = /** @class */ function() {
    function PatternExtractor(pattern) {
        this.pattern = pattern;
    }
    PatternExtractor.prototype.Extract = function(url) {
        if (!url) return null;
        if (!this.pattern) return null;
        var urlParts = url.split("/");
        var patternParts = this.pattern.split("/");
        var params = {};
        if (urlParts.length !== patternParts.length) return null;
        for(var i = 0; i < urlParts.length; i++){
            if (patternParts[i].startsWith(":")) {
                var paramName = patternParts[i].substring(1);
                params[paramName] = urlParts[i];
            } else if (urlParts[i] !== patternParts[i]) return null;
        }
        return params;
    };
    return PatternExtractor;
}();
module.exports.PatternExtractor = $2a404462d8fb984c$var$PatternExtractor;
/*
    TO JEST DO DUPY BO ZAWSZE COŚ ZAJDZIE WIĘC NIE NADAJE SIE DO CotentSwitchera!!!!!!!!!
*/ var $2a404462d8fb984c$var$PatternExtractorV2 = /** @class */ function() {
    function PatternExtractorV2(pattern) {
        this.pattern = pattern;
    }
    PatternExtractorV2.prototype.Extract = function(input) {
        var patternSegments = this.pattern.split("/");
        var inputSegments = input.split("/");
        var params = {};
        for(var i = 0; i < patternSegments.length; i++){
            var patternSegment = patternSegments[i];
            var inputSegment = inputSegments[i];
            if (patternSegment.startsWith(":?")) {
                var paramName = patternSegment.substring(2);
                if (paramName != "") params[paramName] = inputSegment || null;
            } else if (patternSegment.startsWith(":")) {
                var paramName = patternSegment.substring(1);
                if (paramName != "") params[paramName] = inputSegment || null;
            }
        }
        return params;
    };
    return PatternExtractorV2;
}();
module.exports.PatternExtractorV2 = $2a404462d8fb984c$var$PatternExtractorV2;

});

parcelRegister("8B6cm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Validator = module.exports.ValidationResult = void 0;

var $afOau = parcelRequire("afOau");

var $6wI3m = parcelRequire("6wI3m");

var $dzlP0 = parcelRequire("dzlP0");
var $64269651993f5a6a$var$ValidationResult = /** @class */ function() {
    function ValidationResult(IsValid, IsNotValid, FirstError) {
        if (IsValid === void 0) IsValid = new $dzlP0.RefBool();
        if (IsNotValid === void 0) IsNotValid = new $dzlP0.RefBool(true);
        if (FirstError === void 0) FirstError = new $6wI3m.Ref("");
        this.IsValid = IsValid;
        this.IsNotValid = IsNotValid;
        this.FirstError = FirstError;
    }
    return ValidationResult;
}();
module.exports.ValidationResult = $64269651993f5a6a$var$ValidationResult;
var $64269651993f5a6a$var$ValidationRule = /** @class */ function() {
    function ValidationRule(predicate, message) {
        this.predicate = predicate;
        this.message = message;
    }
    return ValidationRule;
}();
var $64269651993f5a6a$var$Validator = /** @class */ function() {
    function Validator(valueToValidate, isEnabled) {
        if (isEnabled === void 0) isEnabled = true;
        var _this = this;
        this.valueToValidate = valueToValidate;
        this.isEnabled = isEnabled;
        this.isValid = new $dzlP0.RefBool();
        this.isNotValid = new $dzlP0.RefBool(true);
        this.firstErrorMessage = new $6wI3m.Ref("");
        this.rules = [];
        this.wasInitiallyValidated = false;
        this.valueToValidate.OnChange(function(v) {
            if (_this.isEnabled) _this.Validate();
        });
    }
    Validator.prototype.Enable = function(enable) {
        var _this = this;
        if (enable === void 0) enable = true;
        $afOau.RV.Use(enable, function(v) {
            _this.isEnabled = v;
            if (_this.isEnabled) _this.Validate();
        });
        return this;
    };
    Validator.prototype.Enabled = function() {
        this.isEnabled = true;
        this.Validate();
        return this;
    };
    Validator.prototype.Disabled = function() {
        this.isEnabled = false;
        return this;
    };
    Validator.prototype.Validate = function() {
        for(var _i = 0, _a = this.rules; _i < _a.length; _i++){
            var rule = _a[_i];
            var isValid = rule.predicate(this.valueToValidate.value);
            if (isValid == false) {
                this.firstErrorMessage.value = rule.message;
                this.isValid.value = false;
                this.isNotValid.value = true;
                return this;
            }
        }
        this.firstErrorMessage.value = "";
        this.isValid.value = true;
        this.isNotValid.value = false;
        return this;
    };
    Validator.prototype.MustBeNotEmpty = function(message) {
        if (message === void 0) message = "Value can not be empty";
        this.AddRule(function(v) {
            return !!v;
        }, message);
        return this;
    };
    Validator.prototype.MustBeLowerThan = function(value, message) {
        if (message === void 0) message = "Value must be lower than " + value;
        this.AddRule(function(v) {
            return +v < value;
        }, message);
        return this;
    };
    Validator.prototype.MustBeLowerOrEqualThan = function(value, message) {
        if (message === void 0) message = "Value must be lower or equal to " + value;
        this.AddRule(function(v) {
            return +v <= value;
        }, message);
        return this;
    };
    Validator.prototype.MustBeGraterThan = function(value, message) {
        if (message === void 0) message = "Value must be greater than " + value;
        this.AddRule(function(v) {
            return +v > value;
        }, message);
        return this;
    };
    Validator.prototype.MustBeGraterOrEqualThan = function(value, message) {
        if (message === void 0) message = "Value must be greater or equal to " + value;
        this.AddRule(function(v) {
            return +v >= value;
        }, message);
        return this;
    };
    Validator.prototype.MustBeOneOf = function(options, message) {
        if (message === void 0) message = "Must be ".concat(options.join(" or "));
        this.AddRule(function(v) {
            return options.includes(v);
        }, message);
        return this;
    };
    Validator.prototype.AddRule = function(predicate, messageIfNotValid) {
        this.rules.push(new $64269651993f5a6a$var$ValidationRule(predicate, messageIfNotValid));
        return this;
    };
    Object.defineProperty(Validator.prototype, "IsValid", {
        get: function() {
            return this.Result.IsValid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Validator.prototype, "IsNotValid", {
        get: function() {
            return this.Result.IsNotValid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Validator.prototype, "FirstError", {
        get: function() {
            return this.Result.FirstError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Validator.prototype, "Result", {
        get: function() {
            if (this.wasInitiallyValidated === false && this.isEnabled) {
                this.Validate();
                this.wasInitiallyValidated = true;
            }
            return new $64269651993f5a6a$var$ValidationResult(this.isValid, this.isNotValid, this.firstErrorMessage);
        },
        enumerable: false,
        configurable: true
    });
    return Validator;
}();
module.exports.Validator = $64269651993f5a6a$var$Validator;

});

parcelRegister("iwAjC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefWatcher = void 0;
var $d7c762a3ad6d7260$var$RefWatcher = /** @class */ function() {
    function RefWatcher() {}
    RefWatcher.Watch = function(refs, doWhenAnyRefChange, callRightaway) {
        if (callRightaway === void 0) callRightaway = true;
        refs.forEach(function(ref) {
            ref.OnChange(function(v) {
                return doWhenAnyRefChange();
            });
        });
        if (callRightaway) doWhenAnyRefChange();
    };
    return RefWatcher;
}();
module.exports.RefWatcher = $d7c762a3ad6d7260$var$RefWatcher;

});

parcelRegister("7mcBr", function(module, exports) {
"use strict";
var $55b45d2339b48f9b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Root = void 0;

var $iqyiC = parcelRequire("iqyiC");

var $joGvE = parcelRequire("joGvE");
var $55b45d2339b48f9b$var$Root = /** @class */ function(_super) {
    $55b45d2339b48f9b$var$__extends(Root, _super);
    function Root(hook, divClass) {
        if (divClass === void 0) divClass = "";
        var _a;
        var _this = _super.call(this, divClass) || this;
        (_a = (0, $iqyiC.$)(hook !== null && hook !== void 0 ? hook : Root.Hook)) === null || _a === void 0 || _a.Append(_this.Element);
        return _this;
    }
    Root.Hook = "body";
    return Root;
}($joGvE.Div);
module.exports.Root = $55b45d2339b48f9b$var$Root;

});

parcelRegister("gkD0R", function(module, exports) {
"use strict";
var $be3cc6b835bdc563$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Span = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $be3cc6b835bdc563$var$Span = /** @class */ function(_super) {
    $be3cc6b835bdc563$var$__extends(Span, _super);
    function Span(text) {
        var _this = _super.call(this, "span") || this;
        if (text) _this.Text(text);
        return _this;
    }
    Span.Name = "Span";
    return Span;
}($aKtiT.ComponentBase);
module.exports.Span = $be3cc6b835bdc563$var$Span;

});

parcelRegister("aUfnT", function(module, exports) {
"use strict";
var $7f0b115c103f2e8e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pre = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $7f0b115c103f2e8e$var$Pre = /** @class */ function(_super) {
    $7f0b115c103f2e8e$var$__extends(Pre, _super);
    function Pre() {
        return _super.call(this, "pre") || this;
    }
    return Pre;
}($aKtiT.ComponentBase);
module.exports.Pre = $7f0b115c103f2e8e$var$Pre;

});

parcelRegister("1h8RE", function(module, exports) {
"use strict";
var $0ede4142b3defe6a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoWidthTwoColumns = void 0;

var $joGvE = parcelRequire("joGvE");
var $0ede4142b3defe6a$var$AutoWidthTwoColumns = /** @class */ function(_super) {
    $0ede4142b3defe6a$var$__extends(AutoWidthTwoColumns, _super);
    function AutoWidthTwoColumns() {
        var _this = _super.call(this, "tf-stretch") || this;
        _this.LeftColumn = new $joGvE.Div("tf-min-width-column");
        _this.RightColumn = new $joGvE.Div("tf-wide-column");
        _this.Append(_this.LeftColumn);
        _this.Append(_this.RightColumn);
        return _this;
    }
    AutoWidthTwoColumns.prototype.Show = function() {
        _super.prototype.Show.call(this, "inline-flex");
        return this;
    };
    return AutoWidthTwoColumns;
}($joGvE.Div);
module.exports.AutoWidthTwoColumns = $0ede4142b3defe6a$var$AutoWidthTwoColumns;

});

parcelRegister("gOMMX", function(module, exports) {
"use strict";
var $c3e7294051227311$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TwinColumns = void 0;

var $joGvE = parcelRequire("joGvE");
var $c3e7294051227311$var$TwinColumns = /** @class */ function(_super) {
    $c3e7294051227311$var$__extends(TwinColumns, _super);
    function TwinColumns() {
        var _this = _super.call(this) || this;
        _this.LeftColumn = new $joGvE.Div().HalfWidth().InlineBlock().Style("vertical-align: top");
        _this.RightColumn = new $joGvE.Div().HalfWidth().InlineBlock().Style("vertical-align: top");
        _this.Append(_this.LeftColumn);
        _this.Append(_this.RightColumn);
        return _this;
    }
    TwinColumns.prototype.AppendToLeft = function() {
        var _a;
        var content = [];
        for(var _i = 0; _i < arguments.length; _i++)content[_i] = arguments[_i];
        (_a = this.LeftColumn).Append.apply(_a, content);
        return this;
    };
    TwinColumns.prototype.AppendToRight = function() {
        var _a;
        var content = [];
        for(var _i = 0; _i < arguments.length; _i++)content[_i] = arguments[_i];
        (_a = this.RightColumn).Append.apply(_a, content);
        return this;
    };
    TwinColumns.prototype.Show = function() {
        _super.prototype.Show.call(this);
        return this;
    };
    return TwinColumns;
}($joGvE.Div);
module.exports.TwinColumns = $c3e7294051227311$var$TwinColumns;

});

parcelRegister("hPtm1", function(module, exports) {
"use strict";
var $cfadf83aa2467e9d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TwoFloatingColumns = void 0;

var $joGvE = parcelRequire("joGvE");
var $cfadf83aa2467e9d$var$TwoFloatingColumns = /** @class */ function(_super) {
    $cfadf83aa2467e9d$var$__extends(TwoFloatingColumns, _super);
    function TwoFloatingColumns() {
        var _this = _super.call(this) || this;
        _this.LeftColumn = new $joGvE.Div() //.Style("border: 3px dotted green")
        .FloatLeft(); //.Background("lightblue")
        _this.RightColumn = new $joGvE.Div() //.Style("border: 3px dotted blue")
        .FloatLeft(); //.Border(1, "lightyellow")
        _this.ClearBoth();
        _this.Append(_this.LeftColumn);
        _this.Append(_this.RightColumn);
        return _this;
    }
    TwoFloatingColumns.prototype.Show = function() {
        _super.prototype.Show.call(this);
        return this;
    };
    return TwoFloatingColumns;
}($joGvE.Div);
module.exports.TwoFloatingColumns = $cfadf83aa2467e9d$var$TwoFloatingColumns;

});

parcelRegister("2S24U", function(module, exports) {
"use strict";
var $21723c9d67724d86$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Button = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $6wI3m = parcelRequire("6wI3m");
var $21723c9d67724d86$var$Button = /** @class */ function(_super) {
    $21723c9d67724d86$var$__extends(Button, _super);
    function Button(label, onClick) {
        if (label === void 0) label = "Button";
        var _this = _super.call(this, "button") || this;
        _this.label = label;
        _this.InitialLabel = "";
        if (label instanceof $6wI3m.Ref) _this.InitialLabel = label.value;
        else _this.InitialLabel = label;
        _this.Class(Button.DefaultCssClasses);
        if (onClick) _this.OnClick(function() {
            return onClick(_this);
        });
        _this.Label(_this.label);
        return _this;
    }
    Button.prototype.Label = function(label, transform) {
        var _this = this;
        this.React(label, function(v) {
            return _this.element.innerHTML = transform ? transform(v) : v.toString();
        });
        return this;
    };
    Button.prototype.RestoreInitialLabel = function() {
        return this.Label(this.InitialLabel);
    };
    Button.Name = "Button";
    Button.DefaultCssClasses = "";
    return Button;
}($aKtiT.ComponentBase);
module.exports.Button = $21723c9d67724d86$var$Button;

});

parcelRegister("5PIlt", function(module, exports) {
"use strict";
var $43f41d38fca657e1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Link = void 0;

var $2s69t = parcelRequire("2s69t");
var $43f41d38fca657e1$var$Link = /** @class */ function(_super) {
    $43f41d38fca657e1$var$__extends(Link, _super);
    function Link(label, url, openInNewCard) {
        if (openInNewCard === void 0) openInNewCard = false;
        var _this = _super.call(this, "a") || this;
        _this.React(label, function(v) {
            return _this.Label(v);
        });
        _this.React(url, function(v) {
            return _this.Url(v);
        });
        if (url === undefined && typeof label === "string" && label.startsWith("http")) _this.Url(label);
        if (openInNewCard) _this.OpenInNewCard();
        return _this;
    }
    Link.prototype.Label = function(label) {
        this.Text(label);
        return this;
    };
    Link.prototype.Url = function(url) {
        this.Attribute("href", url);
        return this;
    };
    Link.prototype.OpenInNewCard = function() {
        this.Attribute("target", "_blank");
        return this;
    };
    Link.prototype.DoNotOpenInNewCard = function() {
        this.RemoveAttribute("target");
        return this;
    };
    Link.prototype.NoDecorationOnHover = function() {
        this.Style("text-decoration: none");
        return this;
    };
    Link.Name = "Link";
    return Link;
}($2s69t.ComponentBase);
module.exports.Link = $43f41d38fca657e1$var$Link;

});

parcelRegister("eONQW", function(module, exports) {
"use strict";
var $ac9c67f290a10e7d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Image = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $8PO3e = parcelRequire("8PO3e");

var $d5iKF = parcelRequire("d5iKF");

var $CJCrq = parcelRequire("CJCrq");
var $ac9c67f290a10e7d$var$Image = /** @class */ function(_super) {
    $ac9c67f290a10e7d$var$__extends(Image, _super);
    function Image(src, alt) {
        var _this = _super.call(this, "img") || this;
        _this.Info = new $d5iKF.ImageInfo(); // Do not use directly! Use OnInfoReady event instead
        _this.OnInfoReady = new $8PO3e.HandlersCollection();
        _this.blobUrl = "";
        _this.busy = false;
        if (src instanceof Blob) _this.FromBlob(src);
        else if (src) _this.React(src, function(v) {
            return v && _this.Src(v);
        });
        if (alt) _this.React(alt, function(v) {
            return _this.Alt(v);
        });
        _this.element.onload = function() {
            _this.Info.Width = _this.element.naturalWidth;
            _this.Info.Height = _this.element.naturalHeight;
            _this.OnInfoReady.Call(_this.Info);
            if (_this.Info.LoadMethod == $CJCrq.ImageSource.Blob) URL.revokeObjectURL(_this.blobUrl); // For memory clean up
            _this.busy = false;
        };
        return _this;
    }
    Image.prototype.FromBlob = function(blob) {
        if (this.busy) return this;
        this.busy = true;
        this.blobUrl = URL.createObjectURL(blob);
        this.Attribute("src", this.blobUrl);
        this.Info.LoadMethod = $CJCrq.ImageSource.Blob;
        this.Info.Size = blob.size;
        return this;
    };
    Image.prototype.Src = function(src) {
        if (!src) return this;
        if (this.busy) return this;
        this.busy = true;
        this.Attribute("src", src);
        this.Info.LoadMethod = $CJCrq.ImageSource.Http;
        this.Info.Size = -1;
        return this;
    };
    Image.prototype.GetAlt = function() {
        var _a;
        return (_a = this.GetAttribute("alt")) !== null && _a !== void 0 ? _a : "";
    };
    Object.defineProperty(Image.prototype, "IsEmpty", {
        get: function() {
            return this.GetAttribute("src") === "";
        },
        enumerable: false,
        configurable: true
    });
    Image.prototype.FromBase64 = function(base64) {
        if (!base64) return this;
        if (this.busy) return this;
        this.busy = true;
        var base64prefix = "data:image/png;base64,";
        if (!base64.startsWith(base64prefix)) base64 = base64prefix + base64;
        this.Attribute("src", base64);
        this.Info.LoadMethod = $CJCrq.ImageSource.Base64;
        this.Info.Size = this.Base64Size;
        return this;
    };
    Object.defineProperty(Image.prototype, "IsBase64", {
        get: function() {
            var _a, _b;
            return (_b = (_a = this.GetAttribute("src")) === null || _a === void 0 ? void 0 : _a.startsWith("data:image")) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Image.prototype, "IsHttp", {
        get: function() {
            var _a, _b;
            return (_b = (_a = this.GetAttribute("src")) === null || _a === void 0 ? void 0 : _a.startsWith("http")) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    Image.prototype.Load = function(source) {
        if (source instanceof Blob) this.FromBlob(source);
        else if (this.IsHttp) this.Src(source);
        else if (this.IsBase64) this.FromBase64(source);
        return this;
    };
    Image.prototype.Alt = function(description) {
        if (description) this.Attribute("alt", description);
        return this;
    };
    Image.prototype.ObjectPosition = function(xAxis, yAxis) {
        var _this = this;
        this.React(xAxis, function(x) {
            return _this.Style("object-position", "".concat(x, "% ").concat(yAxis.value, "%"));
        });
        this.React(yAxis, function(y) {
            return _this.Style("object-position", "".concat(xAxis.value, "% ").concat(y, "%"));
        });
        return this;
    };
    Image.prototype.ObjectFit = function(fit) {
        var _this = this;
        this.React(fit, function(x) {
            return _this.Style("object-fit", x);
        });
        return this;
    };
    Object.defineProperty(Image.prototype, "SourceInfo", {
        get: function() {
            var src = this.GetAttribute("src");
            if (!src) return $CJCrq.ImageSource.Unset;
            if (src.startsWith("http")) return $CJCrq.ImageSource.Http;
            if (src.startsWith("data:image")) return $CJCrq.ImageSource.Base64;
            return $CJCrq.ImageSource.Unset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Image.prototype, "Base64Size", {
        get: function() {
            var base64 = this.GetAttribute("src");
            var size = base64.length * (3 / 4);
            return Number(size);
        },
        enumerable: false,
        configurable: true
    });
    Image.Name = "Image";
    return Image;
}($aKtiT.ComponentBase);
module.exports.Image = $ac9c67f290a10e7d$var$Image;

});
parcelRegister("d5iKF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImageInfo = void 0;

var $CJCrq = parcelRequire("CJCrq");
var $986a49b1f35547d3$var$ImageInfo = /** @class */ function() {
    function ImageInfo() {
        this.Width = 0;
        this.Height = 0;
        this.Size = 0;
        this.LoadMethod = $CJCrq.ImageSource.Unset;
    }
    Object.defineProperty(ImageInfo.prototype, "AsString", {
        get: function() {
            return "".concat(this.Width, "\xd7").concat(this.Height, "px, ").concat((this.Size / 1024).toFixed(1), "kb");
        },
        enumerable: false,
        configurable: true
    });
    return ImageInfo;
}();
module.exports.ImageInfo = $986a49b1f35547d3$var$ImageInfo;

});
parcelRegister("CJCrq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImageSource = void 0;
var $0746efb636b3d380$var$ImageSource;
(function(ImageSource) {
    ImageSource["Unset"] = "Unset";
    ImageSource["Http"] = "http";
    ImageSource["Base64"] = "base64";
    ImageSource["Blob"] = "blob";
})($0746efb636b3d380$var$ImageSource || (module.exports.ImageSource = $0746efb636b3d380$var$ImageSource = {}));

});



parcelRegister("iuQir", function(module, exports) {
"use strict";
var $d7739854c757ee07$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d7739854c757ee07$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d7739854c757ee07$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Canvas = void 0;

var $2s69t = parcelRequire("2s69t");
var $d7739854c757ee07$var$Canvas = /** @class */ function(_super) {
    $d7739854c757ee07$var$__extends(Canvas, _super);
    function Canvas() {
        var _this = _super.call(this, "canvas") || this;
        _this.busy = false;
        return _this;
    }
    Object.defineProperty(Canvas.prototype, "Context", {
        get: function() {
            var context = this.element.getContext("2d", {
                alpha: false,
                desynchronized: true
            });
            if (!context) throw new Error("Failed to get context");
            context.imageSmoothingEnabled = false;
            return context;
        },
        enumerable: false,
        configurable: true
    });
    Canvas.prototype.Draw = function(picture) {
        return $d7739854c757ee07$var$__awaiter(this, void 0, void 0, function() {
            var bitmap;
            return $d7739854c757ee07$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.busy) return [
                            2 /*return*/ 
                        ];
                        this.busy = true;
                        return [
                            4 /*yield*/ ,
                            createImageBitmap(picture)
                        ];
                    case 1:
                        bitmap = _a.sent();
                        this.Context.clearRect(0, 0, bitmap.width, bitmap.height);
                        this.element.width = bitmap.width;
                        this.element.height = bitmap.height;
                        this.Context.drawImage(bitmap, 0, 0);
                        bitmap.close();
                        this.busy = false;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Canvas.Name = "Canvas";
    return Canvas;
}($2s69t.ComponentBase);
module.exports.Canvas = $d7739854c757ee07$var$Canvas;

});

parcelRegister("8a2qt", function(module, exports) {
"use strict";
var $5f1123a90b240cf7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClickableImage = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $eONQW = parcelRequire("eONQW");
var $5f1123a90b240cf7$var$ClickableImage = /** @class */ function(_super) {
    $5f1123a90b240cf7$var$__extends(ClickableImage, _super);
    function ClickableImage(src, url, alt) {
        var _this = _super.call(this, "a") || this;
        _this.CursorPointer();
        _this.image = new $eONQW.Image(src);
        _this.Append(_this.image);
        if (url) _this.Url(url);
        if (alt) _this.Alt(alt);
        return _this;
    }
    ClickableImage.prototype.Src = function(src) {
        return this.Attribute("src", src);
    };
    ClickableImage.prototype.Url = function(url) {
        return this.Attribute("href", url);
    };
    ClickableImage.prototype.Alt = function(description) {
        return this.Attribute("alt", description);
    };
    ClickableImage.Name = "ClickableImage";
    return ClickableImage;
}($aKtiT.ComponentBase);
module.exports.ClickableImage = $5f1123a90b240cf7$var$ClickableImage;

});

parcelRegister("gyVEa", function(module, exports) {
"use strict";
var $c0ec89c624c3e597$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NewLine = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $c0ec89c624c3e597$var$NewLine = /** @class */ function(_super) {
    $c0ec89c624c3e597$var$__extends(NewLine, _super);
    function NewLine() {
        return _super.call(this, "br") || this;
    }
    return NewLine;
}($aKtiT.ComponentBase);
module.exports.NewLine = $c0ec89c624c3e597$var$NewLine;

});

parcelRegister("gwSD4", function(module, exports) {
"use strict";
var $c08a02bb9f008e92$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Line = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $c08a02bb9f008e92$var$Line = /** @class */ function(_super) {
    $c08a02bb9f008e92$var$__extends(Line, _super);
    function Line() {
        var _this = _super.call(this, "hr") || this;
        _this.ClearBoth();
        return _this;
    }
    return Line;
}($aKtiT.ComponentBase);
module.exports.Line = $c08a02bb9f008e92$var$Line;

});

parcelRegister("bQA5y", function(module, exports) {
"use strict";
var $8a008b807e25ba4c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Paragraph = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $8a008b807e25ba4c$var$Paragraph = /** @class */ function(_super) {
    $8a008b807e25ba4c$var$__extends(Paragraph, _super);
    function Paragraph(klass) {
        var _this = _super.call(this, "p") || this;
        _this.Class(klass);
        return _this;
    }
    return Paragraph;
}($aKtiT.ComponentBase);
module.exports.Paragraph = $8a008b807e25ba4c$var$Paragraph;

});

parcelRegister("8fPhC", function(module, exports) {
"use strict";
var $6027813168e64ccb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnorderedList = void 0;

var $2s69t = parcelRequire("2s69t");

var $2MZa4 = parcelRequire("2MZa4");
var $6027813168e64ccb$var$UnorderedList = /** @class */ function(_super) {
    $6027813168e64ccb$var$__extends(UnorderedList, _super);
    function UnorderedList(initialItems) {
        var _this = _super.call(this, "ul") || this;
        if (initialItems && initialItems instanceof Array) _this.LoadItems(initialItems);
        if (initialItems && initialItems instanceof $2s69t.Collection) initialItems.OnChange(function(items) {
            return _this.LoadItems(items);
        });
        return _this;
    }
    UnorderedList.prototype.Add = function(item) {
        this.Append(new $2MZa4.ListItem(item));
        return this;
    };
    UnorderedList.prototype.LoadItems = function(items) {
        var _this = this;
        this.Clear();
        items.forEach(function(i) {
            return _this.Add(i);
        });
        return this;
    };
    UnorderedList.Name = "UnorderedList";
    return UnorderedList;
}($2s69t.ComponentBase);
module.exports.UnorderedList = $6027813168e64ccb$var$UnorderedList;

});
parcelRegister("2MZa4", function(module, exports) {
"use strict";
var $207f81d6353d7e92$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListItem = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $207f81d6353d7e92$var$ListItem = /** @class */ function(_super) {
    $207f81d6353d7e92$var$__extends(ListItem, _super);
    function ListItem(item) {
        var _this = _super.call(this, "li") || this;
        _this.Append(item);
        return _this;
    }
    return ListItem;
}($aKtiT.ComponentBase);
module.exports.ListItem = $207f81d6353d7e92$var$ListItem;

});


parcelRegister("2yjo2", function(module, exports) {
"use strict";
var $1dbdcb8929a6339d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedList = void 0;

var $2s69t = parcelRequire("2s69t");

var $2MZa4 = parcelRequire("2MZa4");
var $1dbdcb8929a6339d$var$OrderedList = /** @class */ function(_super) {
    $1dbdcb8929a6339d$var$__extends(OrderedList, _super);
    function OrderedList(initialItems, type) {
        if (type === void 0) type = "1";
        var _this = _super.call(this, "ol") || this;
        _this.Attribute("type", type);
        if (initialItems) _this.LoadItems(initialItems);
        return _this;
    }
    OrderedList.prototype.Add = function(item) {
        this.Append(new $2MZa4.ListItem(item));
        return this;
    };
    OrderedList.prototype.LoadItems = function(items) {
        var _this = this;
        this.Clear();
        items.forEach(function(i) {
            return _this.Add(i);
        });
        return this;
    };
    OrderedList.Name = "OrderedList";
    return OrderedList;
}($2s69t.ComponentBase);
module.exports.OrderedList = $1dbdcb8929a6339d$var$OrderedList;

});

parcelRegister("9ewxt", function(module, exports) {
"use strict";
var $6b8ea9689e3c7664$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionViewer = void 0;

var $joGvE = parcelRequire("joGvE");
var $6b8ea9689e3c7664$var$CollectionViewer = /** @class */ function(_super) {
    $6b8ea9689e3c7664$var$__extends(CollectionViewer, _super);
    function CollectionViewer(collection) {
        var _this = _super.call(this) || this;
        collection.OnChange(function(v) {
            _this.Clear().Append(JSON.stringify(v));
        }, true);
        return _this;
    }
    return CollectionViewer;
}($joGvE.Div);
module.exports.CollectionViewer = $6b8ea9689e3c7664$var$CollectionViewer;

});

parcelRegister("4TgXd", function(module, exports) {
"use strict";
var $38f97332e8486431$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionPrinter = void 0;

var $6IcxB = parcelRequire("6IcxB");

var $8y6Fd = parcelRequire("8y6Fd");

var $joGvE = parcelRequire("joGvE");
var $38f97332e8486431$var$CollectionPrinter = /** @class */ function(_super) {
    $38f97332e8486431$var$__extends(CollectionPrinter, _super);
    function CollectionPrinter(data, itemPrinter, options) {
        if (options === void 0) options = {};
        var _this = _super.call(this) || this;
        if (data && data instanceof $6IcxB.Collection) data = new $8y6Fd.CollectionView(data).Refresh();
        data.OnChange(function(items) {
            _this.Clear();
            if (options.reverse == true) _this.Prepend.apply(_this, items.map(function(item) {
                return itemPrinter(item);
            }));
            else _this.Append.apply(_this, items.map(function(item) {
                return itemPrinter(item);
            }));
        }, true);
        return _this;
    }
    return CollectionPrinter;
}($joGvE.Div);
module.exports.CollectionPrinter = $38f97332e8486431$var$CollectionPrinter;

});

parcelRegister("8UMl5", function(module, exports) {
"use strict";
var $67d90cd94994eb0c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $67d90cd94994eb0c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $67d90cd94994eb0c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CopyIcon = void 0;

var $dv39x = parcelRequire("dv39x");
/*
    NIE WIEM O CO KAMAN ALE KIEDY TA KLASA DZIEDZICZY PO Link TO DOSTAJE:
    Cannot access 'Link' before initialization
    CO CIEKAWE KIEDY ZADEKLARUJE SIE TE KLASE ZARAZ POD Link (W PLIKU Link.ts) TO WSZYSTKO DZIAŁA!
    LUB KIEDY ZROBI SIĘ DOKŁADNĄ KOPIE Link I TYLKO INACZEJ NAZWIE TO TEŻ DZIAŁA!
    ŻADNE CZYSZCZENIE, ZMIENIANIE IMPORTÓW, REINSTALACJA NARZĘDZI NIE POMAGA. NIE WIEM O CO CHODZI :(
*/ var $67d90cd94994eb0c$var$CopyIcon = /** @class */ function(_super) {
    $67d90cd94994eb0c$var$__extends(CopyIcon, _super); // 'extends A' because when trying to 'extend Link' it throws 'Cannot access 'Link' before initialization', which does not make sense!!!
    function CopyIcon(value, icon) {
        if (icon === void 0) icon = "\uD83D\uDCCB";
        var _this = _super.call(this, icon) || this;
        _this.MarginLeft(8).OnClick(function() {
            return $67d90cd94994eb0c$var$__awaiter(_this, void 0, void 0, function() {
                return $67d90cd94994eb0c$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.CopyToClipboard(value)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        });
        return _this;
    }
    CopyIcon.prototype.CopyToClipboard = function(textToCopy) {
        // navigator clipboard api needs a secure context (https)
        if (navigator.clipboard && window.isSecureContext) return new Promise(function(res, rej) {
            // navigator clipboard api method'
            navigator.clipboard.writeText(textToCopy);
            res("Success");
        });
        else {
            // text area method
            var textArea_1 = document.createElement("textarea");
            textArea_1.value = textToCopy;
            // make the textarea out of viewport
            textArea_1.style.position = "fixed";
            textArea_1.style.left = "-999999px";
            textArea_1.style.top = "-999999px";
            document.body.appendChild(textArea_1);
            textArea_1.focus();
            textArea_1.select();
            return new Promise(function(res, rej) {
                // here the magic happens
                document.execCommand("copy") ? res("Copy to clipboard succeeded") : rej("Copy to clipboard failed");
                textArea_1.remove();
            });
        }
    };
    return CopyIcon;
}($dv39x.A // 'extends A' because when trying to 'extend Link' it throws 'Cannot access 'Link' before initialization', which does not make sense!!!
);
module.exports.CopyIcon = $67d90cd94994eb0c$var$CopyIcon;

});
parcelRegister("dv39x", function(module, exports) {
"use strict";
var $9d409db7c74604f2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.A = void 0;

var $2s69t = parcelRequire("2s69t");
var $9d409db7c74604f2$var$A = /** @class */ function(_super) {
    $9d409db7c74604f2$var$__extends(A, _super);
    function A(label) {
        var _this = _super.call(this, "a") || this;
        _this.Text(label);
        return _this;
    }
    A.Name = "A";
    return A;
}($2s69t.ComponentBase);
module.exports.A = $9d409db7c74604f2$var$A;

});


parcelRegister("7LfyP", function(module, exports) {
"use strict";
var $5a68fe3a0b69bef6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tabs = void 0;

var $2s69t = parcelRequire("2s69t");

var $gYRyj = parcelRequire("gYRyj");
var $5a68fe3a0b69bef6$var$Tabs = /** @class */ function(_super) {
    $5a68fe3a0b69bef6$var$__extends(Tabs, _super);
    function Tabs(ref) {
        if (ref === void 0) ref = new $2s69t.Ref("");
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.switches = new $gYRyj.TabsSwitcher(_this.ref);
        _this.content = new $2s69t.DestroyingContentSwitcher(_this.ref);
        _this.Append(_this.switches, _this.content);
        return _this;
    }
    Tabs.prototype.Add = function(label, content) {
        this.switches.Add(label);
        this.content.AddContent(label, content);
        return this;
    };
    Tabs.Name = "Tabs";
    return Tabs;
}($2s69t.Div);
module.exports.Tabs = $5a68fe3a0b69bef6$var$Tabs;

});
parcelRegister("gYRyj", function(module, exports) {
"use strict";
var $c5cbca57d8bc3bdc$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TabsSwitcher = void 0;

var $2s69t = parcelRequire("2s69t");
var $c5cbca57d8bc3bdc$var$TabsSwitcher = /** @class */ function(_super) {
    $c5cbca57d8bc3bdc$var$__extends(TabsSwitcher, _super);
    function TabsSwitcher(ref) {
        var _this = _super.call(this, "ul", ref) || this;
        _this.switches = {};
        _this.Attribute("uk-tab");
        _this.Class("uk-tab");
        return _this;
    }
    TabsSwitcher.prototype.Refresh = function() {
        var _this = this;
        this.switches.Keys().forEach(function(activator) {
            var cmp = _this.switches[activator];
            if (_this.ref.value === activator) cmp.AddClass("uk-active");
            else cmp.RemoveClass("uk-active");
        });
    };
    TabsSwitcher.prototype.Add = function(label) {
        var _this = this;
        var item = new $2s69t.ListItem(new $2s69t.Link(label, "#"));
        this.switches[label] = item;
        item.OnClick(function() {
            return _this.ref.value = label;
        });
        if (this.ref.value == label) item.AddClass("uk-active");
        if (this.ref.value == "") this.ref.value = label;
        this.Append(item);
        return this;
    };
    TabsSwitcher.Name = "TabsSwitcher";
    return TabsSwitcher;
}($2s69t.RefComponentBase);
module.exports.TabsSwitcher = $c5cbca57d8bc3bdc$var$TabsSwitcher;

});


parcelRegister("hIO35", function(module, exports) {
"use strict";
var $ce6d5e5be4be20de$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NonRefEditableLabel = module.exports.EditableLabel = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $gkD0R = parcelRequire("gkD0R");

var $3B1VX = parcelRequire("3B1VX");

var $etGN3 = parcelRequire("etGN3");
var $ce6d5e5be4be20de$var$EditableLabel = /** @class */ function(_super) {
    $ce6d5e5be4be20de$var$__extends(EditableLabel, _super);
    function EditableLabel(ref) {
        var _this = _super.call(this, "div") || this;
        _this.ref = ref;
        _this.valueBeforeEdit = "";
        _this.label = new $3B1VX.Text(ref).CursorPointer().Show().OnClick(function() {
            _this.EditMode();
        });
        _this.textInput = new $etGN3.TextInput(ref);
        _this.textInput.OnBlur(function() {
            return _this.EndOfEdit();
        }).OnEnterKeyPressed(function() {
            return _this.EndOfEdit();
        }).Hide();
        _this.Append(_this.label);
        _this.Append(_this.textInput);
        return _this;
    }
    EditableLabel.prototype.EditMode = function() {
        this.valueBeforeEdit = this.ref.value;
        var labelWidth = getComputedStyle(this.label.Element).width;
        var w = +labelWidth.replace("px", "");
        if (w < 100) w += 32;
        this.label.Hide();
        this.textInput.Show().Width(w).Padding(2, 6).Focus();
    };
    Object.defineProperty(EditableLabel.prototype, "IsEditMode", {
        get: function() {
            return this.textInput.IsVisible();
        },
        enumerable: false,
        configurable: true
    });
    EditableLabel.prototype.ToggleEditMode = function() {
        if (this.IsEditMode) this.CloseEditMode();
        else this.EditMode();
        return this;
    };
    EditableLabel.prototype.OpenEditMode = function() {
        this.EditMode();
        return this;
    };
    EditableLabel.prototype.CloseEditMode = function() {
        this.EndOfEdit();
        return this;
    };
    EditableLabel.prototype.LabelConfig = function(config) {
        config(this.label);
        return this;
    };
    EditableLabel.prototype.TextInputConfig = function(config) {
        config(this.textInput);
        return this;
    };
    EditableLabel.prototype.OnEditEnd = function(callback) {
        this.editEnd = callback;
        return this;
    };
    EditableLabel.prototype.EndOfEdit = function() {
        var _a;
        if (!this.textInput.IsVisible()) return; // To prevent double call
        this.textInput.Hide();
        this.label.Show();
        (_a = this.editEnd) === null || _a === void 0 || _a.call(this, this.valueBeforeEdit, this.ref.value);
    };
    EditableLabel.prototype.DefaultText = function(text) {
        this.label.DefaultText(text);
        return this;
    };
    EditableLabel.prototype.Placeholder = function(placeholder) {
        this.textInput.Placeholder(placeholder);
        return this;
    };
    EditableLabel.prototype.Style = function(prop, val) {
        this.label.Style(prop, val);
        this.textInput.Style(prop, val);
        return this;
    };
    EditableLabel.Name = "EditableLabel";
    return EditableLabel;
}($aKtiT.ComponentBase);
module.exports.EditableLabel = $ce6d5e5be4be20de$var$EditableLabel;
var $ce6d5e5be4be20de$var$NonRefEditableLabel = /** @class */ function(_super) {
    $ce6d5e5be4be20de$var$__extends(NonRefEditableLabel, _super);
    function NonRefEditableLabel(value, onChange) {
        var _this = _super.call(this, "div") || this;
        _this.value = "";
        _this.label = new $gkD0R.Span(value);
        _this.label.Show().OnClick(function() {
            var labelWidth = getComputedStyle(_this.label.Element).width;
            var w = +labelWidth.replace("px", "");
            if (w < 100) w += 20;
            _this.label.Hide();
            _this.textInput.Show().Width(w).Padding(2, 6).Focus();
        });
        _this.textInput = new $etGN3.NonRefTextInput(value, function(v) {
            _this.value = v;
            onChange(v);
        });
        _this.textInput.OnBlur(function() {
            _this.textInput.Hide();
            _this.label.Show();
            _this.label.Text(_this.value);
        }).OnEnterKeyPressed(function() {
            _this.textInput.Hide();
            _this.label.Show();
            _this.label.Text(_this.value);
        }).Hide();
        _this.Append(_this.label);
        _this.Append(_this.textInput);
        return _this;
    }
    NonRefEditableLabel.prototype.Placeholder = function(placeholder) {
        this.textInput.Placeholder(placeholder);
        return this;
    };
    NonRefEditableLabel.prototype.Style = function(prop, val) {
        this.label.Style(prop, val);
        this.textInput.Style(prop, val);
        return this;
    };
    return NonRefEditableLabel;
}($aKtiT.ComponentBase);
module.exports.NonRefEditableLabel = $ce6d5e5be4be20de$var$NonRefEditableLabel;

});
parcelRegister("etGN3", function(module, exports) {
"use strict";
var $a8a4f76189473a77$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NonRefTextInput = module.exports.TextInput = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");

var $8PO3e = parcelRequire("8PO3e");
var $a8a4f76189473a77$var$TextInput = /** @class */ function(_super) {
    $a8a4f76189473a77$var$__extends(TextInput, _super);
    function TextInput(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = _super.call(this, "input", ref) || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Class(TextInput.DefaultCssClasses);
        _this.element.addEventListener("input", function(e) {
            _this.ref.value = e.target.value;
            _this.onChange.Call(_this.ref.value, e);
        });
        _this.Refresh();
        return _this;
    }
    TextInput.prototype.Placeholder = function(placeholderText) {
        var _this = this;
        if (placeholderText) this.React(placeholderText, function(v) {
            return _this.element.setAttribute("placeholder", v);
        });
        return this;
    };
    TextInput.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    TextInput.prototype.Refresh = function() {
        this.element.value = this.ref.value;
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    TextInput.Name = "TextInput";
    TextInput.DefaultCssClasses = "";
    return TextInput;
}($k6KGm.RefComponentBase);
module.exports.TextInput = $a8a4f76189473a77$var$TextInput;
var $a8a4f76189473a77$var$NonRefTextInput = /** @class */ function(_super) {
    $a8a4f76189473a77$var$__extends(NonRefTextInput, _super);
    function NonRefTextInput(value, onChange) {
        var _this = _super.call(this, "input") || this;
        _this.value = value;
        _this.Class($a8a4f76189473a77$var$TextInput.DefaultCssClasses);
        _this.element.addEventListener("input", function(e) {
            // this.ref.SetValue(e.target.value, this);
            onChange(e.target.value);
        });
        _this.Refresh();
        return _this;
    }
    NonRefTextInput.prototype.Placeholder = function(placeholder) {
        this.element.setAttribute("placeholder", placeholder);
        return this;
    };
    NonRefTextInput.prototype.Refresh = function() {
        this.element.value = this.value;
    // if (this.showThatChanged)
    //     this.ref.HasChanged
    //         ? this.element.classList.add("tf-value-changed")
    //         : this.element.classList.remove("tf-value-changed");
    };
    NonRefTextInput.DefaultCssClasses = "";
    return NonRefTextInput;
}($aKtiT.ComponentBase);
module.exports.NonRefTextInput = $a8a4f76189473a77$var$NonRefTextInput;

});


parcelRegister("jCElc", function(module, exports) {
"use strict";
var $e490dbcb2c83c831$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PasswordInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $etGN3 = parcelRequire("etGN3");
var $e490dbcb2c83c831$var$PasswordInput = /** @class */ function(_super) {
    $e490dbcb2c83c831$var$__extends(PasswordInput, _super);
    function PasswordInput(passwordRef) {
        if (passwordRef === void 0) passwordRef = new $6wI3m.Ref("");
        var _this = _super.call(this, "") || this;
        _this.passwordRef = passwordRef;
        _this.showPasswordBtn = new $gkD0R.Span("\uD83D\uDC40").PositionAbsolute().Top(8).Right(6).Opacity(0.5).CursorPointer().Hide();
        _this.PositionRelative();
        _this.passwordInput = new $etGN3.TextInput(_this.passwordRef).Class($etGN3.TextInput.DefaultCssClasses).Attribute("type", "password");
        _this.Append(_this.passwordInput, _this.showPasswordBtn);
        return _this;
    }
    PasswordInput.prototype.SetupInput = function(setup) {
        setup(this.passwordInput);
        return this;
    };
    PasswordInput.prototype.SetupButton = function(setup) {
        setup(this.showPasswordBtn);
        return this;
    };
    PasswordInput.prototype.StyleInput = function(style) {
        this.passwordInput.Style(style);
        return this;
    };
    PasswordInput.prototype.StyleButton = function(style) {
        this.showPasswordBtn.Style(style);
        return this;
    };
    PasswordInput.prototype.ShowPasswordOnTouch = function() {
        var _this = this;
        this.showPasswordBtn.Show();
        this.showPasswordBtn.On([
            "mousedown",
            "touchstart"
        ], function() {
            _this.passwordInput.Attribute("type", "text");
            _this.showPasswordBtn.Opacity(1);
        }).On([
            "mouseup",
            "touchend"
        ], function() {
            _this.passwordInput.Attribute("type", "password");
            _this.showPasswordBtn.Opacity(0.5);
        });
        return this;
    };
    PasswordInput.prototype.TogglePasswordView = function() {
        var _this = this;
        this.showPasswordBtn.Show();
        var passwordVisible = new $6wI3m.Ref(false);
        this.showPasswordBtn.OnClick(function() {
            passwordVisible.value = !passwordVisible.value;
            _this.passwordInput.Attribute("type", passwordVisible.value ? "text" : "password");
            _this.showPasswordBtn.Opacity(passwordVisible.value ? 1 : 0.5);
        });
        return this;
    };
    PasswordInput.prototype.Placeholder = function(placeholder) {
        var _this = this;
        this.React(placeholder, function(v) {
            return _this.passwordInput.Placeholder(v);
        });
        return this;
    };
    PasswordInput.Name = "PasswordInput";
    return PasswordInput;
}($joGvE.Div);
module.exports.PasswordInput = $e490dbcb2c83c831$var$PasswordInput;

});

parcelRegister("4ytZ3", function(module, exports) {
"use strict";
var $3511988913dff7b1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NumberInput = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $6wI3m = parcelRequire("6wI3m");
var $3511988913dff7b1$var$NumberInput = /** @class */ function(_super) {
    $3511988913dff7b1$var$__extends(NumberInput, _super);
    function NumberInput(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref(0);
        var _this = _super.call(this, "input", ref) || this;
        _this.min = undefined;
        _this.max = undefined;
        _this.Class(NumberInput.DefaultCssClasses);
        _this.element.setAttribute("type", "number");
        _this.element.setAttribute("value", _this.ref.value.toString());
        _this.element.addEventListener("input", function(e) {
            // console.log(this.ID, 'input',e.target.value, this.ref.value)
            _this.ref.value = +e.target.value; // TODO: zwalidować czy to nie powoduje zapętlenia refreshy
        });
        _this.element.addEventListener("mousewheel", function(e) {
            // e.preventDefault();
            // console.log(this.ID, 'mousewheel',e.target.value, this.ref.value)
            _this.ref.value = +e.target.value;
        }, {
            passive: false
        });
        return _this;
    }
    NumberInput.prototype.Step = function(step) {
        var _this = this;
        this.React(step, function(v) {
            return _this.Attribute("step", v.toString());
        });
        return this;
    };
    NumberInput.prototype.Min = function(min) {
        var _this = this;
        this.React(min, function(v) {
            return _this.Attribute("min", v.toString());
        });
        return this;
    };
    NumberInput.prototype.Max = function(max) {
        var _this = this;
        this.React(max, function(v) {
            return _this.Attribute("max", v.toString());
        });
        return this;
    };
    NumberInput.prototype.Range = function(min, max) {
        this.Min(min);
        this.Max(max);
        return this;
    };
    NumberInput.prototype.Refresh = function() {
        // console.log(this.ID, 'refresh', this.ref.value)
        this.element.value = this.ref.value.toString();
        if (this.min !== undefined && this.max !== undefined) {
            if (this.min !== this.max && this.ref.value >= this.min && this.ref.value <= this.max) this.Style("background", "");
            else this.Style("background", "pink");
        }
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    NumberInput.Name = "NumberInput";
    NumberInput.DefaultCssClasses = "";
    return NumberInput;
}($k6KGm.RefComponentBase);
module.exports.NumberInput = $3511988913dff7b1$var$NumberInput;

});

parcelRegister("2Q6Ax", function(module, exports) {
"use strict";
var $21158c68a1869eda$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NumericRange = void 0;

var $2s69t = parcelRequire("2s69t");
var $21158c68a1869eda$var$NumericRange = /** @class */ function(_super) {
    $21158c68a1869eda$var$__extends(NumericRange, _super);
    function NumericRange(min, max, range) {
        var _this = _super.call(this) || this;
        _this.min = min;
        _this.max = max;
        _this.minInput = new $2s69t.NumberInput(_this.min).HalfWidth();
        _this.maxInput = new $2s69t.NumberInput(_this.max).HalfWidth();
        if (range) {
            _this.minInput.Min(range[0]);
            _this.maxInput.Max(range[1]);
        }
        _this.Append(_this.minInput, _this.maxInput);
        return _this;
    }
    NumericRange.prototype.ShowThatChanged = function(showOrNot) {
        this.minInput.ShowThatChanged(showOrNot);
        this.maxInput.ShowThatChanged(showOrNot);
        return this;
    };
    NumericRange.Name = "NumericRange";
    return NumericRange;
}($2s69t.Div);
module.exports.NumericRange = $21158c68a1869eda$var$NumericRange;

});

parcelRegister("2OnCU", function(module, exports) {
"use strict";
var $20c2940b48787776$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Range = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $6wI3m = parcelRequire("6wI3m");
var $20c2940b48787776$var$Range = /** @class */ function(_super) {
    $20c2940b48787776$var$__extends(Range, _super);
    function Range(ref, range) {
        if (ref === void 0) ref = new $6wI3m.Ref(0);
        if (range === void 0) range = [
            0,
            100
        ];
        var _this = _super.call(this, "input", ref) || this;
        _this.min = undefined;
        _this.max = undefined;
        _this.Class(Range.DefaultCssClasses);
        if (range && range.length == 2) {
            _this.Min(range[0]);
            _this.Max(range[1]);
        }
        _this.Attribute("type", "range");
        _this.Attribute("value", _this.ref.value.toString());
        _this.element.addEventListener("input", function(e) {
            _this.ref.value = +e.target.value;
        });
        return _this;
    }
    Range.prototype.Min = function(min) {
        var _this = this;
        this.React(min, function(v) {
            return _this.Attribute("min", v.toString());
        });
        return this;
    };
    Range.prototype.Max = function(max) {
        var _this = this;
        this.React(max, function(v) {
            return _this.Attribute("max", v.toString());
        });
        return this;
    };
    Range.prototype.Refresh = function() {
        this.element.value = this.ref.value.toString();
    };
    Range.Name = "Range";
    Range.DefaultCssClasses = "";
    return Range;
}($k6KGm.RefComponentBase);
module.exports.Range = $20c2940b48787776$var$Range;

});

parcelRegister("bGQX2", function(module, exports) {
"use strict";
var $882cb0f4f90f3af3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $882cb0f4f90f3af3$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Select = void 0;

var $2s69t = parcelRequire("2s69t");

var $k6KGm = parcelRequire("k6KGm");
var $882cb0f4f90f3af3$var$Select = /** @class */ function(_super) {
    $882cb0f4f90f3af3$var$__extends(Select, _super);
    function Select(ref, initialOptions, optionsReloadTrigger) {
        if (ref === void 0) ref = new $2s69t.Ref("");
        if (initialOptions === void 0) initialOptions = [];
        var _this = _super.call(this, "select", ref) || this;
        _this.options = [];
        _this.InitialOptions = [];
        _this.clickHandler = function() {
            _this.RemoveDefaultOption();
            _this.element.removeEventListener("click", _this.clickHandler);
            _this.ref.value = _this.element.value; // BEZ TEGO PO KLIKNIĘCU KONTROLKA POKAZUJE PIERWSZĄ WARTOŚĆ ALE ref SIĘ NIE USTAWIA NA TE WARTOŚĆ
        };
        _this.modifyValueAfterChangeFn = function(t) {
            return t;
        };
        _this.DefaultValue = "__default__";
        _this.wasDefaultValueEverSet = false;
        _this.removeItOnFirstClick = false;
        _this.AddClass(Select.DefaultCssClasses);
        _this.WidthAuto();
        if (initialOptions instanceof $2s69t.Collection) initialOptions.OnChange(function() {
            return _this.LoadOptions(initialOptions.Items);
        });
        else if (typeof initialOptions === "function") {
            var options = initialOptions();
            _this.LoadOptions(options);
            if (!optionsReloadTrigger) _this.element.addEventListener("click", function(e) {
                var options = initialOptions();
                _this.LoadOptions(options);
            });
            else optionsReloadTrigger.OnChange(function() {
                return _this.LoadOptions(initialOptions());
            });
        } else if (Array.isArray(initialOptions)) {
            if (initialOptions[0] instanceof $2s69t.SelectOption) initialOptions.forEach(function(opt) {
                return _this.AddOption(opt);
            });
            else if (typeof initialOptions[0] == "string") initialOptions.forEach(function(opt) {
                return _this.AddOption(new $2s69t.SelectOption(opt));
            });
        } else if (initialOptions instanceof Object) {
            var entries = Object.entries(initialOptions);
            entries.map(function(_a) {
                var key = _a[0], value = _a[1];
                return _this.AddOption(new $2s69t.SelectOption(key, value));
            });
        }
        _this.InitialOptions = $882cb0f4f90f3af3$var$__spreadArray([], _this.options, true);
        _this.element.addEventListener("change", function(e) {
            var _a, _b;
            _this.ref.value = _this.modifyValueAfterChangeFn(e.target.value);
            var index = _this.options.findIndex(function(x) {
                return x.Value === e.target.value;
            });
            var key = ((_a = _this.options.find(function(x) {
                return x.Value === e.target.value;
            })) === null || _a === void 0 ? void 0 : _a.Text) || "";
            (_b = _this.onChangeCallback) === null || _b === void 0 || _b.call(_this, _this.ref.value, index, key);
        });
        _this.element.value = ref.value != null ? String(ref.value) : "";
        if (_this.removeItOnFirstClick) _this.RemoveDefaultOptionOnFirstClick();
        return _this;
    }
    Object.defineProperty(Select.prototype, "Index", {
        get: function() {
            var _this = this;
            return this.options.findIndex(function(x) {
                return x.Value === _this.ref.value;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "Key", {
        get: function() {
            var _this = this;
            var _a;
            return ((_a = this.options.find(function(x) {
                return x.Value === _this.ref.value;
            })) === null || _a === void 0 ? void 0 : _a.Text) || this.defaultOptionText;
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.SetValue = function(value) {
        var _this = this;
        var _a, _b;
        _super.prototype.SetValue.call(this, value);
        var index = this.options.findIndex(function(x) {
            return x.Value === _this.ref.value;
        });
        var key = ((_a = this.options.find(function(x) {
            return x.Value === _this.ref.value;
        })) === null || _a === void 0 ? void 0 : _a.Text) || "";
        (_b = this.onChangeCallback) === null || _b === void 0 || _b.call(this, this.ref.value, index, key);
        return this;
    };
    Select.prototype.RemoveDefaultOptionOnFirstClick = function() {
        /*
            UŻYCIE TEJ OPCJI SPOWODUJE USUNIĘCIE WARTOŚCI DOMYŚLNEJ Z LISTY OPCJI
            ALE RÓWNIEŻ USTAWI PIERWSZĄ OPCJĘ. DEFAULTOWA JUŻ SIĘ WIĘCEJ NIE POJAWI.
            NIE WIEM CZY NIE LEPIEJ BYŁO BY Z TEGO ZREZYGNOWAĆ.
        */ this.element.addEventListener("click", this.clickHandler);
        // this.OnClick(this.handler)
        return this;
    };
    Object.defineProperty(Select.prototype, "IsOpen", {
        get: function() {
            return document.activeElement === this.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "Options", {
        get: function() {
            return this.options;
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.ModifyAfterChange = function(fn) {
        this.modifyValueAfterChangeFn = fn;
        return this;
    };
    Select.prototype.CreateOption = function(option) {
        var optionElement = document.createElement("option");
        optionElement.text = option.Text;
        optionElement.value = option.Value != null ? String(option.Value) : "";
        return optionElement;
    };
    Select.prototype.PrependOption = function(option) {
        this.options.unshift(option);
        var optionElement = this.CreateOption(option);
        this.element.Prepend(optionElement);
        this.Refresh();
        return this;
    };
    Select.prototype.AddOption = function(option) {
        this.options.push(option);
        var optionElement = this.CreateOption(option);
        this.element.Append(optionElement);
        this.Refresh();
        return this;
    };
    Object.defineProperty(Select.prototype, "IsDefault", {
        get: function() {
            return !this.IsValueInOptions();
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.AddDefaultOption = function(text, removeItOnFirstClick) {
        if (removeItOnFirstClick === void 0) removeItOnFirstClick = false;
        this.removeItOnFirstClick = removeItOnFirstClick;
        this.wasDefaultValueEverSet = true;
        this.defaultOptionText = text;
        this.defaultOptionElement = document.createElement("option");
        this.defaultOptionElement.text = text;
        this.defaultOptionElement.value = this.DefaultValue;
        this.element.Append(this.defaultOptionElement);
        this.Refresh();
        return this;
    };
    Select.prototype.RemoveDefaultOption = function() {
        if (this.defaultOptionElement) {
            this.element.removeChild(this.defaultOptionElement);
            this.defaultOptionElement = null;
        }
        return this;
    };
    Select.prototype.ClearOptions = function() {
        this.options = [];
        this.element.textContent = "";
        if (this.wasDefaultValueEverSet) this.AddDefaultOption(this.defaultOptionText);
        return this;
    };
    Select.prototype.AddOptions = function(options) {
        var _this = this;
        options.forEach(function(o) {
            return _this.AddOption(o);
        });
        return this;
    };
    Select.prototype.LoadOptions = function(options) {
        var _this = this;
        this.ClearOptions();
        if (options[0] instanceof $2s69t.SelectOption) options.forEach(function(o) {
            return _this.AddOption(o);
        });
        else options.forEach(function(o) {
            return _this.AddOption(new $2s69t.SelectOption(o));
        });
        this.Refresh();
        return this;
    };
    Select.prototype.ReplaceOption = function(predicate, replacement) {
        var optionsCopy = $882cb0f4f90f3af3$var$__spreadArray([], this.Options, true);
        var foundIndex = optionsCopy.findIndex(function(x) {
            return predicate(x);
        });
        optionsCopy[foundIndex] = replacement;
        this.LoadOptions(optionsCopy);
        return this;
    };
    Select.prototype.LoadInitialOptions = function() {
        return this.LoadOptions(this.InitialOptions);
    };
    Select.prototype.OnChange = function(callback, callRightaway) {
        var _this = this;
        var _a, _b;
        if (callRightaway === void 0) callRightaway = false;
        this.onChangeCallback = callback;
        if (callRightaway) {
            var index = this.options.findIndex(function(x) {
                return x.Value === _this.ref.value;
            });
            var key = ((_a = this.options.find(function(x) {
                return x.Value === _this.ref.value;
            })) === null || _a === void 0 ? void 0 : _a.Text) || "";
            (_b = this.onChangeCallback) === null || _b === void 0 || _b.call(this, this.ref.value, index, key);
        }
        return this;
    };
    Select.prototype.Refresh = function() {
        if (this.IsValueInOptions()) this.element.value = this.ref.value != null ? String(this.ref.value) : "";
        else this.element.value = this.DefaultValue;
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
        return this;
    };
    Select.prototype.IsValueInOptions = function() {
        var refValue = this.ref.value != null ? String(this.ref.value) : "";
        return this.options.map(function(x) {
            var _a;
            return (_a = x.Value) === null || _a === void 0 ? void 0 : _a.toString();
        }).includes(refValue);
    };
    Select.Name = "Select";
    Select.DefaultCssClasses = "";
    return Select;
}($k6KGm.RefComponentBase);
module.exports.Select = $882cb0f4f90f3af3$var$Select;

});

parcelRegister("eBSeP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SelectOption = void 0;
var $aa2e97fb58a44c38$var$SelectOption = /** @class */ function() {
    function SelectOption(Text, Value) {
        this.Text = Text;
        this.Value = Value;
        if (this.Value === undefined) this.Value = this.Text;
    }
    return SelectOption;
}();
module.exports.SelectOption = $aa2e97fb58a44c38$var$SelectOption;

});

parcelRegister("7fnxp", function(module, exports) {
"use strict";
var $546c313ef87b9e01$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NonRefCheckboxV2 = module.exports.NonRefCheckbox = module.exports.Checkbox = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $jHilJ = parcelRequire("jHilJ");

var $6wI3m = parcelRequire("6wI3m");

var $aKtiT = parcelRequire("aKtiT");

var $8PO3e = parcelRequire("8PO3e");

var $gkD0R = parcelRequire("gkD0R");
var $546c313ef87b9e01$var$Checkbox = /** @class */ function(_super) {
    $546c313ef87b9e01$var$__extends(Checkbox, _super);
    function Checkbox(ref, label) {
        if (ref === void 0) ref = new $6wI3m.Ref(false);
        var _this = _super.call(this, "label", ref) || this;
        _this.ref = ref;
        _this.onCheckHandlers = new $8PO3e.HandlersCollection();
        _this.onUncheckHandlers = new $8PO3e.HandlersCollection();
        _this.onChangeHandlers = new $8PO3e.HandlersCollection();
        _this.Class("tf-checkbox");
        _this.Input = new $jHilJ.GenericComponent("input").AddClass("uk-checkbox").Attribute("type", "checkbox");
        if (ref.value) _this.Input.Attribute("checked", ref.value ? "checked" : "");
        _this.element.addEventListener("click", function(e) {
            _this.ref.value = _this.Input.element.checked; // czemu nie target.checked?
            _this.onChangeHandlers.Call(_this.ref.value);
            if (_this.ref.value == true) _this.onCheckHandlers.Call();
            else _this.onUncheckHandlers.Call();
        });
        _this.Append(_this.Input);
        if (label) _this.Append(new $gkD0R.Span(label).Class("checkbox-text"));
        return _this;
    }
    Checkbox.prototype.OnCheck = function(handler) {
        this.onCheckHandlers.Add(handler);
        return this;
    };
    Checkbox.prototype.OnUncheck = function(handler) {
        this.onUncheckHandlers.Add(handler);
        return this;
    };
    Checkbox.prototype.OnChange = function(handler) {
        this.onChangeHandlers.Add(handler);
        return this;
    };
    Checkbox.prototype.Refresh = function() {
        this.Input.element.checked = this.ref.value;
        if (this.showThatChanged) this.ref.HasChanged ? this.Input.element.classList.add("tf-value-changed") : this.Input.element.classList.remove("tf-value-changed");
    };
    Checkbox.prototype.Enabled = function() {
        this.Input.Enabled();
        return this;
    };
    Checkbox.prototype.Disabled = function() {
        this.Input.Disabled();
        return this;
    };
    Checkbox.prototype.Enable = function(isEnabled) {
        this.Input.Enable(isEnabled);
        return this;
    };
    Checkbox.prototype.EnableWhen = function(toWatch, predicate) {
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        this.Input.EnableWhen(toWatch, predicate);
        return this;
    };
    Checkbox.prototype.DisableWhen = function(toWatch, predicate) {
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        this.Input.DisableWhen(toWatch, predicate);
        return this;
    };
    Checkbox.prototype.Disable = function(isDisabled) {
        this.Input.Disable(isDisabled);
        return this;
    };
    Checkbox.Name = "Checkbox";
    return Checkbox;
}($k6KGm.RefComponentBase);
module.exports.Checkbox = $546c313ef87b9e01$var$Checkbox;
var $546c313ef87b9e01$var$NonRefCheckbox = /** @class */ function(_super) {
    $546c313ef87b9e01$var$__extends(NonRefCheckbox, _super);
    function NonRefCheckbox(value, onChange, label) {
        var _this = _super.call(this, "label") || this;
        _this.value = value;
        _this.input = new $jHilJ.GenericComponent("input").AddClass("uk-checkbox").Attribute("type", "checkbox");
        if (value()) _this.input.Attribute("checked");
        else _this.input.RemoveAttribute("checked");
        _this.element.addEventListener("click", function(e) {
            // console.log('!', this.input.element.checked);
            onChange(_this.input.element.checked);
        });
        _this.Append(_this.input);
        if (label) _this.Append(new $gkD0R.Span(" " + label));
        return _this;
    }
    NonRefCheckbox.prototype.Refresh = function() {
        this.input.element.checked = this.value();
    };
    return NonRefCheckbox;
}($aKtiT.ComponentBase);
module.exports.NonRefCheckbox = $546c313ef87b9e01$var$NonRefCheckbox;
var $546c313ef87b9e01$var$NonRefCheckboxV2 = /** @class */ function(_super) {
    $546c313ef87b9e01$var$__extends(NonRefCheckboxV2, _super);
    function NonRefCheckboxV2(value, onChange, label) {
        var _this = _super.call(this, "label") || this;
        _this.value = value;
        _this.input = new $jHilJ.GenericComponent("input").AddClass("uk-checkbox").Attribute("type", "checkbox");
        if (value) _this.input.Attribute("checked");
        else _this.input.RemoveAttribute("checked");
        _this.element.addEventListener("click", function(e) {
            onChange(_this.input.element.checked);
        });
        _this.Append(_this.input);
        if (label) _this.Append(new $gkD0R.Span(" " + label));
        return _this;
    }
    NonRefCheckboxV2.prototype.Refresh = function() {
        this.input.element.checked = this.value;
    };
    return NonRefCheckboxV2;
}($aKtiT.ComponentBase);
module.exports.NonRefCheckboxV2 = $546c313ef87b9e01$var$NonRefCheckboxV2;

});
parcelRegister("jHilJ", function(module, exports) {
"use strict";
var $e570444aa1c3a529$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GenericComponent = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $e570444aa1c3a529$var$GenericComponent = /** @class */ function(_super) {
    $e570444aa1c3a529$var$__extends(GenericComponent, _super);
    function GenericComponent(element) {
        return _super.call(this, element) || this;
    }
    return GenericComponent;
}($aKtiT.ComponentBase);
module.exports.GenericComponent = $e570444aa1c3a529$var$GenericComponent;

});


parcelRegister("5duNI", function(module, exports) {
"use strict";
var $3cc60f0ae7725ed1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3cc60f0ae7725ed1$var$__assign = module.exports && module.exports.__assign || function() {
    $3cc60f0ae7725ed1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3cc60f0ae7725ed1$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Rate = void 0;

var $joGvE = parcelRequire("joGvE");

var $85QoO = parcelRequire("85QoO");

var $1gg6H = parcelRequire("1gg6H");
var $3cc60f0ae7725ed1$var$Rate = /** @class */ function(_super) {
    $3cc60f0ae7725ed1$var$__extends(Rate, _super);
    function Rate(rating, config) {
        var _this = _super.call(this) || this;
        _this.Config = new $85QoO.RateConfig();
        if (config) _this.Config = $3cc60f0ae7725ed1$var$__assign($3cc60f0ae7725ed1$var$__assign({}, _this.Config), config);
        var _loop_1 = function(i) {
            var star = new $1gg6H.RateStar(rating, i, this_1.Config);
            if (this_1.Config.Readonly == false) star.OnClick(function() {
                return rating.value = i;
            });
            this_1.Append(star);
        };
        var this_1 = this;
        for(var i = 1; i <= _this.Config.Count; i++)_loop_1(i);
        return _this;
    }
    Rate.Name = "Rate";
    return Rate;
}($joGvE.Div);
module.exports.Rate = $3cc60f0ae7725ed1$var$Rate;

});
parcelRegister("85QoO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RateConfig = void 0;
var $5e476fc5648d347a$var$RateConfig = /** @class */ function() {
    function RateConfig() {
        this.Count = 5;
        this.SelectedSymbol = "\u2B50";
        this.SelectedStyle = "opacity: 1;";
        this.DeselectedSymbol = "\u2B50";
        this.DeselectedStyle = "opacity: 0.4;";
        this.Readonly = false;
    }
    return RateConfig;
}();
module.exports.RateConfig = $5e476fc5648d347a$var$RateConfig;

});

parcelRegister("1gg6H", function(module, exports) {
"use strict";
var $0eb3c79bca772948$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RateStar = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");
var $0eb3c79bca772948$var$RateStar = /** @class */ function(_super) {
    $0eb3c79bca772948$var$__extends(RateStar, _super);
    function RateStar(rating, showWhenLowerOrEqual, config) {
        var _this = _super.call(this) || this;
        _this.showWhenLowerOrEqual = showWhenLowerOrEqual;
        _this.config = config;
        _this.selected = new $gkD0R.Span(_this.config.SelectedSymbol).Style(_this.config.SelectedStyle).Hide();
        _this.deselected = new $gkD0R.Span(_this.config.DeselectedSymbol).Style(_this.config.DeselectedStyle);
        _this.DisplayInlineBlock();
        if (_this.config.Readonly == false) _this.CursorPointer();
        _this.Append(_this.selected, _this.deselected);
        rating.OnChange(function(v) {
            if (v >= _this.showWhenLowerOrEqual) {
                _this.selected.Show();
                _this.deselected.Hide();
            } else {
                _this.selected.Hide();
                _this.deselected.Show();
            }
        }, true);
        return _this;
    }
    return RateStar;
}($joGvE.Div);
module.exports.RateStar = $0eb3c79bca772948$var$RateStar;

});


parcelRegister("8Q6S6", function(module, exports) {
"use strict";
var $66f882a3097101e7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");
var $66f882a3097101e7$var$DateInput = /** @class */ function(_super) {
    $66f882a3097101e7$var$__extends(DateInput, _super);
    function DateInput(value) {
        var _this = this;
        if (value instanceof $6wI3m.Ref) _this = _super.call(this, "input", value) || this;
        else if (value instanceof Date) _this = _super.call(this, "input", new $6wI3m.Ref(value)) || this;
        else if (typeof value === "number") _this = _super.call(this, "input", new $6wI3m.Ref(new Date(value))) || this;
        else _this = _super.call(this, "input", new $6wI3m.Ref(new Date())) || this;
        _this.Class("uk-input");
        _this.Attribute("type", "date");
        _this.element.addEventListener("change", function(e) {
            var _a;
            var v = new Date(e.target.value);
            _this.ref.value = v;
            (_a = _this.onChange) === null || _a === void 0 || _a.call(_this, v);
        });
        _this.Refresh();
        return _this;
    }
    DateInput.prototype.OnChange = function(callback) {
        this.onChange = callback;
        return this;
    };
    DateInput.prototype.Refresh = function() {
        this.element.valueAsDate = new Date(this.ref.value);
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    DateInput.prototype.PadTo2Digits = function(num) {
        return num.toString().padStart(2, "0");
    };
    DateInput.prototype.FormatDate = function(date) {
        return [
            date.getFullYear(),
            this.PadTo2Digits(date.getMonth() + 1),
            this.PadTo2Digits(date.getDate())
        ].join("-");
    };
    DateInput.Name = "DateInput";
    return DateInput;
}($k6KGm.RefComponentBase);
module.exports.DateInput = $66f882a3097101e7$var$DateInput;

});

parcelRegister("5ACZp", function(module, exports) {
"use strict";
var $411e8f08c0ff235c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");
var $411e8f08c0ff235c$var$TimeInput = /** @class */ function(_super) {
    $411e8f08c0ff235c$var$__extends(TimeInput, _super);
    function TimeInput(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref(TimeInput.DefaultTime);
        var _this = _super.call(this, "input", ref) || this;
        _this.Class("uk-input");
        _this.Attribute("type", "time");
        _this.element.addEventListener("change", function(e) {
            var _a;
            var v = e.target.value;
            var _b = v.split(":"), hour = _b[0], minute = _b[1];
            _this.ref.value = v;
            (_a = _this.onChange) === null || _a === void 0 || _a.call(_this, v, +hour, +minute);
        });
        _this.Refresh();
        return _this;
    }
    TimeInput.prototype.OnChange = function(callback) {
        this.onChange = callback;
        return this;
    };
    TimeInput.prototype.Refresh = function() {
        this.element.value = this.FormatTime(this.ref.value);
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    TimeInput.prototype.AddTime = function(hours, minutes) {
        var _a, _b, _c;
        if (minutes === void 0) minutes = 0;
        var _d = ((_b = (_a = this.Value) === null || _a === void 0 ? void 0 : _a.split(":")) === null || _b === void 0 ? void 0 : _b.map(function(x) {
            return +x;
        })) || [
            0,
            0
        ], hh = _d[0], mm = _d[1];
        hh = (hh + hours) % 24;
        hh < 0 && (hh = 23);
        mm = (mm + minutes) % 60;
        mm < 0 && (mm = 59);
        var v = hh + ":" + mm;
        this.Value = v;
        (_c = this.onChange) === null || _c === void 0 || _c.call(this, v, hh, mm);
        return this;
    };
    TimeInput.prototype.SetTime = function(hours, minutes) {
        var _a;
        if (minutes === void 0) minutes = 0;
        var v = hours + ":" + minutes;
        this.Value = v;
        (_a = this.onChange) === null || _a === void 0 || _a.call(this, v, hours, minutes);
        return this;
    };
    TimeInput.prototype.PadTo2Digits = function(num) {
        return num.toString().padStart(2, "0");
    };
    TimeInput.prototype.FormatTime = function(time) {
        var _a = time.split(":"), hour = _a[0], minute = _a[1];
        return [
            this.PadTo2Digits(hour),
            this.PadTo2Digits(minute)
        ].join(":");
    };
    TimeInput.Name = "TimeInput";
    TimeInput.DefaultTime = "12:00";
    return TimeInput;
}($k6KGm.RefComponentBase);
module.exports.TimeInput = $411e8f08c0ff235c$var$TimeInput;

});

parcelRegister("3UiF9", function(module, exports) {
"use strict";
var $2d851419d9636d90$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTimeInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");
var $2d851419d9636d90$var$DateTimeInput = /** @class */ function(_super) {
    $2d851419d9636d90$var$__extends(DateTimeInput, _super);
    function DateTimeInput(ref) {
        var _this = this;
        if (ref instanceof $6wI3m.Ref) _this = _super.call(this, "input", ref) || this;
        else if (ref instanceof Date) _this = _super.call(this, "input", new $6wI3m.Ref(ref)) || this;
        else if (typeof ref === "number") _this = _super.call(this, "input", new $6wI3m.Ref(new Date(ref))) || this;
        else _this = _super.call(this, "input", new $6wI3m.Ref(new Date())) || this;
        _this.Class("uk-input");
        _this.Attribute("type", "datetime-local");
        // this.Attribute("type", "datetime");
        _this.element.addEventListener("change", function(e) {
            var v = e.target.value;
            // console.log('onchange', v)
            _this.ref.value = new Date(v);
        });
        _this.Refresh();
        return _this;
    }
    DateTimeInput.prototype.Refresh = function() {
        // Uzyskanie aktualnej daty i godziny w czasie uniwersalnym (UTC)
        var t = this.ref.value;
        // const tzoh = new Date().getTimezoneOffset() / 60;
        // console.log('TZO', tzoh)
        var year = t.getFullYear();
        var month = t.getMonth() + 1; // Pamiętaj, że miesiące są indeksowane od 0
        var day = t.getDate();
        // console.log(t.getHours(), tzoh)
        var hours = t.getHours(); //- tzoh;
        var minutes = t.getMinutes();
        // // Formatowanie daty i godziny do ISO string
        var dateWithoutTimezone = "".concat(year, "-").concat(month.toString().padStart(2, "0"), "-").concat(day.toString().padStart(2, "0"), "T").concat(hours.toString().padStart(2, "0"), ":").concat(minutes.toString().padStart(2, "0"));
        // console.log('CCCCCCCCc', currentISOString)
        this.element.value = dateWithoutTimezone;
        // console.log('REFR1', this.ref.value)
        // // console.log('REFR iso', this.ref.value.toISOString())
        // // console.log('REFR utc', this.ref.value.toUTCString())
        // console.log('REFR iii', currentISOString)
        // this.element.value =currentISOString// this.ref.value.toISOString().slice(0, 16);
        // console.log('REFR', this.element.value)
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    DateTimeInput.Name = "DateTimeInput";
    return DateTimeInput;
}($k6KGm.RefComponentBase);
module.exports.DateTimeInput = $2d851419d9636d90$var$DateTimeInput;

});

parcelRegister("2Tv9C", function(module, exports) {
"use strict";
var $21b8e266d708dd19$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EditableDateLabel = void 0;

var $3B1VX = parcelRequire("3B1VX");

var $8Q6S6 = parcelRequire("8Q6S6");

var $joGvE = parcelRequire("joGvE");

var $8PO3e = parcelRequire("8PO3e");

var $2Vdhf = parcelRequire("2Vdhf");

var $2s69t = parcelRequire("2s69t");
var $21b8e266d708dd19$var$EditableDateLabel = /** @class */ function(_super) {
    $21b8e266d708dd19$var$__extends(EditableDateLabel, _super);
    function EditableDateLabel(ref, printer) {
        if (ref === void 0) ref = new $2Vdhf.RefDate(0);
        if (printer === void 0) printer = function(value) {
            return +value == 0 ? "unset" : value.getDate() + "." + (value.getMonth() + 1) + "." + value.getFullYear();
        };
        var _this = _super.call(this) || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Label = new $3B1VX.Text(ref, function(v) {
            return printer(v);
        }).CursorPointer().OnClick(function() {
            _this.Label.Hide();
            _this.DateInput.Show();
            _this.OffButton.Show();
        });
        _this.DateInput = new $8Q6S6.DateInput(ref).DisplayInline().WidthAuto().Hide().OnChange(function(date) {
            _this.DateInput.Hide();
            _this.OffButton.Hide();
            _this.Label.Show();
            _this.onChange.Call(date);
        }).OnBlur(function() {
            _this.DateInput.Hide();
            _this.OffButton.Hide();
            _this.Label.Show();
        });
        _this.OffButton = new $2s69t.Button("\u2716").CursorPointer().Inline().Hide();
        _this.OffButton.OnClick(function() {
            _this.Label.Show();
            _this.DateInput.Hide();
            _this.OffButton.Hide();
        });
        // this.DateInput.Width(85, "%")
        _this.OffButton.MarginLeft(6);
        // NIE DA SIE KLIKNĄĆ W KONTROLKE BO ŁAPIE BLURA :(
        // this.SetAttribute("tabindex", "0");
        // this.OnBlur(() =>
        // {
        //     this.DateInput.Hide();
        //     this.Label.Show();
        // });
        _this.Append(_this.Label, _this.DateInput, _this.OffButton);
        return _this;
    }
    EditableDateLabel.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    EditableDateLabel.prototype.DateInputConfig = function(config) {
        config(this.DateInput);
        return this;
    };
    EditableDateLabel.prototype.OffButtonConfig = function(config) {
        config(this.OffButton);
        return this;
    };
    EditableDateLabel.prototype.LabelConfig = function(config) {
        config(this.Label);
        return this;
    };
    EditableDateLabel.Name = "EditableDateLabel";
    return EditableDateLabel;
}($joGvE.Div);
module.exports.EditableDateLabel = $21b8e266d708dd19$var$EditableDateLabel;

});

parcelRegister("fGn1O", function(module, exports) {
"use strict";
var $b6aca43425439cfe$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EditableTextarea = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $3B1VX = parcelRequire("3B1VX");

var $37QPp = parcelRequire("37QPp");
var $b6aca43425439cfe$var$EditableTextarea = /** @class */ function(_super) {
    $b6aca43425439cfe$var$__extends(EditableTextarea, _super);
    function EditableTextarea(ref, config) {
        if (config === void 0) config = {
            editOnClick: true
        };
        var _this = _super.call(this, "div") || this;
        _this.ref = ref;
        _this.config = config;
        _this.valueBeforeEdit = "";
        _this.label = new $3B1VX.Text(ref).CursorPointer().Show();
        if (config.editOnClick) _this.label.OnClick(function() {
            if (config.editOnClick) _this.EditMode();
        });
        _this.textInput = new $37QPp.MultilineInput(ref).Hide();
        if (config.editOnClick) _this.textInput.OnBlur(function() {
            if (config.editOnClick) _this.EndOfEdit();
        });
        _this.Append(_this.label, _this.textInput);
        return _this;
    }
    EditableTextarea.prototype.EditMode = function() {
        var linesCount = this.ref.value.split("\n").length;
        this.textInput.Rows(linesCount);
        this.valueBeforeEdit = this.ref.value;
        var labelWidth = getComputedStyle(this.label.Element).width;
        var w = +labelWidth.replace("px", "");
        if (w < 100) w += 32;
        this.label.Hide();
        this.textInput.Show().Width(w).Padding(2, 6);
    };
    EditableTextarea.prototype.EnableEditMode = function() {
        this.config.editOnClick = true;
    };
    EditableTextarea.prototype.DisableEditMode = function() {
        this.config.editOnClick = false;
    };
    Object.defineProperty(EditableTextarea.prototype, "IsEditMode", {
        get: function() {
            return this.textInput.IsVisible();
        },
        enumerable: false,
        configurable: true
    });
    EditableTextarea.prototype.ToggleEditMode = function() {
        if (this.IsEditMode) this.CloseEditMode();
        else this.EditMode();
        return this;
    };
    EditableTextarea.prototype.OpenEditMode = function() {
        this.EditMode();
        return this;
    };
    EditableTextarea.prototype.CloseEditMode = function() {
        this.EndOfEdit();
        return this;
    };
    EditableTextarea.prototype.LabelConfig = function(config) {
        config(this.label);
        return this;
    };
    EditableTextarea.prototype.TextInputConfig = function(config) {
        config(this.textInput);
        return this;
    };
    EditableTextarea.prototype.OnEditEnd = function(callback) {
        this.editEnd = callback;
        return this;
    };
    EditableTextarea.prototype.EndOfEdit = function() {
        var _a;
        if (!this.textInput.IsVisible()) return; // To prevent double call
        this.textInput.Hide();
        this.label.Show();
        (_a = this.editEnd) === null || _a === void 0 || _a.call(this, this.valueBeforeEdit, this.ref.value);
    };
    EditableTextarea.prototype.DefaultText = function(text) {
        this.label.DefaultText(text);
        return this;
    };
    EditableTextarea.prototype.Placeholder = function(placeholder) {
        this.textInput.Placeholder(placeholder);
        return this;
    };
    EditableTextarea.prototype.Style = function(prop, val) {
        this.label.Style(prop, val);
        this.textInput.Style(prop, val);
        return this;
    };
    EditableTextarea.Name = "EditableTextarea";
    return EditableTextarea;
}($aKtiT.ComponentBase);
module.exports.EditableTextarea = $b6aca43425439cfe$var$EditableTextarea;

});
parcelRegister("37QPp", function(module, exports) {
"use strict";
var $246b012041d45c9e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultilineInput = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $6wI3m = parcelRequire("6wI3m");
var $246b012041d45c9e$var$MultilineInput = /** @class */ function(_super) {
    $246b012041d45c9e$var$__extends(MultilineInput, _super);
    function MultilineInput(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = this;
        if (typeof ref === "string") ref = new $6wI3m.Ref(ref);
        _this = _super.call(this, "textarea", ref) || this;
        _this.Class(MultilineInput.DefaultCssClasses);
        _this.element.addEventListener("input", function(e) {
            _this.ref.value = e.target.value;
        });
        _this.Refresh();
        return _this;
    }
    MultilineInput.prototype.Placeholder = function(placeholder) {
        var _this = this;
        this.React(placeholder, function(v) {
            return _this.Attribute("placeholder", v.toString());
        });
        return this;
    };
    MultilineInput.prototype.Readonly = function() {
        this.Attribute("readonly");
        return this;
    };
    MultilineInput.prototype.Rows = function(count) {
        var _this = this;
        this.React(count, function(v) {
            return _this.Attribute("rows", v.toString());
        });
        return this;
    };
    MultilineInput.prototype.Refresh = function() {
        this.element.value = this.ref.value;
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    MultilineInput.Name = "MultilineInput";
    MultilineInput.DefaultCssClasses = "";
    return MultilineInput;
}($k6KGm.RefComponentBase);
module.exports.MultilineInput = $246b012041d45c9e$var$MultilineInput;

});


parcelRegister("hEMp0", function(module, exports) {
"use strict";
var $cdabb7ce117dd32c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabeledTextInput2 = module.exports.LabeledTextInput = void 0;

var $etGN3 = parcelRequire("etGN3");

var $6wI3m = parcelRequire("6wI3m");

var $gkD0R = parcelRequire("gkD0R");

var $joGvE = parcelRequire("joGvE");
var $cdabb7ce117dd32c$var$LabeledTextInput = /** @class */ function(_super) {
    $cdabb7ce117dd32c$var$__extends(LabeledTextInput, _super);
    function LabeledTextInput(label, variable) {
        if (variable === void 0) variable = new $6wI3m.Ref("");
        var _this = _super.call(this, "LabeledTextInput") || this;
        _this.Append(new $gkD0R.Span(label).Class("label"));
        _this.Append(new $etGN3.TextInput(variable).Placeholder(label).Class("input"));
        return _this;
    }
    return LabeledTextInput;
}($joGvE.Div);
module.exports.LabeledTextInput = $cdabb7ce117dd32c$var$LabeledTextInput;
var $cdabb7ce117dd32c$var$LabeledTextInput2 = /** @class */ function(_super) {
    $cdabb7ce117dd32c$var$__extends(LabeledTextInput2, _super);
    function LabeledTextInput2(label, variable) {
        if (variable === void 0) variable = new $6wI3m.Ref("");
        var _this = _super.call(this) || this;
        _this.Append(new $gkD0R.Span(label).Width(320).DisplayInlineBlock(), new $etGN3.TextInput(variable).Placeholder(label).Width(200));
        return _this;
    }
    return LabeledTextInput2;
}($joGvE.Div);
module.exports.LabeledTextInput2 = $cdabb7ce117dd32c$var$LabeledTextInput2;

});

parcelRegister("kUDwd", function(module, exports) {
"use strict";
var $f397b129d653e146$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabeledNumberInput = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $4ytZ3 = parcelRequire("4ytZ3");
var $f397b129d653e146$var$LabeledNumberInput = /** @class */ function(_super) {
    $f397b129d653e146$var$__extends(LabeledNumberInput, _super);
    function LabeledNumberInput(label, ref) {
        var _this = _super.call(this, "tf-form-labeled-number") || this;
        _this.label = label;
        _this.ref = ref;
        _this.labelCmp = new $gkD0R.Span(_this.label).Class("label");
        _this.numberInput = new $4ytZ3.NumberInput(_this.ref).Class("input");
        _this.Append(_this.labelCmp, _this.numberInput);
        return _this;
    }
    LabeledNumberInput.prototype.Min = function(min) {
        this.numberInput.Min(min);
        return this;
    };
    LabeledNumberInput.prototype.Max = function(max) {
        this.numberInput.Max(max);
        return this;
    };
    LabeledNumberInput.prototype.Step = function(step) {
        this.numberInput.Step(step);
        return this;
    };
    LabeledNumberInput.prototype.Edit = function(hook) {
        hook(this.labelCmp, this.numberInput);
        return this;
    };
    return LabeledNumberInput;
}($joGvE.Div);
module.exports.LabeledNumberInput = $f397b129d653e146$var$LabeledNumberInput;

});

parcelRegister("iBXy5", function(module, exports) {
"use strict";
var $d8c9dfd5cab4d14d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabeledSelect2 = module.exports.LabeledSelect = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $bGQX2 = parcelRequire("bGQX2");
var $d8c9dfd5cab4d14d$var$LabeledSelect = /** @class */ function(_super) {
    $d8c9dfd5cab4d14d$var$__extends(LabeledSelect, _super);
    function LabeledSelect(label, ref, selectOptions) {
        if (selectOptions === void 0) selectOptions = [];
        var _this = _super.call(this, "tf-form-labeled-select") || this;
        _this.label = label;
        _this.ref = ref;
        _this.selectOptions = selectOptions;
        _this.labelCmp = new $gkD0R.Span(_this.label).Class("label");
        _this.input = new $bGQX2.Select(_this.ref, _this.selectOptions).Class("input");
        _this.Append(_this.labelCmp, _this.input);
        return _this;
    }
    LabeledSelect.prototype.Edit = function(hook) {
        hook(this.labelCmp, this.input);
        return this;
    };
    return LabeledSelect;
}($joGvE.Div);
module.exports.LabeledSelect = $d8c9dfd5cab4d14d$var$LabeledSelect;
var $d8c9dfd5cab4d14d$var$LabeledSelect2 = /** @class */ function(_super) {
    $d8c9dfd5cab4d14d$var$__extends(LabeledSelect2, _super);
    function LabeledSelect2(label, ref, selectOptions) {
        if (selectOptions === void 0) selectOptions = [];
        var _this = _super.call(this, "tf-form-labeled-select") || this;
        _this.label = label;
        _this.ref = ref;
        _this.selectOptions = selectOptions;
        _this.labelCmp = new $gkD0R.Span(_this.label).Class("label").Width(320).DisplayInlineBlock();
        _this.Select = new $bGQX2.Select(_this.ref, _this.selectOptions).Class("input").Width(200);
        _this.Append(_this.labelCmp, _this.Select);
        return _this;
    }
    LabeledSelect2.prototype.Edit = function(hook) {
        hook(this.labelCmp, this.Select);
        return this;
    };
    return LabeledSelect2;
}($joGvE.Div);
module.exports.LabeledSelect2 = $d8c9dfd5cab4d14d$var$LabeledSelect2;

});

parcelRegister("6dx9g", function(module, exports) {
"use strict";
var $012b0f2770500f94$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultipleFilesInput = module.exports.FileInput = module.exports.FileInputV1 = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $8PO3e = parcelRequire("8PO3e");
var $012b0f2770500f94$var$FileInputV1 = /** @class */ function(_super) {
    $012b0f2770500f94$var$__extends(FileInputV1, _super);
    function FileInputV1() {
        var _this = _super.call(this, "input") || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Attribute("type", "file");
        _this.Class($012b0f2770500f94$var$FileInput.DefaultCssClasses);
        _this.element.addEventListener("change", function(e) {
            var _a;
            // console.log(this.element.files[0])
            _this.onChange.Call((_a = _this.element.files) === null || _a === void 0 ? void 0 : _a[0], e);
        });
        return _this;
    }
    FileInputV1.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    FileInputV1.Name = "FileInput";
    FileInputV1.DefaultCssClasses = "";
    return FileInputV1;
}($aKtiT.ComponentBase);
module.exports.FileInputV1 = $012b0f2770500f94$var$FileInputV1;
var $012b0f2770500f94$var$FileInput = /** @class */ function(_super) {
    $012b0f2770500f94$var$__extends(FileInput, _super);
    function FileInput(onChange) {
        var _this = _super.call(this, "input") || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Attribute("type", "file");
        _this.Class(FileInput.DefaultCssClasses);
        _this.onChange.Add(onChange);
        _this.element.addEventListener("change", function(e) {
            var _a;
            _this.onChange.Call((_a = _this.element.files) === null || _a === void 0 ? void 0 : _a[0], e);
        });
        return _this;
    }
    FileInput.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    FileInput.Name = "FileInput";
    FileInput.DefaultCssClasses = "";
    return FileInput;
}($aKtiT.ComponentBase);
module.exports.FileInput = $012b0f2770500f94$var$FileInput;
var $012b0f2770500f94$var$MultipleFilesInput = /** @class */ function(_super) {
    $012b0f2770500f94$var$__extends(MultipleFilesInput, _super);
    function MultipleFilesInput(onChange) {
        var _this = _super.call(this, "input") || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Attribute("type", "file").Attribute("multiple");
        _this.Class($012b0f2770500f94$var$FileInput.DefaultCssClasses);
        _this.onChange.Add(onChange);
        _this.element.addEventListener("change", function(e) {
            _this.onChange.Call(_this.element.files, e);
        });
        return _this;
    }
    MultipleFilesInput.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    MultipleFilesInput.Name = "MultipleFilesInput";
    MultipleFilesInput.DefaultCssClasses = "";
    return MultipleFilesInput;
}($aKtiT.ComponentBase);
module.exports.MultipleFilesInput = $012b0f2770500f94$var$MultipleFilesInput;

});

parcelRegister("bL1Ff", function(module, exports) {
"use strict";
var $88f55ffae983f4ad$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupMenu = module.exports.Menu = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $2S24U = parcelRequire("2S24U");
var $88f55ffae983f4ad$var$Menu = /** @class */ function(_super) {
    $88f55ffae983f4ad$var$__extends(Menu, _super);
    function Menu(menuItems, menuClasses, onClose) {
        if (menuClasses === void 0) menuClasses = "";
        var _this = _super.call(this, "menu") || this;
        _this.onClose = onClose;
        // ☢️ UWAGA! TO MA BYĆ FUNKCJA (NIE METODA) JEŚLI ZROBIMY Z TEGO METODĘ TO NIE DZIAŁA document.removeEventListener. 
        // NIE WAŻNE CZY DO TEJ METODY PRZEKAŻEMY WSKAŹNIK NA METODE, WYWOŁANIE FUNKCJI STRZAŁKOWEJ CZY ZROBIMY .bind(this). 
        // KAŻDA TA OPCJA NIE DZIAŁA CO POTEM POWODUJE PROBLEMY Z RemoveSelf BO JEST TRACONY KONTEKST DO this. 
        // MOŻNA OD BIEDY WSPOMÓC SIĘ POMOCNICZĄ FLAGĄ ALE TAK KOD JEST CZYSTSZY CHOĆ WYGLĄDA KRETYŃSKO.
        _this.DocumentClick = function() {
            var _a;
            _this.RemoveSelf();
            (_a = _this.onClose) === null || _a === void 0 || _a.call(_this);
        };
        _this.Class(menuClasses);
        _this.Append.apply(_this, Object.entries(menuItems).map(function(_a) {
            var label = _a[0], action = _a[1];
            var span = new $gkD0R.Span(label).Class("menu-item").OnClick(function() {
                var _a;
                document.removeEventListener("click", _this.DocumentClick);
                _this.RemoveSelf();
                (_a = _this.onClose) === null || _a === void 0 || _a.call(_this);
                action();
            });
            return span;
        }));
        document.addEventListener("click", _this.DocumentClick, {
            once: true
        });
        return _this;
    }
    Menu.Name = "Menu";
    return Menu;
}($joGvE.Div);
module.exports.Menu = $88f55ffae983f4ad$var$Menu;
/*
    REMEMBER TO KEEP BUTTON IN A RELATIVE CONTAINER.
*/ var $88f55ffae983f4ad$var$PopupMenu = /** @class */ function(_super) {
    $88f55ffae983f4ad$var$__extends(PopupMenu, _super);
    function PopupMenu(menuItems, activator, menuClasses) {
        if (activator === void 0) activator = new $2S24U.Button("\u22EE").RemoveAllClasses();
        if (menuClasses === void 0) menuClasses = "";
        var _this = _super.call(this, "popup-menu") || this;
        var allowClick = true;
        _this.Append(activator.OnClick(function(_) {
            if (!allowClick) return;
            allowClick = false;
            _.Disabled();
            _this.Append(new $88f55ffae983f4ad$var$Menu(menuItems, menuClasses, function() {
                allowClick = true;
                _.Enabled();
            }));
        }));
        return _this;
    }
    PopupMenu.Name = "PopupMenu";
    return PopupMenu;
}($joGvE.Div);
module.exports.PopupMenu = $88f55ffae983f4ad$var$PopupMenu;

});

parcelRegister("5BSVz", function(module, exports) {
"use strict";
var $415b03e7f5c4206b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextCombo = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $joGvE = parcelRequire("joGvE");

var $gg7jy = parcelRequire("gg7jy");

var $azQFq = parcelRequire("azQFq");
// TODO?: pokazywanie wyników tylko jeśli jest focus na kontrolce
// ✅ TODO: możliwość odkliknięcia - lista wyników znika
// TODO: możliwość wybrania strzałkami z klawiatury
// ✅ TODO: ESC zamyka listę wyników
// TODO: po wybraniu/kliknięciu lista wyników zamyka się
var $415b03e7f5c4206b$var$TextCombo = /** @class */ function(_super) {
    $415b03e7f5c4206b$var$__extends(TextCombo, _super);
    function TextCombo(needle, stack) {
        if (needle === void 0) needle = new $6wI3m.Ref("");
        if (stack === void 0) stack = [];
        var _this = _super.call(this) || this;
        _this.needle = needle;
        _this.MaxResults = 5;
        _this.whenNoResultsText = "No results found";
        _this.SearchInput = new $azQFq.ClearableTextInput(_this.needle);
        _this.ResultsList = new $gg7jy.TextComboSearchResult(_this.MaxResults);
        needle.OnChange(function(v) {
            // TODO: move it all to TextComboSearchResult????
            var needleValue = v.trim().toLowerCase();
            var items = Array.isArray(stack) ? stack : stack.Items;
            var filteredItems = items.filter(function(x) {
                return x.SearchBy.toLowerCase().includes(needleValue);
            });
            // TODO: move to ResultsList?
            if (filteredItems.length == 0) _this.ResultsList.NoResults(_this.whenNoResultsText);
            else if (needleValue.length == 0) _this.ResultsList.Hide();
            else _this.ResultsList.LoadResults(filteredItems);
        });
        _this.SearchInput.TextInput.OnBlur(function() {
            // Timeout because Hide fires before item click
            setTimeout(function() {
                _this.ResultsList.Hide();
            }, 300);
        });
        _this.SearchInput.TextInput.OnFocus(function() {
            if (needle.value.length > 0) _this.ResultsList.Show();
        });
        _this.Append(_this.SearchInput, _this.ResultsList);
        return _this;
    }
    TextCombo.prototype.Placeholder = function(placeholder) {
        this.SearchInput.TextInput.Placeholder(placeholder);
        return this;
    };
    TextCombo.prototype.NoResultsText = function(text) {
        this.whenNoResultsText = text;
        return this;
    };
    TextCombo.Name = "TextCombo";
    TextCombo.DefaultCssClasses = "";
    return TextCombo;
}($joGvE.Div);
module.exports.TextCombo = $415b03e7f5c4206b$var$TextCombo;

});
parcelRegister("gg7jy", function(module, exports) {
"use strict";
var $bd63d07550015afb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextComboSearchResult = void 0;

var $joGvE = parcelRequire("joGvE");

var $8Lkmv = parcelRequire("8Lkmv");
var $bd63d07550015afb$var$TextComboSearchResult = /** @class */ function(_super) {
    $bd63d07550015afb$var$__extends(TextComboSearchResult, _super);
    function TextComboSearchResult(maxResults) {
        var _this = _super.call(this, "TextComboSearchResult") || this;
        _this.maxResults = maxResults;
        return _this;
    }
    TextComboSearchResult.prototype.NoResults = function(whenNoResultsText) {
        if (whenNoResultsText === void 0) whenNoResultsText = "No results found";
        this.Clear();
        this.Show();
        this.Append(new $joGvE.Div().Text(whenNoResultsText).Style("text-align: center;").Class("no-results"));
    };
    TextComboSearchResult.prototype.LoadResults = function(items) {
        this.Clear();
        this.Show();
        this.Append.apply(this, items.slice(0, this.maxResults).map(function(x) {
            return new $8Lkmv.TextComboSearchResultItem(x);
        }));
    };
    return TextComboSearchResult;
}($joGvE.Div);
module.exports.TextComboSearchResult = $bd63d07550015afb$var$TextComboSearchResult;

});
parcelRegister("8Lkmv", function(module, exports) {
"use strict";
var $661281f9fbfe1c03$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextComboSearchResultItem = void 0;

var $joGvE = parcelRequire("joGvE");
var $661281f9fbfe1c03$var$TextComboSearchResultItem = /** @class */ function(_super) {
    $661281f9fbfe1c03$var$__extends(TextComboSearchResultItem, _super);
    function TextComboSearchResultItem(item) {
        var _this = _super.call(this, "TextComboSearchResultItem") || this;
        _this.Append(item.BindedTo());
        return _this;
    }
    return TextComboSearchResultItem;
}($joGvE.Div);
module.exports.TextComboSearchResultItem = $661281f9fbfe1c03$var$TextComboSearchResultItem;

});


parcelRegister("azQFq", function(module, exports) {
"use strict";
var $7b3606d93cf72d77$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClearableTextInput = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $etGN3 = parcelRequire("etGN3");
var $7b3606d93cf72d77$var$ClearableTextInput = /** @class */ function(_super) {
    $7b3606d93cf72d77$var$__extends(ClearableTextInput, _super);
    function ClearableTextInput(value, placeholder) {
        var _this = _super.call(this, "ClearableTextInput") || this;
        _this.value = value;
        _this.placeholder = placeholder;
        _this.PositionRelative();
        _this.TextInput = new $etGN3.TextInput(_this.value).Placeholder(_this.placeholder || "");
        _this.ClearButton = new $gkD0R.Span("\xd7").Class("x");
        _this.ClearButton.OnClick(function() {
            return _this.value.value = "";
        }).VisibleWhen(_this.value, function(v) {
            return v.length > 0;
        });
        _this.Append(_this.TextInput, _this.ClearButton);
        return _this;
    }
    ClearableTextInput.Name = "ClearableTextInput";
    return ClearableTextInput;
}($joGvE.Div);
module.exports.ClearableTextInput = $7b3606d93cf72d77$var$ClearableTextInput;

});


parcelRegister("7Kd03", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SearchableItem = void 0;

var $joGvE = parcelRequire("joGvE");
var $5a36e9ce10fb7745$var$SearchableItem = /** @class */ function() {
    function SearchableItem(searchBy, bindedTo, onClick) {
        this.SearchBy = searchBy;
        this.BindedTo = function() {
            return new $joGvE.Div().Append(bindedTo()).OnClick(onClick);
        };
    }
    return SearchableItem;
}();
module.exports.SearchableItem = $5a36e9ce10fb7745$var$SearchableItem;

});

parcelRegister("bEnZu", function(module, exports) {
"use strict";
var $87b60a2f958f6b0a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalWindow = void 0;

var $iqyiC = parcelRequire("iqyiC");

var $6wI3m = parcelRequire("6wI3m");

var $8PO3e = parcelRequire("8PO3e");

var $joGvE = parcelRequire("joGvE");

var $5PIlt = parcelRequire("5PIlt");

var $4wFdb = parcelRequire("4wFdb");

var $3B1VX = parcelRequire("3B1VX");
var $87b60a2f958f6b0a$var$ModalWindow = /** @class */ function(_super) {
    $87b60a2f958f6b0a$var$__extends(ModalWindow, _super);
    function ModalWindow(title, blurBackground, lockScroll, closeOnClickAway) {
        if (blurBackground === void 0) blurBackground = true;
        if (lockScroll === void 0) lockScroll = false;
        if (closeOnClickAway === void 0) closeOnClickAway = false;
        var _this = _super.call(this) || this;
        _this.blurBackground = blurBackground;
        _this.lockScroll = lockScroll;
        _this.closeOnClickAway = closeOnClickAway;
        _this.shutter = new $4wFdb.Shutter();
        _this.windowTitle = new $6wI3m.Ref("");
        _this.onBeforeCloseOrHideWindow = new $8PO3e.HandlersCollection();
        _this.onCloseOrHideWindow = new $8PO3e.HandlersCollection(); // close by pressing X or CloseWindow() call
        _this.onExitWindow = new $8PO3e.HandlersCollection(); // close by calling ExitWindow()
        _this.CloseButtonAction = function() {
            return _this.CloseWindow();
        };
        _this.CloseButton = new $5PIlt.Link("\xd7").NoDecorationOnHover().Class("tf-modal-window-close").OnClick(function() {
            return _this.CloseButtonAction();
        });
        _this.header = new $joGvE.Div().Class("tf-modal-window-header");
        _this.content = new $joGvE.Div().Class("tf-modal-window-content");
        _this.footer = new $joGvE.Div().Class("tf-modal-window-footer");
        _this.wasEverOpen = false;
        _this.Class(ModalWindow.DefaultCssClasses);
        _this.windowTitle.value = title instanceof $6wI3m.Ref ? title.value : title;
        return _this;
    }
    Object.defineProperty(ModalWindow.prototype, "Shutter", {
        get: function() {
            return this.shutter;
        },
        enumerable: false,
        configurable: true
    });
    ModalWindow.prototype.NoCloseButton = function() {
        this.CloseButton = null;
        return this;
    };
    ModalWindow.prototype.SetCloseButtonAction = function(handler) {
        this.CloseButtonAction = handler;
        return this;
    };
    ModalWindow.prototype.FullScreen = function() {
        return this.WidthPercent(100).HeightPercent(100);
    };
    ModalWindow.prototype.HideOnClose = function() {
        var _this = this;
        this.CloseButtonAction = function() {
            return _this.HideWindow();
        };
        return this;
    };
    ModalWindow.prototype.OpenWindow = function() {
        var _this = this;
        var _a, _b;
        this.Append(this.header.Append(new $joGvE.Div("tf-modal-window-header-title-section").Append(new $3B1VX.Text(this.windowTitle)), new $joGvE.Div("tf-modal-window-header-buttons-section").Append(this.CloseButton && this.CloseButton)), this.content, this.footer.HasAnyChildren && this.footer);
        if (this.blurBackground) (_a = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _a === void 0 || _a.Append(this.shutter.Element);
        (_b = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _b === void 0 || _b.Append(this.Element);
        if (this.lockScroll) this.LockPageScroll();
        if (this.closeOnClickAway) this.Shutter.OnClick(function() {
            return _this.CloseButtonAction();
        });
        return this;
    };
    ModalWindow.prototype.Title = function(title) {
        this.windowTitle.value = title;
        return this;
    };
    ModalWindow.prototype.CloseWindow = function(onClosePayload) {
        if (this.onBeforeCloseOrHideWindow.AreAny) {
            var allowClose = this.onBeforeCloseOrHideWindow.CallAndGatherReturnValue();
            if (allowClose.some(function(x) {
                return x == false;
            })) return this;
        }
        this.RemoveWindow();
        this.onCloseOrHideWindow.Call(onClosePayload);
        return this;
    };
    ModalWindow.prototype.RemoveWindow = function() {
        var _a, _b;
        this.Clear();
        try {
            (_a = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _a === void 0 || _a.removeChild(this.Element);
            if (this.blurBackground) (_b = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _b === void 0 || _b.removeChild(this.shutter.Element);
        } catch (ex) {
            throw new Error("[truffle] You are trying to remove element (that window) that is not a child of ".concat(ModalWindow.Hook, ". Make sure Root.Hook and ModalWindow.Root are the same. Remember to not attach ModalWindow to any other element with .Append(). Exception:"), ex);
        }
        if (this.lockScroll) this.UnlockPageScroll();
    };
    ModalWindow.prototype.ExitWindow = function(onExitPayload) {
        this.RemoveWindow();
        this.onExitWindow.Call(onExitPayload);
        return this;
    };
    ModalWindow.prototype.ShowWindow = function() {
        var _a;
        if (this.wasEverOpen == false) {
            this.OpenWindow();
            this.wasEverOpen = true;
        }
        (_a = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _a === void 0 || _a.Append(this.shutter.Element);
        this.Show().ZIndex(100);
        return this;
    };
    ModalWindow.prototype.HideWindow = function() {
        var _a;
        if (this.blurBackground) (_a = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _a === void 0 || _a.removeChild(this.shutter.Element);
        this.Hide();
        this.onCloseOrHideWindow.Call();
        if (this.lockScroll) this.UnlockPageScroll();
        return this;
    };
    ModalWindow.prototype.AddToHeader = function() {
        var _a;
        var elements = [];
        for(var _i = 0; _i < arguments.length; _i++)elements[_i] = arguments[_i];
        (_a = this.header).Append.apply(_a, elements);
        return this;
    };
    ModalWindow.prototype.AddContent = function() {
        var _a;
        var elements = [];
        for(var _i = 0; _i < arguments.length; _i++)elements[_i] = arguments[_i];
        (_a = this.content).Append.apply(_a, elements);
        return this;
    };
    ModalWindow.prototype.AddToFooter = function() {
        var _a;
        var elements = [];
        for(var _i = 0; _i < arguments.length; _i++)elements[_i] = arguments[_i];
        (_a = this.footer).Append.apply(_a, elements);
        return this;
    };
    ModalWindow.prototype.OnCloseWindow = function(handler) {
        this.onCloseOrHideWindow.Add(handler);
        return this;
    };
    ModalWindow.prototype.OnExitWindow = function(handler) {
        this.onExitWindow.Add(handler);
        return this;
    };
    ModalWindow.prototype.OnBeforeCloseWindow = function(handler) {
        this.onBeforeCloseOrHideWindow.Add(handler);
        return this;
    };
    ModalWindow.prototype.LockPageScroll = function() {
        document.body.classList.add("tf-stop-scrolling");
    };
    ModalWindow.prototype.UnlockPageScroll = function() {
        document.body.classList.remove("tf-stop-scrolling");
    };
    ModalWindow.Name = "ModalWindow";
    ModalWindow.DefaultCssClasses = "";
    ModalWindow.Hook = "body";
    return ModalWindow;
}($joGvE.Div);
module.exports.ModalWindow = $87b60a2f958f6b0a$var$ModalWindow;

});
parcelRegister("4wFdb", function(module, exports) {
"use strict";
var $34ba1e59762b223a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Shutter = void 0;

var $joGvE = parcelRequire("joGvE");
var $34ba1e59762b223a$var$Shutter = /** @class */ function(_super) {
    $34ba1e59762b223a$var$__extends(Shutter, _super);
    function Shutter() {
        return _super.call(this, "tf-shutter") || this;
    }
    return Shutter;
}($joGvE.Div);
module.exports.Shutter = $34ba1e59762b223a$var$Shutter;

});


parcelRegister("fMKT6", function(module, exports) {
"use strict";
var $b7dfb5a097b9983d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadioSwitchesBuilder = void 0;

var $k6KGm = parcelRequire("k6KGm");
var $b7dfb5a097b9983d$var$RadioSwitchesBuilder = /** @class */ function(_super) {
    $b7dfb5a097b9983d$var$__extends(RadioSwitchesBuilder, _super);
    function RadioSwitchesBuilder(ref) {
        var _this = _super.call(this, "div", ref) || this;
        _this.switches = {};
        _this.classWhenActive = {};
        return _this;
    }
    RadioSwitchesBuilder.prototype.Refresh = function() {
        var _this = this;
        this.switches.Keys().forEach(function(activator) {
            var cmp = _this.switches[activator];
            var classWhenActive = _this.classWhenActive[activator];
            if (_this.ref.value === activator) cmp.AddClass(classWhenActive);
            else cmp.RemoveClass(classWhenActive);
        });
    };
    RadioSwitchesBuilder.prototype.AddSwitch = function(activator, cmp, cssClassWhenActive) {
        var _this = this;
        this.switches[activator] = cmp;
        this.classWhenActive[activator] = cssClassWhenActive;
        cmp.OnClick(function() {
            return _this.ref.value = activator;
        });
        if (this.ref.value == activator) cmp.AddClass(cssClassWhenActive);
        if (this.ref.value == "") this.ref.value = activator;
        this.Append(cmp);
        return this;
    };
    return RadioSwitchesBuilder;
}($k6KGm.RefComponentBase);
module.exports.RadioSwitchesBuilder = $b7dfb5a097b9983d$var$RadioSwitchesBuilder;

});

parcelRegister("a9HcF", function(module, exports) {
"use strict";
var $764c41ee5cf11ca2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DestroyingContentSwitcher = void 0;

var $k6KGm = parcelRequire("k6KGm");
var $764c41ee5cf11ca2$var$DestroyingContentSwitcher = /** @class */ function(_super) {
    $764c41ee5cf11ca2$var$__extends(DestroyingContentSwitcher, _super);
    function DestroyingContentSwitcher(ref) {
        var _this = _super.call(this, "div", ref) || this;
        _this.contents = {};
        return _this;
    }
    DestroyingContentSwitcher.prototype.AddContent = function(activator, cmp) {
        var activatorKey = activator != null ? String(activator) : "";
        this.contents[activatorKey] = cmp;
        if (activator === this.ref.value) {
            var result = cmp();
            if (Array.isArray(result)) this.Append.apply(this, result);
            else this.Append(result);
        } else if (this.defaultContent) {
            // this.Append(this.defaultContent()) 
            var result = this.defaultContent();
            if (Array.isArray(result)) this.Append.apply(this, result);
            else this.Append(result);
        }
        return this;
    };
    DestroyingContentSwitcher.prototype.AddDefaultContent = function(cmp) {
        this.defaultContent = cmp;
        if (!this.contents.Keys().includes(this.ref.value != null ? String(this.ref.value) : "")) {
            // this.Append(cmp());
            var result = cmp();
            if (Array.isArray(result)) this.Append.apply(this, result);
            else this.Append(result);
        }
        return this;
    };
    DestroyingContentSwitcher.prototype.Refresh = function() {
        var _a, _b;
        var valueKey = this.ref.value != null ? String(this.ref.value) : "";
        var c = (_b = (_a = this.contents)[valueKey]) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.Clear();
        if (c) {
            // this.Append(c);
            // const result = c;
            if (Array.isArray(c)) this.Append.apply(this, c);
            else this.Append(c);
        } else if (this.defaultContent) {
            // this.Append(this.defaultContent())
            var result = this.defaultContent();
            if (Array.isArray(result)) this.Append.apply(this, result);
            else this.Append(result);
        }
    };
    DestroyingContentSwitcher.Name = "DestroyingContentSwitcher";
    return DestroyingContentSwitcher;
}($k6KGm.RefComponentBase);
module.exports.DestroyingContentSwitcher = $764c41ee5cf11ca2$var$DestroyingContentSwitcher;

});

parcelRegister("3slAG", function(module, exports) {
"use strict";
var $2844bc1766a7ae91$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DestroyingPatternContentSwitcher = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $3CTSE = parcelRequire("3CTSE");
var $2844bc1766a7ae91$var$DestroyingPatternContentSwitcher = /** @class */ function(_super) {
    $2844bc1766a7ae91$var$__extends(DestroyingPatternContentSwitcher, _super);
    function DestroyingPatternContentSwitcher(ref) {
        var _this = _super.call(this, "div", ref) || this;
        _this.contents = {}; // TODO: to jest słabe, trzeba by to wynieść do jakiejś osobnej klasy
        return _this;
    }
    DestroyingPatternContentSwitcher.prototype.AddContent = function(pattern, cmp) {
        this.contents[pattern] = cmp;
        // const extractor = new PatternExtractor(pattern);
        // const params = extractor.Extract(this.ref.value);
        // if (params == null) // a co jak mamy pattern bez parametrów? zwraca pusty obiekt? TAK!
        // {
        //     return this;
        // }
        // this.Append(cmp(params));
        return this;
    };
    DestroyingPatternContentSwitcher.prototype.AddDefaultContent = function(defaultCmp) {
        this.defaultContent = defaultCmp;
        if (!this.IsRefOneOfPatterns()) this.Append(defaultCmp());
        return this;
    };
    DestroyingPatternContentSwitcher.prototype.IsRefOneOfPatterns = function() {
        for(var _i = 0, _a = this.contents.Keys(); _i < _a.length; _i++){
            var pattern = _a[_i];
            var extractor = new $3CTSE.PatternExtractor(pattern);
            var params = extractor.Extract(this.ref.value);
            if (params != null) return true;
        }
        return false;
    };
    DestroyingPatternContentSwitcher.prototype.FindPatternAndParams = function() {
        for(var _i = 0, _a = this.contents.Keys(); _i < _a.length; _i++){
            var pattern = _a[_i];
            var extractor = new $3CTSE.PatternExtractor(pattern);
            var params = extractor.Extract(this.ref.value);
            if (params != null) return {
                found: true,
                pattern: pattern,
                params: params
            };
        }
        return {
            found: false,
            pattern: null,
            params: null
        };
    };
    DestroyingPatternContentSwitcher.prototype.Refresh = function() {
        this.Clear();
        var searchResult = this.FindPatternAndParams();
        if (searchResult.found) this.Append(this.contents[searchResult.pattern](searchResult.params));
        else if (this.defaultContent) this.Append(this.defaultContent());
        return this;
    };
    DestroyingPatternContentSwitcher.Name = "DestroyingPatternContentSwitcher";
    return DestroyingPatternContentSwitcher;
}($k6KGm.RefComponentBase);
module.exports.DestroyingPatternContentSwitcher = $2844bc1766a7ae91$var$DestroyingPatternContentSwitcher;

});

parcelRegister("4yfSX", function(module, exports) {
"use strict";
var $3506a8e7090cd5f2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HidingContentSwitcher = void 0;

var $k6KGm = parcelRequire("k6KGm");
var $3506a8e7090cd5f2$var$HidingContentSwitcher = /** @class */ function(_super) {
    $3506a8e7090cd5f2$var$__extends(HidingContentSwitcher, _super);
    function HidingContentSwitcher(ref) {
        var _this = _super.call(this, "div", ref) || this;
        _this.contents = {};
        _this.showAses = {};
        _this.defaultContentShowAs = "";
        return _this;
    }
    HidingContentSwitcher.prototype.AddContent = function(activator, cmp, showAs) {
        var activatorKey = activator != null ? String(activator) : "";
        this.contents[activatorKey] = cmp();
        this.showAses[activatorKey] = showAs || "";
        if (activator === this.ref.value) this.Append(this.contents[activatorKey]);
        return this;
    };
    HidingContentSwitcher.prototype.AddDefaultContent = function(cmp, showAs) {
        this.defaultContent = cmp();
        this.defaultContentShowAs = showAs || "";
        if (!this.IsOneOfTheContents()) this.Append(this.defaultContent);
        return this;
    };
    HidingContentSwitcher.prototype.IsOneOfTheContents = function() {
        return this.contents.Keys().includes(this.ref.value != null ? String(this.ref.value) : "");
    };
    HidingContentSwitcher.prototype.Refresh = function() {
        var _a, _b;
        this.contents.Values().forEach(function(x) {
            return x.Hide();
        });
        var valueKey = this.ref.value != null ? String(this.ref.value) : "";
        var newContent = this.contents[valueKey];
        if (newContent) {
            (_a = this.defaultContent) === null || _a === void 0 || _a.Hide();
            if (!this.Exist(newContent)) this.Append(newContent);
            newContent.Show(this.showAses[valueKey]);
        } else {
            if (this.defaultContent && !this.Exist(this.defaultContent)) this.Append(this.defaultContent);
            (_b = this.defaultContent) === null || _b === void 0 || _b.Show(this.defaultContentShowAs);
        }
    };
    HidingContentSwitcher.Name = "HidingContentSwitcher";
    return HidingContentSwitcher;
}($k6KGm.RefComponentBase);
module.exports.HidingContentSwitcher = $3506a8e7090cd5f2$var$HidingContentSwitcher;

});

parcelRegister("3700g", function(module, exports) {
"use strict";
var $2442072dd1bbd50e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tabs = module.exports.TabsSwitcher = module.exports.ButtonTabs = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");

var $joGvE = parcelRequire("joGvE");

var $2S24U = parcelRequire("2S24U");

var $5PIlt = parcelRequire("5PIlt");

var $2MZa4 = parcelRequire("2MZa4");

var $a9HcF = parcelRequire("a9HcF");

var $fMKT6 = parcelRequire("fMKT6");
var $2442072dd1bbd50e$var$ButtonTabs = /** @class */ function(_super) {
    $2442072dd1bbd50e$var$__extends(ButtonTabs, _super);
    function ButtonTabs(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.switches = new $fMKT6.RadioSwitchesBuilder(_this.ref);
        _this.content = new $a9HcF.DestroyingContentSwitcher(_this.ref);
        _this.Append(_this.switches, _this.content);
        return _this;
    }
    ButtonTabs.prototype.Add = function(label, content) {
        this.switches.AddSwitch(label, new $2S24U.Button(label), "uk-button-danger");
        this.content.AddContent(label, content);
        return this;
    };
    return ButtonTabs;
}($joGvE.Div);
module.exports.ButtonTabs = $2442072dd1bbd50e$var$ButtonTabs;
var $2442072dd1bbd50e$var$TabsSwitcher = /** @class */ function(_super) {
    $2442072dd1bbd50e$var$__extends(TabsSwitcher, _super);
    function TabsSwitcher(ref) {
        var _this = _super.call(this, "ul", ref) || this;
        _this.switches = {};
        _this.Attribute("uk-tab");
        _this.Class("uk-tab");
        return _this;
    }
    TabsSwitcher.prototype.Refresh = function() {
        var _this = this;
        this.switches.Keys().forEach(function(activator) {
            var cmp = _this.switches[activator];
            if (_this.ref.value === activator) cmp.AddClass("uk-active");
            else cmp.RemoveClass("uk-active");
        });
    };
    TabsSwitcher.prototype.Add = function(label) {
        var _this = this;
        var item = new $2MZa4.ListItem(new $5PIlt.Link(label, "#"));
        this.switches[label] = item;
        item.OnClick(function() {
            return _this.ref.value = label;
        });
        if (this.ref.value == label) item.AddClass("uk-active");
        if (this.ref.value == "") this.ref.value = label;
        this.Append(item);
        return this;
    };
    return TabsSwitcher;
}($k6KGm.RefComponentBase);
module.exports.TabsSwitcher = $2442072dd1bbd50e$var$TabsSwitcher;
var $2442072dd1bbd50e$var$Tabs = /** @class */ function(_super) {
    $2442072dd1bbd50e$var$__extends(Tabs, _super);
    function Tabs(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.switches = new $2442072dd1bbd50e$var$TabsSwitcher(_this.ref);
        _this.content = new $a9HcF.DestroyingContentSwitcher(_this.ref);
        _this.Append(_this.switches, _this.content);
        return _this;
    }
    Tabs.prototype.Add = function(label, content) {
        this.switches.Add(label);
        this.content.AddContent(label, content);
        return this;
    };
    return Tabs;
}($joGvE.Div);
module.exports.Tabs = $2442072dd1bbd50e$var$Tabs;

});

parcelRegister("fhrT0", function(module, exports) {
"use strict";
var $b1fe132ae5518be4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VerticalButtonTabs = void 0;

var $2S24U = parcelRequire("2S24U");

var $1h8RE = parcelRequire("1h8RE");

var $a9HcF = parcelRequire("a9HcF");

var $6wI3m = parcelRequire("6wI3m");

var $fMKT6 = parcelRequire("fMKT6");
var $b1fe132ae5518be4$var$VerticalButtonTabs = /** @class */ function(_super) {
    $b1fe132ae5518be4$var$__extends(VerticalButtonTabs, _super);
    function VerticalButtonTabs(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.switcher = new $fMKT6.RadioSwitchesBuilder(_this.ref);
        _this.contentSwitcher = new $a9HcF.DestroyingContentSwitcher(_this.ref);
        _this.useActivator = function(label) {
            return new $2S24U.Button(label);
        };
        _this.LeftColumn.Append(_this.switcher);
        _this.RightColumn.Append(_this.contentSwitcher);
        return _this;
    }
    VerticalButtonTabs.prototype.Add = function(label, content) {
        this.switcher.AddSwitch(label, this.useActivator(label), "uk-button-danger");
        this.contentSwitcher.AddContent(label, content);
        return this;
    };
    VerticalButtonTabs.prototype.UseActivator = function(fn) {
        this.useActivator = fn;
        return this;
    };
    return VerticalButtonTabs;
}($1h8RE.AutoWidthTwoColumns);
module.exports.VerticalButtonTabs = $b1fe132ae5518be4$var$VerticalButtonTabs;

});

parcelRegister("4YE9f", function(module, exports) {
"use strict";
var $39fbe89ec484fc7d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Led = module.exports.BlinkMode = void 0;

var $joGvE = parcelRequire("joGvE");
var $39fbe89ec484fc7d$var$BlinkMode;
(function(BlinkMode) {
    BlinkMode["Blink"] = "Blink";
    BlinkMode["LightUp"] = "Flash";
    BlinkMode["Both"] = "Both";
})($39fbe89ec484fc7d$var$BlinkMode || (module.exports.BlinkMode = $39fbe89ec484fc7d$var$BlinkMode = {}));
var $39fbe89ec484fc7d$var$Led = /** @class */ function(_super) {
    $39fbe89ec484fc7d$var$__extends(Led, _super);
    function Led(color) {
        if (color === void 0) color = Led.White;
        var _this = _super.call(this, "led") || this;
        _this.previousColor = Led.White;
        _this.currentColor = Led.White;
        _this.blinkTimer = null;
        _this.lightUpTimer = null;
        _this.SetColor(color);
        _this.NoShadow(color);
        return _this;
    }
    Led.prototype.LightUpShadow = function(color) {
        this.Style("box-shadow: 0 0 6px 2px ".concat(color));
    };
    Led.prototype.NoShadow = function(color) {
        this.Style("box-shadow: 0 0 2px 1px ".concat(color));
    };
    Led.prototype.SetColor = function(color) {
        this.previousColor = this.currentColor;
        this.currentColor = color;
        this.Background(color);
        if (color == Led.White) this.Style("border: 1px solid #d8d8d8");
        else this.Style("border: none");
        return this;
    };
    Led.prototype.PreviousColor = function() {
        this.SetColor(this.previousColor);
        return this;
    };
    Led.prototype.LightUp = function(color, duration) {
        var _this = this;
        if (color === void 0) color = this.currentColor;
        if (duration === void 0) duration = 0;
        this.SetColor(color);
        this.LightUpShadow(color);
        this.lightUpTimer && clearTimeout(this.lightUpTimer);
        if (duration > 0) this.lightUpTimer = setTimeout(function() {
            return _this.NoShadow(color);
        }, duration);
        return this;
    };
    Led.prototype.Blink = function(color, interval, mode) {
        var _this = this;
        if (color === void 0) color = this.currentColor;
        if (interval === void 0) interval = 1000;
        if (mode === void 0) mode = $39fbe89ec484fc7d$var$BlinkMode.Blink;
        this.SetColor(color);
        var counter = 0;
        this.blinkTimer && clearInterval(this.blinkTimer);
        if (interval > 0) this.blinkTimer = setInterval(function() {
            if (counter = 1 - counter) switch(mode){
                case $39fbe89ec484fc7d$var$BlinkMode.Blink:
                    _this.SetColor(color);
                    _this.NoShadow(color);
                    break;
                case $39fbe89ec484fc7d$var$BlinkMode.LightUp:
                    _this.LightUpShadow(color);
                    break;
                case $39fbe89ec484fc7d$var$BlinkMode.Both:
                    _this.SetColor(color);
                    _this.LightUpShadow(color);
                    break;
            }
            else switch(mode){
                case $39fbe89ec484fc7d$var$BlinkMode.Blink:
                    _this.SetColor(Led.White);
                    _this.NoShadow(Led.White);
                    break;
                case $39fbe89ec484fc7d$var$BlinkMode.LightUp:
                    _this.NoShadow(color);
                    break;
                case $39fbe89ec484fc7d$var$BlinkMode.Both:
                    _this.SetColor(Led.White);
                    _this.NoShadow(Led.White);
                    break;
            }
        }, interval);
        return this;
    };
    Led.prototype.Destroy = function() {
        this.blinkTimer && clearInterval(this.blinkTimer);
        this.lightUpTimer && clearInterval(this.lightUpTimer);
    };
    Led.Name = "Led";
    Led.Green = "#00e100";
    Led.Yellow = "#ffc107";
    Led.Red = "#f44336";
    Led.White = "#fff";
    Led.Blue = "#007bff";
    Led.Gray = "#c8c8c8";
    Led.Black = "#000";
    Led.Brown = "#8b4513";
    Led.Purple = "#9c27b0";
    Led.Pink = "#e91e63";
    Led.Orange = "#ff9800";
    return Led;
}($joGvE.Div);
module.exports.Led = $39fbe89ec484fc7d$var$Led;

});

parcelRegister("1bL1j", function(module, exports) {
"use strict";
var $0ddb4aba3c249cfe$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProgressBar = void 0;

var $joGvE = parcelRequire("joGvE");

var $k6KGm = parcelRequire("k6KGm");
var $0ddb4aba3c249cfe$var$ProgressBar = /** @class */ function(_super) {
    $0ddb4aba3c249cfe$var$__extends(ProgressBar, _super);
    function ProgressBar(value, color) {
        if (color === void 0) color = "#f0506e";
        var _this = _super.call(this, "div", value) || this;
        _this.bar = new $joGvE.Div().HeightPercent(100);
        _this.Style("width: 100%; height: 2px; background-color: transparent; border: none;");
        _this.bar.Background(color);
        _this.Append(_this.bar);
        _this.Refresh();
        return _this;
    }
    ProgressBar.prototype.Invert = function() {
        this.bar.FloatRight();
        return this;
    };
    ProgressBar.prototype.Refresh = function() {
        this.bar.WidthPercent(this.ref.value);
    };
    ProgressBar.Name = "ProgressBar";
    return ProgressBar;
}($k6KGm.RefComponentBase);
module.exports.ProgressBar = $0ddb4aba3c249cfe$var$ProgressBar;

});

parcelRegister("8BrJA", function(module, exports) {
"use strict";
var $64374ae64cd84fe1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableBuilder = void 0;

var $2s69t = parcelRequire("2s69t");

var $8y6Fd = parcelRequire("8y6Fd");

var $1lIsG = parcelRequire("1lIsG");

var $pCapU = parcelRequire("pCapU");

var $cUBMo = parcelRequire("cUBMo");

var $1lG8E = parcelRequire("1lG8E");

var $7Fc9Q = parcelRequire("7Fc9Q");

var $3lnvs = parcelRequire("3lnvs");
var $64374ae64cd84fe1$var$TableBuilder = /** @class */ function(_super) {
    $64374ae64cd84fe1$var$__extends(TableBuilder, _super);
    function TableBuilder(data) {
        var _a;
        var _this = _super.call(this) || this;
        _this.columns = [];
        _this.body = new $1lIsG.TableBody();
        _this.whenEmpty = new $2s69t.Span("No results").Style("display: block; margin: 48px 0; text-align: center; white-space: nowrap;");
        if (data && data instanceof Array) _this.dataView = new $8y6Fd.CollectionView(new $2s69t.Collection(data)).Refresh();
        else if (data && data instanceof $2s69t.Collection) _this.dataView = new $8y6Fd.CollectionView(data).Refresh();
        else if (data && data instanceof $8y6Fd.CollectionView) _this.dataView = data;
        _this.Class(TableBuilder.DefaultCssClasses);
        (_a = _this.dataView) === null || _a === void 0 || _a.AddSubscriber(_this);
        return _this;
    }
    TableBuilder.prototype.Reset = function() {
        this.columns = [];
        this.Clear();
        return this;
    };
    TableBuilder.prototype.WhenEmpty = function(component) {
        this.whenEmpty = component;
        return this;
    };
    TableBuilder.prototype.Refresh = function() {
        var _this = this;
        var _a, _b, _c, _d;
        this.body.Clear();
        if (((_b = (_a = this.dataView) === null || _a === void 0 ? void 0 : _a.Items) === null || _b === void 0 ? void 0 : _b.length) === 0) this.body.Append(new $cUBMo.TableRow().Append(new $pCapU.TableCell().Merge(this.columns.length).Append(this.whenEmpty)));
        else (_d = (_c = this === null || this === void 0 ? void 0 : this.dataView) === null || _c === void 0 ? void 0 : _c.Items) === null || _d === void 0 || _d.forEach(function(record) {
            var _a;
            var row = new $cUBMo.TableRow();
            (_a = _this.eachRowHandler) === null || _a === void 0 || _a.call(_this, row, record);
            _this.columns.forEach(function(c) {
                if (c.AddWhen && !c.AddWhen(record)) {
                    // Add empty cell
                    var cell_1 = new $pCapU.TableCell();
                    row.Append(cell_1);
                    return;
                }
                var cell = new $pCapU.TableCell();
                var elem = c.Mapping(record, row, cell, _this.body, _this);
                var m;
                if (!Array.isArray(elem)) m = [
                    elem
                ];
                else m = elem;
                m.forEach(function(e) {
                    cell.Append(e);
                });
                row.Append(cell);
            });
            _this.body.Append(row);
        });
    };
    TableBuilder.prototype.Build = function() {
        this.Append(new $3lnvs.TableHeaderV2(this.columns.map(function(x) {
            return x.Headers;
        })));
        this.Refresh();
        this.Append(this.body);
        return this;
    };
    TableBuilder.prototype.AddColumn = function(headers, mapping, addWhen) {
        if (!Array.isArray(headers)) headers = [
            headers
        ];
        this.columns.push(new $7Fc9Q.TableColumn(headers, mapping, addWhen));
        return this;
    };
    TableBuilder.prototype.ForEachRow = function(handler) {
        this.eachRowHandler = handler;
        return this;
    };
    TableBuilder.Name = "TableBuilder";
    TableBuilder.DefaultCssClasses = "uk-table uk-table-small uk-table-divider uk-table-middle";
    return TableBuilder;
}($1lG8E.Table);
module.exports.TableBuilder = $64374ae64cd84fe1$var$TableBuilder;

});
parcelRegister("1lIsG", function(module, exports) {
"use strict";
var $0fba3dc739fa3f8a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableBody = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $0fba3dc739fa3f8a$var$TableBody = /** @class */ function(_super) {
    $0fba3dc739fa3f8a$var$__extends(TableBody, _super); // TODO: no type for tbody?
    function TableBody() {
        return _super.call(this, "tbody") || this;
    }
    return TableBody;
}($aKtiT.ComponentBase);
module.exports.TableBody = $0fba3dc739fa3f8a$var$TableBody;

});

parcelRegister("pCapU", function(module, exports) {
"use strict";
var $04cff1167b76a41a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableCell = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $04cff1167b76a41a$var$TableCell = /** @class */ function(_super) {
    $04cff1167b76a41a$var$__extends(TableCell, _super);
    function TableCell(content) {
        var _this = _super.call(this, "td") || this;
        if (!content) return _this;
        if (typeof content == "string") _this.element.innerText = content;
        else _this.Append(content);
        return _this;
    }
    TableCell.prototype.Merge = function(cellsOnRightCount) {
        this.Attribute("colspan", cellsOnRightCount.toString());
        return this;
    };
    return TableCell;
}($aKtiT.ComponentBase);
module.exports.TableCell = $04cff1167b76a41a$var$TableCell;

});

parcelRegister("cUBMo", function(module, exports) {
"use strict";
var $9668053d81ade9f5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableRow = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $pCapU = parcelRequire("pCapU");
var $9668053d81ade9f5$var$TableRow = /** @class */ function(_super) {
    $9668053d81ade9f5$var$__extends(TableRow, _super);
    function TableRow() {
        return _super.call(this, "tr") || this;
    }
    TableRow.prototype.AddCells = function() {
        var _this = this;
        var cells = [];
        for(var _i = 0; _i < arguments.length; _i++)cells[_i] = arguments[_i];
        cells.forEach(function(c) {
            return _this.Append(new $pCapU.TableCell(c));
        });
        return this;
    };
    return TableRow;
}($aKtiT.ComponentBase);
module.exports.TableRow = $9668053d81ade9f5$var$TableRow;

});

parcelRegister("1lG8E", function(module, exports) {
"use strict";
var $0fb87073a0d55a2d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Table = void 0;

var $2s69t = parcelRequire("2s69t");
var $0fb87073a0d55a2d$var$Table = /** @class */ function(_super) {
    $0fb87073a0d55a2d$var$__extends(Table, _super);
    function Table(headers, body) {
        var _this = _super.call(this, "table") || this;
        _this.Class(Table.DefaultCssClasses);
        if (headers) _this.AddHeaders.apply(_this, headers);
        if (body) body.forEach(function(row) {
            return _this.AddRow.apply(_this, row);
        });
        return _this;
    }
    Table.prototype.AddHeaders = function() {
        var headers = [];
        for(var _i = 0; _i < arguments.length; _i++)headers[_i] = arguments[_i];
        this.Append(new $2s69t.TableHeader(headers));
        return this;
    };
    Table.prototype.AddRow = function() {
        var _a;
        var cells = [];
        for(var _i = 0; _i < arguments.length; _i++)cells[_i] = arguments[_i];
        this.Append((_a = new $2s69t.TableRow()).AddCells.apply(_a, cells));
        return this;
    };
    Table.Name = "Table";
    Table.DefaultCssClasses = "";
    return Table;
}($2s69t.ComponentBase);
module.exports.Table = $0fb87073a0d55a2d$var$Table;

});

parcelRegister("7Fc9Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableColumn = void 0;
var $5945cb0a69213503$var$TableColumn = /** @class */ function() {
    function TableColumn(Headers, Mapping, AddWhen) {
        this.Headers = Headers;
        this.Mapping = Mapping;
        this.AddWhen = AddWhen;
    }
    return TableColumn;
}();
module.exports.TableColumn = $5945cb0a69213503$var$TableColumn;

});

parcelRegister("3lnvs", function(module, exports) {
"use strict";
var $26f591266fc43a13$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableHeaderV2 = void 0;

var $2s69t = parcelRequire("2s69t");
var $26f591266fc43a13$var$TableHeaderV2 = /** @class */ function(_super) {
    $26f591266fc43a13$var$__extends(TableHeaderV2, _super);
    function TableHeaderV2(columnsHeaders) {
        var _this = _super.call(this, "thead") || this;
        var maxRows = Math.max.apply(Math, columnsHeaders.map(function(hs) {
            return hs.length;
        }));
        var _loop_1 = function(rowIndex) {
            var cells = columnsHeaders.map(function(x) {
                return x[rowIndex];
            });
            this_1.Append(new $2s69t.TableHeaderRow(cells));
        };
        var this_1 = this;
        for(var rowIndex = 0; rowIndex < maxRows; rowIndex++)_loop_1(rowIndex);
        return _this;
    }
    return TableHeaderV2;
}($2s69t.ComponentBase);
module.exports.TableHeaderV2 = $26f591266fc43a13$var$TableHeaderV2;

});


parcelRegister("bdjAM", function(module, exports) {
"use strict";
var $82a01b3c4a454fc0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableHeader = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $dLmKH = parcelRequire("dLmKH");
var $82a01b3c4a454fc0$var$TableHeader = /** @class */ function(_super) {
    $82a01b3c4a454fc0$var$__extends(TableHeader, _super);
    function TableHeader(headers) {
        var _this = _super.call(this, "thead") || this;
        if (headers) _this.Append(new $dLmKH.TableHeaderRow(headers));
        return _this;
    }
    return TableHeader;
}($aKtiT.ComponentBase);
module.exports.TableHeader = $82a01b3c4a454fc0$var$TableHeader;

});
parcelRegister("dLmKH", function(module, exports) {
"use strict";
var $a05150494376724d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableHeaderRow = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $kWKxK = parcelRequire("kWKxK");
var $a05150494376724d$var$TableHeaderRow = /** @class */ function(_super) {
    $a05150494376724d$var$__extends(TableHeaderRow, _super);
    function TableHeaderRow(strings) {
        var _this = _super.call(this, "tr") || this;
        strings.forEach(function(str) {
            _this.Append(new $kWKxK.TableHeaderCell(str));
        });
        return _this;
    }
    return TableHeaderRow;
}($aKtiT.ComponentBase);
module.exports.TableHeaderRow = $a05150494376724d$var$TableHeaderRow;

});
parcelRegister("kWKxK", function(module, exports) {
"use strict";
var $f3fd53f403c219a2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableHeaderCell = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $f3fd53f403c219a2$var$TableHeaderCell = /** @class */ function(_super) {
    $f3fd53f403c219a2$var$__extends(TableHeaderCell, _super);
    function TableHeaderCell(element) {
        var _this = _super.call(this, "th") || this;
        if (!element) return _this;
        if (typeof element == "string") _this.Text(element);
        else _this.Append(element);
        return _this;
    }
    return TableHeaderCell;
}($aKtiT.ComponentBase);
module.exports.TableHeaderCell = $f3fd53f403c219a2$var$TableHeaderCell;

});



parcelRegister("2ZZKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonViewerConfig = void 0;
var $22f12e1fe2753cc2$var$JsonViewerConfig = /** @class */ function() {
    function JsonViewerConfig() {
        this.foldAll = true;
        this.foldSymbol = "\u2795";
        this.unfoldSymbol = "\u2796";
        this.keyPrinter = function(key, objType) {
            return "\u25FE " + key + ":";
        };
        this.arrayKeyPrinter = function(index, objType) {
            return "#" + index;
        };
        this.keyStyle = "color: #222";
        this.nullStyle = "color: #ff7f96";
        this.stringStyle = "color: green";
        this.numberStyle = "color: blue";
        this.boolStyle = "color: violet";
        this.typePrinter = function(t) {
            return "(" + t + ")";
        };
        this.typeInfoStyle = "color: #aaa; font-style: italic;";
        this.maxStringLength = 100;
        this.indent = 22;
        this.showCopyIcon = true;
        this.copyValueIcon = "\uD83D\uDCCB";
        this.openLinkButton = "\uD83C\uDF10";
        this.markedColor = "yellow";
    }
    return JsonViewerConfig;
}();
module.exports.JsonViewerConfig = $22f12e1fe2753cc2$var$JsonViewerConfig;

});

parcelRegister("eBKPc", function(module, exports) {
"use strict";
var $aa28d7d45cf2f7d2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aa28d7d45cf2f7d2$var$__assign = module.exports && module.exports.__assign || function() {
    $aa28d7d45cf2f7d2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aa28d7d45cf2f7d2$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonViewer = module.exports.RefJsonViewer = void 0;

var $hPtm1 = parcelRequire("hPtm1");

var $5PIlt = parcelRequire("5PIlt");

var $8UMl5 = parcelRequire("8UMl5");

var $joGvE = parcelRequire("joGvE");

var $2ZZKK = parcelRequire("2ZZKK");

var $gkD0R = parcelRequire("gkD0R");
var $aa28d7d45cf2f7d2$var$RefJsonViewer = /** @class */ function(_super) {
    $aa28d7d45cf2f7d2$var$__extends(RefJsonViewer, _super);
    function RefJsonViewer(objAsString, config) {
        var _this = _super.call(this) || this;
        objAsString.OnChange(function(x) {
            var ob;
            try {
                ob = JSON.parse(x);
            } catch (ex) {
                return;
            }
            _this.Clear().Append(new $aa28d7d45cf2f7d2$var$JsonViewer(ob, undefined, config));
        }, true);
        return _this;
    }
    return RefJsonViewer;
}($joGvE.Div);
module.exports.RefJsonViewer = $aa28d7d45cf2f7d2$var$RefJsonViewer;
var $aa28d7d45cf2f7d2$var$ValuePrinter = /** @class */ function(_super) {
    $aa28d7d45cf2f7d2$var$__extends(ValuePrinter, _super);
    function ValuePrinter(value, style, config) {
        var _this = _super.call(this, value) || this;
        _this.config = config;
        _this.Margin(8).MarginLeft(0).Style(style).CursorPointer().OnClick(function(self) {
            return _this.Mark(self);
        });
        return _this;
    }
    ValuePrinter.prototype.Mark = function(element) {
        element.ToggleStyle("background-color", this.config.markedColor, "transparent");
    };
    return ValuePrinter;
}($gkD0R.Span);
var $aa28d7d45cf2f7d2$var$ValueTypePrinter = /** @class */ function(_super) {
    $aa28d7d45cf2f7d2$var$__extends(ValueTypePrinter, _super);
    function ValueTypePrinter(type, config) {
        var _this = _super.call(this, config.typePrinter(type)) || this;
        _this.config = config;
        _this.CursorPointer().Style(config.typeInfoStyle).OnClick(function(self) {
            return _this.Mark(self);
        });
        return _this;
    }
    ValueTypePrinter.prototype.Mark = function(element) {
        element.ToggleStyle("background-color", this.config.markedColor, "transparent");
    };
    return ValueTypePrinter;
}($gkD0R.Span);
var $aa28d7d45cf2f7d2$var$JsonViewer = /** @class */ function(_super) {
    $aa28d7d45cf2f7d2$var$__extends(JsonViewer, _super);
    function JsonViewer(obj, key, config) {
        if (key === void 0) key = "";
        var _this = _super.call(this) || this;
        _this.config = config;
        _this.Config = new $2ZZKK.JsonViewerConfig();
        _this.Config = $aa28d7d45cf2f7d2$var$__assign($aa28d7d45cf2f7d2$var$__assign({}, _this.Config), _this.config);
        var tk = new $hPtm1.TwoFloatingColumns();
        var objType = typeof obj;
        if (key) tk.LeftColumn.Append(new $gkD0R.Span(_this.Config.keyPrinter(key, objType)).FloatLeft().MarginRight(6).Style(_this.Config.keyStyle).CursorPointer().OnClick(function(_) {
            return _.ToggleStyle("background-color", _this.Config.markedColor, "transparent");
        }));
        if (obj === null) tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter("null", _this.Config.nullStyle, _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter("null", _this.Config));
        else if (objType === "string") {
            var str = void 0;
            if (obj.length > _this.Config.maxStringLength) str = '"'.concat(obj.slice(0, _this.Config.maxStringLength), '....."');
            else str = '"'.concat(obj, '"');
            var isLink = obj.startsWith("http");
            var printer = new $aa28d7d45cf2f7d2$var$ValuePrinter(str, _this.Config.stringStyle, _this.Config);
            // if (isLink)
            // {
            //     printer.OnHover(_=>_.Style("text-decoration: underline"))
            //         .OnMouseOut(_=>_.Style("text-decoration: none"))
            // }
            tk.RightColumn.Append(printer);
            tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValueTypePrinter("".concat(obj.length, " char").concat(obj.length > 1 ? "s" : "", " string"), _this.Config), _this.Config.showCopyIcon && new $8UMl5.CopyIcon(obj, _this.Config.copyValueIcon), isLink && new $5PIlt.Link(_this.Config.openLinkButton, obj).MarginLeft(4).NoDecorationOnHover().OpenInNewCard());
        } else if (objType === "number") tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter(obj.toString(), _this.Config.numberStyle, _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter("number", _this.Config), _this.Config.showCopyIcon && new $8UMl5.CopyIcon(obj.toString(), _this.Config.copyValueIcon));
        else if (objType === "boolean") tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter(obj ? "true" : "false", _this.Config.boolStyle, _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter("boolean", _this.Config));
        else if (Array.isArray(obj)) {
            if (obj.length === 0) tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter("[ ]", "", _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter("empty array", _this.Config));
            else {
                var foldButton_1 = new $5PIlt.Link(_this.Config.foldSymbol).NoDecorationOnHover().MarginLeft(4).MarginRight(4).CursorPointer().OnClick(function() {
                    foldButton_1.Text(tk.RightColumn.IsVisible() ? _this.Config.foldSymbol : _this.Config.unfoldSymbol);
                    tk.RightColumn.Toggle();
                });
                tk.LeftColumn.Append(new $aa28d7d45cf2f7d2$var$ValueTypePrinter("array of ".concat(obj.length, " ").concat(_this.GetType(obj[0])).concat(obj.length > 1 ? "s" : ""), _this.Config), foldButton_1);
                if (_this.Config.foldAll) {
                    tk.RightColumn.Hide();
                    foldButton_1.Text(_this.Config.foldSymbol);
                } else {
                    tk.RightColumn.Show();
                    foldButton_1.Text(_this.Config.unfoldSymbol);
                }
                tk.LeftColumn.WidthPercent(100);
                tk.RightColumn.MarginLeft(_this.Config.indent);
                obj.forEach(function(e, i) {
                    return tk.RightColumn.Append(new JsonViewer(e, _this.Config.arrayKeyPrinter(i.toString(), typeof e), _this.config));
                });
            }
        } else if (objType === "object") {
            var keys = Object.keys(obj);
            if (keys.length === 0) tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter("{ }", "", _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter("empty object", _this.Config));
            else {
                if (key) {
                    var foldButton_2 = new $5PIlt.Link(_this.Config.foldSymbol).NoDecorationOnHover().MarginLeft(4).MarginRight(4).CursorPointer().OnClick(function() {
                        foldButton_2.Text(tk.RightColumn.IsVisible() ? _this.Config.foldSymbol : _this.Config.unfoldSymbol);
                        tk.RightColumn.Toggle();
                    });
                    tk.LeftColumn.Append(new $aa28d7d45cf2f7d2$var$ValueTypePrinter("".concat(keys.length, " field").concat(keys.length > 1 ? "s" : "", " object"), _this.Config), foldButton_2);
                    tk.LeftColumn.WidthPercent(100);
                    tk.RightColumn.MarginLeft(_this.Config.indent);
                    if (_this.Config.foldAll) {
                        tk.RightColumn.Hide();
                        foldButton_2.Text(_this.Config.foldSymbol);
                    } else {
                        tk.RightColumn.Show();
                        foldButton_2.Text(_this.Config.unfoldSymbol);
                    }
                }
                keys.forEach(function(k) {
                    var v = obj[k];
                    tk.RightColumn.Append(new JsonViewer(v, k, _this.config));
                });
            }
        }
        _this.Append(tk);
        _this.Append(new $joGvE.Div().ClearBoth());
        return _this;
    }
    JsonViewer.prototype.GetType = function(obj) {
        var objType = typeof obj;
        var isArray = Array.isArray(obj);
        if (isArray && obj.length > 0) return "array of ".concat(this.GetType(obj[0]), "s");
        else if (isArray) return "array";
        else return objType;
    };
    JsonViewer.Name = "JsonViewer";
    return JsonViewer;
}($joGvE.Div);
module.exports.JsonViewer = $aa28d7d45cf2f7d2$var$JsonViewer;

});

parcelRegister("e6E17", function(module, exports) {
"use strict";
var $a450aac81bb82448$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a450aac81bb82448$var$__assign = module.exports && module.exports.__assign || function() {
    $a450aac81bb82448$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a450aac81bb82448$var$__assign.apply(this, arguments);
};
var $a450aac81bb82448$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a450aac81bb82448$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Snack = module.exports.SnackPrinter = module.exports.SnackOptions = void 0;

var $iqyiC = parcelRequire("iqyiC");

var $6wI3m = parcelRequire("6wI3m");

var $1bL1j = parcelRequire("1bL1j");

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");
var $a450aac81bb82448$var$SnackOptions = /** @class */ function() {
    function SnackOptions() {
        this.autoCloseTimeout = 4500;
        this.showCloseButton = true;
        this.clickAnywhereToClose = false;
        this.showTimeoutBar = true;
    }
    return SnackOptions;
}();
module.exports.SnackOptions = $a450aac81bb82448$var$SnackOptions;
var $a450aac81bb82448$var$SnackPrinter = /** @class */ function(_super) {
    $a450aac81bb82448$var$__extends(SnackPrinter, _super);
    function SnackPrinter(header, content, options) {
        var _this = _super.call(this) || this;
        _this.CloseButton = new $gkD0R.Span("\xd7").Class("tf-snack-x");
        _this.timer = null;
        var opt = $a450aac81bb82448$var$__assign($a450aac81bb82448$var$__assign({}, new $a450aac81bb82448$var$SnackOptions()), options);
        var p = new $6wI3m.Ref(100);
        if (opt.showTimeoutBar && opt.autoCloseTimeout && opt.autoCloseTimeout > 0) _this.timer = setInterval(function() {
            return p.value--;
        }, opt.autoCloseTimeout / 100);
        _this.Append(opt.showTimeoutBar && new $1bL1j.ProgressBar(p).Invert(), opt.showCloseButton && _this.CloseButton, new $joGvE.Div().Append(header).Class("tf-snack-label"), content && new $joGvE.Div().Append(content).Class("tf-snack-content"));
        return _this;
    }
    SnackPrinter.prototype.OnRemove = function() {
        return $a450aac81bb82448$var$__awaiter(this, void 0, void 0, function() {
            return $a450aac81bb82448$var$__generator(this, function(_a) {
                if (this.timer) clearInterval(this.timer);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return SnackPrinter;
}($joGvE.Div);
module.exports.SnackPrinter = $a450aac81bb82448$var$SnackPrinter;
var $a450aac81bb82448$var$Snack = /** @class */ function(_super) {
    $a450aac81bb82448$var$__extends(Snack, _super);
    function Snack(header, content, options) {
        var _a;
        var _b;
        var _this = _super.call(this) || this;
        _this.Config = new $a450aac81bb82448$var$SnackOptions();
        _this.Class(Snack.DefaultCssClasses);
        _this.Config = $a450aac81bb82448$var$__assign($a450aac81bb82448$var$__assign({}, _this.Config), options);
        var cont = Array.isArray(content) ? (_a = new $joGvE.Div()).Append.apply(_a, content) : content;
        var printer = new $a450aac81bb82448$var$SnackPrinter(header, cont, _this.Config);
        printer.CloseButton.OnClick(function() {
            return _this.Close();
        });
        _this.Append(printer);
        if (_this.Config.clickAnywhereToClose) _this.OnClick(function() {
            _this.Close();
        });
        (_b = (0, $iqyiC.$)("body")) === null || _b === void 0 || _b.Append(_this.Element);
        if (_this.Config.autoCloseTimeout && _this.Config.autoCloseTimeout > 0) setTimeout(function() {
            return _this.Close();
        }, _this.Config.autoCloseTimeout);
        return _this;
    }
    Snack.prototype.Close = function() {
        var _a;
        (_a = (0, $iqyiC.$)("body")) === null || _a === void 0 || _a.Remove(this.Element);
        return this;
    };
    Snack.Name = "Snack";
    Snack.DefaultCssClasses = "tf-snack";
    return Snack;
}($joGvE.Div);
module.exports.Snack = $a450aac81bb82448$var$Snack;

});

parcelRegister("50yqK", function(module, exports) {
"use strict";
var $3a57a8fc65d9b876$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicPaginator = void 0;

var $3B1VX = parcelRequire("3B1VX");

var $2s69t = parcelRequire("2s69t");

var $kanmU = parcelRequire("kanmU");
var $3a57a8fc65d9b876$var$BasicPaginator = /** @class */ function(_super) {
    $3a57a8fc65d9b876$var$__extends(BasicPaginator, _super);
    function BasicPaginator(start, count, total, filtered) {
        var _this = _super.call(this, "paginator") || this;
        _this.count = count;
        _this.goToFirstButton = new $2s69t.Button("\xab").FontSize(18).Padding(0, 14).OnClick(function() {
            return _this.Brain.GoToFirst();
        });
        _this.gotoPreviousButton = new $2s69t.Button("\u2039").FontSize(18).Padding(0, 14).OnClick(function() {
            return _this.Brain.GoToPreviousPage();
        });
        _this.gotoNextButton = new $2s69t.Button("\u203A").FontSize(18).Padding(0, 14).OnClick(function() {
            return _this.Brain.GoToNextPage();
        });
        _this.gotoLastButton = new $2s69t.Button("\xbb").FontSize(18).Padding(0, 14).OnClick(function() {
            return _this.Brain.GoToLast();
        });
        _this.Brain = new $kanmU.PaginatorBrain(start, count, total, filtered);
        _this.display = new $3B1VX.Text(_this.Brain.display).Style("vertical-align: middle; margin: 0 16px");
        return _this;
    }
    BasicPaginator.prototype.AddGoToFirstButton = function() {
        this.Append(this.goToFirstButton);
        return this;
    };
    BasicPaginator.prototype.AddGoToPreviousButton = function() {
        this.Append(this.gotoPreviousButton);
        return this;
    };
    BasicPaginator.prototype.AddDisplay = function() {
        this.Append(this.display);
        return this;
    };
    BasicPaginator.prototype.AddGoToNextButton = function() {
        this.Append(this.gotoNextButton);
        return this;
    };
    BasicPaginator.prototype.AddGoToLastButton = function() {
        this.Append(this.gotoLastButton);
        return this;
    };
    BasicPaginator.prototype.AddPagesCountSwitch = function(pageSizes) {
        var _this = this;
        if (pageSizes === void 0) pageSizes = [
            5,
            10,
            20
        ];
        var pageSizesOptions = pageSizes.map(function(x) {
            return new $2s69t.SelectOption("".concat(x, " ").concat(_this.Brain.options.PerPageTranslation), x);
        });
        var pagesCountSwitch = new $2s69t.Select(this.count, pageSizesOptions).ModifyAfterChange(function(v) {
            return +v;
        }).WidthAuto();
        this.Append(pagesCountSwitch);
        return this;
    };
    return BasicPaginator;
}($2s69t.Div);
module.exports.BasicPaginator = $3a57a8fc65d9b876$var$BasicPaginator;

});
parcelRegister("kanmU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PaginatorBrain = module.exports.PaginatorBrainOptions = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $eae6de5785a00ef7$var$PaginatorBrainOptions = /** @class */ function() {
    function PaginatorBrainOptions() {
        this.FilteredTranslation = "filtered";
        this.InTotalTranslation = "in total";
        this.NoResultsTranslation = "No results";
        this.PerPageTranslation = "per page";
    }
    return PaginatorBrainOptions;
}();
module.exports.PaginatorBrainOptions = $eae6de5785a00ef7$var$PaginatorBrainOptions;
var $eae6de5785a00ef7$var$PaginatorBrain = /** @class */ function() {
    function PaginatorBrain(start, count, total, filtered, options) {
        if (options === void 0) options = new $eae6de5785a00ef7$var$PaginatorBrainOptions();
        var _this = this;
        this.start = start;
        this.count = count;
        this.total = total;
        this.filtered = filtered;
        this.options = options;
        this.display = new $6wI3m.Ref("");
        this.start.OnChange(function(_) {
            return _this.Refresh();
        });
        this.count.OnChange(function(_) {
            return _this.Refresh();
        });
        this.total.OnChange(function(_) {
            return _this.Refresh();
        });
        this.filtered.OnChange(function(_) {
            return _this.Refresh();
        });
        this.Refresh();
    }
    PaginatorBrain.prototype.Refresh = function() {
        var _a = this.Calc(), start = _a[0], end = _a[1];
        var total = this.total.value;
        var filtered = this.filtered.value;
        if (filtered > 0 && total > 0) {
            start += 1;
            if (start > end) start = end;
        }
        if (start < 0) start = 0;
        if (filtered != total) this.display.value = "".concat(start, " - ").concat(end, " / ").concat(filtered, " ").concat(this.options.FilteredTranslation, " / ").concat(total, " ").concat(this.options.InTotalTranslation);
        else if (start == end && start == 0) this.display.value = this.options.NoResultsTranslation;
        else if (start == end) this.display.value = "".concat(start, " / ").concat(total);
        else this.display.value = "".concat(start, " - ").concat(end, " / ").concat(total);
    };
    PaginatorBrain.prototype.Calc = function() {
        var start = this.start.value;
        var count = this.count.value;
        var last = this.filtered.value;
        var end = 0;
        if (start < 0) start = 0;
        if (start >= last) start = last;
        end = start + count;
        if (end >= last) end = last;
        if (start == end && start > 0) start -= 1;
        this.start.value = start;
        return [
            start,
            end
        ];
    };
    PaginatorBrain.prototype.GoToNextPage = function() {
        this.start.value += this.count.value;
    };
    PaginatorBrain.prototype.GoToPreviousPage = function() {
        this.start.value -= this.count.value;
    };
    PaginatorBrain.prototype.GoToFirst = function() {
        this.start.value = 0;
    };
    PaginatorBrain.prototype.GoToLast = function() {
        this.start.value = this.total.value - 1;
    };
    return PaginatorBrain;
}();
module.exports.PaginatorBrain = $eae6de5785a00ef7$var$PaginatorBrain;

});


parcelRegister("et3h1", function(module, exports) {
"use strict";
var $a886502ccd1e8fc0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimplePaginator = void 0;

var $50yqK = parcelRequire("50yqK");
var $a886502ccd1e8fc0$var$SimplePaginator = /** @class */ function(_super) {
    $a886502ccd1e8fc0$var$__extends(SimplePaginator, _super);
    function SimplePaginator(start, count, total, filtered) {
        var _this = _super.call(this, start, count, total, filtered) || this;
        _this.AddGoToFirstButton();
        _this.AddGoToPreviousButton();
        _this.AddDisplay();
        _this.AddGoToNextButton();
        _this.AddGoToLastButton();
        _this.AddPagesCountSwitch([
            5,
            10,
            30
        ]);
        return _this;
    }
    return SimplePaginator;
}($50yqK.BasicPaginator);
module.exports.SimplePaginator = $a886502ccd1e8fc0$var$SimplePaginator;

});

parcelRegister("5snGY", function(module, exports) {
"use strict";
var $3f91f20cf066699d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionPaginator = module.exports.CollectionPaginatorOptions = void 0;

var $epBKP = parcelRequire("epBKP");

var $50yqK = parcelRequire("50yqK");
var $3f91f20cf066699d$var$CollectionPaginatorOptions = /** @class */ function() {
    function CollectionPaginatorOptions() {
        this.PerPage = [
            10,
            30,
            100
        ];
        this.PerPageStorageKey = "";
    }
    return CollectionPaginatorOptions;
}();
module.exports.CollectionPaginatorOptions = $3f91f20cf066699d$var$CollectionPaginatorOptions;
var $3f91f20cf066699d$var$CollectionPaginator = /** @class */ function(_super) {
    $3f91f20cf066699d$var$__extends(CollectionPaginator, _super);
    function CollectionPaginator(collectionView, options) {
        if (options === void 0) options = new $3f91f20cf066699d$var$CollectionPaginatorOptions();
        var _this = this;
        var start = new $epBKP.RefNumber(0);
        var count = new $epBKP.RefNumber(options.PerPage[0] || 10).Storable(options === null || options === void 0 ? void 0 : options.PerPageStorageKey);
        var total = collectionView.Collection.CountRef;
        var filtered = collectionView.FilteredCount;
        collectionView.See(start, count).Refresh();
        _this = _super.call(this, start, count, total, filtered) || this;
        _this.AddGoToFirstButton();
        _this.AddGoToPreviousButton();
        _this.AddDisplay();
        _this.AddGoToNextButton();
        _this.AddGoToLastButton();
        _this.AddPagesCountSwitch(options.PerPage);
        return _this;
    }
    return CollectionPaginator;
}($50yqK.BasicPaginator);
module.exports.CollectionPaginator = $3f91f20cf066699d$var$CollectionPaginator;

});

parcelRegister("bjWq6", function(module, exports) {
"use strict";
var $83dec913f80e5f62$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Spinner = void 0;

var $2s69t = parcelRequire("2s69t");
var $83dec913f80e5f62$var$Spinner = /** @class */ function(_super) {
    $83dec913f80e5f62$var$__extends(Spinner, _super);
    function Spinner() {
        var _this = _super.call(this, "div") || this;
        _this.Attribute("uk-spinner").Style("margin-left", "8px");
        return _this;
    }
    return Spinner;
}($2s69t.ComponentBase);
module.exports.Spinner = $83dec913f80e5f62$var$Spinner;

});

parcelRegister("ckMZV", function(module, exports) {
"use strict";
var $8fad5c3bf2fab2a9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pie = void 0;

var $k6KGm = parcelRequire("k6KGm");
// https://www.freecodecamp.org/news/css-only-pie-chart/
var $8fad5c3bf2fab2a9$var$Pie = /** @class */ function(_super) {
    $8fad5c3bf2fab2a9$var$__extends(Pie, _super);
    function Pie(value) {
        var _this = _super.call(this, "div", value) || this;
        _this.Refresh();
        return _this;
    // this.Style(`--p: ${value}; --b: 22px; --c: #1e87f0;`)
    // this.Text(value.toString() + "%")
    }
    Pie.prototype.Refresh = function() {
        this.Html('<div class="pie" style="--p:'.concat(this.ref.value, ';--b:18px;--c:lightblue;">').concat(this.ref.value, "%</div>"));
    };
    Pie.Name = "Pie";
    return Pie;
}($k6KGm.RefComponentBase);
module.exports.Pie = $8fad5c3bf2fab2a9$var$Pie;

});

parcelRegister("djLWA", function(module, exports) {
"use strict";
var $9b223d6054e3ab07$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9b223d6054e3ab07$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OnlineStorage = void 0;

var $cOIL8 = parcelRequire("cOIL8");
// TODO: remove due to better OnlineStorage @ @tblabs/storage
var $9b223d6054e3ab07$var$OnlineStorage = /** @class */ function() {
    function OnlineStorage(url) {
        this.url = url;
    }
    OnlineStorage.prototype.Upload = function(file_1, newFileNameWithoutExtension_1) {
        return $9b223d6054e3ab07$var$__awaiter(this, arguments, void 0, function(file, newFileNameWithoutExtension, folder, override) {
            var fileExtension, formData, response, fileDir, ex_1;
            if (folder === void 0) folder = "";
            if (override === void 0) override = true;
            return $9b223d6054e3ab07$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!file || !(newFileNameWithoutExtension === null || newFileNameWithoutExtension === void 0 ? void 0 : newFileNameWithoutExtension.trim())) return [
                            2 /*return*/ ,
                            $cOIL8.UploadResult.Failure("No file or file name provided")
                        ];
                        fileExtension = file.name.split(".").pop();
                        formData = new FormData();
                        formData.append("file", file);
                        formData.append("folder", folder.trim());
                        formData.append("name", newFileNameWithoutExtension.trim() + "." + fileExtension);
                        formData.append("override", override ? "override-if-exist" : "throw-if-already-exist");
                        return [
                            4 /*yield*/ ,
                            fetch(this.url, {
                                method: "POST",
                                body: formData
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) throw new Error("Request failed with status ".concat(response.status));
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 2:
                        fileDir = _a.sent();
                        return [
                            2 /*return*/ ,
                            $cOIL8.UploadResult.Success(fileDir)
                        ];
                    case 3:
                        ex_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $cOIL8.UploadResult.Failure("Can not upload: ".concat(ex_1.message))
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return OnlineStorage;
}();
module.exports.OnlineStorage = $9b223d6054e3ab07$var$OnlineStorage;

});
parcelRegister("cOIL8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UploadResult = void 0;
var $954cdfd10ed9378c$var$UploadResult = /** @class */ function() {
    function UploadResult(IsSuccess, UploadedFileDir, ErrorMessage) {
        if (IsSuccess === void 0) IsSuccess = false;
        if (UploadedFileDir === void 0) UploadedFileDir = "";
        if (ErrorMessage === void 0) ErrorMessage = "";
        this.IsSuccess = IsSuccess;
        this.UploadedFileDir = UploadedFileDir;
        this.ErrorMessage = ErrorMessage;
    }
    UploadResult.Success = function(dir) {
        return new UploadResult(true, dir, "");
    };
    UploadResult.Failure = function(reason) {
        return new UploadResult(false, "", reason);
    };
    return UploadResult;
}();
module.exports.UploadResult = $954cdfd10ed9378c$var$UploadResult;

});


parcelRegister("aq9Em", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Switch = void 0;
var $7963d1637bb659f7$var$Switch = /** @class */ function() {
    function Switch(valueFromCtor) {
        this.valueFromCtor = valueFromCtor;
        this.cases = {};
    }
    Switch.prototype.Case = function(value, toDo) {
        this.cases[value] = toDo;
        return this;
    };
    Switch.prototype.Default = function(toDo) {
        this.default = toDo;
        return this;
    };
    Switch.prototype.Execute = function(variable) {
        var _a, _b, _c, _d, _e, _f;
        if (!variable) return ((_b = (_a = this.cases) === null || _a === void 0 ? void 0 : _a[this.valueFromCtor]) === null || _b === void 0 ? void 0 : _b.call(_a)) || ((_c = this.default) === null || _c === void 0 ? void 0 : _c.call(this)) || undefined;
        return ((_e = (_d = this.cases) === null || _d === void 0 ? void 0 : _d[variable]) === null || _e === void 0 ? void 0 : _e.call(_d)) || ((_f = this.default) === null || _f === void 0 ? void 0 : _f.call(this)) || undefined;
    };
    return Switch;
}();
module.exports.Switch = $7963d1637bb659f7$var$Switch;

});


















var $45fvw = parcelRequire("45fvw");
var $3798e175c5551adb$exports = {};
//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

(function(global, factory) {
    factory((parcelRequire("45fvw")));
})($3798e175c5551adb$exports, function(moment) {
    "use strict";
    //! moment.js locale configuration
    var monthsNominative = "stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017Adziernik_listopad_grudzie\u0144".split("_"), monthsSubjective = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015Bnia_pa\u017Adziernika_listopada_grudnia".split("_"), monthsParse = [
        /^sty/i,
        /^lut/i,
        /^mar/i,
        /^kwi/i,
        /^maj/i,
        /^cze/i,
        /^lip/i,
        /^sie/i,
        /^wrz/i,
        /^paź/i,
        /^lis/i,
        /^gru/i
    ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + " ";
        switch(key){
            case "ss":
                return result + (plural(number) ? "sekundy" : "sekund");
            case "m":
                return withoutSuffix ? "minuta" : "minut\u0119";
            case "mm":
                return result + (plural(number) ? "minuty" : "minut");
            case "h":
                return withoutSuffix ? "godzina" : "godzin\u0119";
            case "hh":
                return result + (plural(number) ? "godziny" : "godzin");
            case "ww":
                return result + (plural(number) ? "tygodnie" : "tygodni");
            case "MM":
                return result + (plural(number) ? "miesi\u0105ce" : "miesi\u0119cy");
            case "yy":
                return result + (plural(number) ? "lata" : "lat");
        }
    }
    var pl = moment.defineLocale("pl", {
        months: function(momentToFormat, format) {
            if (!momentToFormat) return monthsNominative;
            else if (/D MMMM/.test(format)) return monthsSubjective[momentToFormat.month()];
            else return monthsNominative[momentToFormat.month()];
        },
        monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017A_lis_gru".split("_"),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: "niedziela_poniedzia\u0142ek_wtorek_\u015Broda_czwartek_pi\u0105tek_sobota".split("_"),
        weekdaysShort: "ndz_pon_wt_\u015Br_czw_pt_sob".split("_"),
        weekdaysMin: "Nd_Pn_Wt_\u015Ar_Cz_Pt_So".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Dzi\u015B o] LT",
            nextDay: "[Jutro o] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[W niedziel\u0119 o] LT";
                    case 2:
                        return "[We wtorek o] LT";
                    case 3:
                        return "[W \u015Brod\u0119 o] LT";
                    case 6:
                        return "[W sobot\u0119 o] LT";
                    default:
                        return "[W] dddd [o] LT";
                }
            },
            lastDay: "[Wczoraj o] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[W zesz\u0142\u0105 niedziel\u0119 o] LT";
                    case 3:
                        return "[W zesz\u0142\u0105 \u015Brod\u0119 o] LT";
                    case 6:
                        return "[W zesz\u0142\u0105 sobot\u0119 o] LT";
                    default:
                        return "[W zesz\u0142y] dddd [o] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "%s temu",
            s: "kilka sekund",
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: "1 dzie\u0144",
            dd: "%d dni",
            w: "tydzie\u0144",
            ww: translate,
            M: "miesi\u0105c",
            MM: translate,
            y: "rok",
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    return pl;
});



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $b654a702b809d076$export$81a299892cc9479c extends (0, $2s69t.ComponentBase) {
    constructor(className){
        super("article");
        this.Class(className);
    }
}



var $2s69t = parcelRequire("2s69t");
class $3bb00af81c679004$export$448e687a629d6c89 extends (0, $2s69t.ComponentBase) {
    constructor(imageUrl){
        super("figure");
        this.Class("product-card__image-container");
        this.Append(new (0, $2s69t.Image)(imageUrl).Class("product-card__image").Attribute("loading", "lazy"), new (0, $2s69t.Div)("product-card__image-overlay").Attribute("role", "presentation"));
    }
}
class $3bb00af81c679004$export$e0198da9c9cf3981 extends (0, $2s69t.ComponentBase) {
    constructor(imageUrl){
        super("figure");
        this.Class("product-card__image-container");
        this.Append(new (0, $2s69t.Image)(imageUrl).Class("product-card__image").Attribute("loading", "lazy"));
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $1614c8db74c4885c$export$e71c4d32a2263218 extends (0, $2s69t.Div) {
    constructor(className, content){
        super(className);
        this.Append(...content);
    }
}


class $2456fa212220ae4e$export$ad8695fad87bad08 extends (0, $1614c8db74c4885c$export$e71c4d32a2263218) {
    constructor(product){
        const rating = product.Rating.Plus(1); // ex. 4.93 = 5 stars, not 4
        super("product__rating", [
            new (0, $2s69t.Rate)(rating, {
                SelectedSymbol: "\u2B50",
                DeselectedSymbol: "\u2B50",
                Count: 5,
                Readonly: true,
                DeselectedStyle: "opacity: 0.3"
            }).Class("product__rating-stars"),
            new (0, $2s69t.Text)(product.Rating, (v)=>v + "/5").Class("product__rating-score")
        ]);
    }
}



var $2s69t = parcelRequire("2s69t");
class $4cabb9c17fd0d780$export$e17b9c1182212c96 extends (0, $2s69t.Div) {
    constructor(svgAsText){
        super();
        this.DisplayInlineBlock();
        if (svgAsText instanceof (0, $2s69t.Ref)) svgAsText.OnChange((v)=>this.Html(v), true);
        else this.Html(svgAsText);
    }
}


class $e713613ae4567f75$export$4f13f83fd8bb1dac {
}
$e713613ae4567f75$export$4f13f83fd8bb1dac.Star = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-star product-reviews__star fill-rose-400 text-rose-400"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.EmptyStar = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-star product-reviews__star text-slate-400"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.ChevronDown = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.ChevronUp = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-up-icon lucide-chevron-up"><path d="m18 15-6-6-6 6"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.ArrowUp = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-move-up-left-icon lucide-move-up-left"><path d="M5 11V5H11"/><path d="M5 5L19 19"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.ArrowDown = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-move-down-right-icon lucide-move-down-right"><path d="M19 13V19H13"/><path d="M5 5L19 19"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.X = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x-icon lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Info = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-badge-info-icon lucide-badge-info"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><line x1="12" x2="12" y1="16" y2="12"/><line x1="12" x2="12.01" y1="8" y2="8"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.ArrowRight = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right product-card__button-icon"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Search = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search icon search__icon"> <circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.PercentSquare = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-percent-square product-accordion__icon text-rose-400"><rect width="18" height="18" x="3" y="3" rx="2"></rect><path d="m15 9-6 6"></path><path d="M9 9h.01"></path><path d="M15 15h.01"></path></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Package = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-package-icon lucide-package"><path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"/><path d="M12 22V12"/><polyline points="3.29 7 12 12 20.71 7"/><path d="m7.5 4.27 9 5.15"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Ticket = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ticket-percent-icon lucide-ticket-percent"><path d="M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M9 9h.01"/><path d="m15 9-6 6"/><path d="M15 15h.01"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Truck = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-truck-icon lucide-truck"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Wallet = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-wallet-icon lucide-wallet"><path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"/><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Person = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-person-standing-icon lucide-person-standing"><circle cx="12" cy="5" r="1"/><path d="m9 20 3-6 3 6"/><path d="m6 8 6 2 6-2"/><path d="M12 10v4"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Phone = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone-icon lucide-phone"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Mail = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-mail-icon lucide-mail"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"/><rect x="2" y="4" width="20" height="16" rx="2"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Home = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-house-icon lucide-house"><path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"/><path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Brain = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-brain-icon lucide-brain"><path d="M12 18V5"/><path d="M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4"/><path d="M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"/><path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"/><path d="M18 18a4 4 0 0 0 2-7.464"/><path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"/><path d="M6 18a4 4 0 0 1-2-7.464"/><path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Telegram = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-up-right-icon lucide-arrow-up-right"><path d="M7 7h10v10"/><path d="M7 17 17 7"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Messenger = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-zap-icon lucide-zap"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Close = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Facebook = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-facebook-icon lucide-facebook"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Instagram = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-instagram-icon lucide-instagram"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Youtube = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-youtube-icon lucide-youtube"><path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"/><path d="m10 15 5-3-5-3z"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Pin = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin-icon lucide-map-pin"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/></svg>`;


class $5fab74cb69e32728$export$1d96fa344306c891 extends (0, $b654a702b809d076$export$81a299892cc9479c) {
    constructor(product){
        super("product-card group");
        this.OnClick(()=>window.location.hash = `produkt/${product.Url.value}`);
        const pricePerDay = product.GetPriceAsText();
        this.Append(new (0, $2s69t.Link)("", product.Url.value).Class("product-card__link").Append(new (0, $3bb00af81c679004$export$e0198da9c9cf3981)(product.Images.First()?.ThumbnailUrl.value ?? ""), new (0, $2456fa212220ae4e$export$ad8695fad87bad08)(product).PositionAbsolute().Top(0).Right(8), new (0, $2s69t.Div)("product-card__content").Append(new (0, $2s69t.Div)("product-card__title").Id(`product-${product.Title.value.toLowerCase()}`).Text(product.Title.value), new (0, $2s69t.Paragraph)("product-card__description").Text(product.Subtitle.value), new (0, $2s69t.Div)("product-card__footer" + (pricePerDay != "" ? "" : " justify-right")).Append(pricePerDay != "" && new (0, $2s69t.Paragraph)("product-card__price").Text(pricePerDay), new (0, $2s69t.Div)("product-card__button").Attribute("aria-hidden", "true").Append(new (0, $2s69t.Span)("Zobacz wi\u0119cej"), new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).ArrowRight))) // product-card__footer
        ) // product-card__content
        ));
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $6d7758add37969e7$export$a8a3e93435678ff9 extends (0, $2s69t.ComponentBase) {
    constructor(text, level, className){
        super(`h${level}`);
        this.Text(text instanceof (0, $2s69t.Ref) ? text.value : text);
        this.Class(className);
    }
}



var $2s69t = parcelRequire("2s69t");
class $c1fc4eeff635c01a$export$d5db36c0a81f4154 extends (0, $2s69t.Div) {
    constructor(category){
        super("category-breadcrumbs");
        this.Append(new (0, $2s69t.Link)("Oferta", "#kategorie-produktow").Class("product__breadcrumbs-link"), new (0, $2s69t.Span)().Html("&gt;").Class("product-breadcrumbs__separator"), new (0, $2s69t.Link)(category.Title.value, "#kategoria/" + category.Url.value).Class("product__breadcrumbs-link"));
    }
}



var $2s69t = parcelRequire("2s69t");




class $2f2cbdbc856cdc57$export$51f830f4e6416fad extends (0, $b654a702b809d076$export$81a299892cc9479c) {
    constructor(article){
        super("product-card group");
        this.OnClick(()=>window.location.hash = `blog/${article.Url.value}`);
        this.Append(new (0, $2s69t.Link)("", article.Url.value).Class("product-card__link").Append(new (0, $3bb00af81c679004$export$e0198da9c9cf3981)(article.Images.First()?.ThumbnailUrl.value ?? ""), new (0, $2s69t.Div)("product-card__content").Append(new (0, $2s69t.Div)("product-card__title").Text(article.Title.value), new (0, $2s69t.Paragraph)("product-card__description").Text(article.Subtitle.value ?? ""), new (0, $2s69t.Div)("product-card__footer justify-right").Append(new (0, $2s69t.Div)("product-card__button").Append(new (0, $2s69t.Span)("Czytaj"), new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).ArrowRight))))));
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $1bf177c98cdb5fdd$export$4ca9840115f43bad extends (0, $2s69t.Link) {
    constructor(label, url){
        super(label, url ? "#" + url : "");
        this.Class("hash-link");
    }
}


class $29090c12eed7b0cf$export$70620985e9db1652 extends (0, $1bf177c98cdb5fdd$export$4ca9840115f43bad) {
    constructor(url, text = ""){
        super("\uD83D\uDC13 " + text, url);
        this.Class("admin-button");
    }
}


class $fff8cccdab1195b8$export$fd88fd0f00d26ab7 extends (0, $2s69t.Div) {
    constructor(menu){
        super();
        const entries = Object.fromEntries(Object.entries(menu).map(([key, value])=>[
                key,
                ()=>window.location.hash = value
            ]));
        const popup = new (0, $2s69t.PopupMenu)(entries, new (0, $29090c12eed7b0cf$export$70620985e9db1652)("", ""));
        this.PositionRelative().FloatRight();
        this.Append(popup);
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $653a908f0842fe90$export$aff4fc93593c3bcf extends (0, $2s69t.Div) {
    constructor(title, content, theme = "#ead4a1"){
        super();
        this.Style(`display: block; margin: 32px 0; text-align: center;`);
        this.Append(new (0, $2s69t.Div)().Style(`display: inline-block; padding: 16px; text-align: left; border-left: 12px solid ${theme}`).Append(new (0, $2s69t.Div)().Text(title).TextAlignLeft().FontSize(20).MarginBottom(16).Color(theme), new (0, $2s69t.Text)(content).Color("#ccc")));
    }
}
class $653a908f0842fe90$export$f04a3ea04edc0e04 extends $653a908f0842fe90$export$aff4fc93593c3bcf {
    constructor(title, content){
        super(title, content, "#ff7795");
    }
}
class $653a908f0842fe90$export$7715d6c0b6e4e443 extends $653a908f0842fe90$export$aff4fc93593c3bcf {
    constructor(title, content){
        super(title, content, "#90cf00");
    }
}



var $2s69t = parcelRequire("2s69t");
class $6fc67b0c57e6c65f$export$3b0d6d7590275603 extends (0, $2s69t.Div) {
    constructor(text = "\u0141adowanie..."){
        super();
        this.Style("display: flex; align-items: center; gap: 8px; justify-content: center;");
        this.Append(new (0, $2s69t.Image)("spinner.gif").Width(32).Height(32), text);
    }
}


class $341ff3746ff11fcf$export$6955bcca4cd3539f extends (0, $2s69t.Div) {
    constructor(pageTitle, cssClasses = ""){
        super(cssClasses);
        this.pageTitle = pageTitle;
        this.body = void 0;
        this.loader = new (0, $6fc67b0c57e6c65f$export$3b0d6d7590275603)("\u0141adowanie strony...");
        this.SetTitle(this.pageTitle);
        this.body = new (0, $2s69t.Div)("");
        this.Append(new (0, $2s69t.Div)("content").Append(this.body));
    }
    SetTitle(title) {
        document.title = title instanceof (0, $2s69t.Ref) ? title.value : title || "specTeam.pl";
    }
    async Content(content) {
        try {
            this.Append(this.loader);
            await content(this.body);
        } catch (ex) {
            console.error(ex);
            let messageHeader = "Error";
            let messageBody = ex.message;
            const msg = ex.message.toLowerCase();
            if (msg.includes("unauthorized")) {
                messageHeader = "Unauthorized";
                messageBody = "You are not supposed to be here...";
            } else if (msg.includes("failed to fetch")) {
                messageHeader = "Connection problem";
                messageBody = "Check your connection and try again";
            }
            this.body.Append(new (0, $653a908f0842fe90$export$aff4fc93593c3bcf)(messageHeader, messageBody));
        } finally{
            this.loader.RemoveSelf();
        }
    }
}
class $341ff3746ff11fcf$export$b25f57c16f88d7e0 extends (0, $2s69t.Div) {
    constructor(pageTitle, cssClasses = ""){
        super("admin-page " + cssClasses);
        this.pageTitle = pageTitle;
        this.body = void 0;
        this.loader = new (0, $6fc67b0c57e6c65f$export$3b0d6d7590275603)("\u0141adowanie strony...");
        this.SetTitle(this.pageTitle);
        this.body = new (0, $2s69t.Div)("");
        this.Append(new (0, $2s69t.Div)("content").Append(this.body));
    }
    SetTitle(title) {
        document.title = title instanceof (0, $2s69t.Ref) ? title.value : title || "specTeam.pl";
    }
    async Content(content) {
        try {
            this.Append(this.loader);
            await content(this.body);
        } catch (ex) {
            console.error(ex);
            let messageHeader = "Error";
            let messageBody = ex.message;
            const msg = ex.message.toLowerCase();
            if (msg.includes("unauthorized")) {
                messageHeader = "Unauthorized";
                messageBody = "You are not supposed to be here...";
            } else if (msg.includes("failed to fetch")) {
                messageHeader = "Connection problem";
                messageBody = "Check your connection and try again";
            }
            this.body.Append(new (0, $653a908f0842fe90$export$aff4fc93593c3bcf)(messageHeader, messageBody));
        } finally{
            this.loader.RemoveSelf();
        }
    }
}



var $2s69t = parcelRequire("2s69t");
class $73730ebfabef2c36$export$1b198b648cc5b0ce extends (0, $2s69t.Div) {
    constructor(_shop){
        super("footer");
        this._shop = _shop;
        this.Html(`<footer>
        <div class="footer-container">
            <div class="footer-content">
                <img src="${this._shop.Shop.Logo.value}" alt="Logo" class="footer-logo">
                <nav class="footer-nav">
                    <a href="https://facebook.com/specteamwypozyczalnia#" class="footer-link facebook-link" target="_blank" rel="noopener">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-facebook-icon lucide-facebook"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                        </svg>
                        Facebook
                    </a>
                    <a href="https://www.instagram.com/specteam.pl/" class="footer-link facebook-link" target="_blank" rel="noopener">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-instagram-icon lucide-instagram"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
                        </svg>
                        Instagram
                    </a>
                    <a href="https://www.youtube.com/@specteam-pl" class="footer-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-youtube-icon lucide-youtube"><path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"/><path d="m10 15 5-3-5-3z"/>
                        </svg>
                        Youtube
                    </a>
                </nav>
            </div>
        </div>
    </footer>`);
    }
}


class $d86f1adc95b0751d$export$5a5b9651d5b3445d extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_shop, _blog, categoryUrl){
        super("specTeam.pl - Kategoria produkt\xf3w");
        this._shop = _shop;
        this._blog = _blog;
        this.categoryUrl = categoryUrl;
        this.Append(new (0, $73730ebfabef2c36$export$1b198b648cc5b0ce)(_shop));
        this.Content(async (body)=>{
            await Promise.all([
                this._shop.Load(),
                this._blog.Load()
            ]);
            const category = this._shop.CategoryByUrl(this.categoryUrl);
            let products = this._shop.ProductsByCategory(category);
            this.SetTitle(category?.Title);
            // If Anonymous user, filter out invisible products
            if (!this._shop.IsAuthorized) products = products.filter((x)=>x.Visible.value);
            const articles = this._blog.ArticlesRelatedToCategory(category);
            body.Append(this._shop.IsAuthorized && new (0, $fff8cccdab1195b8$export$fd88fd0f00d26ab7)({
                "Dodaj produkt": `product/add`,
                "Dodaj artyku\u0142": `categories/edit`,
                "Zmie\u0144 kolejno\u015B\u0107 produkt\xf3w": `category/edit/${this.categoryUrl}`
            }), new (0, $c1fc4eeff635c01a$export$d5db36c0a81f4154)(category), new (0, $6d7758add37969e7$export$a8a3e93435678ff9)(category.Title.value, 5).Class("section-title"), products.length == 0 && "Brak produkt\xf3w w tej kategorii", products.length > 0 && new (0, $2s69t.Div)("row").MarginTop(64).Append(new (0, $2s69t.Div)("container").Append(new (0, $2s69t.Div)("products").Append(...products?.map((x)=>new (0, $5fab74cb69e32728$export$1d96fa344306c891)(x).ApplyStyle(x.Visible, false, "opacity", "0.3", "1"))))));
            if (articles.length > 0) body.Append(new (0, $2s69t.Line)().Margin(16).BorderColor("#3e3e3e").BorderStyle("dashed"), new (0, $6d7758add37969e7$export$a8a3e93435678ff9)("Powi\u0105zane artyku\u0142y", 5).Class("section-title").Margin(32).Color("#ccc"), new (0, $2s69t.Div)("row").MarginTop(64).Append(new (0, $2s69t.Div)("container").Append(new (0, $2s69t.Div)("products").Append(...articles?.map((x)=>new (0, $2f2cbdbc856cdc57$export$51f830f4e6416fad)(x))))));
        });
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $520c253b7bf906da$export$b2539bed5023c21c extends (0, $2s69t.Div) {
    constructor(collection, selectedTab){
        super("product-info__tabs-scroll");
        const buttons = collection.Items.filter((x)=>x.IsVisible.value).map((entry)=>new (0, $2s69t.Button)(entry.Label.value).Class("tabs__trigger product-info__tab-trigger").OnClick((btn)=>selectedTab.value = entry.Label.value).When(selectedTab, (v)=>v === entry.Label.value, (btn)=>btn.Class("active"), (btn)=>btn.RemoveClass("active")));
        this.Append(new (0, $2s69t.Div)("tabs__list product-info__tabs-list").Append(...buttons));
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
var $b43ee6739f221f6f$exports = {};
(function() {
    /**
 * Created by Tivie on 13-07-2015.
 */ function getDefaultOpts(simple) {
        "use strict";
        var defaultOptions = {
            omitExtraWLInCodeBlocks: {
                defaultValue: false,
                describe: "Omit the default extra whiteline added to code blocks",
                type: "boolean"
            },
            noHeaderId: {
                defaultValue: false,
                describe: "Turn on/off generated header id",
                type: "boolean"
            },
            prefixHeaderId: {
                defaultValue: false,
                describe: "Add a prefix to the generated header ids. Passing a string will prefix that string to the header id. Setting to true will add a generic 'section-' prefix",
                type: "string"
            },
            rawPrefixHeaderId: {
                defaultValue: false,
                describe: 'Setting this option to true will prevent showdown from modifying the prefix. This might result in malformed IDs (if, for instance, the " char is used in the prefix)',
                type: "boolean"
            },
            ghCompatibleHeaderId: {
                defaultValue: false,
                describe: "Generate header ids compatible with github style (spaces are replaced with dashes, a bunch of non alphanumeric chars are removed)",
                type: "boolean"
            },
            rawHeaderId: {
                defaultValue: false,
                describe: "Remove only spaces, ' and \" from generated header ids (including prefixes), replacing them with dashes (-). WARNING: This might result in malformed ids",
                type: "boolean"
            },
            headerLevelStart: {
                defaultValue: false,
                describe: "The header blocks level start",
                type: "integer"
            },
            parseImgDimensions: {
                defaultValue: false,
                describe: "Turn on/off image dimension parsing",
                type: "boolean"
            },
            simplifiedAutoLink: {
                defaultValue: false,
                describe: "Turn on/off GFM autolink style",
                type: "boolean"
            },
            excludeTrailingPunctuationFromURLs: {
                defaultValue: false,
                describe: "Excludes trailing punctuation from links generated with autoLinking",
                type: "boolean"
            },
            literalMidWordUnderscores: {
                defaultValue: false,
                describe: "Parse midword underscores as literal underscores",
                type: "boolean"
            },
            literalMidWordAsterisks: {
                defaultValue: false,
                describe: "Parse midword asterisks as literal asterisks",
                type: "boolean"
            },
            strikethrough: {
                defaultValue: false,
                describe: "Turn on/off strikethrough support",
                type: "boolean"
            },
            tables: {
                defaultValue: false,
                describe: "Turn on/off tables support",
                type: "boolean"
            },
            tablesHeaderId: {
                defaultValue: false,
                describe: "Add an id to table headers",
                type: "boolean"
            },
            ghCodeBlocks: {
                defaultValue: true,
                describe: "Turn on/off GFM fenced code blocks support",
                type: "boolean"
            },
            tasklists: {
                defaultValue: false,
                describe: "Turn on/off GFM tasklist support",
                type: "boolean"
            },
            smoothLivePreview: {
                defaultValue: false,
                describe: "Prevents weird effects in live previews due to incomplete input",
                type: "boolean"
            },
            smartIndentationFix: {
                defaultValue: false,
                describe: "Tries to smartly fix indentation in es6 strings",
                type: "boolean"
            },
            disableForced4SpacesIndentedSublists: {
                defaultValue: false,
                describe: "Disables the requirement of indenting nested sublists by 4 spaces",
                type: "boolean"
            },
            simpleLineBreaks: {
                defaultValue: false,
                describe: "Parses simple line breaks as <br> (GFM Style)",
                type: "boolean"
            },
            requireSpaceBeforeHeadingText: {
                defaultValue: false,
                describe: "Makes adding a space between `#` and the header text mandatory (GFM Style)",
                type: "boolean"
            },
            ghMentions: {
                defaultValue: false,
                describe: "Enables github @mentions",
                type: "boolean"
            },
            ghMentionsLink: {
                defaultValue: "https://github.com/{u}",
                describe: "Changes the link generated by @mentions. Only applies if ghMentions option is enabled.",
                type: "string"
            },
            encodeEmails: {
                defaultValue: true,
                describe: "Encode e-mail addresses through the use of Character Entities, transforming ASCII e-mail addresses into its equivalent decimal entities",
                type: "boolean"
            },
            openLinksInNewWindow: {
                defaultValue: false,
                describe: "Open all links in new windows",
                type: "boolean"
            },
            backslashEscapesHTMLTags: {
                defaultValue: false,
                describe: "Support for HTML Tag escaping. ex: <div>foo</div>",
                type: "boolean"
            },
            emoji: {
                defaultValue: false,
                describe: "Enable emoji support. Ex: `this is a :smile: emoji`",
                type: "boolean"
            },
            underline: {
                defaultValue: false,
                describe: "Enable support for underline. Syntax is double or triple underscores: `__underline word__`. With this option enabled, underscores no longer parses into `<em>` and `<strong>`",
                type: "boolean"
            },
            ellipsis: {
                defaultValue: true,
                describe: "Replaces three dots with the ellipsis unicode character",
                type: "boolean"
            },
            completeHTMLDocument: {
                defaultValue: false,
                describe: "Outputs a complete html document, including `<html>`, `<head>` and `<body>` tags",
                type: "boolean"
            },
            metadata: {
                defaultValue: false,
                describe: "Enable support for document metadata (defined at the top of the document between `\xab\xab\xab` and `\xbb\xbb\xbb` or between `---` and `---`).",
                type: "boolean"
            },
            splitAdjacentBlockquotes: {
                defaultValue: false,
                describe: "Split adjacent blockquote blocks",
                type: "boolean"
            }
        };
        if (simple === false) return JSON.parse(JSON.stringify(defaultOptions));
        var ret = {};
        for(var opt in defaultOptions)if (defaultOptions.hasOwnProperty(opt)) ret[opt] = defaultOptions[opt].defaultValue;
        return ret;
    }
    function allOptionsOn() {
        "use strict";
        var options = getDefaultOpts(true), ret = {};
        for(var opt in options)if (options.hasOwnProperty(opt)) ret[opt] = true;
        return ret;
    }
    /**
 * Created by Tivie on 06-01-2015.
 */ // Private properties
    var showdown = {}, parsers = {}, extensions = {}, globalOptions = getDefaultOpts(true), setFlavor = "vanilla", flavor = {
        github: {
            omitExtraWLInCodeBlocks: true,
            simplifiedAutoLink: true,
            excludeTrailingPunctuationFromURLs: true,
            literalMidWordUnderscores: true,
            strikethrough: true,
            tables: true,
            tablesHeaderId: true,
            ghCodeBlocks: true,
            tasklists: true,
            disableForced4SpacesIndentedSublists: true,
            simpleLineBreaks: true,
            requireSpaceBeforeHeadingText: true,
            ghCompatibleHeaderId: true,
            ghMentions: true,
            backslashEscapesHTMLTags: true,
            emoji: true,
            splitAdjacentBlockquotes: true
        },
        original: {
            noHeaderId: true,
            ghCodeBlocks: false
        },
        ghost: {
            omitExtraWLInCodeBlocks: true,
            parseImgDimensions: true,
            simplifiedAutoLink: true,
            excludeTrailingPunctuationFromURLs: true,
            literalMidWordUnderscores: true,
            strikethrough: true,
            tables: true,
            tablesHeaderId: true,
            ghCodeBlocks: true,
            tasklists: true,
            smoothLivePreview: true,
            simpleLineBreaks: true,
            requireSpaceBeforeHeadingText: true,
            ghMentions: false,
            encodeEmails: true
        },
        vanilla: getDefaultOpts(true),
        allOn: allOptionsOn()
    };
    /**
 * helper namespace
 * @type {{}}
 */ showdown.helper = {};
    /**
 * TODO LEGACY SUPPORT CODE
 * @type {{}}
 */ showdown.extensions = {};
    /**
 * Set a global option
 * @static
 * @param {string} key
 * @param {*} value
 * @returns {showdown}
 */ showdown.setOption = function(key, value) {
        "use strict";
        globalOptions[key] = value;
        return this;
    };
    /**
 * Get a global option
 * @static
 * @param {string} key
 * @returns {*}
 */ showdown.getOption = function(key) {
        "use strict";
        return globalOptions[key];
    };
    /**
 * Get the global options
 * @static
 * @returns {{}}
 */ showdown.getOptions = function() {
        "use strict";
        return globalOptions;
    };
    /**
 * Reset global options to the default values
 * @static
 */ showdown.resetOptions = function() {
        "use strict";
        globalOptions = getDefaultOpts(true);
    };
    /**
 * Set the flavor showdown should use as default
 * @param {string} name
 */ showdown.setFlavor = function(name) {
        "use strict";
        if (!flavor.hasOwnProperty(name)) throw Error(name + " flavor was not found");
        showdown.resetOptions();
        var preset = flavor[name];
        setFlavor = name;
        for(var option in preset)if (preset.hasOwnProperty(option)) globalOptions[option] = preset[option];
    };
    /**
 * Get the currently set flavor
 * @returns {string}
 */ showdown.getFlavor = function() {
        "use strict";
        return setFlavor;
    };
    /**
 * Get the options of a specified flavor. Returns undefined if the flavor was not found
 * @param {string} name Name of the flavor
 * @returns {{}|undefined}
 */ showdown.getFlavorOptions = function(name) {
        "use strict";
        if (flavor.hasOwnProperty(name)) return flavor[name];
    };
    /**
 * Get the default options
 * @static
 * @param {boolean} [simple=true]
 * @returns {{}}
 */ showdown.getDefaultOptions = function(simple) {
        "use strict";
        return getDefaultOpts(simple);
    };
    /**
 * Get or set a subParser
 *
 * subParser(name)       - Get a registered subParser
 * subParser(name, func) - Register a subParser
 * @static
 * @param {string} name
 * @param {function} [func]
 * @returns {*}
 */ showdown.subParser = function(name, func) {
        "use strict";
        if (showdown.helper.isString(name)) {
            if (typeof func !== "undefined") parsers[name] = func;
            else {
                if (parsers.hasOwnProperty(name)) return parsers[name];
                else throw Error("SubParser named " + name + " not registered!");
            }
        }
    };
    /**
 * Gets or registers an extension
 * @static
 * @param {string} name
 * @param {object|object[]|function=} ext
 * @returns {*}
 */ showdown.extension = function(name, ext) {
        "use strict";
        if (!showdown.helper.isString(name)) throw Error("Extension 'name' must be a string");
        name = showdown.helper.stdExtName(name);
        // Getter
        if (showdown.helper.isUndefined(ext)) {
            if (!extensions.hasOwnProperty(name)) throw Error("Extension named " + name + " is not registered!");
            return extensions[name];
        // Setter
        } else {
            // Expand extension if it's wrapped in a function
            if (typeof ext === "function") ext = ext();
            // Ensure extension is an array
            if (!showdown.helper.isArray(ext)) ext = [
                ext
            ];
            var validExtension = validate(ext, name);
            if (validExtension.valid) extensions[name] = ext;
            else throw Error(validExtension.error);
        }
    };
    /**
 * Gets all extensions registered
 * @returns {{}}
 */ showdown.getAllExtensions = function() {
        "use strict";
        return extensions;
    };
    /**
 * Remove an extension
 * @param {string} name
 */ showdown.removeExtension = function(name) {
        "use strict";
        delete extensions[name];
    };
    /**
 * Removes all extensions
 */ showdown.resetExtensions = function() {
        "use strict";
        extensions = {};
    };
    /**
 * Validate extension
 * @param {array} extension
 * @param {string} name
 * @returns {{valid: boolean, error: string}}
 */ function validate(extension, name) {
        "use strict";
        var errMsg = name ? "Error in " + name + " extension->" : "Error in unnamed extension", ret = {
            valid: true,
            error: ""
        };
        if (!showdown.helper.isArray(extension)) extension = [
            extension
        ];
        for(var i = 0; i < extension.length; ++i){
            var baseMsg = errMsg + " sub-extension " + i + ": ", ext = extension[i];
            if (typeof ext !== "object") {
                ret.valid = false;
                ret.error = baseMsg + "must be an object, but " + typeof ext + " given";
                return ret;
            }
            if (!showdown.helper.isString(ext.type)) {
                ret.valid = false;
                ret.error = baseMsg + 'property "type" must be a string, but ' + typeof ext.type + " given";
                return ret;
            }
            var type = ext.type = ext.type.toLowerCase();
            // normalize extension type
            if (type === "language") type = ext.type = "lang";
            if (type === "html") type = ext.type = "output";
            if (type !== "lang" && type !== "output" && type !== "listener") {
                ret.valid = false;
                ret.error = baseMsg + "type " + type + ' is not recognized. Valid values: "lang/language", "output/html" or "listener"';
                return ret;
            }
            if (type === "listener") {
                if (showdown.helper.isUndefined(ext.listeners)) {
                    ret.valid = false;
                    ret.error = baseMsg + '. Extensions of type "listener" must have a property called "listeners"';
                    return ret;
                }
            } else if (showdown.helper.isUndefined(ext.filter) && showdown.helper.isUndefined(ext.regex)) {
                ret.valid = false;
                ret.error = baseMsg + type + ' extensions must define either a "regex" property or a "filter" method';
                return ret;
            }
            if (ext.listeners) {
                if (typeof ext.listeners !== "object") {
                    ret.valid = false;
                    ret.error = baseMsg + '"listeners" property must be an object but ' + typeof ext.listeners + " given";
                    return ret;
                }
                for(var ln in ext.listeners){
                    if (ext.listeners.hasOwnProperty(ln)) {
                        if (typeof ext.listeners[ln] !== "function") {
                            ret.valid = false;
                            ret.error = baseMsg + '"listeners" property must be an hash of [event name]: [callback]. listeners.' + ln + " must be a function but " + typeof ext.listeners[ln] + " given";
                            return ret;
                        }
                    }
                }
            }
            if (ext.filter) {
                if (typeof ext.filter !== "function") {
                    ret.valid = false;
                    ret.error = baseMsg + '"filter" must be a function, but ' + typeof ext.filter + " given";
                    return ret;
                }
            } else if (ext.regex) {
                if (showdown.helper.isString(ext.regex)) ext.regex = new RegExp(ext.regex, "g");
                if (!(ext.regex instanceof RegExp)) {
                    ret.valid = false;
                    ret.error = baseMsg + '"regex" property must either be a string or a RegExp object, but ' + typeof ext.regex + " given";
                    return ret;
                }
                if (showdown.helper.isUndefined(ext.replace)) {
                    ret.valid = false;
                    ret.error = baseMsg + '"regex" extensions must implement a replace string or function';
                    return ret;
                }
            }
        }
        return ret;
    }
    /**
 * Validate extension
 * @param {object} ext
 * @returns {boolean}
 */ showdown.validateExtension = function(ext) {
        "use strict";
        var validateExtension = validate(ext, null);
        if (!validateExtension.valid) {
            console.warn(validateExtension.error);
            return false;
        }
        return true;
    };
    /**
 * showdownjs helper functions
 */ if (!showdown.hasOwnProperty("helper")) showdown.helper = {};
    /**
 * Check if var is string
 * @static
 * @param {string} a
 * @returns {boolean}
 */ showdown.helper.isString = function(a) {
        "use strict";
        return typeof a === "string" || a instanceof String;
    };
    /**
 * Check if var is a function
 * @static
 * @param {*} a
 * @returns {boolean}
 */ showdown.helper.isFunction = function(a) {
        "use strict";
        var getType = {};
        return a && getType.toString.call(a) === "[object Function]";
    };
    /**
 * isArray helper function
 * @static
 * @param {*} a
 * @returns {boolean}
 */ showdown.helper.isArray = function(a) {
        "use strict";
        return Array.isArray(a);
    };
    /**
 * Check if value is undefined
 * @static
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 */ showdown.helper.isUndefined = function(value) {
        "use strict";
        return typeof value === "undefined";
    };
    /**
 * ForEach helper function
 * Iterates over Arrays and Objects (own properties only)
 * @static
 * @param {*} obj
 * @param {function} callback Accepts 3 params: 1. value, 2. key, 3. the original array/object
 */ showdown.helper.forEach = function(obj, callback) {
        "use strict";
        // check if obj is defined
        if (showdown.helper.isUndefined(obj)) throw new Error("obj param is required");
        if (showdown.helper.isUndefined(callback)) throw new Error("callback param is required");
        if (!showdown.helper.isFunction(callback)) throw new Error("callback param must be a function/closure");
        if (typeof obj.forEach === "function") obj.forEach(callback);
        else if (showdown.helper.isArray(obj)) for(var i = 0; i < obj.length; i++)callback(obj[i], i, obj);
        else if (typeof obj === "object") {
            for(var prop in obj)if (obj.hasOwnProperty(prop)) callback(obj[prop], prop, obj);
        } else throw new Error("obj does not seem to be an array or an iterable object");
    };
    /**
 * Standardidize extension name
 * @static
 * @param {string} s extension name
 * @returns {string}
 */ showdown.helper.stdExtName = function(s) {
        "use strict";
        return s.replace(/[_?*+\/\\.^-]/g, "").replace(/\s/g, "").toLowerCase();
    };
    function escapeCharactersCallback(wholeMatch, m1) {
        "use strict";
        var charCodeToEscape = m1.charCodeAt(0);
        return "\xa8E" + charCodeToEscape + "E";
    }
    /**
 * Callback used to escape characters when passing through String.replace
 * @static
 * @param {string} wholeMatch
 * @param {string} m1
 * @returns {string}
 */ showdown.helper.escapeCharactersCallback = escapeCharactersCallback;
    /**
 * Escape characters in a string
 * @static
 * @param {string} text
 * @param {string} charsToEscape
 * @param {boolean} afterBackslash
 * @returns {XML|string|void|*}
 */ showdown.helper.escapeCharacters = function(text, charsToEscape, afterBackslash) {
        "use strict";
        // First we have to escape the escape characters so that
        // we can build a character class out of them
        var regexString = "([" + charsToEscape.replace(/([\[\]\\])/g, "\\$1") + "])";
        if (afterBackslash) regexString = "\\\\" + regexString;
        var regex = new RegExp(regexString, "g");
        text = text.replace(regex, escapeCharactersCallback);
        return text;
    };
    /**
 * Unescape HTML entities
 * @param txt
 * @returns {string}
 */ showdown.helper.unescapeHTMLEntities = function(txt) {
        "use strict";
        return txt.replace(/&quot;/g, '"').replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
    };
    var rgxFindMatchPos = function(str, left, right, flags) {
        "use strict";
        var f = flags || "", g = f.indexOf("g") > -1, x = new RegExp(left + "|" + right, "g" + f.replace(/g/g, "")), l = new RegExp(left, f.replace(/g/g, "")), pos = [], t, s, m, start, end;
        do {
            t = 0;
            while(m = x.exec(str)){
                if (l.test(m[0])) {
                    if (!t++) {
                        s = x.lastIndex;
                        start = s - m[0].length;
                    }
                } else if (t) {
                    if (!--t) {
                        end = m.index + m[0].length;
                        var obj = {
                            left: {
                                start: start,
                                end: s
                            },
                            match: {
                                start: s,
                                end: m.index
                            },
                            right: {
                                start: m.index,
                                end: end
                            },
                            wholeMatch: {
                                start: start,
                                end: end
                            }
                        };
                        pos.push(obj);
                        if (!g) return pos;
                    }
                }
            }
        }while (t && (x.lastIndex = s));
        return pos;
    };
    /**
 * matchRecursiveRegExp
 *
 * (c) 2007 Steven Levithan <stevenlevithan.com>
 * MIT License
 *
 * Accepts a string to search, a left and right format delimiter
 * as regex patterns, and optional regex flags. Returns an array
 * of matches, allowing nested instances of left/right delimiters.
 * Use the "g" flag to return all matches, otherwise only the
 * first is returned. Be careful to ensure that the left and
 * right format delimiters produce mutually exclusive matches.
 * Backreferences are not supported within the right delimiter
 * due to how it is internally combined with the left delimiter.
 * When matching strings whose format delimiters are unbalanced
 * to the left or right, the output is intentionally as a
 * conventional regex library with recursion support would
 * produce, e.g. "<<x>" and "<x>>" both produce ["x"] when using
 * "<" and ">" as the delimiters (both strings contain a single,
 * balanced instance of "<x>").
 *
 * examples:
 * matchRecursiveRegExp("test", "\\(", "\\)")
 * returns: []
 * matchRecursiveRegExp("<t<<e>><s>>t<>", "<", ">", "g")
 * returns: ["t<<e>><s>", ""]
 * matchRecursiveRegExp("<div id=\"x\">test</div>", "<div\\b[^>]*>", "</div>", "gi")
 * returns: ["test"]
 */ showdown.helper.matchRecursiveRegExp = function(str, left, right, flags) {
        "use strict";
        var matchPos = rgxFindMatchPos(str, left, right, flags), results = [];
        for(var i = 0; i < matchPos.length; ++i)results.push([
            str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end),
            str.slice(matchPos[i].match.start, matchPos[i].match.end),
            str.slice(matchPos[i].left.start, matchPos[i].left.end),
            str.slice(matchPos[i].right.start, matchPos[i].right.end)
        ]);
        return results;
    };
    /**
 *
 * @param {string} str
 * @param {string|function} replacement
 * @param {string} left
 * @param {string} right
 * @param {string} flags
 * @returns {string}
 */ showdown.helper.replaceRecursiveRegExp = function(str, replacement, left, right, flags) {
        "use strict";
        if (!showdown.helper.isFunction(replacement)) {
            var repStr = replacement;
            replacement = function() {
                return repStr;
            };
        }
        var matchPos = rgxFindMatchPos(str, left, right, flags), finalStr = str, lng = matchPos.length;
        if (lng > 0) {
            var bits = [];
            if (matchPos[0].wholeMatch.start !== 0) bits.push(str.slice(0, matchPos[0].wholeMatch.start));
            for(var i = 0; i < lng; ++i){
                bits.push(replacement(str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end), str.slice(matchPos[i].match.start, matchPos[i].match.end), str.slice(matchPos[i].left.start, matchPos[i].left.end), str.slice(matchPos[i].right.start, matchPos[i].right.end)));
                if (i < lng - 1) bits.push(str.slice(matchPos[i].wholeMatch.end, matchPos[i + 1].wholeMatch.start));
            }
            if (matchPos[lng - 1].wholeMatch.end < str.length) bits.push(str.slice(matchPos[lng - 1].wholeMatch.end));
            finalStr = bits.join("");
        }
        return finalStr;
    };
    /**
 * Returns the index within the passed String object of the first occurrence of the specified regex,
 * starting the search at fromIndex. Returns -1 if the value is not found.
 *
 * @param {string} str string to search
 * @param {RegExp} regex Regular expression to search
 * @param {int} [fromIndex = 0] Index to start the search
 * @returns {Number}
 * @throws InvalidArgumentError
 */ showdown.helper.regexIndexOf = function(str, regex, fromIndex) {
        "use strict";
        if (!showdown.helper.isString(str)) throw "InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string";
        if (regex instanceof RegExp === false) throw "InvalidArgumentError: second parameter of showdown.helper.regexIndexOf function must be an instance of RegExp";
        var indexOf = str.substring(fromIndex || 0).search(regex);
        return indexOf >= 0 ? indexOf + (fromIndex || 0) : indexOf;
    };
    /**
 * Splits the passed string object at the defined index, and returns an array composed of the two substrings
 * @param {string} str string to split
 * @param {int} index index to split string at
 * @returns {[string,string]}
 * @throws InvalidArgumentError
 */ showdown.helper.splitAtIndex = function(str, index) {
        "use strict";
        if (!showdown.helper.isString(str)) throw "InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string";
        return [
            str.substring(0, index),
            str.substring(index)
        ];
    };
    /**
 * Obfuscate an e-mail address through the use of Character Entities,
 * transforming ASCII characters into their equivalent decimal or hex entities.
 *
 * Since it has a random component, subsequent calls to this function produce different results
 *
 * @param {string} mail
 * @returns {string}
 */ showdown.helper.encodeEmailAddress = function(mail) {
        "use strict";
        var encode = [
            function(ch) {
                return "&#" + ch.charCodeAt(0) + ";";
            },
            function(ch) {
                return "&#x" + ch.charCodeAt(0).toString(16) + ";";
            },
            function(ch) {
                return ch;
            }
        ];
        mail = mail.replace(/./g, function(ch) {
            if (ch === "@") // this *must* be encoded. I insist.
            ch = encode[Math.floor(Math.random() * 2)](ch);
            else {
                var r = Math.random();
                // roughly 10% raw, 45% hex, 45% dec
                ch = r > 0.9 ? encode[2](ch) : r > 0.45 ? encode[1](ch) : encode[0](ch);
            }
            return ch;
        });
        return mail;
    };
    /**
 *
 * @param str
 * @param targetLength
 * @param padString
 * @returns {string}
 */ showdown.helper.padEnd = function padEnd(str, targetLength, padString) {
        "use strict";
        /*jshint bitwise: false*/ // eslint-disable-next-line space-infix-ops
        targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
        /*jshint bitwise: true*/ padString = String(padString || " ");
        if (str.length > targetLength) return String(str);
        else {
            targetLength = targetLength - str.length;
            if (targetLength > padString.length) padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            return String(str) + padString.slice(0, targetLength);
        }
    };
    /**
 * POLYFILLS
 */ // use this instead of builtin is undefined for IE8 compatibility
    if (typeof console === "undefined") console = {
        warn: function(msg) {
            "use strict";
            alert(msg);
        },
        log: function(msg) {
            "use strict";
            alert(msg);
        },
        error: function(msg) {
            "use strict";
            throw msg;
        }
    };
    /**
 * Common regexes.
 * We declare some common regexes to improve performance
 */ showdown.helper.regexes = {
        asteriskDashAndColon: /([*_:~])/g
    };
    /**
 * EMOJIS LIST
 */ showdown.helper.emojis = {
        "+1": "\ud83d\udc4d",
        "-1": "\ud83d\udc4e",
        "100": "\ud83d\udcaf",
        "1234": "\ud83d\udd22",
        "1st_place_medal": "\ud83e\udd47",
        "2nd_place_medal": "\ud83e\udd48",
        "3rd_place_medal": "\ud83e\udd49",
        "8ball": "\ud83c\udfb1",
        "a": "\ud83c\udd70\uFE0F",
        "ab": "\ud83c\udd8e",
        "abc": "\ud83d\udd24",
        "abcd": "\ud83d\udd21",
        "accept": "\ud83c\ude51",
        "aerial_tramway": "\ud83d\udea1",
        "airplane": "\u2708\uFE0F",
        "alarm_clock": "\u23F0",
        "alembic": "\u2697\uFE0F",
        "alien": "\ud83d\udc7d",
        "ambulance": "\ud83d\ude91",
        "amphora": "\ud83c\udffa",
        "anchor": "\u2693\uFE0F",
        "angel": "\ud83d\udc7c",
        "anger": "\ud83d\udca2",
        "angry": "\ud83d\ude20",
        "anguished": "\ud83d\ude27",
        "ant": "\ud83d\udc1c",
        "apple": "\ud83c\udf4e",
        "aquarius": "\u2652\uFE0F",
        "aries": "\u2648\uFE0F",
        "arrow_backward": "\u25C0\uFE0F",
        "arrow_double_down": "\u23EC",
        "arrow_double_up": "\u23EB",
        "arrow_down": "\u2B07\uFE0F",
        "arrow_down_small": "\ud83d\udd3d",
        "arrow_forward": "\u25B6\uFE0F",
        "arrow_heading_down": "\u2935\uFE0F",
        "arrow_heading_up": "\u2934\uFE0F",
        "arrow_left": "\u2B05\uFE0F",
        "arrow_lower_left": "\u2199\uFE0F",
        "arrow_lower_right": "\u2198\uFE0F",
        "arrow_right": "\u27A1\uFE0F",
        "arrow_right_hook": "\u21AA\uFE0F",
        "arrow_up": "\u2B06\uFE0F",
        "arrow_up_down": "\u2195\uFE0F",
        "arrow_up_small": "\ud83d\udd3c",
        "arrow_upper_left": "\u2196\uFE0F",
        "arrow_upper_right": "\u2197\uFE0F",
        "arrows_clockwise": "\ud83d\udd03",
        "arrows_counterclockwise": "\ud83d\udd04",
        "art": "\ud83c\udfa8",
        "articulated_lorry": "\ud83d\ude9b",
        "artificial_satellite": "\ud83d\udef0",
        "astonished": "\ud83d\ude32",
        "athletic_shoe": "\ud83d\udc5f",
        "atm": "\ud83c\udfe7",
        "atom_symbol": "\u269B\uFE0F",
        "avocado": "\ud83e\udd51",
        "b": "\ud83c\udd71\uFE0F",
        "baby": "\ud83d\udc76",
        "baby_bottle": "\ud83c\udf7c",
        "baby_chick": "\ud83d\udc24",
        "baby_symbol": "\ud83d\udebc",
        "back": "\ud83d\udd19",
        "bacon": "\ud83e\udd53",
        "badminton": "\ud83c\udff8",
        "baggage_claim": "\ud83d\udec4",
        "baguette_bread": "\ud83e\udd56",
        "balance_scale": "\u2696\uFE0F",
        "balloon": "\ud83c\udf88",
        "ballot_box": "\ud83d\uddf3",
        "ballot_box_with_check": "\u2611\uFE0F",
        "bamboo": "\ud83c\udf8d",
        "banana": "\ud83c\udf4c",
        "bangbang": "\u203C\uFE0F",
        "bank": "\ud83c\udfe6",
        "bar_chart": "\ud83d\udcca",
        "barber": "\ud83d\udc88",
        "baseball": "\u26BE\uFE0F",
        "basketball": "\ud83c\udfc0",
        "basketball_man": "\u26F9\uFE0F",
        "basketball_woman": "\u26F9\uFE0F&zwj;\u2640\uFE0F",
        "bat": "\ud83e\udd87",
        "bath": "\ud83d\udec0",
        "bathtub": "\ud83d\udec1",
        "battery": "\ud83d\udd0b",
        "beach_umbrella": "\ud83c\udfd6",
        "bear": "\ud83d\udc3b",
        "bed": "\ud83d\udecf",
        "bee": "\ud83d\udc1d",
        "beer": "\ud83c\udf7a",
        "beers": "\ud83c\udf7b",
        "beetle": "\ud83d\udc1e",
        "beginner": "\ud83d\udd30",
        "bell": "\ud83d\udd14",
        "bellhop_bell": "\ud83d\udece",
        "bento": "\ud83c\udf71",
        "biking_man": "\ud83d\udeb4",
        "bike": "\ud83d\udeb2",
        "biking_woman": "\ud83d\udeb4&zwj;\u2640\uFE0F",
        "bikini": "\ud83d\udc59",
        "biohazard": "\u2623\uFE0F",
        "bird": "\ud83d\udc26",
        "birthday": "\ud83c\udf82",
        "black_circle": "\u26AB\uFE0F",
        "black_flag": "\ud83c\udff4",
        "black_heart": "\ud83d\udda4",
        "black_joker": "\ud83c\udccf",
        "black_large_square": "\u2B1B\uFE0F",
        "black_medium_small_square": "\u25FE\uFE0F",
        "black_medium_square": "\u25FC\uFE0F",
        "black_nib": "\u2712\uFE0F",
        "black_small_square": "\u25AA\uFE0F",
        "black_square_button": "\ud83d\udd32",
        "blonde_man": "\ud83d\udc71",
        "blonde_woman": "\ud83d\udc71&zwj;\u2640\uFE0F",
        "blossom": "\ud83c\udf3c",
        "blowfish": "\ud83d\udc21",
        "blue_book": "\ud83d\udcd8",
        "blue_car": "\ud83d\ude99",
        "blue_heart": "\ud83d\udc99",
        "blush": "\ud83d\ude0a",
        "boar": "\ud83d\udc17",
        "boat": "\u26F5\uFE0F",
        "bomb": "\ud83d\udca3",
        "book": "\ud83d\udcd6",
        "bookmark": "\ud83d\udd16",
        "bookmark_tabs": "\ud83d\udcd1",
        "books": "\ud83d\udcda",
        "boom": "\ud83d\udca5",
        "boot": "\ud83d\udc62",
        "bouquet": "\ud83d\udc90",
        "bowing_man": "\ud83d\ude47",
        "bow_and_arrow": "\ud83c\udff9",
        "bowing_woman": "\ud83d\ude47&zwj;\u2640\uFE0F",
        "bowling": "\ud83c\udfb3",
        "boxing_glove": "\ud83e\udd4a",
        "boy": "\ud83d\udc66",
        "bread": "\ud83c\udf5e",
        "bride_with_veil": "\ud83d\udc70",
        "bridge_at_night": "\ud83c\udf09",
        "briefcase": "\ud83d\udcbc",
        "broken_heart": "\ud83d\udc94",
        "bug": "\ud83d\udc1b",
        "building_construction": "\ud83c\udfd7",
        "bulb": "\ud83d\udca1",
        "bullettrain_front": "\ud83d\ude85",
        "bullettrain_side": "\ud83d\ude84",
        "burrito": "\ud83c\udf2f",
        "bus": "\ud83d\ude8c",
        "business_suit_levitating": "\ud83d\udd74",
        "busstop": "\ud83d\ude8f",
        "bust_in_silhouette": "\ud83d\udc64",
        "busts_in_silhouette": "\ud83d\udc65",
        "butterfly": "\ud83e\udd8b",
        "cactus": "\ud83c\udf35",
        "cake": "\ud83c\udf70",
        "calendar": "\ud83d\udcc6",
        "call_me_hand": "\ud83e\udd19",
        "calling": "\ud83d\udcf2",
        "camel": "\ud83d\udc2b",
        "camera": "\ud83d\udcf7",
        "camera_flash": "\ud83d\udcf8",
        "camping": "\ud83c\udfd5",
        "cancer": "\u264B\uFE0F",
        "candle": "\ud83d\udd6f",
        "candy": "\ud83c\udf6c",
        "canoe": "\ud83d\udef6",
        "capital_abcd": "\ud83d\udd20",
        "capricorn": "\u2651\uFE0F",
        "car": "\ud83d\ude97",
        "card_file_box": "\ud83d\uddc3",
        "card_index": "\ud83d\udcc7",
        "card_index_dividers": "\ud83d\uddc2",
        "carousel_horse": "\ud83c\udfa0",
        "carrot": "\ud83e\udd55",
        "cat": "\ud83d\udc31",
        "cat2": "\ud83d\udc08",
        "cd": "\ud83d\udcbf",
        "chains": "\u26D3",
        "champagne": "\ud83c\udf7e",
        "chart": "\ud83d\udcb9",
        "chart_with_downwards_trend": "\ud83d\udcc9",
        "chart_with_upwards_trend": "\ud83d\udcc8",
        "checkered_flag": "\ud83c\udfc1",
        "cheese": "\ud83e\uddc0",
        "cherries": "\ud83c\udf52",
        "cherry_blossom": "\ud83c\udf38",
        "chestnut": "\ud83c\udf30",
        "chicken": "\ud83d\udc14",
        "children_crossing": "\ud83d\udeb8",
        "chipmunk": "\ud83d\udc3f",
        "chocolate_bar": "\ud83c\udf6b",
        "christmas_tree": "\ud83c\udf84",
        "church": "\u26EA\uFE0F",
        "cinema": "\ud83c\udfa6",
        "circus_tent": "\ud83c\udfaa",
        "city_sunrise": "\ud83c\udf07",
        "city_sunset": "\ud83c\udf06",
        "cityscape": "\ud83c\udfd9",
        "cl": "\ud83c\udd91",
        "clamp": "\ud83d\udddc",
        "clap": "\ud83d\udc4f",
        "clapper": "\ud83c\udfac",
        "classical_building": "\ud83c\udfdb",
        "clinking_glasses": "\ud83e\udd42",
        "clipboard": "\ud83d\udccb",
        "clock1": "\ud83d\udd50",
        "clock10": "\ud83d\udd59",
        "clock1030": "\ud83d\udd65",
        "clock11": "\ud83d\udd5a",
        "clock1130": "\ud83d\udd66",
        "clock12": "\ud83d\udd5b",
        "clock1230": "\ud83d\udd67",
        "clock130": "\ud83d\udd5c",
        "clock2": "\ud83d\udd51",
        "clock230": "\ud83d\udd5d",
        "clock3": "\ud83d\udd52",
        "clock330": "\ud83d\udd5e",
        "clock4": "\ud83d\udd53",
        "clock430": "\ud83d\udd5f",
        "clock5": "\ud83d\udd54",
        "clock530": "\ud83d\udd60",
        "clock6": "\ud83d\udd55",
        "clock630": "\ud83d\udd61",
        "clock7": "\ud83d\udd56",
        "clock730": "\ud83d\udd62",
        "clock8": "\ud83d\udd57",
        "clock830": "\ud83d\udd63",
        "clock9": "\ud83d\udd58",
        "clock930": "\ud83d\udd64",
        "closed_book": "\ud83d\udcd5",
        "closed_lock_with_key": "\ud83d\udd10",
        "closed_umbrella": "\ud83c\udf02",
        "cloud": "\u2601\uFE0F",
        "cloud_with_lightning": "\ud83c\udf29",
        "cloud_with_lightning_and_rain": "\u26C8",
        "cloud_with_rain": "\ud83c\udf27",
        "cloud_with_snow": "\ud83c\udf28",
        "clown_face": "\ud83e\udd21",
        "clubs": "\u2663\uFE0F",
        "cocktail": "\ud83c\udf78",
        "coffee": "\u2615\uFE0F",
        "coffin": "\u26B0\uFE0F",
        "cold_sweat": "\ud83d\ude30",
        "comet": "\u2604\uFE0F",
        "computer": "\ud83d\udcbb",
        "computer_mouse": "\ud83d\uddb1",
        "confetti_ball": "\ud83c\udf8a",
        "confounded": "\ud83d\ude16",
        "confused": "\ud83d\ude15",
        "congratulations": "\u3297\uFE0F",
        "construction": "\ud83d\udea7",
        "construction_worker_man": "\ud83d\udc77",
        "construction_worker_woman": "\ud83d\udc77&zwj;\u2640\uFE0F",
        "control_knobs": "\ud83c\udf9b",
        "convenience_store": "\ud83c\udfea",
        "cookie": "\ud83c\udf6a",
        "cool": "\ud83c\udd92",
        "policeman": "\ud83d\udc6e",
        "copyright": "\xa9\uFE0F",
        "corn": "\ud83c\udf3d",
        "couch_and_lamp": "\ud83d\udecb",
        "couple": "\ud83d\udc6b",
        "couple_with_heart_woman_man": "\ud83d\udc91",
        "couple_with_heart_man_man": "\ud83d\udc68&zwj;\u2764\uFE0F&zwj;\ud83d\udc68",
        "couple_with_heart_woman_woman": "\ud83d\udc69&zwj;\u2764\uFE0F&zwj;\ud83d\udc69",
        "couplekiss_man_man": "\ud83d\udc68&zwj;\u2764\uFE0F&zwj;\ud83d\udc8b&zwj;\ud83d\udc68",
        "couplekiss_man_woman": "\ud83d\udc8f",
        "couplekiss_woman_woman": "\ud83d\udc69&zwj;\u2764\uFE0F&zwj;\ud83d\udc8b&zwj;\ud83d\udc69",
        "cow": "\ud83d\udc2e",
        "cow2": "\ud83d\udc04",
        "cowboy_hat_face": "\ud83e\udd20",
        "crab": "\ud83e\udd80",
        "crayon": "\ud83d\udd8d",
        "credit_card": "\ud83d\udcb3",
        "crescent_moon": "\ud83c\udf19",
        "cricket": "\ud83c\udfcf",
        "crocodile": "\ud83d\udc0a",
        "croissant": "\ud83e\udd50",
        "crossed_fingers": "\ud83e\udd1e",
        "crossed_flags": "\ud83c\udf8c",
        "crossed_swords": "\u2694\uFE0F",
        "crown": "\ud83d\udc51",
        "cry": "\ud83d\ude22",
        "crying_cat_face": "\ud83d\ude3f",
        "crystal_ball": "\ud83d\udd2e",
        "cucumber": "\ud83e\udd52",
        "cupid": "\ud83d\udc98",
        "curly_loop": "\u27B0",
        "currency_exchange": "\ud83d\udcb1",
        "curry": "\ud83c\udf5b",
        "custard": "\ud83c\udf6e",
        "customs": "\ud83d\udec3",
        "cyclone": "\ud83c\udf00",
        "dagger": "\ud83d\udde1",
        "dancer": "\ud83d\udc83",
        "dancing_women": "\ud83d\udc6f",
        "dancing_men": "\ud83d\udc6f&zwj;\u2642\uFE0F",
        "dango": "\ud83c\udf61",
        "dark_sunglasses": "\ud83d\udd76",
        "dart": "\ud83c\udfaf",
        "dash": "\ud83d\udca8",
        "date": "\ud83d\udcc5",
        "deciduous_tree": "\ud83c\udf33",
        "deer": "\ud83e\udd8c",
        "department_store": "\ud83c\udfec",
        "derelict_house": "\ud83c\udfda",
        "desert": "\ud83c\udfdc",
        "desert_island": "\ud83c\udfdd",
        "desktop_computer": "\ud83d\udda5",
        "male_detective": "\ud83d\udd75\uFE0F",
        "diamond_shape_with_a_dot_inside": "\ud83d\udca0",
        "diamonds": "\u2666\uFE0F",
        "disappointed": "\ud83d\ude1e",
        "disappointed_relieved": "\ud83d\ude25",
        "dizzy": "\ud83d\udcab",
        "dizzy_face": "\ud83d\ude35",
        "do_not_litter": "\ud83d\udeaf",
        "dog": "\ud83d\udc36",
        "dog2": "\ud83d\udc15",
        "dollar": "\ud83d\udcb5",
        "dolls": "\ud83c\udf8e",
        "dolphin": "\ud83d\udc2c",
        "door": "\ud83d\udeaa",
        "doughnut": "\ud83c\udf69",
        "dove": "\ud83d\udd4a",
        "dragon": "\ud83d\udc09",
        "dragon_face": "\ud83d\udc32",
        "dress": "\ud83d\udc57",
        "dromedary_camel": "\ud83d\udc2a",
        "drooling_face": "\ud83e\udd24",
        "droplet": "\ud83d\udca7",
        "drum": "\ud83e\udd41",
        "duck": "\ud83e\udd86",
        "dvd": "\ud83d\udcc0",
        "e-mail": "\ud83d\udce7",
        "eagle": "\ud83e\udd85",
        "ear": "\ud83d\udc42",
        "ear_of_rice": "\ud83c\udf3e",
        "earth_africa": "\ud83c\udf0d",
        "earth_americas": "\ud83c\udf0e",
        "earth_asia": "\ud83c\udf0f",
        "egg": "\ud83e\udd5a",
        "eggplant": "\ud83c\udf46",
        "eight_pointed_black_star": "\u2734\uFE0F",
        "eight_spoked_asterisk": "\u2733\uFE0F",
        "electric_plug": "\ud83d\udd0c",
        "elephant": "\ud83d\udc18",
        "email": "\u2709\uFE0F",
        "end": "\ud83d\udd1a",
        "envelope_with_arrow": "\ud83d\udce9",
        "euro": "\ud83d\udcb6",
        "european_castle": "\ud83c\udff0",
        "european_post_office": "\ud83c\udfe4",
        "evergreen_tree": "\ud83c\udf32",
        "exclamation": "\u2757\uFE0F",
        "expressionless": "\ud83d\ude11",
        "eye": "\ud83d\udc41",
        "eye_speech_bubble": "\ud83d\udc41&zwj;\ud83d\udde8",
        "eyeglasses": "\ud83d\udc53",
        "eyes": "\ud83d\udc40",
        "face_with_head_bandage": "\ud83e\udd15",
        "face_with_thermometer": "\ud83e\udd12",
        "fist_oncoming": "\ud83d\udc4a",
        "factory": "\ud83c\udfed",
        "fallen_leaf": "\ud83c\udf42",
        "family_man_woman_boy": "\ud83d\udc6a",
        "family_man_boy": "\ud83d\udc68&zwj;\ud83d\udc66",
        "family_man_boy_boy": "\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
        "family_man_girl": "\ud83d\udc68&zwj;\ud83d\udc67",
        "family_man_girl_boy": "\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
        "family_man_girl_girl": "\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
        "family_man_man_boy": "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66",
        "family_man_man_boy_boy": "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
        "family_man_man_girl": "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67",
        "family_man_man_girl_boy": "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
        "family_man_man_girl_girl": "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
        "family_man_woman_boy_boy": "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
        "family_man_woman_girl": "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67",
        "family_man_woman_girl_boy": "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
        "family_man_woman_girl_girl": "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
        "family_woman_boy": "\ud83d\udc69&zwj;\ud83d\udc66",
        "family_woman_boy_boy": "\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
        "family_woman_girl": "\ud83d\udc69&zwj;\ud83d\udc67",
        "family_woman_girl_boy": "\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
        "family_woman_girl_girl": "\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
        "family_woman_woman_boy": "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66",
        "family_woman_woman_boy_boy": "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
        "family_woman_woman_girl": "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67",
        "family_woman_woman_girl_boy": "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
        "family_woman_woman_girl_girl": "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
        "fast_forward": "\u23E9",
        "fax": "\ud83d\udce0",
        "fearful": "\ud83d\ude28",
        "feet": "\ud83d\udc3e",
        "female_detective": "\ud83d\udd75\uFE0F&zwj;\u2640\uFE0F",
        "ferris_wheel": "\ud83c\udfa1",
        "ferry": "\u26F4",
        "field_hockey": "\ud83c\udfd1",
        "file_cabinet": "\ud83d\uddc4",
        "file_folder": "\ud83d\udcc1",
        "film_projector": "\ud83d\udcfd",
        "film_strip": "\ud83c\udf9e",
        "fire": "\ud83d\udd25",
        "fire_engine": "\ud83d\ude92",
        "fireworks": "\ud83c\udf86",
        "first_quarter_moon": "\ud83c\udf13",
        "first_quarter_moon_with_face": "\ud83c\udf1b",
        "fish": "\ud83d\udc1f",
        "fish_cake": "\ud83c\udf65",
        "fishing_pole_and_fish": "\ud83c\udfa3",
        "fist_raised": "\u270A",
        "fist_left": "\ud83e\udd1b",
        "fist_right": "\ud83e\udd1c",
        "flags": "\ud83c\udf8f",
        "flashlight": "\ud83d\udd26",
        "fleur_de_lis": "\u269C\uFE0F",
        "flight_arrival": "\ud83d\udeec",
        "flight_departure": "\ud83d\udeeb",
        "floppy_disk": "\ud83d\udcbe",
        "flower_playing_cards": "\ud83c\udfb4",
        "flushed": "\ud83d\ude33",
        "fog": "\ud83c\udf2b",
        "foggy": "\ud83c\udf01",
        "football": "\ud83c\udfc8",
        "footprints": "\ud83d\udc63",
        "fork_and_knife": "\ud83c\udf74",
        "fountain": "\u26F2\uFE0F",
        "fountain_pen": "\ud83d\udd8b",
        "four_leaf_clover": "\ud83c\udf40",
        "fox_face": "\ud83e\udd8a",
        "framed_picture": "\ud83d\uddbc",
        "free": "\ud83c\udd93",
        "fried_egg": "\ud83c\udf73",
        "fried_shrimp": "\ud83c\udf64",
        "fries": "\ud83c\udf5f",
        "frog": "\ud83d\udc38",
        "frowning": "\ud83d\ude26",
        "frowning_face": "\u2639\uFE0F",
        "frowning_man": "\ud83d\ude4d&zwj;\u2642\uFE0F",
        "frowning_woman": "\ud83d\ude4d",
        "middle_finger": "\ud83d\udd95",
        "fuelpump": "\u26FD\uFE0F",
        "full_moon": "\ud83c\udf15",
        "full_moon_with_face": "\ud83c\udf1d",
        "funeral_urn": "\u26B1\uFE0F",
        "game_die": "\ud83c\udfb2",
        "gear": "\u2699\uFE0F",
        "gem": "\ud83d\udc8e",
        "gemini": "\u264A\uFE0F",
        "ghost": "\ud83d\udc7b",
        "gift": "\ud83c\udf81",
        "gift_heart": "\ud83d\udc9d",
        "girl": "\ud83d\udc67",
        "globe_with_meridians": "\ud83c\udf10",
        "goal_net": "\ud83e\udd45",
        "goat": "\ud83d\udc10",
        "golf": "\u26F3\uFE0F",
        "golfing_man": "\ud83c\udfcc\uFE0F",
        "golfing_woman": "\ud83c\udfcc\uFE0F&zwj;\u2640\uFE0F",
        "gorilla": "\ud83e\udd8d",
        "grapes": "\ud83c\udf47",
        "green_apple": "\ud83c\udf4f",
        "green_book": "\ud83d\udcd7",
        "green_heart": "\ud83d\udc9a",
        "green_salad": "\ud83e\udd57",
        "grey_exclamation": "\u2755",
        "grey_question": "\u2754",
        "grimacing": "\ud83d\ude2c",
        "grin": "\ud83d\ude01",
        "grinning": "\ud83d\ude00",
        "guardsman": "\ud83d\udc82",
        "guardswoman": "\ud83d\udc82&zwj;\u2640\uFE0F",
        "guitar": "\ud83c\udfb8",
        "gun": "\ud83d\udd2b",
        "haircut_woman": "\ud83d\udc87",
        "haircut_man": "\ud83d\udc87&zwj;\u2642\uFE0F",
        "hamburger": "\ud83c\udf54",
        "hammer": "\ud83d\udd28",
        "hammer_and_pick": "\u2692",
        "hammer_and_wrench": "\ud83d\udee0",
        "hamster": "\ud83d\udc39",
        "hand": "\u270B",
        "handbag": "\ud83d\udc5c",
        "handshake": "\ud83e\udd1d",
        "hankey": "\ud83d\udca9",
        "hatched_chick": "\ud83d\udc25",
        "hatching_chick": "\ud83d\udc23",
        "headphones": "\ud83c\udfa7",
        "hear_no_evil": "\ud83d\ude49",
        "heart": "\u2764\uFE0F",
        "heart_decoration": "\ud83d\udc9f",
        "heart_eyes": "\ud83d\ude0d",
        "heart_eyes_cat": "\ud83d\ude3b",
        "heartbeat": "\ud83d\udc93",
        "heartpulse": "\ud83d\udc97",
        "hearts": "\u2665\uFE0F",
        "heavy_check_mark": "\u2714\uFE0F",
        "heavy_division_sign": "\u2797",
        "heavy_dollar_sign": "\ud83d\udcb2",
        "heavy_heart_exclamation": "\u2763\uFE0F",
        "heavy_minus_sign": "\u2796",
        "heavy_multiplication_x": "\u2716\uFE0F",
        "heavy_plus_sign": "\u2795",
        "helicopter": "\ud83d\ude81",
        "herb": "\ud83c\udf3f",
        "hibiscus": "\ud83c\udf3a",
        "high_brightness": "\ud83d\udd06",
        "high_heel": "\ud83d\udc60",
        "hocho": "\ud83d\udd2a",
        "hole": "\ud83d\udd73",
        "honey_pot": "\ud83c\udf6f",
        "horse": "\ud83d\udc34",
        "horse_racing": "\ud83c\udfc7",
        "hospital": "\ud83c\udfe5",
        "hot_pepper": "\ud83c\udf36",
        "hotdog": "\ud83c\udf2d",
        "hotel": "\ud83c\udfe8",
        "hotsprings": "\u2668\uFE0F",
        "hourglass": "\u231B\uFE0F",
        "hourglass_flowing_sand": "\u23F3",
        "house": "\ud83c\udfe0",
        "house_with_garden": "\ud83c\udfe1",
        "houses": "\ud83c\udfd8",
        "hugs": "\ud83e\udd17",
        "hushed": "\ud83d\ude2f",
        "ice_cream": "\ud83c\udf68",
        "ice_hockey": "\ud83c\udfd2",
        "ice_skate": "\u26F8",
        "icecream": "\ud83c\udf66",
        "id": "\ud83c\udd94",
        "ideograph_advantage": "\ud83c\ude50",
        "imp": "\ud83d\udc7f",
        "inbox_tray": "\ud83d\udce5",
        "incoming_envelope": "\ud83d\udce8",
        "tipping_hand_woman": "\ud83d\udc81",
        "information_source": "\u2139\uFE0F",
        "innocent": "\ud83d\ude07",
        "interrobang": "\u2049\uFE0F",
        "iphone": "\ud83d\udcf1",
        "izakaya_lantern": "\ud83c\udfee",
        "jack_o_lantern": "\ud83c\udf83",
        "japan": "\ud83d\uddfe",
        "japanese_castle": "\ud83c\udfef",
        "japanese_goblin": "\ud83d\udc7a",
        "japanese_ogre": "\ud83d\udc79",
        "jeans": "\ud83d\udc56",
        "joy": "\ud83d\ude02",
        "joy_cat": "\ud83d\ude39",
        "joystick": "\ud83d\udd79",
        "kaaba": "\ud83d\udd4b",
        "key": "\ud83d\udd11",
        "keyboard": "\u2328\uFE0F",
        "keycap_ten": "\ud83d\udd1f",
        "kick_scooter": "\ud83d\udef4",
        "kimono": "\ud83d\udc58",
        "kiss": "\ud83d\udc8b",
        "kissing": "\ud83d\ude17",
        "kissing_cat": "\ud83d\ude3d",
        "kissing_closed_eyes": "\ud83d\ude1a",
        "kissing_heart": "\ud83d\ude18",
        "kissing_smiling_eyes": "\ud83d\ude19",
        "kiwi_fruit": "\ud83e\udd5d",
        "koala": "\ud83d\udc28",
        "koko": "\ud83c\ude01",
        "label": "\ud83c\udff7",
        "large_blue_circle": "\ud83d\udd35",
        "large_blue_diamond": "\ud83d\udd37",
        "large_orange_diamond": "\ud83d\udd36",
        "last_quarter_moon": "\ud83c\udf17",
        "last_quarter_moon_with_face": "\ud83c\udf1c",
        "latin_cross": "\u271D\uFE0F",
        "laughing": "\ud83d\ude06",
        "leaves": "\ud83c\udf43",
        "ledger": "\ud83d\udcd2",
        "left_luggage": "\ud83d\udec5",
        "left_right_arrow": "\u2194\uFE0F",
        "leftwards_arrow_with_hook": "\u21A9\uFE0F",
        "lemon": "\ud83c\udf4b",
        "leo": "\u264C\uFE0F",
        "leopard": "\ud83d\udc06",
        "level_slider": "\ud83c\udf9a",
        "libra": "\u264E\uFE0F",
        "light_rail": "\ud83d\ude88",
        "link": "\ud83d\udd17",
        "lion": "\ud83e\udd81",
        "lips": "\ud83d\udc44",
        "lipstick": "\ud83d\udc84",
        "lizard": "\ud83e\udd8e",
        "lock": "\ud83d\udd12",
        "lock_with_ink_pen": "\ud83d\udd0f",
        "lollipop": "\ud83c\udf6d",
        "loop": "\u27BF",
        "loud_sound": "\ud83d\udd0a",
        "loudspeaker": "\ud83d\udce2",
        "love_hotel": "\ud83c\udfe9",
        "love_letter": "\ud83d\udc8c",
        "low_brightness": "\ud83d\udd05",
        "lying_face": "\ud83e\udd25",
        "m": "\u24C2\uFE0F",
        "mag": "\ud83d\udd0d",
        "mag_right": "\ud83d\udd0e",
        "mahjong": "\ud83c\udc04\uFE0F",
        "mailbox": "\ud83d\udceb",
        "mailbox_closed": "\ud83d\udcea",
        "mailbox_with_mail": "\ud83d\udcec",
        "mailbox_with_no_mail": "\ud83d\udced",
        "man": "\ud83d\udc68",
        "man_artist": "\ud83d\udc68&zwj;\ud83c\udfa8",
        "man_astronaut": "\ud83d\udc68&zwj;\ud83d\ude80",
        "man_cartwheeling": "\ud83e\udd38&zwj;\u2642\uFE0F",
        "man_cook": "\ud83d\udc68&zwj;\ud83c\udf73",
        "man_dancing": "\ud83d\udd7a",
        "man_facepalming": "\ud83e\udd26&zwj;\u2642\uFE0F",
        "man_factory_worker": "\ud83d\udc68&zwj;\ud83c\udfed",
        "man_farmer": "\ud83d\udc68&zwj;\ud83c\udf3e",
        "man_firefighter": "\ud83d\udc68&zwj;\ud83d\ude92",
        "man_health_worker": "\ud83d\udc68&zwj;\u2695\uFE0F",
        "man_in_tuxedo": "\ud83e\udd35",
        "man_judge": "\ud83d\udc68&zwj;\u2696\uFE0F",
        "man_juggling": "\ud83e\udd39&zwj;\u2642\uFE0F",
        "man_mechanic": "\ud83d\udc68&zwj;\ud83d\udd27",
        "man_office_worker": "\ud83d\udc68&zwj;\ud83d\udcbc",
        "man_pilot": "\ud83d\udc68&zwj;\u2708\uFE0F",
        "man_playing_handball": "\ud83e\udd3e&zwj;\u2642\uFE0F",
        "man_playing_water_polo": "\ud83e\udd3d&zwj;\u2642\uFE0F",
        "man_scientist": "\ud83d\udc68&zwj;\ud83d\udd2c",
        "man_shrugging": "\ud83e\udd37&zwj;\u2642\uFE0F",
        "man_singer": "\ud83d\udc68&zwj;\ud83c\udfa4",
        "man_student": "\ud83d\udc68&zwj;\ud83c\udf93",
        "man_teacher": "\ud83d\udc68&zwj;\ud83c\udfeb",
        "man_technologist": "\ud83d\udc68&zwj;\ud83d\udcbb",
        "man_with_gua_pi_mao": "\ud83d\udc72",
        "man_with_turban": "\ud83d\udc73",
        "tangerine": "\ud83c\udf4a",
        "mans_shoe": "\ud83d\udc5e",
        "mantelpiece_clock": "\ud83d\udd70",
        "maple_leaf": "\ud83c\udf41",
        "martial_arts_uniform": "\ud83e\udd4b",
        "mask": "\ud83d\ude37",
        "massage_woman": "\ud83d\udc86",
        "massage_man": "\ud83d\udc86&zwj;\u2642\uFE0F",
        "meat_on_bone": "\ud83c\udf56",
        "medal_military": "\ud83c\udf96",
        "medal_sports": "\ud83c\udfc5",
        "mega": "\ud83d\udce3",
        "melon": "\ud83c\udf48",
        "memo": "\ud83d\udcdd",
        "men_wrestling": "\ud83e\udd3c&zwj;\u2642\uFE0F",
        "menorah": "\ud83d\udd4e",
        "mens": "\ud83d\udeb9",
        "metal": "\ud83e\udd18",
        "metro": "\ud83d\ude87",
        "microphone": "\ud83c\udfa4",
        "microscope": "\ud83d\udd2c",
        "milk_glass": "\ud83e\udd5b",
        "milky_way": "\ud83c\udf0c",
        "minibus": "\ud83d\ude90",
        "minidisc": "\ud83d\udcbd",
        "mobile_phone_off": "\ud83d\udcf4",
        "money_mouth_face": "\ud83e\udd11",
        "money_with_wings": "\ud83d\udcb8",
        "moneybag": "\ud83d\udcb0",
        "monkey": "\ud83d\udc12",
        "monkey_face": "\ud83d\udc35",
        "monorail": "\ud83d\ude9d",
        "moon": "\ud83c\udf14",
        "mortar_board": "\ud83c\udf93",
        "mosque": "\ud83d\udd4c",
        "motor_boat": "\ud83d\udee5",
        "motor_scooter": "\ud83d\udef5",
        "motorcycle": "\ud83c\udfcd",
        "motorway": "\ud83d\udee3",
        "mount_fuji": "\ud83d\uddfb",
        "mountain": "\u26F0",
        "mountain_biking_man": "\ud83d\udeb5",
        "mountain_biking_woman": "\ud83d\udeb5&zwj;\u2640\uFE0F",
        "mountain_cableway": "\ud83d\udea0",
        "mountain_railway": "\ud83d\ude9e",
        "mountain_snow": "\ud83c\udfd4",
        "mouse": "\ud83d\udc2d",
        "mouse2": "\ud83d\udc01",
        "movie_camera": "\ud83c\udfa5",
        "moyai": "\ud83d\uddff",
        "mrs_claus": "\ud83e\udd36",
        "muscle": "\ud83d\udcaa",
        "mushroom": "\ud83c\udf44",
        "musical_keyboard": "\ud83c\udfb9",
        "musical_note": "\ud83c\udfb5",
        "musical_score": "\ud83c\udfbc",
        "mute": "\ud83d\udd07",
        "nail_care": "\ud83d\udc85",
        "name_badge": "\ud83d\udcdb",
        "national_park": "\ud83c\udfde",
        "nauseated_face": "\ud83e\udd22",
        "necktie": "\ud83d\udc54",
        "negative_squared_cross_mark": "\u274E",
        "nerd_face": "\ud83e\udd13",
        "neutral_face": "\ud83d\ude10",
        "new": "\ud83c\udd95",
        "new_moon": "\ud83c\udf11",
        "new_moon_with_face": "\ud83c\udf1a",
        "newspaper": "\ud83d\udcf0",
        "newspaper_roll": "\ud83d\uddde",
        "next_track_button": "\u23ED",
        "ng": "\ud83c\udd96",
        "no_good_man": "\ud83d\ude45&zwj;\u2642\uFE0F",
        "no_good_woman": "\ud83d\ude45",
        "night_with_stars": "\ud83c\udf03",
        "no_bell": "\ud83d\udd15",
        "no_bicycles": "\ud83d\udeb3",
        "no_entry": "\u26D4\uFE0F",
        "no_entry_sign": "\ud83d\udeab",
        "no_mobile_phones": "\ud83d\udcf5",
        "no_mouth": "\ud83d\ude36",
        "no_pedestrians": "\ud83d\udeb7",
        "no_smoking": "\ud83d\udead",
        "non-potable_water": "\ud83d\udeb1",
        "nose": "\ud83d\udc43",
        "notebook": "\ud83d\udcd3",
        "notebook_with_decorative_cover": "\ud83d\udcd4",
        "notes": "\ud83c\udfb6",
        "nut_and_bolt": "\ud83d\udd29",
        "o": "\u2B55\uFE0F",
        "o2": "\ud83c\udd7e\uFE0F",
        "ocean": "\ud83c\udf0a",
        "octopus": "\ud83d\udc19",
        "oden": "\ud83c\udf62",
        "office": "\ud83c\udfe2",
        "oil_drum": "\ud83d\udee2",
        "ok": "\ud83c\udd97",
        "ok_hand": "\ud83d\udc4c",
        "ok_man": "\ud83d\ude46&zwj;\u2642\uFE0F",
        "ok_woman": "\ud83d\ude46",
        "old_key": "\ud83d\udddd",
        "older_man": "\ud83d\udc74",
        "older_woman": "\ud83d\udc75",
        "om": "\ud83d\udd49",
        "on": "\ud83d\udd1b",
        "oncoming_automobile": "\ud83d\ude98",
        "oncoming_bus": "\ud83d\ude8d",
        "oncoming_police_car": "\ud83d\ude94",
        "oncoming_taxi": "\ud83d\ude96",
        "open_file_folder": "\ud83d\udcc2",
        "open_hands": "\ud83d\udc50",
        "open_mouth": "\ud83d\ude2e",
        "open_umbrella": "\u2602\uFE0F",
        "ophiuchus": "\u26CE",
        "orange_book": "\ud83d\udcd9",
        "orthodox_cross": "\u2626\uFE0F",
        "outbox_tray": "\ud83d\udce4",
        "owl": "\ud83e\udd89",
        "ox": "\ud83d\udc02",
        "package": "\ud83d\udce6",
        "page_facing_up": "\ud83d\udcc4",
        "page_with_curl": "\ud83d\udcc3",
        "pager": "\ud83d\udcdf",
        "paintbrush": "\ud83d\udd8c",
        "palm_tree": "\ud83c\udf34",
        "pancakes": "\ud83e\udd5e",
        "panda_face": "\ud83d\udc3c",
        "paperclip": "\ud83d\udcce",
        "paperclips": "\ud83d\udd87",
        "parasol_on_ground": "\u26F1",
        "parking": "\ud83c\udd7f\uFE0F",
        "part_alternation_mark": "\u303D\uFE0F",
        "partly_sunny": "\u26C5\uFE0F",
        "passenger_ship": "\ud83d\udef3",
        "passport_control": "\ud83d\udec2",
        "pause_button": "\u23F8",
        "peace_symbol": "\u262E\uFE0F",
        "peach": "\ud83c\udf51",
        "peanuts": "\ud83e\udd5c",
        "pear": "\ud83c\udf50",
        "pen": "\ud83d\udd8a",
        "pencil2": "\u270F\uFE0F",
        "penguin": "\ud83d\udc27",
        "pensive": "\ud83d\ude14",
        "performing_arts": "\ud83c\udfad",
        "persevere": "\ud83d\ude23",
        "person_fencing": "\ud83e\udd3a",
        "pouting_woman": "\ud83d\ude4e",
        "phone": "\u260E\uFE0F",
        "pick": "\u26CF",
        "pig": "\ud83d\udc37",
        "pig2": "\ud83d\udc16",
        "pig_nose": "\ud83d\udc3d",
        "pill": "\ud83d\udc8a",
        "pineapple": "\ud83c\udf4d",
        "ping_pong": "\ud83c\udfd3",
        "pisces": "\u2653\uFE0F",
        "pizza": "\ud83c\udf55",
        "place_of_worship": "\ud83d\uded0",
        "plate_with_cutlery": "\ud83c\udf7d",
        "play_or_pause_button": "\u23EF",
        "point_down": "\ud83d\udc47",
        "point_left": "\ud83d\udc48",
        "point_right": "\ud83d\udc49",
        "point_up": "\u261D\uFE0F",
        "point_up_2": "\ud83d\udc46",
        "police_car": "\ud83d\ude93",
        "policewoman": "\ud83d\udc6e&zwj;\u2640\uFE0F",
        "poodle": "\ud83d\udc29",
        "popcorn": "\ud83c\udf7f",
        "post_office": "\ud83c\udfe3",
        "postal_horn": "\ud83d\udcef",
        "postbox": "\ud83d\udcee",
        "potable_water": "\ud83d\udeb0",
        "potato": "\ud83e\udd54",
        "pouch": "\ud83d\udc5d",
        "poultry_leg": "\ud83c\udf57",
        "pound": "\ud83d\udcb7",
        "rage": "\ud83d\ude21",
        "pouting_cat": "\ud83d\ude3e",
        "pouting_man": "\ud83d\ude4e&zwj;\u2642\uFE0F",
        "pray": "\ud83d\ude4f",
        "prayer_beads": "\ud83d\udcff",
        "pregnant_woman": "\ud83e\udd30",
        "previous_track_button": "\u23EE",
        "prince": "\ud83e\udd34",
        "princess": "\ud83d\udc78",
        "printer": "\ud83d\udda8",
        "purple_heart": "\ud83d\udc9c",
        "purse": "\ud83d\udc5b",
        "pushpin": "\ud83d\udccc",
        "put_litter_in_its_place": "\ud83d\udeae",
        "question": "\u2753",
        "rabbit": "\ud83d\udc30",
        "rabbit2": "\ud83d\udc07",
        "racehorse": "\ud83d\udc0e",
        "racing_car": "\ud83c\udfce",
        "radio": "\ud83d\udcfb",
        "radio_button": "\ud83d\udd18",
        "radioactive": "\u2622\uFE0F",
        "railway_car": "\ud83d\ude83",
        "railway_track": "\ud83d\udee4",
        "rainbow": "\ud83c\udf08",
        "rainbow_flag": "\ud83c\udff3\uFE0F&zwj;\ud83c\udf08",
        "raised_back_of_hand": "\ud83e\udd1a",
        "raised_hand_with_fingers_splayed": "\ud83d\udd90",
        "raised_hands": "\ud83d\ude4c",
        "raising_hand_woman": "\ud83d\ude4b",
        "raising_hand_man": "\ud83d\ude4b&zwj;\u2642\uFE0F",
        "ram": "\ud83d\udc0f",
        "ramen": "\ud83c\udf5c",
        "rat": "\ud83d\udc00",
        "record_button": "\u23FA",
        "recycle": "\u267B\uFE0F",
        "red_circle": "\ud83d\udd34",
        "registered": "\xae\uFE0F",
        "relaxed": "\u263A\uFE0F",
        "relieved": "\ud83d\ude0c",
        "reminder_ribbon": "\ud83c\udf97",
        "repeat": "\ud83d\udd01",
        "repeat_one": "\ud83d\udd02",
        "rescue_worker_helmet": "\u26D1",
        "restroom": "\ud83d\udebb",
        "revolving_hearts": "\ud83d\udc9e",
        "rewind": "\u23EA",
        "rhinoceros": "\ud83e\udd8f",
        "ribbon": "\ud83c\udf80",
        "rice": "\ud83c\udf5a",
        "rice_ball": "\ud83c\udf59",
        "rice_cracker": "\ud83c\udf58",
        "rice_scene": "\ud83c\udf91",
        "right_anger_bubble": "\ud83d\uddef",
        "ring": "\ud83d\udc8d",
        "robot": "\ud83e\udd16",
        "rocket": "\ud83d\ude80",
        "rofl": "\ud83e\udd23",
        "roll_eyes": "\ud83d\ude44",
        "roller_coaster": "\ud83c\udfa2",
        "rooster": "\ud83d\udc13",
        "rose": "\ud83c\udf39",
        "rosette": "\ud83c\udff5",
        "rotating_light": "\ud83d\udea8",
        "round_pushpin": "\ud83d\udccd",
        "rowing_man": "\ud83d\udea3",
        "rowing_woman": "\ud83d\udea3&zwj;\u2640\uFE0F",
        "rugby_football": "\ud83c\udfc9",
        "running_man": "\ud83c\udfc3",
        "running_shirt_with_sash": "\ud83c\udfbd",
        "running_woman": "\ud83c\udfc3&zwj;\u2640\uFE0F",
        "sa": "\ud83c\ude02\uFE0F",
        "sagittarius": "\u2650\uFE0F",
        "sake": "\ud83c\udf76",
        "sandal": "\ud83d\udc61",
        "santa": "\ud83c\udf85",
        "satellite": "\ud83d\udce1",
        "saxophone": "\ud83c\udfb7",
        "school": "\ud83c\udfeb",
        "school_satchel": "\ud83c\udf92",
        "scissors": "\u2702\uFE0F",
        "scorpion": "\ud83e\udd82",
        "scorpius": "\u264F\uFE0F",
        "scream": "\ud83d\ude31",
        "scream_cat": "\ud83d\ude40",
        "scroll": "\ud83d\udcdc",
        "seat": "\ud83d\udcba",
        "secret": "\u3299\uFE0F",
        "see_no_evil": "\ud83d\ude48",
        "seedling": "\ud83c\udf31",
        "selfie": "\ud83e\udd33",
        "shallow_pan_of_food": "\ud83e\udd58",
        "shamrock": "\u2618\uFE0F",
        "shark": "\ud83e\udd88",
        "shaved_ice": "\ud83c\udf67",
        "sheep": "\ud83d\udc11",
        "shell": "\ud83d\udc1a",
        "shield": "\ud83d\udee1",
        "shinto_shrine": "\u26E9",
        "ship": "\ud83d\udea2",
        "shirt": "\ud83d\udc55",
        "shopping": "\ud83d\udecd",
        "shopping_cart": "\ud83d\uded2",
        "shower": "\ud83d\udebf",
        "shrimp": "\ud83e\udd90",
        "signal_strength": "\ud83d\udcf6",
        "six_pointed_star": "\ud83d\udd2f",
        "ski": "\ud83c\udfbf",
        "skier": "\u26F7",
        "skull": "\ud83d\udc80",
        "skull_and_crossbones": "\u2620\uFE0F",
        "sleeping": "\ud83d\ude34",
        "sleeping_bed": "\ud83d\udecc",
        "sleepy": "\ud83d\ude2a",
        "slightly_frowning_face": "\ud83d\ude41",
        "slightly_smiling_face": "\ud83d\ude42",
        "slot_machine": "\ud83c\udfb0",
        "small_airplane": "\ud83d\udee9",
        "small_blue_diamond": "\ud83d\udd39",
        "small_orange_diamond": "\ud83d\udd38",
        "small_red_triangle": "\ud83d\udd3a",
        "small_red_triangle_down": "\ud83d\udd3b",
        "smile": "\ud83d\ude04",
        "smile_cat": "\ud83d\ude38",
        "smiley": "\ud83d\ude03",
        "smiley_cat": "\ud83d\ude3a",
        "smiling_imp": "\ud83d\ude08",
        "smirk": "\ud83d\ude0f",
        "smirk_cat": "\ud83d\ude3c",
        "smoking": "\ud83d\udeac",
        "snail": "\ud83d\udc0c",
        "snake": "\ud83d\udc0d",
        "sneezing_face": "\ud83e\udd27",
        "snowboarder": "\ud83c\udfc2",
        "snowflake": "\u2744\uFE0F",
        "snowman": "\u26C4\uFE0F",
        "snowman_with_snow": "\u2603\uFE0F",
        "sob": "\ud83d\ude2d",
        "soccer": "\u26BD\uFE0F",
        "soon": "\ud83d\udd1c",
        "sos": "\ud83c\udd98",
        "sound": "\ud83d\udd09",
        "space_invader": "\ud83d\udc7e",
        "spades": "\u2660\uFE0F",
        "spaghetti": "\ud83c\udf5d",
        "sparkle": "\u2747\uFE0F",
        "sparkler": "\ud83c\udf87",
        "sparkles": "\u2728",
        "sparkling_heart": "\ud83d\udc96",
        "speak_no_evil": "\ud83d\ude4a",
        "speaker": "\ud83d\udd08",
        "speaking_head": "\ud83d\udde3",
        "speech_balloon": "\ud83d\udcac",
        "speedboat": "\ud83d\udea4",
        "spider": "\ud83d\udd77",
        "spider_web": "\ud83d\udd78",
        "spiral_calendar": "\ud83d\uddd3",
        "spiral_notepad": "\ud83d\uddd2",
        "spoon": "\ud83e\udd44",
        "squid": "\ud83e\udd91",
        "stadium": "\ud83c\udfdf",
        "star": "\u2B50\uFE0F",
        "star2": "\ud83c\udf1f",
        "star_and_crescent": "\u262A\uFE0F",
        "star_of_david": "\u2721\uFE0F",
        "stars": "\ud83c\udf20",
        "station": "\ud83d\ude89",
        "statue_of_liberty": "\ud83d\uddfd",
        "steam_locomotive": "\ud83d\ude82",
        "stew": "\ud83c\udf72",
        "stop_button": "\u23F9",
        "stop_sign": "\ud83d\uded1",
        "stopwatch": "\u23F1",
        "straight_ruler": "\ud83d\udccf",
        "strawberry": "\ud83c\udf53",
        "stuck_out_tongue": "\ud83d\ude1b",
        "stuck_out_tongue_closed_eyes": "\ud83d\ude1d",
        "stuck_out_tongue_winking_eye": "\ud83d\ude1c",
        "studio_microphone": "\ud83c\udf99",
        "stuffed_flatbread": "\ud83e\udd59",
        "sun_behind_large_cloud": "\ud83c\udf25",
        "sun_behind_rain_cloud": "\ud83c\udf26",
        "sun_behind_small_cloud": "\ud83c\udf24",
        "sun_with_face": "\ud83c\udf1e",
        "sunflower": "\ud83c\udf3b",
        "sunglasses": "\ud83d\ude0e",
        "sunny": "\u2600\uFE0F",
        "sunrise": "\ud83c\udf05",
        "sunrise_over_mountains": "\ud83c\udf04",
        "surfing_man": "\ud83c\udfc4",
        "surfing_woman": "\ud83c\udfc4&zwj;\u2640\uFE0F",
        "sushi": "\ud83c\udf63",
        "suspension_railway": "\ud83d\ude9f",
        "sweat": "\ud83d\ude13",
        "sweat_drops": "\ud83d\udca6",
        "sweat_smile": "\ud83d\ude05",
        "sweet_potato": "\ud83c\udf60",
        "swimming_man": "\ud83c\udfca",
        "swimming_woman": "\ud83c\udfca&zwj;\u2640\uFE0F",
        "symbols": "\ud83d\udd23",
        "synagogue": "\ud83d\udd4d",
        "syringe": "\ud83d\udc89",
        "taco": "\ud83c\udf2e",
        "tada": "\ud83c\udf89",
        "tanabata_tree": "\ud83c\udf8b",
        "taurus": "\u2649\uFE0F",
        "taxi": "\ud83d\ude95",
        "tea": "\ud83c\udf75",
        "telephone_receiver": "\ud83d\udcde",
        "telescope": "\ud83d\udd2d",
        "tennis": "\ud83c\udfbe",
        "tent": "\u26FA\uFE0F",
        "thermometer": "\ud83c\udf21",
        "thinking": "\ud83e\udd14",
        "thought_balloon": "\ud83d\udcad",
        "ticket": "\ud83c\udfab",
        "tickets": "\ud83c\udf9f",
        "tiger": "\ud83d\udc2f",
        "tiger2": "\ud83d\udc05",
        "timer_clock": "\u23F2",
        "tipping_hand_man": "\ud83d\udc81&zwj;\u2642\uFE0F",
        "tired_face": "\ud83d\ude2b",
        "tm": "\u2122\uFE0F",
        "toilet": "\ud83d\udebd",
        "tokyo_tower": "\ud83d\uddfc",
        "tomato": "\ud83c\udf45",
        "tongue": "\ud83d\udc45",
        "top": "\ud83d\udd1d",
        "tophat": "\ud83c\udfa9",
        "tornado": "\ud83c\udf2a",
        "trackball": "\ud83d\uddb2",
        "tractor": "\ud83d\ude9c",
        "traffic_light": "\ud83d\udea5",
        "train": "\ud83d\ude8b",
        "train2": "\ud83d\ude86",
        "tram": "\ud83d\ude8a",
        "triangular_flag_on_post": "\ud83d\udea9",
        "triangular_ruler": "\ud83d\udcd0",
        "trident": "\ud83d\udd31",
        "triumph": "\ud83d\ude24",
        "trolleybus": "\ud83d\ude8e",
        "trophy": "\ud83c\udfc6",
        "tropical_drink": "\ud83c\udf79",
        "tropical_fish": "\ud83d\udc20",
        "truck": "\ud83d\ude9a",
        "trumpet": "\ud83c\udfba",
        "tulip": "\ud83c\udf37",
        "tumbler_glass": "\ud83e\udd43",
        "turkey": "\ud83e\udd83",
        "turtle": "\ud83d\udc22",
        "tv": "\ud83d\udcfa",
        "twisted_rightwards_arrows": "\ud83d\udd00",
        "two_hearts": "\ud83d\udc95",
        "two_men_holding_hands": "\ud83d\udc6c",
        "two_women_holding_hands": "\ud83d\udc6d",
        "u5272": "\ud83c\ude39",
        "u5408": "\ud83c\ude34",
        "u55b6": "\ud83c\ude3a",
        "u6307": "\ud83c\ude2f\uFE0F",
        "u6708": "\ud83c\ude37\uFE0F",
        "u6709": "\ud83c\ude36",
        "u6e80": "\ud83c\ude35",
        "u7121": "\ud83c\ude1a\uFE0F",
        "u7533": "\ud83c\ude38",
        "u7981": "\ud83c\ude32",
        "u7a7a": "\ud83c\ude33",
        "umbrella": "\u2614\uFE0F",
        "unamused": "\ud83d\ude12",
        "underage": "\ud83d\udd1e",
        "unicorn": "\ud83e\udd84",
        "unlock": "\ud83d\udd13",
        "up": "\ud83c\udd99",
        "upside_down_face": "\ud83d\ude43",
        "v": "\u270C\uFE0F",
        "vertical_traffic_light": "\ud83d\udea6",
        "vhs": "\ud83d\udcfc",
        "vibration_mode": "\ud83d\udcf3",
        "video_camera": "\ud83d\udcf9",
        "video_game": "\ud83c\udfae",
        "violin": "\ud83c\udfbb",
        "virgo": "\u264D\uFE0F",
        "volcano": "\ud83c\udf0b",
        "volleyball": "\ud83c\udfd0",
        "vs": "\ud83c\udd9a",
        "vulcan_salute": "\ud83d\udd96",
        "walking_man": "\ud83d\udeb6",
        "walking_woman": "\ud83d\udeb6&zwj;\u2640\uFE0F",
        "waning_crescent_moon": "\ud83c\udf18",
        "waning_gibbous_moon": "\ud83c\udf16",
        "warning": "\u26A0\uFE0F",
        "wastebasket": "\ud83d\uddd1",
        "watch": "\u231A\uFE0F",
        "water_buffalo": "\ud83d\udc03",
        "watermelon": "\ud83c\udf49",
        "wave": "\ud83d\udc4b",
        "wavy_dash": "\u3030\uFE0F",
        "waxing_crescent_moon": "\ud83c\udf12",
        "wc": "\ud83d\udebe",
        "weary": "\ud83d\ude29",
        "wedding": "\ud83d\udc92",
        "weight_lifting_man": "\ud83c\udfcb\uFE0F",
        "weight_lifting_woman": "\ud83c\udfcb\uFE0F&zwj;\u2640\uFE0F",
        "whale": "\ud83d\udc33",
        "whale2": "\ud83d\udc0b",
        "wheel_of_dharma": "\u2638\uFE0F",
        "wheelchair": "\u267F\uFE0F",
        "white_check_mark": "\u2705",
        "white_circle": "\u26AA\uFE0F",
        "white_flag": "\ud83c\udff3\uFE0F",
        "white_flower": "\ud83d\udcae",
        "white_large_square": "\u2B1C\uFE0F",
        "white_medium_small_square": "\u25FD\uFE0F",
        "white_medium_square": "\u25FB\uFE0F",
        "white_small_square": "\u25AB\uFE0F",
        "white_square_button": "\ud83d\udd33",
        "wilted_flower": "\ud83e\udd40",
        "wind_chime": "\ud83c\udf90",
        "wind_face": "\ud83c\udf2c",
        "wine_glass": "\ud83c\udf77",
        "wink": "\ud83d\ude09",
        "wolf": "\ud83d\udc3a",
        "woman": "\ud83d\udc69",
        "woman_artist": "\ud83d\udc69&zwj;\ud83c\udfa8",
        "woman_astronaut": "\ud83d\udc69&zwj;\ud83d\ude80",
        "woman_cartwheeling": "\ud83e\udd38&zwj;\u2640\uFE0F",
        "woman_cook": "\ud83d\udc69&zwj;\ud83c\udf73",
        "woman_facepalming": "\ud83e\udd26&zwj;\u2640\uFE0F",
        "woman_factory_worker": "\ud83d\udc69&zwj;\ud83c\udfed",
        "woman_farmer": "\ud83d\udc69&zwj;\ud83c\udf3e",
        "woman_firefighter": "\ud83d\udc69&zwj;\ud83d\ude92",
        "woman_health_worker": "\ud83d\udc69&zwj;\u2695\uFE0F",
        "woman_judge": "\ud83d\udc69&zwj;\u2696\uFE0F",
        "woman_juggling": "\ud83e\udd39&zwj;\u2640\uFE0F",
        "woman_mechanic": "\ud83d\udc69&zwj;\ud83d\udd27",
        "woman_office_worker": "\ud83d\udc69&zwj;\ud83d\udcbc",
        "woman_pilot": "\ud83d\udc69&zwj;\u2708\uFE0F",
        "woman_playing_handball": "\ud83e\udd3e&zwj;\u2640\uFE0F",
        "woman_playing_water_polo": "\ud83e\udd3d&zwj;\u2640\uFE0F",
        "woman_scientist": "\ud83d\udc69&zwj;\ud83d\udd2c",
        "woman_shrugging": "\ud83e\udd37&zwj;\u2640\uFE0F",
        "woman_singer": "\ud83d\udc69&zwj;\ud83c\udfa4",
        "woman_student": "\ud83d\udc69&zwj;\ud83c\udf93",
        "woman_teacher": "\ud83d\udc69&zwj;\ud83c\udfeb",
        "woman_technologist": "\ud83d\udc69&zwj;\ud83d\udcbb",
        "woman_with_turban": "\ud83d\udc73&zwj;\u2640\uFE0F",
        "womans_clothes": "\ud83d\udc5a",
        "womans_hat": "\ud83d\udc52",
        "women_wrestling": "\ud83e\udd3c&zwj;\u2640\uFE0F",
        "womens": "\ud83d\udeba",
        "world_map": "\ud83d\uddfa",
        "worried": "\ud83d\ude1f",
        "wrench": "\ud83d\udd27",
        "writing_hand": "\u270D\uFE0F",
        "x": "\u274C",
        "yellow_heart": "\ud83d\udc9b",
        "yen": "\ud83d\udcb4",
        "yin_yang": "\u262F\uFE0F",
        "yum": "\ud83d\ude0b",
        "zap": "\u26A1\uFE0F",
        "zipper_mouth_face": "\ud83e\udd10",
        "zzz": "\ud83d\udca4",
        /* special emojis :P */ "octocat": '<img alt=":octocat:" height="20" width="20" align="absmiddle" src="https://assets-cdn.github.com/images/icons/emoji/octocat.png">',
        "showdown": "<span style=\"font-family: 'Anonymous Pro', monospace; text-decoration: underline; text-decoration-style: dashed; text-decoration-color: #3e8b8a;text-underline-position: under;\">S</span>"
    };
    /**
 * Created by Estevao on 31-05-2015.
 */ /**
 * Showdown Converter class
 * @class
 * @param {object} [converterOptions]
 * @returns {Converter}
 */ showdown.Converter = function(converterOptions) {
        "use strict";
        var /**
       * Options used by this converter
       * @private
       * @type {{}}
       */ options = {}, /**
       * Language extensions used by this converter
       * @private
       * @type {Array}
       */ langExtensions = [], /**
       * Output modifiers extensions used by this converter
       * @private
       * @type {Array}
       */ outputModifiers = [], /**
       * Event listeners
       * @private
       * @type {{}}
       */ listeners = {}, /**
       * The flavor set in this converter
       */ setConvFlavor = setFlavor, /**
       * Metadata of the document
       * @type {{parsed: {}, raw: string, format: string}}
       */ metadata = {
            parsed: {},
            raw: "",
            format: ""
        };
        _constructor();
        /**
   * Converter constructor
   * @private
   */ function _constructor() {
            converterOptions = converterOptions || {};
            for(var gOpt in globalOptions)if (globalOptions.hasOwnProperty(gOpt)) options[gOpt] = globalOptions[gOpt];
            // Merge options
            if (typeof converterOptions === "object") {
                for(var opt in converterOptions)if (converterOptions.hasOwnProperty(opt)) options[opt] = converterOptions[opt];
            } else throw Error("Converter expects the passed parameter to be an object, but " + typeof converterOptions + " was passed instead.");
            if (options.extensions) showdown.helper.forEach(options.extensions, _parseExtension);
        }
        /**
   * Parse extension
   * @param {*} ext
   * @param {string} [name='']
   * @private
   */ function _parseExtension(ext, name) {
            name = name || null;
            // If it's a string, the extension was previously loaded
            if (showdown.helper.isString(ext)) {
                ext = showdown.helper.stdExtName(ext);
                name = ext;
                // LEGACY_SUPPORT CODE
                if (showdown.extensions[ext]) {
                    console.warn("DEPRECATION WARNING: " + ext + " is an old extension that uses a deprecated loading method." + "Please inform the developer that the extension should be updated!");
                    legacyExtensionLoading(showdown.extensions[ext], ext);
                    return;
                // END LEGACY SUPPORT CODE
                } else if (!showdown.helper.isUndefined(extensions[ext])) ext = extensions[ext];
                else throw Error('Extension "' + ext + '" could not be loaded. It was either not found or is not a valid extension.');
            }
            if (typeof ext === "function") ext = ext();
            if (!showdown.helper.isArray(ext)) ext = [
                ext
            ];
            var validExt = validate(ext, name);
            if (!validExt.valid) throw Error(validExt.error);
            for(var i = 0; i < ext.length; ++i){
                switch(ext[i].type){
                    case "lang":
                        langExtensions.push(ext[i]);
                        break;
                    case "output":
                        outputModifiers.push(ext[i]);
                        break;
                }
                if (ext[i].hasOwnProperty("listeners")) {
                    for(var ln in ext[i].listeners)if (ext[i].listeners.hasOwnProperty(ln)) listen(ln, ext[i].listeners[ln]);
                }
            }
        }
        /**
   * LEGACY_SUPPORT
   * @param {*} ext
   * @param {string} name
   */ function legacyExtensionLoading(ext, name) {
            if (typeof ext === "function") ext = ext(new showdown.Converter());
            if (!showdown.helper.isArray(ext)) ext = [
                ext
            ];
            var valid = validate(ext, name);
            if (!valid.valid) throw Error(valid.error);
            for(var i = 0; i < ext.length; ++i)switch(ext[i].type){
                case "lang":
                    langExtensions.push(ext[i]);
                    break;
                case "output":
                    outputModifiers.push(ext[i]);
                    break;
                default:
                    throw Error("Extension loader error: Type unrecognized!!!");
            }
        }
        /**
   * Listen to an event
   * @param {string} name
   * @param {function} callback
   */ function listen(name, callback) {
            if (!showdown.helper.isString(name)) throw Error("Invalid argument in converter.listen() method: name must be a string, but " + typeof name + " given");
            if (typeof callback !== "function") throw Error("Invalid argument in converter.listen() method: callback must be a function, but " + typeof callback + " given");
            if (!listeners.hasOwnProperty(name)) listeners[name] = [];
            listeners[name].push(callback);
        }
        function rTrimInputText(text) {
            var rsp = text.match(/^\s*/)[0].length, rgx = new RegExp("^\\s{0," + rsp + "}", "gm");
            return text.replace(rgx, "");
        }
        /**
   * Dispatch an event
   * @private
   * @param {string} evtName Event name
   * @param {string} text Text
   * @param {{}} options Converter Options
   * @param {{}} globals
   * @returns {string}
   */ this._dispatch = function dispatch(evtName, text, options, globals) {
            if (listeners.hasOwnProperty(evtName)) for(var ei = 0; ei < listeners[evtName].length; ++ei){
                var nText = listeners[evtName][ei](evtName, text, this, options, globals);
                if (nText && typeof nText !== "undefined") text = nText;
            }
            return text;
        };
        /**
   * Listen to an event
   * @param {string} name
   * @param {function} callback
   * @returns {showdown.Converter}
   */ this.listen = function(name, callback) {
            listen(name, callback);
            return this;
        };
        /**
   * Converts a markdown string into HTML
   * @param {string} text
   * @returns {*}
   */ this.makeHtml = function(text) {
            //check if text is not falsy
            if (!text) return text;
            var globals = {
                gHtmlBlocks: [],
                gHtmlMdBlocks: [],
                gHtmlSpans: [],
                gUrls: {},
                gTitles: {},
                gDimensions: {},
                gListLevel: 0,
                hashLinkCounts: {},
                langExtensions: langExtensions,
                outputModifiers: outputModifiers,
                converter: this,
                ghCodeBlocks: [],
                metadata: {
                    parsed: {},
                    raw: "",
                    format: ""
                }
            };
            // This lets us use ¨ trema as an escape char to avoid md5 hashes
            // The choice of character is arbitrary; anything that isn't
            // magic in Markdown will work.
            text = text.replace(/¨/g, "\xa8T");
            // Replace $ with ¨D
            // RegExp interprets $ as a special character
            // when it's in a replacement string
            text = text.replace(/\$/g, "\xa8D");
            // Standardize line endings
            text = text.replace(/\r\n/g, "\n"); // DOS to Unix
            text = text.replace(/\r/g, "\n"); // Mac to Unix
            // Stardardize line spaces
            text = text.replace(/\u00A0/g, "&nbsp;");
            if (options.smartIndentationFix) text = rTrimInputText(text);
            // Make sure text begins and ends with a couple of newlines:
            text = "\n\n" + text + "\n\n";
            // detab
            text = showdown.subParser("detab")(text, options, globals);
            /**
     * Strip any lines consisting only of spaces and tabs.
     * This makes subsequent regexs easier to write, because we can
     * match consecutive blank lines with /\n+/ instead of something
     * contorted like /[ \t]*\n+/
     */ text = text.replace(/^[ \t]+$/mg, "");
            //run languageExtensions
            showdown.helper.forEach(langExtensions, function(ext) {
                text = showdown.subParser("runExtension")(ext, text, options, globals);
            });
            // run the sub parsers
            text = showdown.subParser("metadata")(text, options, globals);
            text = showdown.subParser("hashPreCodeTags")(text, options, globals);
            text = showdown.subParser("githubCodeBlocks")(text, options, globals);
            text = showdown.subParser("hashHTMLBlocks")(text, options, globals);
            text = showdown.subParser("hashCodeTags")(text, options, globals);
            text = showdown.subParser("stripLinkDefinitions")(text, options, globals);
            text = showdown.subParser("blockGamut")(text, options, globals);
            text = showdown.subParser("unhashHTMLSpans")(text, options, globals);
            text = showdown.subParser("unescapeSpecialChars")(text, options, globals);
            // attacklab: Restore dollar signs
            text = text.replace(/¨D/g, "$$");
            // attacklab: Restore tremas
            text = text.replace(/¨T/g, "\xa8");
            // render a complete html document instead of a partial if the option is enabled
            text = showdown.subParser("completeHTMLDocument")(text, options, globals);
            // Run output modifiers
            showdown.helper.forEach(outputModifiers, function(ext) {
                text = showdown.subParser("runExtension")(ext, text, options, globals);
            });
            // update metadata
            metadata = globals.metadata;
            return text;
        };
        /**
   * Converts an HTML string into a markdown string
   * @param src
   * @param [HTMLParser] A WHATWG DOM and HTML parser, such as JSDOM. If none is supplied, window.document will be used.
   * @returns {string}
   */ this.makeMarkdown = this.makeMd = function(src, HTMLParser) {
            // replace \r\n with \n
            src = src.replace(/\r\n/g, "\n");
            src = src.replace(/\r/g, "\n"); // old macs
            // due to an edge case, we need to find this: > <
            // to prevent removing of non silent white spaces
            // ex: <em>this is</em> <strong>sparta</strong>
            src = src.replace(/>[ \t]+</, ">\xa8NBSP;<");
            if (!HTMLParser) {
                if (window && window.document) HTMLParser = window.document;
                else throw new Error("HTMLParser is undefined. If in a webworker or nodejs environment, you need to provide a WHATWG DOM and HTML such as JSDOM");
            }
            var doc = HTMLParser.createElement("div");
            doc.innerHTML = src;
            var globals = {
                preList: substitutePreCodeTags(doc)
            };
            // remove all newlines and collapse spaces
            clean(doc);
            // some stuff, like accidental reference links must now be escaped
            // TODO
            // doc.innerHTML = doc.innerHTML.replace(/\[[\S\t ]]/);
            var nodes = doc.childNodes, mdDoc = "";
            for(var i = 0; i < nodes.length; i++)mdDoc += showdown.subParser("makeMarkdown.node")(nodes[i], globals);
            function clean(node) {
                for(var n = 0; n < node.childNodes.length; ++n){
                    var child = node.childNodes[n];
                    if (child.nodeType === 3) {
                        if (!/\S/.test(child.nodeValue) && !/^[ ]+$/.test(child.nodeValue)) {
                            node.removeChild(child);
                            --n;
                        } else {
                            child.nodeValue = child.nodeValue.split("\n").join(" ");
                            child.nodeValue = child.nodeValue.replace(/(\s)+/g, "$1");
                        }
                    } else if (child.nodeType === 1) clean(child);
                }
            }
            // find all pre tags and replace contents with placeholder
            // we need this so that we can remove all indentation from html
            // to ease up parsing
            function substitutePreCodeTags(doc) {
                var pres = doc.querySelectorAll("pre"), presPH = [];
                for(var i = 0; i < pres.length; ++i)if (pres[i].childElementCount === 1 && pres[i].firstChild.tagName.toLowerCase() === "code") {
                    var content = pres[i].firstChild.innerHTML.trim(), language = pres[i].firstChild.getAttribute("data-language") || "";
                    // if data-language attribute is not defined, then we look for class language-*
                    if (language === "") {
                        var classes = pres[i].firstChild.className.split(" ");
                        for(var c = 0; c < classes.length; ++c){
                            var matches = classes[c].match(/^language-(.+)$/);
                            if (matches !== null) {
                                language = matches[1];
                                break;
                            }
                        }
                    }
                    // unescape html entities in content
                    content = showdown.helper.unescapeHTMLEntities(content);
                    presPH.push(content);
                    pres[i].outerHTML = '<precode language="' + language + '" precodenum="' + i.toString() + '"></precode>';
                } else {
                    presPH.push(pres[i].innerHTML);
                    pres[i].innerHTML = "";
                    pres[i].setAttribute("prenum", i.toString());
                }
                return presPH;
            }
            return mdDoc;
        };
        /**
   * Set an option of this Converter instance
   * @param {string} key
   * @param {*} value
   */ this.setOption = function(key, value) {
            options[key] = value;
        };
        /**
   * Get the option of this Converter instance
   * @param {string} key
   * @returns {*}
   */ this.getOption = function(key) {
            return options[key];
        };
        /**
   * Get the options of this Converter instance
   * @returns {{}}
   */ this.getOptions = function() {
            return options;
        };
        /**
   * Add extension to THIS converter
   * @param {{}} extension
   * @param {string} [name=null]
   */ this.addExtension = function(extension, name) {
            name = name || null;
            _parseExtension(extension, name);
        };
        /**
   * Use a global registered extension with THIS converter
   * @param {string} extensionName Name of the previously registered extension
   */ this.useExtension = function(extensionName) {
            _parseExtension(extensionName);
        };
        /**
   * Set the flavor THIS converter should use
   * @param {string} name
   */ this.setFlavor = function(name) {
            if (!flavor.hasOwnProperty(name)) throw Error(name + " flavor was not found");
            var preset = flavor[name];
            setConvFlavor = name;
            for(var option in preset)if (preset.hasOwnProperty(option)) options[option] = preset[option];
        };
        /**
   * Get the currently set flavor of this converter
   * @returns {string}
   */ this.getFlavor = function() {
            return setConvFlavor;
        };
        /**
   * Remove an extension from THIS converter.
   * Note: This is a costly operation. It's better to initialize a new converter
   * and specify the extensions you wish to use
   * @param {Array} extension
   */ this.removeExtension = function(extension) {
            if (!showdown.helper.isArray(extension)) extension = [
                extension
            ];
            for(var a = 0; a < extension.length; ++a){
                var ext = extension[a];
                for(var i = 0; i < langExtensions.length; ++i)if (langExtensions[i] === ext) langExtensions.splice(i, 1);
                for(var ii = 0; ii < outputModifiers.length; ++ii)if (outputModifiers[ii] === ext) outputModifiers.splice(ii, 1);
            }
        };
        /**
   * Get all extension of THIS converter
   * @returns {{language: Array, output: Array}}
   */ this.getAllExtensions = function() {
            return {
                language: langExtensions,
                output: outputModifiers
            };
        };
        /**
   * Get the metadata of the previously parsed document
   * @param raw
   * @returns {string|{}}
   */ this.getMetadata = function(raw) {
            if (raw) return metadata.raw;
            else return metadata.parsed;
        };
        /**
   * Get the metadata format of the previously parsed document
   * @returns {string}
   */ this.getMetadataFormat = function() {
            return metadata.format;
        };
        /**
   * Private: set a single key, value metadata pair
   * @param {string} key
   * @param {string} value
   */ this._setMetadataPair = function(key, value) {
            metadata.parsed[key] = value;
        };
        /**
   * Private: set metadata format
   * @param {string} format
   */ this._setMetadataFormat = function(format) {
            metadata.format = format;
        };
        /**
   * Private: set metadata raw text
   * @param {string} raw
   */ this._setMetadataRaw = function(raw) {
            metadata.raw = raw;
        };
    };
    /**
 * Turn Markdown link shortcuts into XHTML <a> tags.
 */ showdown.subParser("anchors", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("anchors.before", text, options, globals);
        var writeAnchorTag = function(wholeMatch, linkText, linkId, url, m5, m6, title) {
            if (showdown.helper.isUndefined(title)) title = "";
            linkId = linkId.toLowerCase();
            // Special case for explicit empty url
            if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) url = "";
            else if (!url) {
                if (!linkId) // lower-case and turn embedded newlines into spaces
                linkId = linkText.toLowerCase().replace(/ ?\n/g, " ");
                url = "#" + linkId;
                if (!showdown.helper.isUndefined(globals.gUrls[linkId])) {
                    url = globals.gUrls[linkId];
                    if (!showdown.helper.isUndefined(globals.gTitles[linkId])) title = globals.gTitles[linkId];
                } else return wholeMatch;
            }
            //url = showdown.helper.escapeCharacters(url, '*_', false); // replaced line to improve performance
            url = url.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
            var result = '<a href="' + url + '"';
            if (title !== "" && title !== null) {
                title = title.replace(/"/g, "&quot;");
                //title = showdown.helper.escapeCharacters(title, '*_', false); // replaced line to improve performance
                title = title.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
                result += ' title="' + title + '"';
            }
            // optionLinksInNewWindow only applies
            // to external links. Hash links (#) open in same page
            if (options.openLinksInNewWindow && !/^#/.test(url)) // escaped _
            result += ' rel="noopener noreferrer" target="\xa8E95Eblank"';
            result += ">" + linkText + "</a>";
            return result;
        };
        // First, handle reference-style links: [link text] [id]
        text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)] ?(?:\n *)?\[(.*?)]()()()()/g, writeAnchorTag);
        // Next, inline-style links: [link text](url "optional title")
        // cases with crazy urls like ./image/cat1).png
        text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<([^>]*)>(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g, writeAnchorTag);
        // normal cases
        text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g, writeAnchorTag);
        // handle reference-style shortcuts: [link text]
        // These must come last in case you've also got [link test][1]
        // or [link test](/foo)
        text = text.replace(/\[([^\[\]]+)]()()()()()/g, writeAnchorTag);
        // Lastly handle GithubMentions if option is enabled
        if (options.ghMentions) text = text.replace(/(^|\s)(\\)?(@([a-z\d]+(?:[a-z\d.-]+?[a-z\d]+)*))/gmi, function(wm, st, escape, mentions, username) {
            if (escape === "\\") return st + mentions;
            //check if options.ghMentionsLink is a string
            if (!showdown.helper.isString(options.ghMentionsLink)) throw new Error("ghMentionsLink option must be a string");
            var lnk = options.ghMentionsLink.replace(/\{u}/g, username), target = "";
            if (options.openLinksInNewWindow) target = ' rel="noopener noreferrer" target="\xa8E95Eblank"';
            return st + '<a href="' + lnk + '"' + target + ">" + mentions + "</a>";
        });
        text = globals.converter._dispatch("anchors.after", text, options, globals);
        return text;
    });
    // url allowed chars [a-z\d_.~:/?#[]@!$&'()*+,;=-]
    var simpleURLRegex = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+?\.[^'">\s]+?)()(\1)?(?=\s|$)(?!["<>])/gi, simpleURLRegex2 = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+\.[^'">\s]+?)([.!?,()\[\]])?(\1)?(?=\s|$)(?!["<>])/gi, delimUrlRegex = /()<(((https?|ftp|dict):\/\/|www\.)[^'">\s]+)()>()/gi, simpleMailRegex = /(^|\s)(?:mailto:)?([A-Za-z0-9!#$%&'*+-/=?^_`{|}~.]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)(?=$|\s)/gmi, delimMailRegex = /<()(?:mailto:)?([-.\w]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)>/gi, replaceLink = function(options) {
        "use strict";
        return function(wm, leadingMagicChars, link, m2, m3, trailingPunctuation, trailingMagicChars) {
            link = link.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
            var lnkTxt = link, append = "", target = "", lmc = leadingMagicChars || "", tmc = trailingMagicChars || "";
            if (/^www\./i.test(link)) link = link.replace(/^www\./i, "http://www.");
            if (options.excludeTrailingPunctuationFromURLs && trailingPunctuation) append = trailingPunctuation;
            if (options.openLinksInNewWindow) target = ' rel="noopener noreferrer" target="\xa8E95Eblank"';
            return lmc + '<a href="' + link + '"' + target + ">" + lnkTxt + "</a>" + append + tmc;
        };
    }, replaceMail = function(options, globals) {
        "use strict";
        return function(wholeMatch, b, mail) {
            var href = "mailto:";
            b = b || "";
            mail = showdown.subParser("unescapeSpecialChars")(mail, options, globals);
            if (options.encodeEmails) {
                href = showdown.helper.encodeEmailAddress(href + mail);
                mail = showdown.helper.encodeEmailAddress(mail);
            } else href = href + mail;
            return b + '<a href="' + href + '">' + mail + "</a>";
        };
    };
    showdown.subParser("autoLinks", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("autoLinks.before", text, options, globals);
        text = text.replace(delimUrlRegex, replaceLink(options));
        text = text.replace(delimMailRegex, replaceMail(options, globals));
        text = globals.converter._dispatch("autoLinks.after", text, options, globals);
        return text;
    });
    showdown.subParser("simplifiedAutoLinks", function(text, options, globals) {
        "use strict";
        if (!options.simplifiedAutoLink) return text;
        text = globals.converter._dispatch("simplifiedAutoLinks.before", text, options, globals);
        if (options.excludeTrailingPunctuationFromURLs) text = text.replace(simpleURLRegex2, replaceLink(options));
        else text = text.replace(simpleURLRegex, replaceLink(options));
        text = text.replace(simpleMailRegex, replaceMail(options, globals));
        text = globals.converter._dispatch("simplifiedAutoLinks.after", text, options, globals);
        return text;
    });
    /**
 * These are all the transformations that form block-level
 * tags like paragraphs, headers, and list items.
 */ showdown.subParser("blockGamut", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("blockGamut.before", text, options, globals);
        // we parse blockquotes first so that we can have headings and hrs
        // inside blockquotes
        text = showdown.subParser("blockQuotes")(text, options, globals);
        text = showdown.subParser("headers")(text, options, globals);
        // Do Horizontal Rules:
        text = showdown.subParser("horizontalRule")(text, options, globals);
        text = showdown.subParser("lists")(text, options, globals);
        text = showdown.subParser("codeBlocks")(text, options, globals);
        text = showdown.subParser("tables")(text, options, globals);
        // We already ran _HashHTMLBlocks() before, in Markdown(), but that
        // was to escape raw HTML in the original Markdown source. This time,
        // we're escaping the markup we've just created, so that we don't wrap
        // <p> tags around block-level tags.
        text = showdown.subParser("hashHTMLBlocks")(text, options, globals);
        text = showdown.subParser("paragraphs")(text, options, globals);
        text = globals.converter._dispatch("blockGamut.after", text, options, globals);
        return text;
    });
    showdown.subParser("blockQuotes", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("blockQuotes.before", text, options, globals);
        // add a couple extra lines after the text and endtext mark
        text = text + "\n\n";
        var rgx = /(^ {0,3}>[ \t]?.+\n(.+\n)*\n*)+/gm;
        if (options.splitAdjacentBlockquotes) rgx = /^ {0,3}>[\s\S]*?(?:\n\n)/gm;
        text = text.replace(rgx, function(bq) {
            // attacklab: hack around Konqueror 3.5.4 bug:
            // "----------bug".replace(/^-/g,"") == "bug"
            bq = bq.replace(/^[ \t]*>[ \t]?/gm, ""); // trim one level of quoting
            // attacklab: clean up hack
            bq = bq.replace(/¨0/g, "");
            bq = bq.replace(/^[ \t]+$/gm, ""); // trim whitespace-only lines
            bq = showdown.subParser("githubCodeBlocks")(bq, options, globals);
            bq = showdown.subParser("blockGamut")(bq, options, globals); // recurse
            bq = bq.replace(/(^|\n)/g, "$1  ");
            // These leading spaces screw with <pre> content, so we need to fix that:
            bq = bq.replace(/(\s*<pre>[^\r]+?<\/pre>)/gm, function(wholeMatch, m1) {
                var pre = m1;
                // attacklab: hack around Konqueror 3.5.4 bug:
                pre = pre.replace(/^  /mg, "\xa80");
                pre = pre.replace(/¨0/g, "");
                return pre;
            });
            return showdown.subParser("hashBlock")("<blockquote>\n" + bq + "\n</blockquote>", options, globals);
        });
        text = globals.converter._dispatch("blockQuotes.after", text, options, globals);
        return text;
    });
    /**
 * Process Markdown `<pre><code>` blocks.
 */ showdown.subParser("codeBlocks", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("codeBlocks.before", text, options, globals);
        // sentinel workarounds for lack of \A and \Z, safari\khtml bug
        text += "\xa80";
        var pattern = /(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=¨0))/g;
        text = text.replace(pattern, function(wholeMatch, m1, m2) {
            var codeblock = m1, nextChar = m2, end = "\n";
            codeblock = showdown.subParser("outdent")(codeblock, options, globals);
            codeblock = showdown.subParser("encodeCode")(codeblock, options, globals);
            codeblock = showdown.subParser("detab")(codeblock, options, globals);
            codeblock = codeblock.replace(/^\n+/g, ""); // trim leading newlines
            codeblock = codeblock.replace(/\n+$/g, ""); // trim trailing newlines
            if (options.omitExtraWLInCodeBlocks) end = "";
            codeblock = "<pre><code>" + codeblock + end + "</code></pre>";
            return showdown.subParser("hashBlock")(codeblock, options, globals) + nextChar;
        });
        // strip sentinel
        text = text.replace(/¨0/, "");
        text = globals.converter._dispatch("codeBlocks.after", text, options, globals);
        return text;
    });
    /**
 *
 *   *  Backtick quotes are used for <code></code> spans.
 *
 *   *  You can use multiple backticks as the delimiters if you want to
 *     include literal backticks in the code span. So, this input:
 *
 *         Just type ``foo `bar` baz`` at the prompt.
 *
 *       Will translate to:
 *
 *         <p>Just type <code>foo `bar` baz</code> at the prompt.</p>
 *
 *    There's no arbitrary limit to the number of backticks you
 *    can use as delimters. If you need three consecutive backticks
 *    in your code, use four for delimiters, etc.
 *
 *  *  You can use spaces to get literal backticks at the edges:
 *
 *         ... type `` `bar` `` ...
 *
 *       Turns to:
 *
 *         ... type <code>`bar`</code> ...
 */ showdown.subParser("codeSpans", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("codeSpans.before", text, options, globals);
        if (typeof text === "undefined") text = "";
        text = text.replace(/(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm, function(wholeMatch, m1, m2, m3) {
            var c = m3;
            c = c.replace(/^([ \t]*)/g, ""); // leading whitespace
            c = c.replace(/[ \t]*$/g, ""); // trailing whitespace
            c = showdown.subParser("encodeCode")(c, options, globals);
            c = m1 + "<code>" + c + "</code>";
            c = showdown.subParser("hashHTMLSpans")(c, options, globals);
            return c;
        });
        text = globals.converter._dispatch("codeSpans.after", text, options, globals);
        return text;
    });
    /**
 * Create a full HTML document from the processed markdown
 */ showdown.subParser("completeHTMLDocument", function(text, options, globals) {
        "use strict";
        if (!options.completeHTMLDocument) return text;
        text = globals.converter._dispatch("completeHTMLDocument.before", text, options, globals);
        var doctype = "html", doctypeParsed = "<!DOCTYPE HTML>\n", title = "", charset = '<meta charset="utf-8">\n', lang = "", metadata = "";
        if (typeof globals.metadata.parsed.doctype !== "undefined") {
            doctypeParsed = "<!DOCTYPE " + globals.metadata.parsed.doctype + ">\n";
            doctype = globals.metadata.parsed.doctype.toString().toLowerCase();
            if (doctype === "html" || doctype === "html5") charset = '<meta charset="utf-8">';
        }
        for(var meta in globals.metadata.parsed)if (globals.metadata.parsed.hasOwnProperty(meta)) switch(meta.toLowerCase()){
            case "doctype":
                break;
            case "title":
                title = "<title>" + globals.metadata.parsed.title + "</title>\n";
                break;
            case "charset":
                if (doctype === "html" || doctype === "html5") charset = '<meta charset="' + globals.metadata.parsed.charset + '">\n';
                else charset = '<meta name="charset" content="' + globals.metadata.parsed.charset + '">\n';
                break;
            case "language":
            case "lang":
                lang = ' lang="' + globals.metadata.parsed[meta] + '"';
                metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
                break;
            default:
                metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
        }
        text = doctypeParsed + "<html" + lang + ">\n<head>\n" + title + charset + metadata + "</head>\n<body>\n" + text.trim() + "\n</body>\n</html>";
        text = globals.converter._dispatch("completeHTMLDocument.after", text, options, globals);
        return text;
    });
    /**
 * Convert all tabs to spaces
 */ showdown.subParser("detab", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("detab.before", text, options, globals);
        // expand first n-1 tabs
        text = text.replace(/\t(?=\t)/g, "    "); // g_tab_width
        // replace the nth with two sentinels
        text = text.replace(/\t/g, "\xa8A\xa8B");
        // use the sentinel to anchor our regex so it doesn't explode
        text = text.replace(/¨B(.+?)¨A/g, function(wholeMatch, m1) {
            var leadingText = m1, numSpaces = 4 - leadingText.length % 4; // g_tab_width
            // there *must* be a better way to do this:
            for(var i = 0; i < numSpaces; i++)leadingText += " ";
            return leadingText;
        });
        // clean up sentinels
        text = text.replace(/¨A/g, "    "); // g_tab_width
        text = text.replace(/¨B/g, "");
        text = globals.converter._dispatch("detab.after", text, options, globals);
        return text;
    });
    showdown.subParser("ellipsis", function(text, options, globals) {
        "use strict";
        if (!options.ellipsis) return text;
        text = globals.converter._dispatch("ellipsis.before", text, options, globals);
        text = text.replace(/\.\.\./g, "\u2026");
        text = globals.converter._dispatch("ellipsis.after", text, options, globals);
        return text;
    });
    /**
 * Turn emoji codes into emojis
 *
 * List of supported emojis: https://github.com/showdownjs/showdown/wiki/Emojis
 */ showdown.subParser("emoji", function(text, options, globals) {
        "use strict";
        if (!options.emoji) return text;
        text = globals.converter._dispatch("emoji.before", text, options, globals);
        var emojiRgx = /:([\S]+?):/g;
        text = text.replace(emojiRgx, function(wm, emojiCode) {
            if (showdown.helper.emojis.hasOwnProperty(emojiCode)) return showdown.helper.emojis[emojiCode];
            return wm;
        });
        text = globals.converter._dispatch("emoji.after", text, options, globals);
        return text;
    });
    /**
 * Smart processing for ampersands and angle brackets that need to be encoded.
 */ showdown.subParser("encodeAmpsAndAngles", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("encodeAmpsAndAngles.before", text, options, globals);
        // Ampersand-encoding based entirely on Nat Irons's Amputator MT plugin:
        // http://bumppo.net/projects/amputator/
        text = text.replace(/&(?!#?[xX]?(?:[0-9a-fA-F]+|\w+);)/g, "&amp;");
        // Encode naked <'s
        text = text.replace(/<(?![a-z\/?$!])/gi, "&lt;");
        // Encode <
        text = text.replace(/</g, "&lt;");
        // Encode >
        text = text.replace(/>/g, "&gt;");
        text = globals.converter._dispatch("encodeAmpsAndAngles.after", text, options, globals);
        return text;
    });
    /**
 * Returns the string, with after processing the following backslash escape sequences.
 *
 * attacklab: The polite way to do this is with the new escapeCharacters() function:
 *
 *    text = escapeCharacters(text,"\\",true);
 *    text = escapeCharacters(text,"`*_{}[]()>#+-.!",true);
 *
 * ...but we're sidestepping its use of the (slow) RegExp constructor
 * as an optimization for Firefox.  This function gets called a LOT.
 */ showdown.subParser("encodeBackslashEscapes", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("encodeBackslashEscapes.before", text, options, globals);
        text = text.replace(/\\(\\)/g, showdown.helper.escapeCharactersCallback);
        text = text.replace(/\\([`*_{}\[\]()>#+.!~=|:-])/g, showdown.helper.escapeCharactersCallback);
        text = globals.converter._dispatch("encodeBackslashEscapes.after", text, options, globals);
        return text;
    });
    /**
 * Encode/escape certain characters inside Markdown code runs.
 * The point is that in code, these characters are literals,
 * and lose their special Markdown meanings.
 */ showdown.subParser("encodeCode", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("encodeCode.before", text, options, globals);
        // Encode all ampersands; HTML entities are not
        // entities within a Markdown code span.
        text = text.replace(/&/g, "&amp;")// Do the angle bracket song and dance:
        .replace(/</g, "&lt;").replace(/>/g, "&gt;")// Now, escape characters that are magic in Markdown:
        .replace(/([*_{}\[\]\\=~-])/g, showdown.helper.escapeCharactersCallback);
        text = globals.converter._dispatch("encodeCode.after", text, options, globals);
        return text;
    });
    /**
 * Within tags -- meaning between < and > -- encode [\ ` * _ ~ =] so they
 * don't conflict with their use in Markdown for code, italics and strong.
 */ showdown.subParser("escapeSpecialCharsWithinTagAttributes", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("escapeSpecialCharsWithinTagAttributes.before", text, options, globals);
        // Build a regex to find HTML tags.
        var tags = /<\/?[a-z\d_:-]+(?:[\s]+[\s\S]+?)?>/gi, comments = /<!(--(?:(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>/gi;
        text = text.replace(tags, function(wholeMatch) {
            return wholeMatch.replace(/(.)<\/?code>(?=.)/g, "$1`").replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
        });
        text = text.replace(comments, function(wholeMatch) {
            return wholeMatch.replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
        });
        text = globals.converter._dispatch("escapeSpecialCharsWithinTagAttributes.after", text, options, globals);
        return text;
    });
    /**
 * Handle github codeblocks prior to running HashHTML so that
 * HTML contained within the codeblock gets escaped properly
 * Example:
 * ```ruby
 *     def hello_world(x)
 *       puts "Hello, #{x}"
 *     end
 * ```
 */ showdown.subParser("githubCodeBlocks", function(text, options, globals) {
        "use strict";
        // early exit if option is not enabled
        if (!options.ghCodeBlocks) return text;
        text = globals.converter._dispatch("githubCodeBlocks.before", text, options, globals);
        text += "\xa80";
        text = text.replace(/(?:^|\n)(?: {0,3})(```+|~~~+)(?: *)([^\s`~]*)\n([\s\S]*?)\n(?: {0,3})\1/g, function(wholeMatch, delim, language, codeblock) {
            var end = options.omitExtraWLInCodeBlocks ? "" : "\n";
            // First parse the github code block
            codeblock = showdown.subParser("encodeCode")(codeblock, options, globals);
            codeblock = showdown.subParser("detab")(codeblock, options, globals);
            codeblock = codeblock.replace(/^\n+/g, ""); // trim leading newlines
            codeblock = codeblock.replace(/\n+$/g, ""); // trim trailing whitespace
            codeblock = "<pre><code" + (language ? ' class="' + language + " language-" + language + '"' : "") + ">" + codeblock + end + "</code></pre>";
            codeblock = showdown.subParser("hashBlock")(codeblock, options, globals);
            // Since GHCodeblocks can be false positives, we need to
            // store the primitive text and the parsed text in a global var,
            // and then return a token
            return "\n\n\xa8G" + (globals.ghCodeBlocks.push({
                text: wholeMatch,
                codeblock: codeblock
            }) - 1) + "G\n\n";
        });
        // attacklab: strip sentinel
        text = text.replace(/¨0/, "");
        return globals.converter._dispatch("githubCodeBlocks.after", text, options, globals);
    });
    showdown.subParser("hashBlock", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("hashBlock.before", text, options, globals);
        text = text.replace(/(^\n+|\n+$)/g, "");
        text = "\n\n\xa8K" + (globals.gHtmlBlocks.push(text) - 1) + "K\n\n";
        text = globals.converter._dispatch("hashBlock.after", text, options, globals);
        return text;
    });
    /**
 * Hash and escape <code> elements that should not be parsed as markdown
 */ showdown.subParser("hashCodeTags", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("hashCodeTags.before", text, options, globals);
        var repFunc = function(wholeMatch, match, left, right) {
            var codeblock = left + showdown.subParser("encodeCode")(match, options, globals) + right;
            return "\xa8C" + (globals.gHtmlSpans.push(codeblock) - 1) + "C";
        };
        // Hash naked <code>
        text = showdown.helper.replaceRecursiveRegExp(text, repFunc, "<code\\b[^>]*>", "</code>", "gim");
        text = globals.converter._dispatch("hashCodeTags.after", text, options, globals);
        return text;
    });
    showdown.subParser("hashElement", function(text, options, globals) {
        "use strict";
        return function(wholeMatch, m1) {
            var blockText = m1;
            // Undo double lines
            blockText = blockText.replace(/\n\n/g, "\n");
            blockText = blockText.replace(/^\n/, "");
            // strip trailing blank lines
            blockText = blockText.replace(/\n+$/g, "");
            // Replace the element text with a marker ("¨KxK" where x is its key)
            blockText = "\n\n\xa8K" + (globals.gHtmlBlocks.push(blockText) - 1) + "K\n\n";
            return blockText;
        };
    });
    showdown.subParser("hashHTMLBlocks", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("hashHTMLBlocks.before", text, options, globals);
        var blockTags = [
            "pre",
            "div",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "table",
            "dl",
            "ol",
            "ul",
            "script",
            "noscript",
            "form",
            "fieldset",
            "iframe",
            "math",
            "style",
            "section",
            "header",
            "footer",
            "nav",
            "article",
            "aside",
            "address",
            "audio",
            "canvas",
            "figure",
            "hgroup",
            "output",
            "video",
            "p"
        ], repFunc = function(wholeMatch, match, left, right) {
            var txt = wholeMatch;
            // check if this html element is marked as markdown
            // if so, it's contents should be parsed as markdown
            if (left.search(/\bmarkdown\b/) !== -1) txt = left + globals.converter.makeHtml(match) + right;
            return "\n\n\xa8K" + (globals.gHtmlBlocks.push(txt) - 1) + "K\n\n";
        };
        if (options.backslashEscapesHTMLTags) // encode backslash escaped HTML tags
        text = text.replace(/\\<(\/?[^>]+?)>/g, function(wm, inside) {
            return "&lt;" + inside + "&gt;";
        });
        // hash HTML Blocks
        for(var i = 0; i < blockTags.length; ++i){
            var opTagPos, rgx1 = new RegExp("^ {0,3}(<" + blockTags[i] + "\\b[^>]*>)", "im"), patLeft = "<" + blockTags[i] + "\\b[^>]*>", patRight = "</" + blockTags[i] + ">";
            // 1. Look for the first position of the first opening HTML tag in the text
            while((opTagPos = showdown.helper.regexIndexOf(text, rgx1)) !== -1){
                // if the HTML tag is \ escaped, we need to escape it and break
                //2. Split the text in that position
                var subTexts = showdown.helper.splitAtIndex(text, opTagPos), //3. Match recursively
                newSubText1 = showdown.helper.replaceRecursiveRegExp(subTexts[1], repFunc, patLeft, patRight, "im");
                // prevent an infinite loop
                if (newSubText1 === subTexts[1]) break;
                text = subTexts[0].concat(newSubText1);
            }
        }
        // HR SPECIAL CASE
        text = text.replace(/(\n {0,3}(<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g, showdown.subParser("hashElement")(text, options, globals));
        // Special case for standalone HTML comments
        text = showdown.helper.replaceRecursiveRegExp(text, function(txt) {
            return "\n\n\xa8K" + (globals.gHtmlBlocks.push(txt) - 1) + "K\n\n";
        }, "^ {0,3}<!--", "-->", "gm");
        // PHP and ASP-style processor instructions (<?...?> and <%...%>)
        text = text.replace(/(?:\n\n)( {0,3}(?:<([?%])[^\r]*?\2>)[ \t]*(?=\n{2,}))/g, showdown.subParser("hashElement")(text, options, globals));
        text = globals.converter._dispatch("hashHTMLBlocks.after", text, options, globals);
        return text;
    });
    /**
 * Hash span elements that should not be parsed as markdown
 */ showdown.subParser("hashHTMLSpans", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("hashHTMLSpans.before", text, options, globals);
        function hashHTMLSpan(html) {
            return "\xa8C" + (globals.gHtmlSpans.push(html) - 1) + "C";
        }
        // Hash Self Closing tags
        text = text.replace(/<[^>]+?\/>/gi, function(wm) {
            return hashHTMLSpan(wm);
        });
        // Hash tags without properties
        text = text.replace(/<([^>]+?)>[\s\S]*?<\/\1>/g, function(wm) {
            return hashHTMLSpan(wm);
        });
        // Hash tags with properties
        text = text.replace(/<([^>]+?)\s[^>]+?>[\s\S]*?<\/\1>/g, function(wm) {
            return hashHTMLSpan(wm);
        });
        // Hash self closing tags without />
        text = text.replace(/<[^>]+?>/gi, function(wm) {
            return hashHTMLSpan(wm);
        });
        /*showdown.helper.matchRecursiveRegExp(text, '<code\\b[^>]*>', '</code>', 'gi');*/ text = globals.converter._dispatch("hashHTMLSpans.after", text, options, globals);
        return text;
    });
    /**
 * Unhash HTML spans
 */ showdown.subParser("unhashHTMLSpans", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("unhashHTMLSpans.before", text, options, globals);
        for(var i = 0; i < globals.gHtmlSpans.length; ++i){
            var repText = globals.gHtmlSpans[i], // limiter to prevent infinite loop (assume 10 as limit for recurse)
            limit = 0;
            while(/¨C(\d+)C/.test(repText)){
                var num = RegExp.$1;
                repText = repText.replace("\xa8C" + num + "C", globals.gHtmlSpans[num]);
                if (limit === 10) {
                    console.error("maximum nesting of 10 spans reached!!!");
                    break;
                }
                ++limit;
            }
            text = text.replace("\xa8C" + i + "C", repText);
        }
        text = globals.converter._dispatch("unhashHTMLSpans.after", text, options, globals);
        return text;
    });
    /**
 * Hash and escape <pre><code> elements that should not be parsed as markdown
 */ showdown.subParser("hashPreCodeTags", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("hashPreCodeTags.before", text, options, globals);
        var repFunc = function(wholeMatch, match, left, right) {
            // encode html entities
            var codeblock = left + showdown.subParser("encodeCode")(match, options, globals) + right;
            return "\n\n\xa8G" + (globals.ghCodeBlocks.push({
                text: wholeMatch,
                codeblock: codeblock
            }) - 1) + "G\n\n";
        };
        // Hash <pre><code>
        text = showdown.helper.replaceRecursiveRegExp(text, repFunc, "^ {0,3}<pre\\b[^>]*>\\s*<code\\b[^>]*>", "^ {0,3}</code>\\s*</pre>", "gim");
        text = globals.converter._dispatch("hashPreCodeTags.after", text, options, globals);
        return text;
    });
    showdown.subParser("headers", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("headers.before", text, options, globals);
        var headerLevelStart = isNaN(parseInt(options.headerLevelStart)) ? 1 : parseInt(options.headerLevelStart), // Set text-style headers:
        //	Header 1
        //	========
        //
        //	Header 2
        //	--------
        //
        setextRegexH1 = options.smoothLivePreview ? /^(.+)[ \t]*\n={2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n=+[ \t]*\n+/gm, setextRegexH2 = options.smoothLivePreview ? /^(.+)[ \t]*\n-{2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n-+[ \t]*\n+/gm;
        text = text.replace(setextRegexH1, function(wholeMatch, m1) {
            var spanGamut = showdown.subParser("spanGamut")(m1, options, globals), hID = options.noHeaderId ? "" : ' id="' + headerId(m1) + '"', hLevel = headerLevelStart, hashBlock = "<h" + hLevel + hID + ">" + spanGamut + "</h" + hLevel + ">";
            return showdown.subParser("hashBlock")(hashBlock, options, globals);
        });
        text = text.replace(setextRegexH2, function(matchFound, m1) {
            var spanGamut = showdown.subParser("spanGamut")(m1, options, globals), hID = options.noHeaderId ? "" : ' id="' + headerId(m1) + '"', hLevel = headerLevelStart + 1, hashBlock = "<h" + hLevel + hID + ">" + spanGamut + "</h" + hLevel + ">";
            return showdown.subParser("hashBlock")(hashBlock, options, globals);
        });
        // atx-style headers:
        //  # Header 1
        //  ## Header 2
        //  ## Header 2 with closing hashes ##
        //  ...
        //  ###### Header 6
        //
        var atxStyle = options.requireSpaceBeforeHeadingText ? /^(#{1,6})[ \t]+(.+?)[ \t]*#*\n+/gm : /^(#{1,6})[ \t]*(.+?)[ \t]*#*\n+/gm;
        text = text.replace(atxStyle, function(wholeMatch, m1, m2) {
            var hText = m2;
            if (options.customizedHeaderId) hText = m2.replace(/\s?\{([^{]+?)}\s*$/, "");
            var span = showdown.subParser("spanGamut")(hText, options, globals), hID = options.noHeaderId ? "" : ' id="' + headerId(m2) + '"', hLevel = headerLevelStart - 1 + m1.length, header = "<h" + hLevel + hID + ">" + span + "</h" + hLevel + ">";
            return showdown.subParser("hashBlock")(header, options, globals);
        });
        function headerId(m) {
            var title, prefix;
            // It is separate from other options to allow combining prefix and customized
            if (options.customizedHeaderId) {
                var match = m.match(/\{([^{]+?)}\s*$/);
                if (match && match[1]) m = match[1];
            }
            title = m;
            // Prefix id to prevent causing inadvertent pre-existing style matches.
            if (showdown.helper.isString(options.prefixHeaderId)) prefix = options.prefixHeaderId;
            else if (options.prefixHeaderId === true) prefix = "section-";
            else prefix = "";
            if (!options.rawPrefixHeaderId) title = prefix + title;
            if (options.ghCompatibleHeaderId) title = title.replace(/ /g, "-")// replace previously escaped chars (&, ¨ and $)
            .replace(/&amp;/g, "").replace(/¨T/g, "").replace(/¨D/g, "")// replace rest of the chars (&~$ are repeated as they might have been escaped)
            // borrowed from github's redcarpet (some they should produce similar results)
            .replace(/[&+$,\/:;=?@"#{}|^¨~\[\]`\\*)(%.!'<>]/g, "").toLowerCase();
            else if (options.rawHeaderId) title = title.replace(/ /g, "-")// replace previously escaped chars (&, ¨ and $)
            .replace(/&amp;/g, "&").replace(/¨T/g, "\xa8").replace(/¨D/g, "$")// replace " and '
            .replace(/["']/g, "-").toLowerCase();
            else title = title.replace(/[^\w]/g, "").toLowerCase();
            if (options.rawPrefixHeaderId) title = prefix + title;
            if (globals.hashLinkCounts[title]) title = title + "-" + globals.hashLinkCounts[title]++;
            else globals.hashLinkCounts[title] = 1;
            return title;
        }
        text = globals.converter._dispatch("headers.after", text, options, globals);
        return text;
    });
    /**
 * Turn Markdown link shortcuts into XHTML <a> tags.
 */ showdown.subParser("horizontalRule", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("horizontalRule.before", text, options, globals);
        var key = showdown.subParser("hashBlock")("<hr />", options, globals);
        text = text.replace(/^ {0,2}( ?-){3,}[ \t]*$/gm, key);
        text = text.replace(/^ {0,2}( ?\*){3,}[ \t]*$/gm, key);
        text = text.replace(/^ {0,2}( ?_){3,}[ \t]*$/gm, key);
        text = globals.converter._dispatch("horizontalRule.after", text, options, globals);
        return text;
    });
    /**
 * Turn Markdown image shortcuts into <img> tags.
 */ showdown.subParser("images", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("images.before", text, options, globals);
        var inlineRegExp = /!\[([^\]]*?)][ \t]*()\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g, crazyRegExp = /!\[([^\]]*?)][ \t]*()\([ \t]?<([^>]*)>(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(?:(["'])([^"]*?)\6))?[ \t]?\)/g, base64RegExp = /!\[([^\]]*?)][ \t]*()\([ \t]?<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g, referenceRegExp = /!\[([^\]]*?)] ?(?:\n *)?\[([\s\S]*?)]()()()()()/g, refShortcutRegExp = /!\[([^\[\]]+)]()()()()()/g;
        function writeImageTagBase64(wholeMatch, altText, linkId, url, width, height, m5, title) {
            url = url.replace(/\s/g, "");
            return writeImageTag(wholeMatch, altText, linkId, url, width, height, m5, title);
        }
        function writeImageTag(wholeMatch, altText, linkId, url, width, height, m5, title) {
            var gUrls = globals.gUrls, gTitles = globals.gTitles, gDims = globals.gDimensions;
            linkId = linkId.toLowerCase();
            if (!title) title = "";
            // Special case for explicit empty url
            if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) url = "";
            else if (url === "" || url === null) {
                if (linkId === "" || linkId === null) // lower-case and turn embedded newlines into spaces
                linkId = altText.toLowerCase().replace(/ ?\n/g, " ");
                url = "#" + linkId;
                if (!showdown.helper.isUndefined(gUrls[linkId])) {
                    url = gUrls[linkId];
                    if (!showdown.helper.isUndefined(gTitles[linkId])) title = gTitles[linkId];
                    if (!showdown.helper.isUndefined(gDims[linkId])) {
                        width = gDims[linkId].width;
                        height = gDims[linkId].height;
                    }
                } else return wholeMatch;
            }
            altText = altText.replace(/"/g, "&quot;")//altText = showdown.helper.escapeCharacters(altText, '*_', false);
            .replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
            //url = showdown.helper.escapeCharacters(url, '*_', false);
            url = url.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
            var result = '<img src="' + url + '" alt="' + altText + '"';
            if (title && showdown.helper.isString(title)) {
                title = title.replace(/"/g, "&quot;")//title = showdown.helper.escapeCharacters(title, '*_', false);
                .replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
                result += ' title="' + title + '"';
            }
            if (width && height) {
                width = width === "*" ? "auto" : width;
                height = height === "*" ? "auto" : height;
                result += ' width="' + width + '"';
                result += ' height="' + height + '"';
            }
            result += " />";
            return result;
        }
        // First, handle reference-style labeled images: ![alt text][id]
        text = text.replace(referenceRegExp, writeImageTag);
        // Next, handle inline images:  ![alt text](url =<width>x<height> "optional title")
        // base64 encoded images
        text = text.replace(base64RegExp, writeImageTagBase64);
        // cases with crazy urls like ./image/cat1).png
        text = text.replace(crazyRegExp, writeImageTag);
        // normal cases
        text = text.replace(inlineRegExp, writeImageTag);
        // handle reference-style shortcuts: ![img text]
        text = text.replace(refShortcutRegExp, writeImageTag);
        text = globals.converter._dispatch("images.after", text, options, globals);
        return text;
    });
    showdown.subParser("italicsAndBold", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("italicsAndBold.before", text, options, globals);
        // it's faster to have 3 separate regexes for each case than have just one
        // because of backtracing, in some cases, it could lead to an exponential effect
        // called "catastrophic backtrace". Ominous!
        function parseInside(txt, left, right) {
            /*
    if (options.simplifiedAutoLink) {
      txt = showdown.subParser('simplifiedAutoLinks')(txt, options, globals);
    }
    */ return left + txt + right;
        }
        // Parse underscores
        if (options.literalMidWordUnderscores) {
            text = text.replace(/\b___(\S[\s\S]*?)___\b/g, function(wm, txt) {
                return parseInside(txt, "<strong><em>", "</em></strong>");
            });
            text = text.replace(/\b__(\S[\s\S]*?)__\b/g, function(wm, txt) {
                return parseInside(txt, "<strong>", "</strong>");
            });
            text = text.replace(/\b_(\S[\s\S]*?)_\b/g, function(wm, txt) {
                return parseInside(txt, "<em>", "</em>");
            });
        } else {
            text = text.replace(/___(\S[\s\S]*?)___/g, function(wm, m) {
                return /\S$/.test(m) ? parseInside(m, "<strong><em>", "</em></strong>") : wm;
            });
            text = text.replace(/__(\S[\s\S]*?)__/g, function(wm, m) {
                return /\S$/.test(m) ? parseInside(m, "<strong>", "</strong>") : wm;
            });
            text = text.replace(/_([^\s_][\s\S]*?)_/g, function(wm, m) {
                // !/^_[^_]/.test(m) - test if it doesn't start with __ (since it seems redundant, we removed it)
                return /\S$/.test(m) ? parseInside(m, "<em>", "</em>") : wm;
            });
        }
        // Now parse asterisks
        if (options.literalMidWordAsterisks) {
            text = text.replace(/([^*]|^)\B\*\*\*(\S[\s\S]*?)\*\*\*\B(?!\*)/g, function(wm, lead, txt) {
                return parseInside(txt, lead + "<strong><em>", "</em></strong>");
            });
            text = text.replace(/([^*]|^)\B\*\*(\S[\s\S]*?)\*\*\B(?!\*)/g, function(wm, lead, txt) {
                return parseInside(txt, lead + "<strong>", "</strong>");
            });
            text = text.replace(/([^*]|^)\B\*(\S[\s\S]*?)\*\B(?!\*)/g, function(wm, lead, txt) {
                return parseInside(txt, lead + "<em>", "</em>");
            });
        } else {
            text = text.replace(/\*\*\*(\S[\s\S]*?)\*\*\*/g, function(wm, m) {
                return /\S$/.test(m) ? parseInside(m, "<strong><em>", "</em></strong>") : wm;
            });
            text = text.replace(/\*\*(\S[\s\S]*?)\*\*/g, function(wm, m) {
                return /\S$/.test(m) ? parseInside(m, "<strong>", "</strong>") : wm;
            });
            text = text.replace(/\*([^\s*][\s\S]*?)\*/g, function(wm, m) {
                // !/^\*[^*]/.test(m) - test if it doesn't start with ** (since it seems redundant, we removed it)
                return /\S$/.test(m) ? parseInside(m, "<em>", "</em>") : wm;
            });
        }
        text = globals.converter._dispatch("italicsAndBold.after", text, options, globals);
        return text;
    });
    /**
 * Form HTML ordered (numbered) and unordered (bulleted) lists.
 */ showdown.subParser("lists", function(text, options, globals) {
        "use strict";
        /**
   * Process the contents of a single ordered or unordered list, splitting it
   * into individual list items.
   * @param {string} listStr
   * @param {boolean} trimTrailing
   * @returns {string}
   */ function processListItems(listStr, trimTrailing) {
            // The $g_list_level global keeps track of when we're inside a list.
            // Each time we enter a list, we increment it; when we leave a list,
            // we decrement. If it's zero, we're not in a list anymore.
            //
            // We do this because when we're not inside a list, we want to treat
            // something like this:
            //
            //    I recommend upgrading to version
            //    8. Oops, now this line is treated
            //    as a sub-list.
            //
            // As a single paragraph, despite the fact that the second line starts
            // with a digit-period-space sequence.
            //
            // Whereas when we're inside a list (or sub-list), that line will be
            // treated as the start of a sub-list. What a kludge, huh? This is
            // an aspect of Markdown's syntax that's hard to parse perfectly
            // without resorting to mind-reading. Perhaps the solution is to
            // change the syntax rules such that sub-lists must start with a
            // starting cardinal number; e.g. "1." or "a.".
            globals.gListLevel++;
            // trim trailing blank lines:
            listStr = listStr.replace(/\n{2,}$/, "\n");
            // attacklab: add sentinel to emulate \z
            listStr += "\xa80";
            var rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0| {0,3}([*+-]|\d+[.])[ \t]+))/gm, isParagraphed = /\n[ \t]*\n(?!¨0)/.test(listStr);
            // Since version 1.5, nesting sublists requires 4 spaces (or 1 tab) indentation,
            // which is a syntax breaking change
            // activating this option reverts to old behavior
            if (options.disableForced4SpacesIndentedSublists) rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0|\2([*+-]|\d+[.])[ \t]+))/gm;
            listStr = listStr.replace(rgx, function(wholeMatch, m1, m2, m3, m4, taskbtn, checked) {
                checked = checked && checked.trim() !== "";
                var item = showdown.subParser("outdent")(m4, options, globals), bulletStyle = "";
                // Support for github tasklists
                if (taskbtn && options.tasklists) {
                    bulletStyle = ' class="task-list-item" style="list-style-type: none;"';
                    item = item.replace(/^[ \t]*\[(x|X| )?]/m, function() {
                        var otp = '<input type="checkbox" disabled style="margin: 0px 0.35em 0.25em -1.6em; vertical-align: middle;"';
                        if (checked) otp += " checked";
                        otp += ">";
                        return otp;
                    });
                }
                // ISSUE #312
                // This input: - - - a
                // causes trouble to the parser, since it interprets it as:
                // <ul><li><li><li>a</li></li></li></ul>
                // instead of:
                // <ul><li>- - a</li></ul>
                // So, to prevent it, we will put a marker (¨A)in the beginning of the line
                // Kind of hackish/monkey patching, but seems more effective than overcomplicating the list parser
                item = item.replace(/^([-*+]|\d\.)[ \t]+[\S\n ]*/g, function(wm2) {
                    return "\xa8A" + wm2;
                });
                // m1 - Leading line or
                // Has a double return (multi paragraph) or
                // Has sublist
                if (m1 || item.search(/\n{2,}/) > -1) {
                    item = showdown.subParser("githubCodeBlocks")(item, options, globals);
                    item = showdown.subParser("blockGamut")(item, options, globals);
                } else {
                    // Recursion for sub-lists:
                    item = showdown.subParser("lists")(item, options, globals);
                    item = item.replace(/\n$/, ""); // chomp(item)
                    item = showdown.subParser("hashHTMLBlocks")(item, options, globals);
                    // Colapse double linebreaks
                    item = item.replace(/\n\n+/g, "\n\n");
                    if (isParagraphed) item = showdown.subParser("paragraphs")(item, options, globals);
                    else item = showdown.subParser("spanGamut")(item, options, globals);
                }
                // now we need to remove the marker (¨A)
                item = item.replace("\xa8A", "");
                // we can finally wrap the line in list item tags
                item = "<li" + bulletStyle + ">" + item + "</li>\n";
                return item;
            });
            // attacklab: strip sentinel
            listStr = listStr.replace(/¨0/g, "");
            globals.gListLevel--;
            if (trimTrailing) listStr = listStr.replace(/\s+$/, "");
            return listStr;
        }
        function styleStartNumber(list, listType) {
            // check if ol and starts by a number different than 1
            if (listType === "ol") {
                var res = list.match(/^ *(\d+)\./);
                if (res && res[1] !== "1") return ' start="' + res[1] + '"';
            }
            return "";
        }
        /**
   * Check and parse consecutive lists (better fix for issue #142)
   * @param {string} list
   * @param {string} listType
   * @param {boolean} trimTrailing
   * @returns {string}
   */ function parseConsecutiveLists(list, listType, trimTrailing) {
            // check if we caught 2 or more consecutive lists by mistake
            // we use the counterRgx, meaning if listType is UL we look for OL and vice versa
            var olRgx = options.disableForced4SpacesIndentedSublists ? /^ ?\d+\.[ \t]/gm : /^ {0,3}\d+\.[ \t]/gm, ulRgx = options.disableForced4SpacesIndentedSublists ? /^ ?[*+-][ \t]/gm : /^ {0,3}[*+-][ \t]/gm, counterRxg = listType === "ul" ? olRgx : ulRgx, result = "";
            if (list.search(counterRxg) !== -1) (function parseCL(txt) {
                var pos = txt.search(counterRxg), style = styleStartNumber(list, listType);
                if (pos !== -1) {
                    // slice
                    result += "\n\n<" + listType + style + ">\n" + processListItems(txt.slice(0, pos), !!trimTrailing) + "</" + listType + ">\n";
                    // invert counterType and listType
                    listType = listType === "ul" ? "ol" : "ul";
                    counterRxg = listType === "ul" ? olRgx : ulRgx;
                    //recurse
                    parseCL(txt.slice(pos));
                } else result += "\n\n<" + listType + style + ">\n" + processListItems(txt, !!trimTrailing) + "</" + listType + ">\n";
            })(list);
            else {
                var style = styleStartNumber(list, listType);
                result = "\n\n<" + listType + style + ">\n" + processListItems(list, !!trimTrailing) + "</" + listType + ">\n";
            }
            return result;
        }
        /** Start of list parsing **/ text = globals.converter._dispatch("lists.before", text, options, globals);
        // add sentinel to hack around khtml/safari bug:
        // http://bugs.webkit.org/show_bug.cgi?id=11231
        text += "\xa80";
        if (globals.gListLevel) text = text.replace(/^(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm, function(wholeMatch, list, m2) {
            var listType = m2.search(/[*+-]/g) > -1 ? "ul" : "ol";
            return parseConsecutiveLists(list, listType, true);
        });
        else text = text.replace(/(\n\n|^\n?)(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm, function(wholeMatch, m1, list, m3) {
            var listType = m3.search(/[*+-]/g) > -1 ? "ul" : "ol";
            return parseConsecutiveLists(list, listType, false);
        });
        // strip sentinel
        text = text.replace(/¨0/, "");
        text = globals.converter._dispatch("lists.after", text, options, globals);
        return text;
    });
    /**
 * Parse metadata at the top of the document
 */ showdown.subParser("metadata", function(text, options, globals) {
        "use strict";
        if (!options.metadata) return text;
        text = globals.converter._dispatch("metadata.before", text, options, globals);
        function parseMetadataContents(content) {
            // raw is raw so it's not changed in any way
            globals.metadata.raw = content;
            // escape chars forbidden in html attributes
            // double quotes
            content = content// ampersand first
            .replace(/&/g, "&amp;")// double quotes
            .replace(/"/g, "&quot;");
            content = content.replace(/\n {4}/g, " ");
            content.replace(/^([\S ]+): +([\s\S]+?)$/gm, function(wm, key, value) {
                globals.metadata.parsed[key] = value;
                return "";
            });
        }
        text = text.replace(/^\s*«««+(\S*?)\n([\s\S]+?)\n»»»+\n/, function(wholematch, format, content) {
            parseMetadataContents(content);
            return "\xa8M";
        });
        text = text.replace(/^\s*---+(\S*?)\n([\s\S]+?)\n---+\n/, function(wholematch, format, content) {
            if (format) globals.metadata.format = format;
            parseMetadataContents(content);
            return "\xa8M";
        });
        text = text.replace(/¨M/g, "");
        text = globals.converter._dispatch("metadata.after", text, options, globals);
        return text;
    });
    /**
 * Remove one level of line-leading tabs or spaces
 */ showdown.subParser("outdent", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("outdent.before", text, options, globals);
        // attacklab: hack around Konqueror 3.5.4 bug:
        // "----------bug".replace(/^-/g,"") == "bug"
        text = text.replace(/^(\t|[ ]{1,4})/gm, "\xa80"); // attacklab: g_tab_width
        // attacklab: clean up hack
        text = text.replace(/¨0/g, "");
        text = globals.converter._dispatch("outdent.after", text, options, globals);
        return text;
    });
    /**
 *
 */ showdown.subParser("paragraphs", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("paragraphs.before", text, options, globals);
        // Strip leading and trailing lines:
        text = text.replace(/^\n+/g, "");
        text = text.replace(/\n+$/g, "");
        var grafs = text.split(/\n{2,}/g), grafsOut = [], end = grafs.length; // Wrap <p> tags
        for(var i = 0; i < end; i++){
            var str = grafs[i];
            // if this is an HTML marker, copy it
            if (str.search(/¨(K|G)(\d+)\1/g) >= 0) grafsOut.push(str);
            else if (str.search(/\S/) >= 0) {
                str = showdown.subParser("spanGamut")(str, options, globals);
                str = str.replace(/^([ \t]*)/g, "<p>");
                str += "</p>";
                grafsOut.push(str);
            }
        }
        /** Unhashify HTML blocks */ end = grafsOut.length;
        for(i = 0; i < end; i++){
            var blockText = "", grafsOutIt = grafsOut[i], codeFlag = false;
            // if this is a marker for an html block...
            // use RegExp.test instead of string.search because of QML bug
            while(/¨(K|G)(\d+)\1/.test(grafsOutIt)){
                var delim = RegExp.$1, num = RegExp.$2;
                if (delim === "K") blockText = globals.gHtmlBlocks[num];
                else // we need to check if ghBlock is a false positive
                if (codeFlag) // use encoded version of all text
                blockText = showdown.subParser("encodeCode")(globals.ghCodeBlocks[num].text, options, globals);
                else blockText = globals.ghCodeBlocks[num].codeblock;
                blockText = blockText.replace(/\$/g, "$$$$"); // Escape any dollar signs
                grafsOutIt = grafsOutIt.replace(/(\n\n)?¨(K|G)\d+\2(\n\n)?/, blockText);
                // Check if grafsOutIt is a pre->code
                if (/^<pre\b[^>]*>\s*<code\b[^>]*>/.test(grafsOutIt)) codeFlag = true;
            }
            grafsOut[i] = grafsOutIt;
        }
        text = grafsOut.join("\n");
        // Strip leading and trailing lines:
        text = text.replace(/^\n+/g, "");
        text = text.replace(/\n+$/g, "");
        return globals.converter._dispatch("paragraphs.after", text, options, globals);
    });
    /**
 * Run extension
 */ showdown.subParser("runExtension", function(ext, text, options, globals) {
        "use strict";
        if (ext.filter) text = ext.filter(text, globals.converter, options);
        else if (ext.regex) {
            // TODO remove this when old extension loading mechanism is deprecated
            var re = ext.regex;
            if (!(re instanceof RegExp)) re = new RegExp(re, "g");
            text = text.replace(re, ext.replace);
        }
        return text;
    });
    /**
 * These are all the transformations that occur *within* block-level
 * tags like paragraphs, headers, and list items.
 */ showdown.subParser("spanGamut", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("spanGamut.before", text, options, globals);
        text = showdown.subParser("codeSpans")(text, options, globals);
        text = showdown.subParser("escapeSpecialCharsWithinTagAttributes")(text, options, globals);
        text = showdown.subParser("encodeBackslashEscapes")(text, options, globals);
        // Process anchor and image tags. Images must come first,
        // because ![foo][f] looks like an anchor.
        text = showdown.subParser("images")(text, options, globals);
        text = showdown.subParser("anchors")(text, options, globals);
        // Make links out of things like `<http://example.com/>`
        // Must come after anchors, because you can use < and >
        // delimiters in inline links like [this](<url>).
        text = showdown.subParser("autoLinks")(text, options, globals);
        text = showdown.subParser("simplifiedAutoLinks")(text, options, globals);
        text = showdown.subParser("emoji")(text, options, globals);
        text = showdown.subParser("underline")(text, options, globals);
        text = showdown.subParser("italicsAndBold")(text, options, globals);
        text = showdown.subParser("strikethrough")(text, options, globals);
        text = showdown.subParser("ellipsis")(text, options, globals);
        // we need to hash HTML tags inside spans
        text = showdown.subParser("hashHTMLSpans")(text, options, globals);
        // now we encode amps and angles
        text = showdown.subParser("encodeAmpsAndAngles")(text, options, globals);
        // Do hard breaks
        if (options.simpleLineBreaks) // GFM style hard breaks
        // only add line breaks if the text does not contain a block (special case for lists)
        {
            if (!/\n\n¨K/.test(text)) text = text.replace(/\n+/g, "<br />\n");
        } else // Vanilla hard breaks
        text = text.replace(/  +\n/g, "<br />\n");
        text = globals.converter._dispatch("spanGamut.after", text, options, globals);
        return text;
    });
    showdown.subParser("strikethrough", function(text, options, globals) {
        "use strict";
        function parseInside(txt) {
            if (options.simplifiedAutoLink) txt = showdown.subParser("simplifiedAutoLinks")(txt, options, globals);
            return "<del>" + txt + "</del>";
        }
        if (options.strikethrough) {
            text = globals.converter._dispatch("strikethrough.before", text, options, globals);
            text = text.replace(/(?:~){2}([\s\S]+?)(?:~){2}/g, function(wm, txt) {
                return parseInside(txt);
            });
            text = globals.converter._dispatch("strikethrough.after", text, options, globals);
        }
        return text;
    });
    /**
 * Strips link definitions from text, stores the URLs and titles in
 * hash references.
 * Link defs are in the form: ^[id]: url "optional title"
 */ showdown.subParser("stripLinkDefinitions", function(text, options, globals) {
        "use strict";
        var regex = /^ {0,3}\[([^\]]+)]:[ \t]*\n?[ \t]*<?([^>\s]+)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n+|(?=¨0))/gm, base64Regex = /^ {0,3}\[([^\]]+)]:[ \t]*\n?[ \t]*<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n\n|(?=¨0)|(?=\n\[))/gm;
        // attacklab: sentinel workarounds for lack of \A and \Z, safari\khtml bug
        text += "\xa80";
        var replaceFunc = function(wholeMatch, linkId, url, width, height, blankLines, title) {
            // if there aren't two instances of linkId it must not be a reference link so back out
            linkId = linkId.toLowerCase();
            if (text.toLowerCase().split(linkId).length - 1 < 2) return wholeMatch;
            if (url.match(/^data:.+?\/.+?;base64,/)) // remove newlines
            globals.gUrls[linkId] = url.replace(/\s/g, "");
            else globals.gUrls[linkId] = showdown.subParser("encodeAmpsAndAngles")(url, options, globals); // Link IDs are case-insensitive
            if (blankLines) // Oops, found blank lines, so it's not a title.
            // Put back the parenthetical statement we stole.
            return blankLines + title;
            else {
                if (title) globals.gTitles[linkId] = title.replace(/"|'/g, "&quot;");
                if (options.parseImgDimensions && width && height) globals.gDimensions[linkId] = {
                    width: width,
                    height: height
                };
            }
            // Completely remove the definition from the text
            return "";
        };
        // first we try to find base64 link references
        text = text.replace(base64Regex, replaceFunc);
        text = text.replace(regex, replaceFunc);
        // attacklab: strip sentinel
        text = text.replace(/¨0/, "");
        return text;
    });
    showdown.subParser("tables", function(text, options, globals) {
        "use strict";
        if (!options.tables) return text;
        var tableRgx = /^ {0,3}\|?.+\|.+\n {0,3}\|?[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*:?[ \t]*(?:[-=]){2,}[\s\S]+?(?:\n\n|¨0)/gm, //singeColTblRgx = /^ {0,3}\|.+\|\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n(?: {0,3}\|.+\|\n)+(?:\n\n|¨0)/gm;
        singeColTblRgx = /^ {0,3}\|.+\|[ \t]*\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n( {0,3}\|.+\|[ \t]*\n)*(?:\n|¨0)/gm;
        function parseStyles(sLine) {
            if (/^:[ \t]*--*$/.test(sLine)) return ' style="text-align:left;"';
            else if (/^--*[ \t]*:[ \t]*$/.test(sLine)) return ' style="text-align:right;"';
            else if (/^:[ \t]*--*[ \t]*:$/.test(sLine)) return ' style="text-align:center;"';
            else return "";
        }
        function parseHeaders(header, style) {
            var id = "";
            header = header.trim();
            // support both tablesHeaderId and tableHeaderId due to error in documentation so we don't break backwards compatibility
            if (options.tablesHeaderId || options.tableHeaderId) id = ' id="' + header.replace(/ /g, "_").toLowerCase() + '"';
            header = showdown.subParser("spanGamut")(header, options, globals);
            return "<th" + id + style + ">" + header + "</th>\n";
        }
        function parseCells(cell, style) {
            var subText = showdown.subParser("spanGamut")(cell, options, globals);
            return "<td" + style + ">" + subText + "</td>\n";
        }
        function buildTable(headers, cells) {
            var tb = "<table>\n<thead>\n<tr>\n", tblLgn = headers.length;
            for(var i = 0; i < tblLgn; ++i)tb += headers[i];
            tb += "</tr>\n</thead>\n<tbody>\n";
            for(i = 0; i < cells.length; ++i){
                tb += "<tr>\n";
                for(var ii = 0; ii < tblLgn; ++ii)tb += cells[i][ii];
                tb += "</tr>\n";
            }
            tb += "</tbody>\n</table>\n";
            return tb;
        }
        function parseTable(rawTable) {
            var i, tableLines = rawTable.split("\n");
            for(i = 0; i < tableLines.length; ++i){
                // strip wrong first and last column if wrapped tables are used
                if (/^ {0,3}\|/.test(tableLines[i])) tableLines[i] = tableLines[i].replace(/^ {0,3}\|/, "");
                if (/\|[ \t]*$/.test(tableLines[i])) tableLines[i] = tableLines[i].replace(/\|[ \t]*$/, "");
                // parse code spans first, but we only support one line code spans
                tableLines[i] = showdown.subParser("codeSpans")(tableLines[i], options, globals);
            }
            var rawHeaders = tableLines[0].split("|").map(function(s) {
                return s.trim();
            }), rawStyles = tableLines[1].split("|").map(function(s) {
                return s.trim();
            }), rawCells = [], headers = [], styles = [], cells = [];
            tableLines.shift();
            tableLines.shift();
            for(i = 0; i < tableLines.length; ++i){
                if (tableLines[i].trim() === "") continue;
                rawCells.push(tableLines[i].split("|").map(function(s) {
                    return s.trim();
                }));
            }
            if (rawHeaders.length < rawStyles.length) return rawTable;
            for(i = 0; i < rawStyles.length; ++i)styles.push(parseStyles(rawStyles[i]));
            for(i = 0; i < rawHeaders.length; ++i){
                if (showdown.helper.isUndefined(styles[i])) styles[i] = "";
                headers.push(parseHeaders(rawHeaders[i], styles[i]));
            }
            for(i = 0; i < rawCells.length; ++i){
                var row = [];
                for(var ii = 0; ii < headers.length; ++ii){
                    showdown.helper.isUndefined(rawCells[i][ii]);
                    row.push(parseCells(rawCells[i][ii], styles[ii]));
                }
                cells.push(row);
            }
            return buildTable(headers, cells);
        }
        text = globals.converter._dispatch("tables.before", text, options, globals);
        // find escaped pipe characters
        text = text.replace(/\\(\|)/g, showdown.helper.escapeCharactersCallback);
        // parse multi column tables
        text = text.replace(tableRgx, parseTable);
        // parse one column tables
        text = text.replace(singeColTblRgx, parseTable);
        text = globals.converter._dispatch("tables.after", text, options, globals);
        return text;
    });
    showdown.subParser("underline", function(text, options, globals) {
        "use strict";
        if (!options.underline) return text;
        text = globals.converter._dispatch("underline.before", text, options, globals);
        if (options.literalMidWordUnderscores) {
            text = text.replace(/\b___(\S[\s\S]*?)___\b/g, function(wm, txt) {
                return "<u>" + txt + "</u>";
            });
            text = text.replace(/\b__(\S[\s\S]*?)__\b/g, function(wm, txt) {
                return "<u>" + txt + "</u>";
            });
        } else {
            text = text.replace(/___(\S[\s\S]*?)___/g, function(wm, m) {
                return /\S$/.test(m) ? "<u>" + m + "</u>" : wm;
            });
            text = text.replace(/__(\S[\s\S]*?)__/g, function(wm, m) {
                return /\S$/.test(m) ? "<u>" + m + "</u>" : wm;
            });
        }
        // escape remaining underscores to prevent them being parsed by italic and bold
        text = text.replace(/(_)/g, showdown.helper.escapeCharactersCallback);
        text = globals.converter._dispatch("underline.after", text, options, globals);
        return text;
    });
    /**
 * Swap back in all the special characters we've hidden.
 */ showdown.subParser("unescapeSpecialChars", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("unescapeSpecialChars.before", text, options, globals);
        text = text.replace(/¨E(\d+)E/g, function(wholeMatch, m1) {
            var charCodeToReplace = parseInt(m1);
            return String.fromCharCode(charCodeToReplace);
        });
        text = globals.converter._dispatch("unescapeSpecialChars.after", text, options, globals);
        return text;
    });
    showdown.subParser("makeMarkdown.blockquote", function(node, globals) {
        "use strict";
        var txt = "";
        if (node.hasChildNodes()) {
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i){
                var innerTxt = showdown.subParser("makeMarkdown.node")(children[i], globals);
                if (innerTxt === "") continue;
                txt += innerTxt;
            }
        }
        // cleanup
        txt = txt.trim();
        txt = "> " + txt.split("\n").join("\n> ");
        return txt;
    });
    showdown.subParser("makeMarkdown.codeBlock", function(node, globals) {
        "use strict";
        var lang = node.getAttribute("language"), num = node.getAttribute("precodenum");
        return "```" + lang + "\n" + globals.preList[num] + "\n```";
    });
    showdown.subParser("makeMarkdown.codeSpan", function(node) {
        "use strict";
        return "`" + node.innerHTML + "`";
    });
    showdown.subParser("makeMarkdown.emphasis", function(node, globals) {
        "use strict";
        var txt = "";
        if (node.hasChildNodes()) {
            txt += "*";
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals);
            txt += "*";
        }
        return txt;
    });
    showdown.subParser("makeMarkdown.header", function(node, globals, headerLevel) {
        "use strict";
        var headerMark = new Array(headerLevel + 1).join("#"), txt = "";
        if (node.hasChildNodes()) {
            txt = headerMark + " ";
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals);
        }
        return txt;
    });
    showdown.subParser("makeMarkdown.hr", function() {
        "use strict";
        return "---";
    });
    showdown.subParser("makeMarkdown.image", function(node) {
        "use strict";
        var txt = "";
        if (node.hasAttribute("src")) {
            txt += "![" + node.getAttribute("alt") + "](";
            txt += "<" + node.getAttribute("src") + ">";
            if (node.hasAttribute("width") && node.hasAttribute("height")) txt += " =" + node.getAttribute("width") + "x" + node.getAttribute("height");
            if (node.hasAttribute("title")) txt += ' "' + node.getAttribute("title") + '"';
            txt += ")";
        }
        return txt;
    });
    showdown.subParser("makeMarkdown.links", function(node, globals) {
        "use strict";
        var txt = "";
        if (node.hasChildNodes() && node.hasAttribute("href")) {
            var children = node.childNodes, childrenLength = children.length;
            txt = "[";
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals);
            txt += "](";
            txt += "<" + node.getAttribute("href") + ">";
            if (node.hasAttribute("title")) txt += ' "' + node.getAttribute("title") + '"';
            txt += ")";
        }
        return txt;
    });
    showdown.subParser("makeMarkdown.list", function(node, globals, type) {
        "use strict";
        var txt = "";
        if (!node.hasChildNodes()) return "";
        var listItems = node.childNodes, listItemsLenght = listItems.length, listNum = node.getAttribute("start") || 1;
        for(var i = 0; i < listItemsLenght; ++i){
            if (typeof listItems[i].tagName === "undefined" || listItems[i].tagName.toLowerCase() !== "li") continue;
            // define the bullet to use in list
            var bullet = "";
            if (type === "ol") bullet = listNum.toString() + ". ";
            else bullet = "- ";
            // parse list item
            txt += bullet + showdown.subParser("makeMarkdown.listItem")(listItems[i], globals);
            ++listNum;
        }
        // add comment at the end to prevent consecutive lists to be parsed as one
        txt += "\n<!-- -->\n";
        return txt.trim();
    });
    showdown.subParser("makeMarkdown.listItem", function(node, globals) {
        "use strict";
        var listItemTxt = "";
        var children = node.childNodes, childrenLenght = children.length;
        for(var i = 0; i < childrenLenght; ++i)listItemTxt += showdown.subParser("makeMarkdown.node")(children[i], globals);
        // if it's only one liner, we need to add a newline at the end
        if (!/\n$/.test(listItemTxt)) listItemTxt += "\n";
        else // it's multiparagraph, so we need to indent
        listItemTxt = listItemTxt.split("\n").join("\n    ").replace(/^ {4}$/gm, "").replace(/\n\n+/g, "\n\n");
        return listItemTxt;
    });
    showdown.subParser("makeMarkdown.node", function(node, globals, spansOnly) {
        "use strict";
        spansOnly = spansOnly || false;
        var txt = "";
        // edge case of text without wrapper paragraph
        if (node.nodeType === 3) return showdown.subParser("makeMarkdown.txt")(node, globals);
        // HTML comment
        if (node.nodeType === 8) return "<!--" + node.data + "-->\n\n";
        // process only node elements
        if (node.nodeType !== 1) return "";
        var tagName = node.tagName.toLowerCase();
        switch(tagName){
            //
            // BLOCKS
            //
            case "h1":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.header")(node, globals, 1) + "\n\n";
                break;
            case "h2":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.header")(node, globals, 2) + "\n\n";
                break;
            case "h3":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.header")(node, globals, 3) + "\n\n";
                break;
            case "h4":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.header")(node, globals, 4) + "\n\n";
                break;
            case "h5":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.header")(node, globals, 5) + "\n\n";
                break;
            case "h6":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.header")(node, globals, 6) + "\n\n";
                break;
            case "p":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.paragraph")(node, globals) + "\n\n";
                break;
            case "blockquote":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.blockquote")(node, globals) + "\n\n";
                break;
            case "hr":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.hr")(node, globals) + "\n\n";
                break;
            case "ol":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.list")(node, globals, "ol") + "\n\n";
                break;
            case "ul":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.list")(node, globals, "ul") + "\n\n";
                break;
            case "precode":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.codeBlock")(node, globals) + "\n\n";
                break;
            case "pre":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.pre")(node, globals) + "\n\n";
                break;
            case "table":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.table")(node, globals) + "\n\n";
                break;
            //
            // SPANS
            //
            case "code":
                txt = showdown.subParser("makeMarkdown.codeSpan")(node, globals);
                break;
            case "em":
            case "i":
                txt = showdown.subParser("makeMarkdown.emphasis")(node, globals);
                break;
            case "strong":
            case "b":
                txt = showdown.subParser("makeMarkdown.strong")(node, globals);
                break;
            case "del":
                txt = showdown.subParser("makeMarkdown.strikethrough")(node, globals);
                break;
            case "a":
                txt = showdown.subParser("makeMarkdown.links")(node, globals);
                break;
            case "img":
                txt = showdown.subParser("makeMarkdown.image")(node, globals);
                break;
            default:
                txt = node.outerHTML + "\n\n";
        }
        // common normalization
        // TODO eventually
        return txt;
    });
    showdown.subParser("makeMarkdown.paragraph", function(node, globals) {
        "use strict";
        var txt = "";
        if (node.hasChildNodes()) {
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals);
        }
        // some text normalization
        txt = txt.trim();
        return txt;
    });
    showdown.subParser("makeMarkdown.pre", function(node, globals) {
        "use strict";
        var num = node.getAttribute("prenum");
        return "<pre>" + globals.preList[num] + "</pre>";
    });
    showdown.subParser("makeMarkdown.strikethrough", function(node, globals) {
        "use strict";
        var txt = "";
        if (node.hasChildNodes()) {
            txt += "~~";
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals);
            txt += "~~";
        }
        return txt;
    });
    showdown.subParser("makeMarkdown.strong", function(node, globals) {
        "use strict";
        var txt = "";
        if (node.hasChildNodes()) {
            txt += "**";
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals);
            txt += "**";
        }
        return txt;
    });
    showdown.subParser("makeMarkdown.table", function(node, globals) {
        "use strict";
        var txt = "", tableArray = [
            [],
            []
        ], headings = node.querySelectorAll("thead>tr>th"), rows = node.querySelectorAll("tbody>tr"), i, ii;
        for(i = 0; i < headings.length; ++i){
            var headContent = showdown.subParser("makeMarkdown.tableCell")(headings[i], globals), allign = "---";
            if (headings[i].hasAttribute("style")) {
                var style = headings[i].getAttribute("style").toLowerCase().replace(/\s/g, "");
                switch(style){
                    case "text-align:left;":
                        allign = ":---";
                        break;
                    case "text-align:right;":
                        allign = "---:";
                        break;
                    case "text-align:center;":
                        allign = ":---:";
                        break;
                }
            }
            tableArray[0][i] = headContent.trim();
            tableArray[1][i] = allign;
        }
        for(i = 0; i < rows.length; ++i){
            var r = tableArray.push([]) - 1, cols = rows[i].getElementsByTagName("td");
            for(ii = 0; ii < headings.length; ++ii){
                var cellContent = " ";
                if (typeof cols[ii] !== "undefined") cellContent = showdown.subParser("makeMarkdown.tableCell")(cols[ii], globals);
                tableArray[r].push(cellContent);
            }
        }
        var cellSpacesCount = 3;
        for(i = 0; i < tableArray.length; ++i)for(ii = 0; ii < tableArray[i].length; ++ii){
            var strLen = tableArray[i][ii].length;
            if (strLen > cellSpacesCount) cellSpacesCount = strLen;
        }
        for(i = 0; i < tableArray.length; ++i){
            for(ii = 0; ii < tableArray[i].length; ++ii)if (i === 1) {
                if (tableArray[i][ii].slice(-1) === ":") tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii].slice(-1), cellSpacesCount - 1, "-") + ":";
                else tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount, "-");
            } else tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount);
            txt += "| " + tableArray[i].join(" | ") + " |\n";
        }
        return txt.trim();
    });
    showdown.subParser("makeMarkdown.tableCell", function(node, globals) {
        "use strict";
        var txt = "";
        if (!node.hasChildNodes()) return "";
        var children = node.childNodes, childrenLength = children.length;
        for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals, true);
        return txt.trim();
    });
    showdown.subParser("makeMarkdown.txt", function(node) {
        "use strict";
        var txt = node.nodeValue;
        // multiple spaces are collapsed
        txt = txt.replace(/ +/g, " ");
        // replace the custom ¨NBSP; with a space
        txt = txt.replace(/¨NBSP;/g, " ");
        // ", <, > and & should replace escaped html entities
        txt = showdown.helper.unescapeHTMLEntities(txt);
        // escape markdown magic characters
        // emphasis, strong and strikethrough - can appear everywhere
        // we also escape pipe (|) because of tables
        // and escape ` because of code blocks and spans
        txt = txt.replace(/([*_~|`])/g, "\\$1");
        // escape > because of blockquotes
        txt = txt.replace(/^(\s*)>/g, "\\$1>");
        // hash character, only troublesome at the beginning of a line because of headers
        txt = txt.replace(/^#/gm, "\\#");
        // horizontal rules
        txt = txt.replace(/^(\s*)([-=]{3,})(\s*)$/, "$1\\$2$3");
        // dot, because of ordered lists, only troublesome at the beginning of a line when preceded by an integer
        txt = txt.replace(/^( {0,3}\d+)\./gm, "$1\\.");
        // +, * and -, at the beginning of a line becomes a list, so we need to escape them also (asterisk was already escaped)
        txt = txt.replace(/^( {0,3})([+-])/gm, "$1\\$2");
        // images and links, ] followed by ( is problematic, so we escape it
        txt = txt.replace(/]([\s]*)\(/g, "\\]$1\\(");
        // reference URIs must also be escaped
        txt = txt.replace(/^ {0,3}\[([\S \t]*?)]:/gm, "\\[$1]:");
        return txt;
    });
    var root = this;
    // AMD Loader
    if (typeof define === "function" && define.amd) define(function() {
        "use strict";
        return showdown;
    });
    else if (0, $b43ee6739f221f6f$exports) $b43ee6739f221f6f$exports = showdown;
    else root.showdown = showdown;
}).call($b43ee6739f221f6f$exports);


(0, (/*@__PURE__*/$parcel$interopDefault($b43ee6739f221f6f$exports))).extension("targetlink", function() {
    return [
        {
            type: "html",
            regex: /(<a [^>]+?)(>.*<\/a>)/g,
            replace: '$1 target="_blank"$2'
        }
    ];
});
class $d08803de9f8654e5$export$7460c8b7e4ce9582 extends (0, $2s69t.Div) {
    constructor(markdown){
        super("markdown");
        // this.TextAlignLeft().Style("text-indent: 0;");
        this.options = {
            tables: true,
            tasklists: true,
            underline: true,
            strikethrough: true,
            backslashEscapesHTMLTags: true,
            simpleLineBreaks: true
        };
        this.converter = new (0, (/*@__PURE__*/$parcel$interopDefault($b43ee6739f221f6f$exports))).Converter(this.options);
        if (markdown instanceof (0, $2s69t.Ref)) markdown.OnChange((md)=>this.Render(md), true);
        else this.Render(markdown);
    }
    Render(markdown) {
        const html = this.converter.makeHtml(markdown).replaceAll("  \n", "<br />");
        this.Html(html);
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

class $f92438a5aaa1760a$export$be6bb94fb0a459a6 extends (0, $2s69t.Div) {
    constructor(faq){
        super("product-questions__item");
        this.Append(new (0, $2s69t.Div)().Class("product-questions__box").Append(new (0, $2s69t.Text)(faq.Question).Class("product-questions__question"), new (0, $d08803de9f8654e5$export$7460c8b7e4ce9582)(faq.Answer).Class("product-questions__answer")), new (0, $2s69t.Div)().Class("product-questions__separator"));
    }
}



var $2s69t = parcelRequire("2s69t");
class $d5372390156ec6d7$export$1f54913ccc4368b1 extends (0, $2s69t.Div) {
    constructor(...components){
        super();
        this.TextAlignCenter().FullWidth().Append(...components);
    }
}


class $1fa304243a95bd67$export$f8e2e07c75919270 extends (0, $2s69t.Div) {
    constructor(field){
        super("product-questions");
        const expand = new (0, $2s69t.RefBool)();
        this.Append(...field.Questions.Take(0, 3).map((x)=>new (0, $f92438a5aaa1760a$export$be6bb94fb0a459a6)(x)), field.Questions.Count > 3 && new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $2s69t.Link)(`\u{25BC} Poka\u{17C} wszystkie ${field.Questions.Count}`).Class("product-questions__toggle").OnClick((_)=>{
            _.Hide();
            expand.True();
        })), new (0, $2s69t.Div)().Append(...field.Questions.Take(3, field.Questions.Count).map((x)=>new (0, $f92438a5aaa1760a$export$be6bb94fb0a459a6)(x))).Visible(expand));
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $ae55eced3e9efe6f$export$e71c4d32a2263218 extends (0, $2s69t.Div) {
    constructor(className, content){
        super(className);
        this.Append(...content);
    }
}


class $0e4d5dbf03b3bffd$export$ace63239d21d36e extends (0, $2s69t.Div) {
    constructor(images){
        super("product__gallery-container");
        if (images.Count == 0) {
            this.Append("Brak zdj\u0119\u0107");
            return;
        }
        const previewPicture = new (0, $2s69t.RefString)(images.Items[0].ThumbnailUrl.value || images.Items[0].NormalizedUrl.value);
        const pictureUrl = new (0, $2s69t.RefString)(images.Items[0].NormalizedUrl.value);
        this.Append(new (0, $ae55eced3e9efe6f$export$e71c4d32a2263218)("product__gallery", [
            new (0, $ae55eced3e9efe6f$export$e71c4d32a2263218)("product__gallery-main", [
                new (0, $2s69t.Image)(previewPicture).Class("w-full h-full object-contain absolute inset-0").Attribute("data-is-main", "true").Opacity(1).OnClick(()=>window.open(pictureUrl.value, "_blank"))
            ]),
            new (0, $ae55eced3e9efe6f$export$e71c4d32a2263218)("product__gallery-thumbs", [
                ...images.Items.map((x)=>new (0, $2s69t.Image)(x.MiniUrl.value || x.ThumbnailUrl.value || x.NormalizedUrl.value, x.Description.value).Class("product__gallery-thumb flex-shrink-0").OnClick(()=>{
                        previewPicture.value = x.ThumbnailUrl.value || x.NormalizedUrl.value;
                        pictureUrl.value = x.NormalizedUrl.value;
                    }))
            ])
        ]));
    }
}


var $02db4fb745f57d51$export$ed12481c953b8653;
(function(FieldType) {
    FieldType["Markdown"] = "Markdown";
    FieldType["Text"] = "Text";
    FieldType["Faq"] = "Faq";
    FieldType["Table"] = "Table";
    FieldType["Gallery"] = "Gallery";
    FieldType["Opinion"] = "Opinion";
    FieldType["TextWithPicture"] = "TextWithPicture";
})($02db4fb745f57d51$export$ed12481c953b8653 || ($02db4fb745f57d51$export$ed12481c953b8653 = {}));



var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");


class $3a981643041d236f$export$6f09e14bdb46efab extends (0, $2s69t.Div) {
    constructor(rating){
        super();
        for(let i = 1; i <= 5; i++)this.Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(rating.value >= i ? (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Star : (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).EmptyStar));
    }
}
class $3a981643041d236f$export$a5a2c11c0642aa49 extends (0, $2s69t.Div) {
    constructor(opinion){
        super("card product-reviews__card");
        this.Append(new (0, $2s69t.Div)("card__content product-reviews__content").Append(new (0, $2s69t.Div)("product-reviews__header").Append(new $3a981643041d236f$export$6f09e14bdb46efab(opinion.Rate).Class("product-reviews__stars"), new (0, $2s69t.Text)(opinion.Author).Class("product-reviews__name")), new (0, $2s69t.Text)(opinion.Comment).Class("product-reviews__text")));
    }
}



var $2s69t = parcelRequire("2s69t");
class $dca4a10ada8bf906$export$e71c4d32a2263218 extends (0, $2s69t.Div) {
    constructor(...cmps){
        super();
        this.DisplayInlineBlock();
        this.Append(...cmps);
    }
}


class $d45a30d7d64dae0c$export$d12abc192c472f41 extends (0, $2s69t.Div) {
    constructor(field){
        super("product-reviews");
        const expand = new (0, $2s69t.RefBool)();
        this.Append(...field.Opinions.Take(0, 3).map((x)=>new (0, $3a981643041d236f$export$a5a2c11c0642aa49)(x)), field.Opinions.Count > 3 && new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $2s69t.Link)(`\u{25BC} Poka\u{17C} wszystkie ${field.Opinions.Count}`).Class("product-reviews__toggle").OnClick((_)=>{
            _.Hide();
            expand.True();
        })), new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(...field.Opinions.Take(3, field.Opinions.Count).map((x)=>new (0, $3a981643041d236f$export$a5a2c11c0642aa49)(x))).Visible(expand, "flex"));
    }
}




var $2s69t = parcelRequire("2s69t");

var $1lG8E = parcelRequire("1lG8E");

class $e6fd0857754df8ca$export$e9f808b8098ef2ce extends (0, $2s69t.Div) {
    constructor(field){
        super("product__specs");
        const table = new (0, $1lG8E.Table)().Class("product__specs-table");
        const tableRows = field.Rows.Items;
        for (const row of tableRows)table.Append(new (0, $2s69t.TableRow)().Class("product__specs-row").Append(new (0, $2s69t.TableCell)(new (0, $d08803de9f8654e5$export$7460c8b7e4ce9582)(row.Left.value)).Class("product__specs-cell product__specs-label"), new (0, $2s69t.TableCell)(new (0, $d08803de9f8654e5$export$7460c8b7e4ce9582)(row.Right.value)).Class("product__specs-cell product__specs-value")));
        this.Append(table);
    }
}




var $2s69t = parcelRequire("2s69t");


class $a11f4f13271e2817$export$8fa854f63c425b37 extends (0, $2s69t.Div) {
    constructor(field){
        super("TextWithPicturePrinter");
        if (field.PicturePosition.Is("left")) this.Append(new (0, $2s69t.Div)("image-container").Append(new (0, $2s69t.Image)(field.PictureUrl.value)), new (0, $d08803de9f8654e5$export$7460c8b7e4ce9582)(field.Text.value).Class("text-container"));
        else this.Append(new (0, $d08803de9f8654e5$export$7460c8b7e4ce9582)(field.Text.value).Class("text-container"), new (0, $2s69t.Div)("image-container").Append(new (0, $2s69t.Image)(field.PictureUrl.value)));
    }
}
class $a11f4f13271e2817$export$3c1286ea28c7fea5 extends (0, $2s69t.Div) {
    constructor(header, field){
        const isLeft = field.PicturePosition.Is("left");
        super("content-block" + (isLeft ? " content-block--reverse" : ""));
        this.Append(new (0, $2s69t.Div)("content-block__container").Append(new (0, $2s69t.Div)("content-block__image").Append(new (0, $2s69t.Image)(field.PictureUrl.value).Class("content-block__img")), new (0, $2s69t.Div)("content-block__content").Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)(header, 2, "content-block__title"), new (0, $d08803de9f8654e5$export$7460c8b7e4ce9582)(field.Text.value).Class("content-block__text"))));
    }
}



class $ebf4bc3d4451a6e3$export$f01d323147c8570b extends (0, $2s69t.Div) {
    constructor(field){
        super("description-field");
        if (field.VisibleHeader.value) this.Append(new (0, $2s69t.Div)("product-description-field-header").Append(field.Icon.value && new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(field.Icon.value).Class("svg-icon"), new (0, $6d7758add37969e7$export$a8a3e93435678ff9)(field.Header.value, 3).Class("product-info-title")));
        const printer = new (0, $2s69t.Switch)(field.Type).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).Text, ()=>new (0, $2s69t.Text)(field.Text)).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).TextWithPicture, ()=>new (0, $a11f4f13271e2817$export$8fa854f63c425b37)(field)).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).Markdown, ()=>new (0, $d08803de9f8654e5$export$7460c8b7e4ce9582)(field.Markdown.value).MarginLeftRight(8)).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).Faq, ()=>new (0, $1fa304243a95bd67$export$f8e2e07c75919270)(field)).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).Opinion, ()=>new (0, $d45a30d7d64dae0c$export$d12abc192c472f41)(field)).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).Gallery, ()=>new (0, $0e4d5dbf03b3bffd$export$ace63239d21d36e)(field.Images).Background("none").MarginAuto()).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).Table, ()=>new (0, $e6fd0857754df8ca$export$e9f808b8098ef2ce)(field)).Default(()=>new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(`No printer for ${field.Type}`)).Execute(field.Type);
        printer?.Style(field.Style.value);
        this.Append(new (0, $2s69t.Div)("product-description-field-content").Append(printer));
    }
}


class $9d11ccb715f9b5f8$export$db66bbe0229adb7a extends (0, $2s69t.Div) {
    constructor(fields, fieldClass = ""){
        super();
        if (fields instanceof (0, $2s69t.Collection)) this.Append(...fields.Items.map((entry)=>new (0, $ebf4bc3d4451a6e3$export$f01d323147c8570b)(entry).Class(fieldClass)));
        else this.Append(...fields.map((entry)=>new (0, $ebf4bc3d4451a6e3$export$f01d323147c8570b)(entry).Class(fieldClass)));
    }
}


class $677a462cbb8c4fc5$export$a161619e565e7a89 extends (0, $2s69t.HidingContentSwitcher) {
    constructor(tabs, description, selectedTab){
        super(selectedTab);
        this.Class("tabs__content product-info__tab-content");
        tabs.Items.map((tab)=>{
            const tabFields = description.Filter((x)=>x.Tab.value === tab.Id.value);
            this.AddContent(tab.Label.value, ()=>new (0, $9d11ccb715f9b5f8$export$db66bbe0229adb7a)(tabFields));
        });
        this.Refresh();
    }
}



var $2s69t = parcelRequire("2s69t");
class $46114c4feb723b20$export$db640cc37fb23a6a extends (0, $2s69t.Div) {
    constructor(tabs, selectedTab){
        super();
        this.DisplayBlock().TextAlignCenter().MarginTop(32);
        this.Append(...tabs.Items.map((x)=>new (0, $2s69t.Span)("\u25CF").Class("dot-btn").OnClick((_)=>selectedTab.value = x.Label.value).When(selectedTab, (v)=>v === x.Label.value, (btn)=>btn.Color("#e11d48"), (btn)=>btn.Color("#ccc"))));
    }
}


class $1ddb027c15b204fa$export$395fdea733a8631f extends (0, $2s69t.Div) {
    constructor(tabs, collection){
        super("product-info__container");
        const visibleTabs = new (0, $2s69t.Collection)(tabs.Filter((x)=>x.IsVisible.value));
        const firstNonEmptyTab = visibleTabs.Items.find((x)=>x.Label.value != "")?.Label?.value || "";
        const selectedTab = new (0, $2s69t.RefString)(firstNonEmptyTab); // NIE ROBIĆ TEGO Storable!
        this.Append(new (0, $2s69t.Div)("card product-info__card").Append(new (0, $2s69t.Div)("card__content product-info__content").Append(new (0, $2s69t.Div)("product-info__tabs").Append(visibleTabs.Count > 0 && new (0, $520c253b7bf906da$export$b2539bed5023c21c)(visibleTabs, selectedTab), new (0, $677a462cbb8c4fc5$export$a161619e565e7a89)(visibleTabs, collection, selectedTab), new (0, $46114c4feb723b20$export$db640cc37fb23a6a)(visibleTabs, selectedTab), new (0, $2s69t.Button)("Czytaj dalej...").Class("product__button product__button--compact").MarginTop(12).OnClick(()=>{
            const currentTabIndex = visibleTabs.Items.findIndex((x)=>x.Label.value == selectedTab.value);
            const nextTab = visibleTabs.Items[currentTabIndex + 1];
            if (nextTab) selectedTab.value = nextTab.Label.value;
        }).VisibleWhen(selectedTab, (v)=>{
            const currentTabIndex = visibleTabs.Items.findIndex((x)=>x.Label.value == selectedTab.value);
            return currentTabIndex < visibleTabs.Items.length - 1;
        })))));
    }
}





var $2s69t = parcelRequire("2s69t");
class $da353777c9526d49$export$54ea5188c2a6e856 extends (0, $2s69t.Div) {
    constructor(product){
        super("product-breadcrumbs");
        this.Append(new (0, $2s69t.Link)("Oferta", "#kategorie-produktow").Class("product__breadcrumbs-link"), new (0, $2s69t.Span)("\u203A").Class("product-breadcrumbs__separator"), new (0, $2s69t.Link)(product.Category.Title.value, "#kategoria/" + product.Category.Url.value).Class("product__breadcrumbs-link"));
    }
}



var $2s69t = parcelRequire("2s69t");

class $7769959ad737ae6c$export$c2ee54cc17aba4db extends (0, $1614c8db74c4885c$export$e71c4d32a2263218) {
    constructor(product, productOption){
        const options = product.Options.List.Items.map((x)=>new (0, $2s69t.SelectOption)(x.Label.value + " " + product.Options.FactorAsLabel(x.Url.value), x.Url.value));
        const optionDescription = new (0, $2s69t.Ref)("");
        productOption.OnChange((v)=>optionDescription.value = product.Options.GetById(v).Description.value, true);
        super("product-option-selector", [
            new (0, $2s69t.Select)(productOption, options).WidthPercent(100),
            new (0, $2s69t.Text)(optionDescription).Class("product-option-selector-description").VisibleWhen(optionDescription, (v)=>v.length > 0)
        ]);
        this.DisplayBlock().FullWidth().Background("#1e293b").Padding(12).BorderRadius(8).Margin(0);
        this.Visible(options.length > 0);
    }
}



var $2s69t = parcelRequire("2s69t");

class $c9ce8a136bb3392c$export$1a5c2628c1de5abc extends (0, $1614c8db74c4885c$export$e71c4d32a2263218) {
    constructor(product){
        super("product__features", [
            ...product.Features.value.split("\n").flatMap((feature)=>new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__feature", [
                    new (0, $2s69t.Span)("\u2713").Class("product__feature-icon"),
                    new (0, $2s69t.Span)(feature).Class("product__feature-text")
                ]))
        ]);
    }
}




var $2s69t = parcelRequire("2s69t");
var $e97714b723cebee9$export$39b11636c68d48ec;
(function(BasketItemType) {
    BasketItemType["Unset"] = "Unset";
    BasketItemType["Rent"] = "Rent";
    BasketItemType["Sale"] = "Sale";
    BasketItemType["Service"] = "Service";
    BasketItemType["Help"] = "Help";
})($e97714b723cebee9$export$39b11636c68d48ec || ($e97714b723cebee9$export$39b11636c68d48ec = {}));




var $2s69t = parcelRequire("2s69t");

class $6ceb8ed68d0117cb$export$92a6cef5d25bfbe0 extends (0, $1614c8db74c4885c$export$e71c4d32a2263218) {
    constructor(){
        super("product__info-bottom", [
            new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__info-bottom-row", [
                new (0, $2s69t.Span)("\uD83D\uDE9A").Class("product__info-bottom-row-icon"),
                new (0, $2s69t.Span)("Dostawa od\n1z\u0142 w 24h").Class("product__info-bottom-row-text")
            ]),
            new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__info-bottom-row", [
                new (0, $2s69t.Span)("\uD83D\uDC68\u200D\uD83D\uDCBB").Class("product__info-bottom-row-icon"),
                new (0, $2s69t.Span)("Pomoc techniczna\n24/7").Class("product__info-bottom-row-text")
            ])
        ]);
    }
}



var $2s69t = parcelRequire("2s69t");


class $6d42fa89da70e953$export$b371bec033580acf extends (0, $1614c8db74c4885c$export$e71c4d32a2263218) {
    constructor(product, rentOrSale){
        if (product.Basketable.value) {
            super("product__actions-tabs", []);
            return;
        }
        if (!product.Rentable.value) rentOrSale.value = (0, $e97714b723cebee9$export$39b11636c68d48ec).Sale;
        if (!product.Saleable.value) rentOrSale.value = (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent;
        super("product__actions-tabs", [
            product.Rentable.value && new (0, $2s69t.Button)("Wypo\u017Cyczenie").OnClick(()=>rentOrSale.value = (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent).Class("product__actions-tab").Attribute("data-testid", "rent-btn").When(rentOrSale, (m)=>m == (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent, (x)=>x.RemoveClass("product__actions-tab--inactive").Class("product__actions-tab--active"), (x)=>x.RemoveClass("product__actions-tab--active").Class("product__actions-tab--inactive")),
            product.Saleable.value && new (0, $2s69t.Button)("Zakup").OnClick(()=>rentOrSale.value = (0, $e97714b723cebee9$export$39b11636c68d48ec).Sale).Class("product__actions-tab").Attribute("data-testid", "sale-btn").When(rentOrSale, (m)=>m == (0, $e97714b723cebee9$export$39b11636c68d48ec).Sale, (x)=>x.RemoveClass("product__actions-tab--inactive").Class("product__actions-tab--active"), (x)=>x.RemoveClass("product__actions-tab--active").Class("product__actions-tab--inactive"))
        ]);
    }
}



var $2s69t = parcelRequire("2s69t");


var $45fvw = parcelRequire("45fvw");

var $2s69t = parcelRequire("2s69t");
class $8d21273b49376a6d$export$8cb450ce50b94421 {
    constructor(_start = new (0, $2s69t.RefDate)(), _end = new (0, $2s69t.RefDate)(), now = new Date()){
        this.now = now;
        this.Start = void 0;
        this.End = void 0;
        this.DaysCount = new (0, $2s69t.RefNumber)();
        this.onChange = new (0, $2s69t.HandlersCollection)();
        if (_start instanceof Date) this.Start = new (0, $2s69t.RefDate)(_start);
        else if (typeof _start === "string") this.Start = new (0, $2s69t.RefDate)(new Date(_start));
        else this.Start = _start;
        if (_end instanceof Date) this.End = new (0, $2s69t.RefDate)(_end);
        else if (typeof _end === "string") this.End = new (0, $2s69t.RefDate)(new Date(_end));
        else this.End = _end;
        this.Start.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Start.value).hour(12).minute(0).seconds(0).millisecond(0).toDate();
        this.End.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.End.value).hour(12).minute(0).seconds(0).millisecond(0).toDate();
        if (this.Start.value < now) this.Start.value = now;
        if (this.End.value < now) this.End.value = now;
        this.Start.OnChange((start)=>{
            if (start < now) {
                start = now;
                this.Start.value = start;
            }
            this.DaysCount.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.End.value).diff(start, "days") + 1;
            const s = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Start.value);
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.End.value);
            if (s.isAfter(e)) this.End.value = this.Start.value;
            this.onChange.Call(start, this.End.value, this.DaysCount.value);
        });
        this.End.OnChange((end)=>{
            if (end < now) end = now;
            this.DaysCount.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(end).diff(this.Start.value, "days") + 1;
            const s = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Start.value);
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.End.value);
            if (s.isAfter(e)) this.Start.value = this.End.value;
            this.onChange.Call(this.Start.value, end, this.DaysCount.value);
        }, true);
    }
    AddDay() {
        this.End.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.End.value).add(1, "day").toDate();
    }
    SubtractDay() {
        this.End.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.End.value).subtract(1, "day").toDate();
        if (this.End.value < this.now) this.End.value = this.now;
    }
    OnChange(handler) {
        this.onChange.Add(handler);
    }
}



var $45fvw = parcelRequire("45fvw");

var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $a8dfaf8f7f447cba$export$b972827e986d3b65 {
    constructor(raw){
        this.Value = new (0, $2s69t.RefNumber)();
        this.Days = new (0, $2s69t.RefNumber)();
        this.Visible = new (0, $2s69t.RefBool)();
        this.Value.value = raw.Value || 0;
        this.Days.value = raw.Days || 0;
        this.Visible.value = raw.Visible || false;
    }
    get PricePerDay() {
        return Math.round(this.Value.value / this.Days.value);
    }
}



var $2s69t = parcelRequire("2s69t");
class $596f68690e85a4b5$export$9ad530ff9b116248 {
    constructor(raw){
        this.Rate = new (0, $2s69t.RefNumber)();
        this.Advantages = new (0, $2s69t.RefString)();
        this.Disadvantages = new (0, $2s69t.RefString)();
        this.Comment = new (0, $2s69t.RefString)();
        this.Author = new (0, $2s69t.RefString)();
        this.Rate.value = raw.Rate || -1;
        this.Advantages.value = raw.Advantages || "";
        this.Disadvantages.value = raw.Disadvantages || "";
        this.Comment.value = raw.Comment || "";
        this.Author.value = raw.Author || "";
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $f84c44bab68f3aae$export$a455218a85c89869 {
    constructor(raw){
        this.Type = void 0;
        this.Visible = new (0, $2s69t.RefBool)(true);
        this.Tab = new (0, $2s69t.RefString)();
        this.Icon = new (0, $2s69t.RefString)();
        this.Header = new (0, $2s69t.RefString)();
        this.Style = new (0, $2s69t.RefString)();
        this.VisibleHeader = new (0, $2s69t.RefBool)(true);
        this.Visible.value = raw.Visible ?? true;
        this.Tab.value = raw.Tab || "default";
        this.Icon.value = raw.Icon || "";
        this.Header.value = raw.Header || "";
        this.VisibleHeader.value = raw.VisibleHeader ?? true;
        this.Style.value = raw.Style || "";
    }
}




var $2s69t = parcelRequire("2s69t");
class $b74f7a0e2f20ee26$export$48e30329ded2268e {
    constructor(raw){
        this.OriginalUrl = new (0, $2s69t.RefString)();
        this.NormalizedUrl = new (0, $2s69t.RefString)();
        this.ThumbnailUrl = new (0, $2s69t.RefString)();
        this.MiniUrl = new (0, $2s69t.RefString)();
        this.Description = new (0, $2s69t.RefString)();
        this.XOffset = new (0, $2s69t.RefNumber)();
        this.YOffset = new (0, $2s69t.RefNumber)();
        this.OriginalUrl.value = raw.OriginalUrl || "";
        this.NormalizedUrl.value = raw.NormalizedUrl || "";
        this.ThumbnailUrl.value = raw.ThumbnailUrl || "";
        this.MiniUrl.value = raw.MiniUrl || "";
        this.Description.value = raw.Description || "";
        this.XOffset.value = raw.XOffset || 0;
        this.YOffset.value = raw.YOffset || 0;
    }
}


class $a30b994e6b93646a$export$f2577b57255d41 extends (0, $f84c44bab68f3aae$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $02db4fb745f57d51$export$ed12481c953b8653).Gallery;
        this.Images = new (0, $2s69t.Collection)();
        this.Images.Load(...raw.Images?.map((x)=>new (0, $b74f7a0e2f20ee26$export$48e30329ded2268e)(x)) || []);
    }
}



var $2s69t = parcelRequire("2s69t");


class $36a5bd63b771eae9$export$2c73285ae9390cec extends (0, $f84c44bab68f3aae$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $02db4fb745f57d51$export$ed12481c953b8653).Text;
        this.Text = new (0, $2s69t.RefString)();
        this.Text.value = raw.Text || "";
    }
}




var $2s69t = parcelRequire("2s69t");



var $2s69t = parcelRequire("2s69t");
class $1cc7232b5fe1e570$export$7562e752e5ef1fad {
    constructor(raw){
        this.Question = new (0, $2s69t.RefString)();
        this.Answer = new (0, $2s69t.RefString)();
        this.Question.value = raw.Question;
        this.Answer.value = raw.Answer;
    }
}


class $70b813bec008bd3a$export$a5b263448200bf07 extends (0, $f84c44bab68f3aae$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $02db4fb745f57d51$export$ed12481c953b8653).Faq;
        this.Questions = new (0, $2s69t.Collection)();
        this.Questions.Load(...raw.Questions?.map((x)=>new (0, $1cc7232b5fe1e570$export$7562e752e5ef1fad)(x)) || []);
    }
}



var $2s69t = parcelRequire("2s69t");


class $2975f5418488deab$export$5af8b454cf0a55a9 extends (0, $f84c44bab68f3aae$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $02db4fb745f57d51$export$ed12481c953b8653).Markdown;
        this.Markdown = new (0, $2s69t.RefString)();
        this.Markdown.value = raw.Markdown || "";
    }
}



var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");
class $0a4cb42aecdf8db9$export$8b0036ef4f4ccb34 {
    constructor(raw){
        this.Left = new (0, $2s69t.RefString)();
        this.Right = new (0, $2s69t.RefString)();
        this.Left.value = raw.Left || "";
        this.Right.value = raw.Right || "";
    }
}



class $ccdc452b7ba9ee56$export$5cefce85eae032bb extends (0, $f84c44bab68f3aae$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $02db4fb745f57d51$export$ed12481c953b8653).Table;
        this.Rows = new (0, $2s69t.Collection)();
        this.Rows.Load(...raw.Rows?.map((x)=>new (0, $0a4cb42aecdf8db9$export$8b0036ef4f4ccb34)(x)) || []);
    }
}



var $2s69t = parcelRequire("2s69t");



class $f6b05669fb6fd6d2$export$c5ef935f3c05dffb extends (0, $f84c44bab68f3aae$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $02db4fb745f57d51$export$ed12481c953b8653).Opinion;
        this.Opinions = new (0, $2s69t.Collection)();
        this.Opinions.Load(...raw.Opinions?.map((x)=>new (0, $596f68690e85a4b5$export$9ad530ff9b116248)(x)) || []);
    }
}



var $2s69t = parcelRequire("2s69t");


class $09e9cef90667330f$export$227a61a47ffe47e1 extends (0, $f84c44bab68f3aae$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $02db4fb745f57d51$export$ed12481c953b8653).TextWithPicture;
        this.Text = new (0, $2s69t.RefString)();
        this.PictureUrl = new (0, $2s69t.RefString)();
        this.PicturePosition = new (0, $2s69t.Ref)("left");
        this.Text.value = raw.Text || "";
        this.PictureUrl.value = raw.PictureUrl || "";
        this.PicturePosition.value = raw.PicturePosition || "left";
    }
}


class $4dd618a9878588eb$export$f6d490d3b7c1d484 {
    static ToClass(raw) {
        switch(raw.Type){
            case (0, $02db4fb745f57d51$export$ed12481c953b8653).Markdown:
                return new (0, $2975f5418488deab$export$5af8b454cf0a55a9)(raw);
            case (0, $02db4fb745f57d51$export$ed12481c953b8653).Faq:
                return new (0, $70b813bec008bd3a$export$a5b263448200bf07)(raw);
            case (0, $02db4fb745f57d51$export$ed12481c953b8653).Gallery:
                return new (0, $a30b994e6b93646a$export$f2577b57255d41)(raw);
            case (0, $02db4fb745f57d51$export$ed12481c953b8653).Table:
                return new (0, $ccdc452b7ba9ee56$export$5cefce85eae032bb)(raw);
            case (0, $02db4fb745f57d51$export$ed12481c953b8653).Text:
                return new (0, $36a5bd63b771eae9$export$2c73285ae9390cec)(raw);
            case (0, $02db4fb745f57d51$export$ed12481c953b8653).TextWithPicture:
                return new (0, $09e9cef90667330f$export$227a61a47ffe47e1)(raw);
            case (0, $02db4fb745f57d51$export$ed12481c953b8653).Opinion:
                return new (0, $f6b05669fb6fd6d2$export$c5ef935f3c05dffb)(raw);
            default:
                throw new Error(`[DescriptionFieldConverter] Unknown "${raw.Type}" description field type`);
        }
    }
}




var $2s69t = parcelRequire("2s69t");
class $f5599661752f7c8e$export$702c536c4b65a073 {
    constructor(raw){
        this.Quantity = new (0, $2s69t.RefNumber)();
        this.Percent = new (0, $2s69t.RefNumber)();
        this.Quantity.value = raw.Quantity || 0;
        this.Percent.value = raw.Percent || 0;
    }
}



var $2s69t = parcelRequire("2s69t");
class $39a2fd1d77a5883f$export$81fb35662c98d436 {
    constructor(raw){
        this.Id = new (0, $2s69t.RefString)();
        this.Url = new (0, $2s69t.RefString)();
        this.Title = new (0, $2s69t.RefString)();
        this.Subtitle = new (0, $2s69t.RefString)();
        this.Image = new (0, $2s69t.RefString)();
        this.Description = new (0, $2s69t.RefString)();
        this.Visible = new (0, $2s69t.RefBool)(true);
        this.RelatedArticles = new (0, $2s69t.Collection)();
        this.Id.value = raw.Id || "";
        this.Url.value = raw.Url || "";
        this.Title.value = raw.Title || "";
        this.Subtitle.value = raw.Subtitle || "";
        this.Image.value = raw.Image || "";
        this.Description.value = raw.Description || "";
        this.Visible.value = raw.Visible ?? true;
        this.RelatedArticles.Load(...raw.RelatedArticles || []);
    }
    static NotFound() {
        return new $39a2fd1d77a5883f$export$81fb35662c98d436({
            Id: "",
            Title: "(brak kategorii)"
        });
    }
}




var $2s69t = parcelRequire("2s69t");
class $e8b5a7f4c6d79c24$export$4d0262465775ab3 {
    // For example 1.25 for 25% more expensive
    constructor(raw){
        this.Url = new (0, $2s69t.RefString)();
        // This is also an ID
        this.Label = new (0, $2s69t.RefString)();
        this.Description = new (0, $2s69t.RefString)();
        this.PriceFactor = new (0, $2s69t.RefNumber)();
        this.Url.value = raw?.Url || "";
        this.Label.value = raw?.Label || "";
        this.Description.value = raw?.Description || "";
        this.PriceFactor.value = raw?.PriceFactor || 1;
    }
    // public GetPriceFactorText(): string
    // {
    //     if (this.PriceFactor.value == 1)
    //         return "";
    //     return `${this.PriceFactor.value > 1 ? "+" : ""}${((this.PriceFactor.value * 100)-100)}% ceny`;
    // }
    static Default() {
        return new $e8b5a7f4c6d79c24$export$4d0262465775ab3({
            Label: "Opcja domy\u015Blna",
            Url: "",
            Description: "",
            PriceFactor: 1
        });
    }
}



var $2s69t = parcelRequire("2s69t");

class $61fc43a213eb1809$export$93c4b472b8e61039 {
    constructor(){
        this.List = new (0, $2s69t.Collection)();
    }
    GetById(url) {
        return this.List.Items.find((x)=>x.Url.value == url) ?? (0, $e8b5a7f4c6d79c24$export$4d0262465775ab3).Default();
    }
    FactorAsLabel(url) {
        const option = this.List.Items.find((x)=>x.Url.value == url) ?? (0, $e8b5a7f4c6d79c24$export$4d0262465775ab3).Default();
        const factor = option.PriceFactor.value;
        if (factor == 1) return "";
        else if (factor > 1) return `(+${((factor - 1) * 100).toFixed(0)}% do ceny)`;
        else return `(${((1 - factor) * 100).toFixed(0)}% taniej)`;
    }
    GetPriceFactor(optionId) {
        return this.List.Items.find((x)=>x.Url.value == optionId)?.PriceFactor?.value ?? 1;
    }
}



var $2s69t = parcelRequire("2s69t");
var $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $568f4ee4022ba00e$var$getRandomValues;
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1d0137947e8554ce$var$byteToHex = [];
for(var $1d0137947e8554ce$var$i = 0; $1d0137947e8554ce$var$i < 256; ++$1d0137947e8554ce$var$i)$1d0137947e8554ce$var$byteToHex.push(($1d0137947e8554ce$var$i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    var uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


class $8ad605e7c4ec2669$export$3e41faf802a29e71 {
    constructor(raw){
        this.Id = new (0, $2s69t.RefString)();
        this.Icon = new (0, $2s69t.RefString)();
        this.Label = new (0, $2s69t.RefString)();
        this.IsVisible = new (0, $2s69t.RefBool)(true);
        this.Id.value = raw?.Id || (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
        this.Icon.value = raw?.Icon || "";
        this.Label.value = raw?.Label || "default";
        this.IsVisible.value = raw?.IsVisible || false;
    }
}


/**
 * Sprawdza, czy dwa zakresy dat nakładają się na siebie.
 * @param start1 Początek pierwszego zakresu
 * @param end1 Koniec pierwszego zakresu
 * @param start2 Początek drugiego zakresu
 * @param end2 Koniec drugiego zakresu
 * @returns true jeśli zakresy się nakładają, false w przeciwnym razie
 */ function $25e09eca18d467c2$export$fedca3e41e371773(start1, end1, start2, end2) {
    return start1 <= end2 && start2 <= end1;
}


var $c99eef43254dc902$export$5c538aa0d3be3a90;
(function(PriceFactorMode) {
    PriceFactorMode["Multiply"] = "multiply";
    PriceFactorMode["Constant"] = "constant";
})($c99eef43254dc902$export$5c538aa0d3be3a90 || ($c99eef43254dc902$export$5c538aa0d3be3a90 = {}));
class $c99eef43254dc902$export$60e1d7099065e3ef {
    constructor(raw){
        this.Start = new (0, $2s69t.RefDate)();
        this.End = new (0, $2s69t.RefDate)();
        this.Mode = new (0, $2s69t.Ref)("multiply");
        this.Value = new (0, $2s69t.RefNumber)(1);
        this.Info = new (0, $2s69t.RefString)("");
        this.Start.value = new Date(raw?.Start ?? 0);
        this.End.value = new Date(raw?.End ?? 0);
        this.Mode.value = raw?.Mode || "multiply";
        this.Value.value = raw?.Value || 1;
        this.Info.value = raw?.Info || "";
    }
}
class $c99eef43254dc902$export$264ad599d7cef668 {
    constructor(raw){
        this.Id = "";
        this.Visible = new (0, $2s69t.RefBool)();
        this.Rentable = new (0, $2s69t.RefBool)();
        this.Saleable = new (0, $2s69t.RefBool)();
        this.Basketable = new (0, $2s69t.RefBool)();
        this.Options = new (0, $61fc43a213eb1809$export$93c4b472b8e61039)();
        this.AddToBasketAs = new (0, $2s69t.Ref)((0, $e97714b723cebee9$export$39b11636c68d48ec).Unset);
        this.CategoryId = new (0, $2s69t.RefString)();
        this.Url = new (0, $2s69t.RefString)();
        this.Title = new (0, $2s69t.RefString)();
        this.Subtitle = new (0, $2s69t.RefString)();
        this.BasketName = new (0, $2s69t.RefString)();
        this.Tags = new (0, $2s69t.RefString)();
        this.RentPrices = new (0, $2s69t.Collection)();
        this.PriceFactor = new (0, $2s69t.Collection)();
        this.Discounts = new (0, $2s69t.Collection)();
        this.SalePrice = new (0, $2s69t.RefNumber)();
        this.Deposit = new (0, $2s69t.RefNumber)();
        this.Features = new (0, $2s69t.RefString)();
        this.Tabs = new (0, $2s69t.Collection)([
            new (0, $8ad605e7c4ec2669$export$3e41faf802a29e71)({
                Label: "Opis",
                Icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-presentation-icon lucide-presentation"><path d="M2 3h20"/><path d="M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3"/><path d="m7 21 5-5 5 5"/></svg>`
            }),
            new (0, $8ad605e7c4ec2669$export$3e41faf802a29e71)({
                Label: "Szczeg\u0142y",
                Icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-package-icon lucide-package"><path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"/><path d="M12 22V12"/><polyline points="3.29 7 12 12 20.71 7"/><path d="m7.5 4.27 9 5.15"/></svg>`
            }),
            new (0, $8ad605e7c4ec2669$export$3e41faf802a29e71)({
                Label: "FAQ i Opinie",
                Icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-microchip-icon lucide-microchip"><path d="M18 12h2"/><path d="M18 16h2"/><path d="M18 20h2"/><path d="M18 4h2"/><path d="M18 8h2"/><path d="M4 12h2"/><path d="M4 16h2"/><path d="M4 20h2"/><path d="M4 4h2"/><path d="M4 8h2"/><path d="M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1.5c-.276 0-.494.227-.562.495a2 2 0 0 1-3.876 0C9.994 2.227 9.776 2 9.5 2z"/></svg>`
            })
        ]);
        this.Description = new (0, $2s69t.Collection)();
        this.Images = new (0, $2s69t.Collection)();
        this.Opinions = new (0, $2s69t.Collection)();
        this.Extras = new (0, $2s69t.Collection)();
        // TODO:
        this.TutorialLink = new (0, $2s69t.RefString)();
        this.Category = (0, $39a2fd1d77a5883f$export$81fb35662c98d436).NotFound();
        this.IsAvailable = new (0, $2s69t.RefBool)(true);
        this.StatusLabel = new (0, $2s69t.RefString)("\uD83D\uDFE2 Produkt dost\u0119pny");
        this.StatusColor = new (0, $2s69t.RefString)("#4ade80");
        this.ShowDiscounts = new (0, $2s69t.RefBool)(true);
        this.ShowExtraInfo = new (0, $2s69t.RefBool)(true);
        this.Rating = new (0, $2s69t.RefNumber)(5);
        this.Id = raw?.Id || "";
        this.Visible.value = raw?.Visible ?? true;
        this.Rentable.value = raw?.Rentable ?? false;
        this.Saleable.value = raw?.Saleable ?? false;
        this.Basketable.value = raw?.Basketable ?? false;
        this.AddToBasketAs.value = raw?.AddToBasketAs || (0, $e97714b723cebee9$export$39b11636c68d48ec).Unset;
        this.Options.List.Load(...raw?.Options?.List?.map((x)=>new (0, $e8b5a7f4c6d79c24$export$4d0262465775ab3)(x)) || []);
        this.CategoryId.value = raw?.CategoryId || "";
        this.Url.value = raw?.Url || "";
        this.Title.value = raw?.Title || "";
        this.Subtitle.value = raw?.Subtitle || "";
        this.BasketName.value = raw?.BasketName || "";
        this.Tags.value = raw?.Tags || "";
        if (raw?.RentPrices) this.RentPrices.Load(...raw.RentPrices.map((x)=>new (0, $a8dfaf8f7f447cba$export$b972827e986d3b65)(x)));
        else this.RentPrices.Load(new (0, $a8dfaf8f7f447cba$export$b972827e986d3b65)({
            Days: 3,
            Visible: true
        }), new (0, $a8dfaf8f7f447cba$export$b972827e986d3b65)({
            Days: 7,
            Visible: true
        }), new (0, $a8dfaf8f7f447cba$export$b972827e986d3b65)({
            Days: 14,
            Visible: true
        }), new (0, $a8dfaf8f7f447cba$export$b972827e986d3b65)({
            Days: 30
        }), new (0, $a8dfaf8f7f447cba$export$b972827e986d3b65)({
            Days: 90
        }));
        if (raw?.PriceFactor) this.PriceFactor.Load(...raw.PriceFactor.map((x)=>new $c99eef43254dc902$export$60e1d7099065e3ef(x)));
        this.SalePrice.value = raw?.SalePrice || 0;
        this.Discounts.Load(...raw?.Discounts?.map((x)=>new (0, $f5599661752f7c8e$export$702c536c4b65a073)(x)) || []);
        this.Deposit.value = raw?.Deposit || 0;
        this.Features.value = raw?.Features || "";
        this.Tabs.Load(...raw?.Tabs?.map((x)=>new (0, $8ad605e7c4ec2669$export$3e41faf802a29e71)(x)) || []);
        this.Description.Load(...raw?.Description?.map((x)=>(0, $4dd618a9878588eb$export$f6d490d3b7c1d484).ToClass(x)) || []);
        this.Images.Load(...raw?.Images?.map((x)=>new (0, $b74f7a0e2f20ee26$export$48e30329ded2268e)(x)) || []);
        this.Opinions.Load(...raw?.Opinions?.map((x)=>new (0, $596f68690e85a4b5$export$9ad530ff9b116248)(x)) || []);
        this.TutorialLink.value = raw?.TutorialLink || "";
        this.StatusLabel.value = raw?.StatusLabel || "\uD83D\uDFE2 Produkt dost\u0119pny";
        this.StatusColor.value = raw?.StatusColor ?? $c99eef43254dc902$export$264ad599d7cef668.StatusColors["Zielony"];
        this.ShowDiscounts.value = raw?.ShowDiscounts ?? true;
        this.ShowExtraInfo.value = raw?.ShowExtraInfo ?? true;
        this.Rating.value = raw?.Rating || 5;
    }
    GetDatesFactor(Dates) {
        const priceFactor = this.PriceFactor.Items.find((x)=>(0, $25e09eca18d467c2$export$fedca3e41e371773)(x.Start.value, x.End.value, Dates.Start.value, Dates.End.value));
        return {
            mode: priceFactor?.Mode?.value ?? "multiply",
            value: priceFactor?.Value?.value ?? 1,
            info: priceFactor?.Info?.value ?? ""
        };
    }
    GetPriceAsText() {
        const visibleRentPrices = this.RentPrices.Items.filter((x)=>x.Visible.value);
        if (this.Rentable.value) {
            const rent = visibleRentPrices.find((x)=>x.Days.value == 3) || visibleRentPrices.find((x)=>x.Days.value == 7);
            if (!rent) return "brak cennika";
            else {
                const price = Math.round(rent.Value.value / rent.Days.value);
                return `ju\u{17C} od ${price}z\u{142} za dzie\u{144}`;
            }
        } else if (this.Saleable.value && this.SalePrice.value <= 0) return `brak ceny`;
        else if (this.Saleable.value) return `ju\u{17C} od ${this.SalePrice.value}z\u{142}`;
        else if (this.Basketable.value) return `ju\u{17C} od ${this.SalePrice.value}z\u{142}`;
        else if (!this.IsAvailable.value) return "Niedost\u0119pny";
        return "";
    }
    GetPrice() {
        if (!this.IsAvailable.value) return Infinity; // THIS IS A HACK FOR 'LOOKING FOR THE LOWEST PRICE IN CATEGORY' LOGIC
        const visibleRentPrices = this.RentPrices.Items.filter((x)=>x.Visible.value);
        if (this.Rentable.value) {
            const rent = visibleRentPrices.find((x)=>x.Days.value == 3) || visibleRentPrices.find((x)=>x.Days.value == 7);
            if (!rent) return Infinity;
            else {
                const price = Math.round(rent.Value.value / rent.Days.value);
                return price;
            }
        } else if (this.Saleable.value && this.SalePrice.value <= 0) return Infinity;
        else if (this.Saleable.value) return this.SalePrice.value;
        else if (this.Basketable.value) return this.SalePrice.value;
        return Infinity;
    }
}
// per 5
$c99eef43254dc902$export$264ad599d7cef668.StatusColors = {
    "Zielony": "#4ade80",
    "Czerwony": "#ef4444",
    "\u017B\xf3\u0142ty": "#eab308",
    "Niebieski": "#3b82f6",
    "Pomara\u0144czowy": "#fb923c",
    "Szary": "#6b7280",
    "Bia\u0142y": "#f3f4f6",
    "Czarny": "#000000"
};


class $37e8e6382e4ad93b$export$737682be82cc7f5e {
    static Calc(prices, totalDays) {
        if (prices.length === 0) return 0;
        if (totalDays > 90) throw new Error(`Max range is 90 days`);
        let range = 0;
        if (totalDays <= prices[0].days) return prices[0].price;
        prices.unshift({
            price: prices[0].price,
            days: 0
        }); // hack to simplify logic
        for(let i = 0; i < prices.length - 1; i++)if (prices[i].days <= totalDays && totalDays <= prices[i + 1].days) {
            range = i;
            const rangeSize = prices[range + 1].days - prices[range].days;
            const pricePerDayInRange = (prices[range + 1].price - prices[range].price) / rangeSize;
            const dayInRange = totalDays - prices[range].days;
            return Math.round(prices[range].price + dayInRange * pricePerDayInRange);
        }
        if (range >= prices.length - 1) range = prices.length;
        return prices[range].price;
    }
}


class $175cbb71857d1a52$export$96f5d1d5ca192c69 {
    static Calc(discounts, quantity) {
        // Szuka zniżki na podstawie ilości
        const applicableDiscount = discounts.filter((discount)=>quantity >= discount.quantity) // Filtrujemy zniżki, które mają ilość mniejszą lub równą zamówieniu
        .sort((a, b)=>b.quantity - a.quantity) // Sortujemy zniżki malejąco wg ilości
        .shift(); // Wybieramy największą ilość, która pasuje
        // Jeśli nie ma pasującej zniżki, zwrócimy 1 (brak zniżki)
        if (!applicableDiscount) return {
            discountMultiplier: 1,
            discountPercent: 0
        };
        // Zwróć wartość jako mnożnik, czyli 1 - (znizka / 100)
        const discountMultiplier = 1 - applicableDiscount.discountPercent / 100;
        return {
            discountMultiplier: discountMultiplier,
            discountPercent: applicableDiscount.discountPercent
        };
    }
}



var $2s69t = parcelRequire("2s69t");

class $b736f03a343573d9$export$94f2c38ab8f7f86f {
    OnChange(handler) {
        this.onChangeHandlers.Add(handler);
    }
    // Input:
    constructor(type, product, productOptionId, quantity, discount){
        this.onChangeHandlers = new (0, $2s69t.HandlersCollection)();
        this.Type = void 0;
        this.Product = void 0;
        this.ProductOptionId = void 0;
        this.Quantity = void 0;
        this.Discounter = void 0;
        // Output:
        this.FinalPriceBeforeDiscount = new (0, $2s69t.RefNumber)();
        this.FinalPriceAfterDiscount = new (0, $2s69t.RefNumber)();
        this.Label = new (0, $2s69t.RefString)();
        // Np. "Wypożyczenie na 4 dni" lub "Zakup"
        this.QuantityDiscountPercent = new (0, $2s69t.RefNumber)();
        this.ExtraInfo = new (0, $2s69t.RefString)();
        this.Type = type;
        this.Product = product;
        this.ProductOptionId = productOptionId;
        this.Quantity = quantity;
        this.Discounter = discount;
        if (!this.Product) this.Product = new (0, $c99eef43254dc902$export$264ad599d7cef668)();
        productOptionId.OnChange((optionId)=>this.UpdateOnInputChange());
        quantity.OnChange((quantity)=>this.UpdateOnInputChange());
        discount.OnChange(()=>this.UpdateOnInputChange());
    }
    GetOptionNameById(id) {
        if (!this.Product) return "";
        return this.Product.Options.List.Items.find((x)=>x.Url.value == id)?.Label.value || "";
    }
}



var $2s69t = parcelRequire("2s69t");


class $93d220080a99fbe4$export$865a56617b7eaf36 extends (0, $b736f03a343573d9$export$94f2c38ab8f7f86f) {
    constructor(basket, Product, ProductOptionId, Quantity, Dates){
        super((0, $e97714b723cebee9$export$39b11636c68d48ec).Rent, Product, ProductOptionId, Quantity, basket.Discounter);
        this.basket = basket;
        this.Product = Product;
        this.ProductOptionId = ProductOptionId;
        this.Quantity = Quantity;
        this.Dates = Dates;
        this.FinalDeposit = new (0, $2s69t.RefNumber)();
        this.Dates.OnChange((start, end, days)=>this.UpdateOnInputChange());
        this.UpdateOnInputChange();
    }
    UpdateOnInputChange() {
        if (!this.Product) return;
        const rentStart = this.Dates.Start.value;
        const quantity = this.Quantity.value;
        const rentDays = this.Dates.DaysCount.value;
        const rentPrices = this.Product.RentPrices.Items.map((x)=>({
                price: x.Value.value,
                days: x.Days.value
            }));
        const quantityDiscounts = this.Product.Discounts.Items.map((x)=>({
                quantity: x.Quantity.value,
                discountPercent: x.Percent.value
            }));
        const optionFactor = this.Product.Options.GetPriceFactor(this.ProductOptionId.value);
        const generalFactor = this.basket.Config.GeneralPriceFactor.value;
        const rentPrice = (0, $37e8e6382e4ad93b$export$737682be82cc7f5e).Calc(rentPrices, rentDays);
        const { discountMultiplier: discountMultiplier, discountPercent: discountPercent } = (0, $175cbb71857d1a52$export$96f5d1d5ca192c69).Calc(quantityDiscounts, quantity);
        const datesFactor = this.Product.PriceFactor.Items.find((x)=>(0, $25e09eca18d467c2$export$fedca3e41e371773)(x.Start.value, x.End.value, this.Dates.Start.value, this.Dates.End.value));
        const mode = datesFactor?.Mode?.value;
        if (mode == (0, $c99eef43254dc902$export$5c538aa0d3be3a90).Multiply) {
            const extraFactor = datesFactor?.Value?.value ?? 1;
            this.FinalPriceBeforeDiscount.value = +(quantity * rentPrice * optionFactor * generalFactor * extraFactor).toFixed(0);
        } else if (mode == (0, $c99eef43254dc902$export$5c538aa0d3be3a90).Constant) {
            const extraValue = datesFactor?.Value?.value ?? 0;
            this.FinalPriceBeforeDiscount.value = +(quantity * rentPrice * optionFactor * generalFactor + extraValue * quantity).toFixed(0);
        } else this.FinalPriceBeforeDiscount.value = +(quantity * rentPrice * optionFactor * generalFactor).toFixed(0);
        const info = datesFactor?.Info?.value ?? "";
        this.ExtraInfo.value = info.replace("{value}", datesFactor?.Value?.value?.toString() ?? "").replace("{start}", (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(datesFactor?.Start?.value).format("DD.MM.YYYY")).replace("{end}", (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(datesFactor?.End?.value).format("DD.MM.YYYY"));
        // const otherDiscountsPercent = this.Discounter.GetTotalPercent();
        // const otherDiscountsMultiplier = 1 - otherDiscountsPercent / 100;
        const otherDiscountsValue = this.Discounter.GetTotalValue(this.FinalPriceBeforeDiscount.value);
        // this.FinalPriceAfterDiscount.value = +(this.FinalPriceBeforeDiscount.value * discountMultiplier * otherDiscountsMultiplier).toFixed(0);
        this.FinalPriceAfterDiscount.value = +(this.FinalPriceBeforeDiscount.value * discountMultiplier - otherDiscountsValue).toFixed(0);
        this.Label.value = `Wypo\u{17C}yczenie na ${rentDays} ${rentDays === 1 ? "dzie\u0144" : "dni"} od ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(rentStart).format("DD.MM.YYYY")}`;
        this.FinalDeposit.value = quantity * this.Product.Deposit.value;
        this.QuantityDiscountPercent.value = discountPercent;
        this.onChangeHandlers.Call();
    }
    AsRaw() {
        if (!this.Product) return undefined;
        return {
            Type: (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent,
            ProductId: this.Product.Id,
            ProductOptionId: this.ProductOptionId.value,
            Quantity: this.Quantity.value,
            RentTime: {
                Start: this.Dates.Start.value,
                End: this.Dates.End.value
            }
        };
    }
}



var $2s69t = parcelRequire("2s69t");
class $83f6380b8602dbed$export$d2c0e45f54d39879 extends (0, $2s69t.Button) {
    constructor(onClick){
        super("Dodaj do koszyka", onClick);
        this.Class("product__button product__button--compact").Attribute("data-testid", "add-to-basket-btn");
    }
}




var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");


var $45fvw = parcelRequire("45fvw");
class $d0b07484f9c84654$export$94ec0042f7fce2b6 extends (0, $1614c8db74c4885c$export$e71c4d32a2263218) {
    constructor(date, dataTestId){
        const input = new (0, $2s69t.DateInput)(date).Class("product__rental-date-input").Attribute("min", new Date().toISOString().split("T")[0]).Attribute("data-testid", dataTestId);
        super("product__rental-date-field", [
            input,
            new (0, $2s69t.Button)("-", ()=>{}).Class("quantity-control__button").PositionAbsolute().Top(0.5, "rem").Left(0.5, "rem").OnClick(()=>date.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date.value).subtract(1, "day").toDate()),
            new (0, $2s69t.Button)("+", ()=>{}).Class("quantity-control__button").PositionAbsolute().Top(0.5, "rem").Right(0.5, "rem").OnClick(()=>date.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date.value).add(1, "day").toDate())
        ]);
        this.Width(190);
    }
}



var $1lG8E = parcelRequire("1lG8E");

var $2s69t = parcelRequire("2s69t");

class $6e8bb3a04a8994de$export$50f691d6023b2894 extends (0, $1614c8db74c4885c$export$e71c4d32a2263218) {
    constructor(quantity, dataTestId){
        super("quantity-control", [
            new (0, $2s69t.Button)("-", ()=>{
                if (quantity.value > 1) quantity.value--;
            }).Class("quantity-control__button").Attribute("data-testid", dataTestId + "-decrement"),
            new (0, $2s69t.Text)(quantity).Class("quantity-control__value--number").Attribute("data-testid", dataTestId + "-value"),
            new (0, $2s69t.Button)("+", ()=>quantity.value++).Class("quantity-control__button").Attribute("data-testid", dataTestId + "-increment")
        ]);
    }
}


class $b107c960523904a5$export$a3dbefa18c477e74 extends (0, $1lG8E.Table) {
    constructor(datesRange, quantity){
        super([], [
            [
                new (0, $2s69t.Label)("Od").Class("product__form-label"),
                new (0, $d0b07484f9c84654$export$94ec0042f7fce2b6)(datesRange.Start, "start-date-input")
            ],
            [
                new (0, $2s69t.Label)("Do").Class("product__form-label"),
                new (0, $d0b07484f9c84654$export$94ec0042f7fce2b6)(datesRange.End, "end-date-input")
            ],
            [
                new (0, $2s69t.Label)("Ilo\u015B\u0107").Class("product__form-label"),
                new (0, $6e8bb3a04a8994de$export$50f691d6023b2894)(quantity, "quantity-input")
            ]
        ]);
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $907a3a1832e6dd3c$export$8f7b277131efb6a extends (0, $2s69t.Div) {
    constructor(discounter){
        super("");
        const userInput = new (0, $2s69t.TextInput)().Class("product__discount-code").Placeholder("Dodatkowy kod rabatowy");
        const label = new (0, $2s69t.RefString)("");
        let discount = null;
        userInput.OnChange((code)=>{
            label.value = "Szukam...";
            discount = discounter.FindByCode(code);
            if (discount) {
                discount.IsOn.value = true;
                discounter.AddDiscount(discount);
                label.value = "\u2705 kod poprawny";
            } else label.value = "\u2716\uFE0F kod niepoprawny";
        });
        this.Append(userInput, new (0, $2s69t.Text)(label).MarginLeft(8));
    }
}



var $2s69t = parcelRequire("2s69t");

class $691b7a13e117f7cf$export$cc0d7e8bb6a1cb3e extends (0, $2s69t.Label) {
    constructor(cost, price){
        super([
            new (0, $2s69t.Checkbox)(cost.IsOn).Class("product__discount-checkbox").Attribute("data-testid", "discount-checkbox-" + cost.Code.value),
            new (0, $2s69t.Text)(price, (v)=>cost.AsString(+v)),
            new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>`).Class("product__discount-info")
        ]);
        this.Class("product__discount");
        if (cost.Description.value) this.Attribute("title", cost.Description.value);
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");


class $141c79e3e63e3129$export$73af2d5a9cf80194 extends (0, $2s69t.ComponentBase) {
    constructor(title){
        super(`h3`);
        this.Class("accordion__header");
        this.Html(`<button type="button" aria-controls="radix-:r19:" aria-expanded="true" data-state="open" data-orientation="vertical" id="radix-:r17:" class="accordion__trigger product-accordion__trigger" data-radix-collection-item=""><div class="product-accordion__row">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-percent-square product-accordion__icon text-rose-400"><rect width="18" height="18" x="3" y="3" rx="2"></rect><path d="m15 9-6 6"></path><path d="M9 9h.01"></path><path d="M15 15h.01"></path></svg><span class="product-accordion__title">${title}</span></div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down accordion__icon"><path d="m6 9 6 6 6-6"></path></svg>
        </button>`);
    }
}
class $141c79e3e63e3129$export$b9675c0bae9f505a extends (0, $2s69t.Div) {
    constructor(title){
        super(`h3`);
        this.Class("accordion__header");
        const isOpen = new (0, $2s69t.RefBool)(false);
        this.OnClick(()=>isOpen.Toggle());
        this.Append(new (0, $2s69t.Button)("").Class("accordion__trigger product-accordion__trigger").Append(new (0, $2s69t.Div)().Class("product-accordion__row").Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).PercentSquare), new (0, $2s69t.Span)(title).Class("product-accordion__title")), new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).ChevronDown).Visible(isOpen), new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).ChevronUp).VisibleWhen(isOpen, (v)=>!v)));
    }
}



var $2s69t = parcelRequire("2s69t");
class $4c7f5669c1fc9a62$export$985b9a77379b54a0 extends (0, $2s69t.Div) {
    constructor(content){
        super("accordion__content");
        this.Append(new (0, $2s69t.Div)("accordion__content-inner product-accordion__content").Append(...content));
    }
}


class $b9252f58c4adff75$export$a766cd26d0d69044 extends (0, $2s69t.Div) {
    constructor(title, content, testId){
        super();
        this.Class("accordion__item product-accordion__item");
        const showContent = new (0, $2s69t.RefBool)(false).Storable(`accordion-${title}`);
        const btn = new (0, $141c79e3e63e3129$export$b9675c0bae9f505a)(title).Attribute("data-testid", testId).OnClick(()=>showContent.Toggle());
        const cnt = new (0, $4c7f5669c1fc9a62$export$985b9a77379b54a0)(content).Visible(showContent, "flex");
        this.Append(btn, cnt);
    }
}


class $611594d53b375bda$export$1e9a924d4716f24c extends (0, $b9252f58c4adff75$export$a766cd26d0d69044) {
    constructor(_basket, price){
        super("Rabaty", [
            new (0, $2s69t.CollectionPrinter)(_basket.Discounter.Discounts, (discount)=>new (0, $691b7a13e117f7cf$export$cc0d7e8bb6a1cb3e)(discount, price)).Class("product__discounts"),
            new (0, $907a3a1832e6dd3c$export$8f7b277131efb6a)(_basket.Discounter).MarginTop(4)
        ], "open-discounts-accordion-btn");
    }
}
class $611594d53b375bda$export$1d04e4fe1442203d extends (0, $b9252f58c4adff75$export$a766cd26d0d69044) {
    constructor(_basket, price){
        super("Op\u0142aty dodatkowe", [
            new (0, $2s69t.CollectionPrinter)(_basket.Discounter.Extras, (extra)=>new (0, $691b7a13e117f7cf$export$cc0d7e8bb6a1cb3e)(extra, price)).Class("product__discounts")
        ]);
    }
}



var $2s69t = parcelRequire("2s69t");

class $5689d05d2e7854a7$export$9a9c690a81d8e533 extends (0, $1614c8db74c4885c$export$e71c4d32a2263218) {
    constructor(item){
        super("product__summary", [
            new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__summary-main product__summary-main--vertical", [
                new (0, $2s69t.Text)(item.ExtraInfo).Style(`border-left: 8px solid #c3185a; padding: 8px; white-space: normal; margin-bottom: 16px; border-radius: 0; color: #eaeaea`).VisibleWhen(item.ExtraInfo, (v)=>v.length > 0, "inline"),
                new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__summary-row", [
                    new (0, $2s69t.Text)(item.FinalPriceBeforeDiscount, (v)=>v + "z\u0142").Class("product__summary-price-original").Attribute("data-testid", "final-price-before-discount-value").VisibleWhen(item.FinalPriceAfterDiscount, (v)=>v != item.FinalPriceBeforeDiscount.value, "flex")
                ]),
                new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__summary-row", [
                    new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__summary-price", [
                        new (0, $2s69t.Text)(item.FinalPriceAfterDiscount).Attribute("data-testid", "final-price-after-discount-value"),
                        " z\u0142 za ",
                        new (0, $2s69t.Text)(item.Dates.DaysCount).Attribute("data-testid", "days-count-value"),
                        " ",
                        new (0, $2s69t.Text)(item.Dates.DaysCount, (v)=>v === 1 ? "dzie\u0144" : "dni")
                    ])
                ]),
                new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__summary-row product__summary-row--deposit", [
                    new (0, $2s69t.Text)(item.FinalDeposit, (v)=>"+ " + v + " z\u0142 kaucji zwrotnej").Attribute("data-testid", "final-deposit-value")
                ])
            ]).PaddingTop(0).MarginTop(0).BorderRadius(0)
        ]);
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

class $2ea0c1e897d25bae$export$3be1b3e65dfde8c8 extends (0, $4cabb9c17fd0d780$export$e17b9c1182212c96) {
    constructor(){
        super(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-cart navbar__icon"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg>`);
    }
}




class $7269e6995a56846d$export$cae179f078f4b4a4 extends (0, $4cabb9c17fd0d780$export$e17b9c1182212c96) {
    constructor(){
        super((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Close);
    }
}


class $62f3957fddb3ee4d$export$c2d62a3ae7d27f57 extends (0, $2s69t.Snack) {
    constructor(item, title){
        super(new (0, $2s69t.Div)("cart-notification").Style("will-change: transform, opacity; opacity: 1; transform: none;").Append(new (0, $2s69t.Div)("cart-notification__header").Append(new (0, $2s69t.Div)("cart-notification__header-content").Append(new (0, $2ea0c1e897d25bae$export$3be1b3e65dfde8c8)(), new (0, $2s69t.Span)(title).Class("cart-notification__header-title")), new (0, $2s69t.Button)("").Class("cart-notification__close").Append(new (0, $7269e6995a56846d$export$cae179f078f4b4a4)()).OnClick(()=>this.Close())), new (0, $2s69t.Div)("cart-notification__body").Append(new (0, $2s69t.Div)("cart-notification__item-name").Text(item.Product?.BasketName.value || ""), new (0, $2s69t.Div)("cart-notification__item-details").Append(new (0, $2s69t.Div)().Text(item.Label.value), new (0, $2s69t.Div)("cart-notification__item-price").Text(`Cena: ${item.FinalPriceAfterDiscount.value} z\u{142}`)))), "", {
            clickAnywhereToClose: true,
            autoCloseTimeout: 3500
        });
    }
}


class $91c33df93849d568$export$1e8160141b52cfb3 extends (0, $2s69t.Div) {
    constructor(_basket){
        super();
        this._basket = _basket;
    }
    TryAddToBasket(item) {
        if (this._basket.IsAlreadyIn(item)) {
            this._basket.UpdateItem(item);
            new (0, $62f3957fddb3ee4d$export$c2d62a3ae7d27f57)(item, "Zaktualizowano koszyk");
        } else {
            this._basket.Add(item);
            new (0, $62f3957fddb3ee4d$export$c2d62a3ae7d27f57)(item, "Dodano do koszyka");
        }
    }
}



var $45fvw = parcelRequire("45fvw");
class $b8df51084fc3355b$export$d8c338b91cfa7c9c extends (0, $91c33df93849d568$export$1e8160141b52cfb3) {
    constructor(product, basket, productOptionId){
        super(basket);
        const quantityInBasket = basket.GetItemBy((0, $e97714b723cebee9$export$39b11636c68d48ec).Rent, product.Id)?.Quantity?.value || 1;
        const quantity = new (0, $2s69t.RefNumber)(quantityInBasket);
        const startDate = new (0, $2s69t.RefDate)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().add(1, "day").toDate()).Storable("rent-start-date");
        const endDate = new (0, $2s69t.RefDate)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().add(3, "day").toDate()).Storable("rent-end-date");
        const datesRange = new (0, $8d21273b49376a6d$export$8cb450ce50b94421)(startDate, endDate);
        const rentItem = new (0, $93d220080a99fbe4$export$865a56617b7eaf36)(basket, product, productOptionId, quantity, datesRange);
        this.Append(new (0, $b107c960523904a5$export$a3dbefa18c477e74)(datesRange, quantity), product.ShowDiscounts.value && new (0, $611594d53b375bda$export$1e9a924d4716f24c)(basket, rentItem.FinalPriceBeforeDiscount), new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__form-row product__form-row--summary", [
            new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__summary-group", [
                new (0, $5689d05d2e7854a7$export$9a9c690a81d8e533)(rentItem)
            ])
        ]), new (0, $83f6380b8602dbed$export$d2c0e45f54d39879)(()=>this.TryAddToBasket(rentItem)));
    }
}



var $2s69t = parcelRequire("2s69t");




class $18c93729b54ca65e$export$ff28d6513ec20674 extends (0, $b736f03a343573d9$export$94f2c38ab8f7f86f) {
    constructor(basket, Product, ProductOptionId, Quantity){
        super((0, $e97714b723cebee9$export$39b11636c68d48ec).Sale, Product, ProductOptionId, Quantity, basket.Discounter);
        this.basket = basket;
        this.Product = Product;
        this.ProductOptionId = ProductOptionId;
        this.Quantity = Quantity;
        this.UpdateOnInputChange();
    }
    UpdateOnInputChange() {
        if (!this.Product) return;
        const quantity = this.Quantity.value;
        const salePrice = this.Product.SalePrice.value;
        const discounts = this.Product.Discounts.Items.map((x)=>({
                quantity: x.Quantity.value,
                discountPercent: x.Percent.value
            }));
        const { discountMultiplier: discountMultiplier, discountPercent: discountPercent } = (0, $175cbb71857d1a52$export$96f5d1d5ca192c69).Calc(discounts, quantity);
        const optionFactor = this.Product.Options.GetPriceFactor(this.ProductOptionId.value);
        const generalFactor = this.basket.Config.GeneralPriceFactor.value;
        this.FinalPriceBeforeDiscount.value = +(quantity * salePrice * optionFactor * generalFactor).toFixed(0);
        // const otherDiscountsPercent = this.Discounter.GetTotalPercent();
        // const otherDiscountsMultiplier = 1 - otherDiscountsPercent / 100;
        const otherDiscountsValue = this.Discounter.GetTotalValue(this.FinalPriceBeforeDiscount.value);
        // this.FinalPriceAfterDiscount.value = +(this.FinalPriceBeforeDiscount.value * discountMultiplier * otherDiscountsMultiplier).toFixed(0);
        this.FinalPriceAfterDiscount.value = +(this.FinalPriceBeforeDiscount.value * discountMultiplier - otherDiscountsValue).toFixed(0);
        this.Label.value = `Zakup`;
        this.QuantityDiscountPercent.value = discountPercent;
        this.onChangeHandlers.Call();
    }
    AsRaw() {
        if (!this.Product) return undefined;
        return {
            Type: (0, $e97714b723cebee9$export$39b11636c68d48ec).Sale,
            ProductId: this.Product.Id,
            ProductOptionId: this.ProductOptionId.value,
            Quantity: this.Quantity.value
        };
    }
}






var $2s69t = parcelRequire("2s69t");

class $82273493f6d80107$export$6b03d03de6783801 extends (0, $1614c8db74c4885c$export$e71c4d32a2263218) {
    constructor(item){
        super("product__summary", [
            new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__summary-main product__summary-main--vertical", [
                new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__summary-row", [
                    new (0, $2s69t.Text)(item.FinalPriceBeforeDiscount, (v)=>v + "z\u0142").Class("product__summary-price-original").Attribute("data-testid", "final-price-before-discount-value").VisibleWhen(item.FinalPriceAfterDiscount, (v)=>v != item.FinalPriceBeforeDiscount.value, "flex")
                ]),
                new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__summary-row", [
                    new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__summary-prices", [
                        new (0, $2s69t.Text)(item.FinalPriceAfterDiscount, (v)=>v + " z\u0142 brutto").Class("product__summary-price").Attribute("data-testid", "final-price-after-discount-value")
                    ])
                ])
            ])
        ]);
    }
}




var $1lG8E = parcelRequire("1lG8E");


class $263c62654fc05b21$export$154942db75f5e635 extends (0, $91c33df93849d568$export$1e8160141b52cfb3) {
    constructor(product, basket, productOptionId){
        super(basket);
        const quantityInBasket = basket.GetItemBy((0, $e97714b723cebee9$export$39b11636c68d48ec).Sale, product.Id)?.Quantity?.value || 1;
        const quantity = new (0, $2s69t.RefNumber)(quantityInBasket);
        const saleItem = new (0, $18c93729b54ca65e$export$ff28d6513ec20674)(basket, product, productOptionId, quantity);
        this.Append(new (0, $1lG8E.Table)([], [
            [
                new (0, $2s69t.Label)("Ilo\u015B\u0107").Class("product__form-label"),
                new (0, $6e8bb3a04a8994de$export$50f691d6023b2894)(quantity)
            ]
        ]), product.ShowDiscounts.value && new (0, $611594d53b375bda$export$1e9a924d4716f24c)(basket, saleItem.FinalPriceBeforeDiscount), new (0, $82273493f6d80107$export$6b03d03de6783801)(saleItem), new (0, $83f6380b8602dbed$export$d2c0e45f54d39879)(()=>this.TryAddToBasket(saleItem)));
    }
}
class $263c62654fc05b21$export$32c6a02824738bdc extends (0, $91c33df93849d568$export$1e8160141b52cfb3) {
    constructor(product, basket, productOptionId){
        super(basket);
        //
        // USŁUGA SERWISU MOŻE BYĆ TRAKTOWANA JAK WYNAJEM ALE BEZ KAUCJI
        // USŁUGA POMOCY MOŻE BYĆ TRAKTOWANA JAK SPRZEDAŻ
        //
        const quantity = new (0, $2s69t.RefNumber)(1);
        const datesRange = new (0, $8d21273b49376a6d$export$8cb450ce50b94421)(new (0, $2s69t.RefDate)(new Date(0)), new (0, $2s69t.RefDate)(new Date(new Date(0))));
        const rentItem = new (0, $93d220080a99fbe4$export$865a56617b7eaf36)(basket, product, productOptionId, quantity, datesRange);
        const saleItem = new (0, $18c93729b54ca65e$export$ff28d6513ec20674)(basket, product, productOptionId, quantity);
        this.Append(product.ShowDiscounts.value && new (0, $611594d53b375bda$export$1e9a924d4716f24c)(basket, rentItem.FinalPriceBeforeDiscount), new (0, $82273493f6d80107$export$6b03d03de6783801)(saleItem), new (0, $83f6380b8602dbed$export$d2c0e45f54d39879)(()=>this.TryAddToBasket(product.AddToBasketAs.Is((0, $e97714b723cebee9$export$39b11636c68d48ec).Service) ? rentItem : saleItem)));
    }
}


class $4c0dbb95c6f174f2$export$2caae2af034ec3ae extends (0, $1614c8db74c4885c$export$e71c4d32a2263218) {
    constructor(product, basket, productOptionId){
        const rentOrSale = new (0, $2s69t.Ref)((0, $e97714b723cebee9$export$39b11636c68d48ec).Rent).Storable("rentOrSale");
        const switcher = new (0, $2s69t.HidingContentSwitcher)(rentOrSale);
        if (product.Rentable.value) switcher.AddContent((0, $e97714b723cebee9$export$39b11636c68d48ec).Rent, ()=>new (0, $b8df51084fc3355b$export$d8c338b91cfa7c9c)(product, basket, productOptionId));
        if (product.Saleable.value) switcher.AddContent((0, $e97714b723cebee9$export$39b11636c68d48ec).Sale, ()=>new (0, $263c62654fc05b21$export$154942db75f5e635)(product, basket, productOptionId));
        super("panel-dark product__actions", [
            new (0, $6d42fa89da70e953$export$b371bec033580acf)(product, rentOrSale),
            switcher,
            !product.Rentable.value && !product.Saleable.value && new (0, $263c62654fc05b21$export$32c6a02824738bdc)(product, basket, productOptionId),
            product.ShowExtraInfo.value && new (0, $6ceb8ed68d0117cb$export$92a6cef5d25bfbe0)()
        ]);
        this.Class("product__form");
    }
}



var $2s69t = parcelRequire("2s69t");
class $cf8887dd1355fa55$export$57adb53c67af775f extends (0, $2s69t.Div) {
    constructor(product){
        super("product__status");
        const rating = product.Rating.Plus(1); // ex. 4.93 = 5 stars, not 4
        this.Append(new (0, $2s69t.Div)("product__status-availability").Append(new (0, $2s69t.Span)("product__status-text").Text(product.StatusLabel.value).Color(product.StatusColor.value)), new (0, $2s69t.Div)("product__status-rating-container").Append(new (0, $2s69t.Div)("product__status-rating").Append(new (0, $2s69t.Rate)(rating, {
            SelectedSymbol: "\u2B50",
            DeselectedSymbol: "\u2B50",
            Count: 5,
            Readonly: true,
            DeselectedStyle: "opacity: 0.3"
        }).Class("product__status-rating")), new (0, $2s69t.Div)("product__status-score").Append(new (0, $2s69t.Text)(product.Rating).Class("product__status-score-value"), new (0, $2s69t.Span)("product__status-score-max").Text("/ 5"))));
    }
}


class $be75d94dabef0070$export$d2548a5892ee5cff extends (0, $2s69t.Div) {
    constructor(product, basket, productOptionIdFromUrl){
        super("product");
        const productOption = new (0, $2s69t.Ref)(productOptionIdFromUrl || product.Options.List.Items[0]?.Url?.value || "");
        this.Append(new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__container", [
            new (0, $da353777c9526d49$export$54ea5188c2a6e856)(product),
            new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__content", [
                new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__left-column", [
                    new (0, $6d7758add37969e7$export$a8a3e93435678ff9)(product.Title, 1, "product__title"),
                    new (0, $c9ce8a136bb3392c$export$1a5c2628c1de5abc)(product),
                    new (0, $0e4d5dbf03b3bffd$export$ace63239d21d36e)(product.Images),
                    new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__info", [
                        new (0, $1ddb027c15b204fa$export$395fdea733a8631f)(product.Tabs, product.Description)
                    ])
                ]),
                new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__right-column", [
                    new (0, $1614c8db74c4885c$export$e71c4d32a2263218)("product__info-features", [
                        new (0, $cf8887dd1355fa55$export$57adb53c67af775f)(product),
                        product.Options.List.Count > 1 && new (0, $7769959ad737ae6c$export$c2ee54cc17aba4db)(product, productOption)
                    ]),
                    new (0, $4c0dbb95c6f174f2$export$2caae2af034ec3ae)(product, basket, productOption)
                ])
            ])
        ]));
    }
}





class $29e5eeb0f023c5ef$export$b49abe999dec25ce extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_shop, _basket, productUrl, optionIdFromUrl = ""){
        super("specTeam.pl - Produkt");
        this._shop = _shop;
        this._basket = _basket;
        this.productUrl = productUrl;
        this.optionIdFromUrl = optionIdFromUrl;
        this.Append(new (0, $73730ebfabef2c36$export$1b198b648cc5b0ce)(_shop));
        this.Content(async (body)=>{
            await this._shop.Load();
            // await this._basket.Load();
            const product = this._shop.ProductByUrl(this.productUrl);
            this.SetTitle(product?.Title);
            body.Append(this._shop.IsAuthorized && new (0, $29090c12eed7b0cf$export$70620985e9db1652)(`product/edit/${product.Url.value}`, "Edytuj produkt"), new (0, $be75d94dabef0070$export$d2548a5892ee5cff)(product, this._basket.Basket, this.optionIdFromUrl));
        });
    }
}



var $2s69t = parcelRequire("2s69t");


class $91836e83c36c5407$export$b8701f5a8d1f6e1b {
    static Normalize(url) {
        return url.toLowerCase().replaceAll(" ", "-").replaceAll("\u0105", "a").replaceAll("\u0119", "e").replaceAll("\u0107", "c").replaceAll("\u0142", "l").replaceAll("\u0144", "n").replaceAll("\xf3", "o").replaceAll("\u015B", "s").replaceAll("\u017A", "z").replaceAll("\u017C", "z");
    }
}


class $ef2d3d65e6dd5349$export$b64d8f09d31f118f extends (0, $2s69t.Div) {
    constructor(fields){
        super();
        this.Append(...fields.Items.filter((entry)=>entry.Visible.value).filter((entry)=>entry.Type === (0, $02db4fb745f57d51$export$ed12481c953b8653).TextWithPicture).map((entry)=>new (0, $a11f4f13271e2817$export$3c1286ea28c7fea5)(entry.Header.value, entry).Id((0, $91836e83c36c5407$export$b8701f5a8d1f6e1b).Normalize(entry.Header.value))));
    }
}



var $2s69t = parcelRequire("2s69t");

class $f55f0eea974c091e$export$d1e9526818fe77f4 extends (0, $2s69t.Div) {
    constructor(collection){
        super("product-info__tabs-scroll");
        this.Append(new (0, $2s69t.Div)("tabs__list product-info__tabs-list").Append(...collection.Items.filter((entry)=>entry.Visible.value).map((entry)=>{
            return new (0, $2s69t.Button)(entry.Header.value).Class("tabs__trigger product-info__tab-trigger").Style("white-space: nowrap;").OnClick(()=>{
                const id = (0, $91836e83c36c5407$export$b8701f5a8d1f6e1b).Normalize(entry.Header.value);
                const element = (0, $2s69t.$)("#" + id);
                if (element) element.scrollIntoView({
                    behavior: "smooth"
                });
            });
        })));
    }
}





class $b2471328be470b31$export$50f4e97f6a438a13 extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_shop){
        super("Wypo\u017Cyczalnia sprz\u0119tu detektywistycznego");
        this.Append(new (0, $73730ebfabef2c36$export$1b198b648cc5b0ce)(_shop));
        this.Content(async (body)=>{
            await _shop.Load();
            body.Append(_shop.IsAuthorized && new (0, $fff8cccdab1195b8$export$fd88fd0f00d26ab7)({
                "Edytuj stron\u0119": "page/edit"
            }), new (0, $f55f0eea974c091e$export$d1e9526818fe77f4)(_shop.Shop.RentalPageContent).MarginTopBottom(1.5, "rem").BorderRadius(0.5, "rem"), new (0, $ef2d3d65e6dd5349$export$b64d8f09d31f118f)(_shop.Shop.RentalPageContent));
        });
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");


class $988daec5f9f5ceb4$export$edd98d03726b2474 extends (0, $2s69t.Div) {
    constructor(svgIcon, title, text){
        super();
        this.Append(new (0, $2s69t.Div)("contact-info__item").Append(new (0, $2s69t.Div)("contact-info__icon").Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(svgIcon)), new (0, $2s69t.Div)("contact-info__content").Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)(title, 3), new (0, $2s69t.Link)(text).OpenInNewCard())));
    }
}








class $d5b706b524502b9c$export$27dfd9e9bbc44937 extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_shop){
        super("specTeam.pl - Kontakt");
        this.Append(new (0, $73730ebfabef2c36$export$1b198b648cc5b0ce)(_shop));
        this.Content(async (body)=>{
            body.PaddingLeft(8).PaddingRight(8).Append(new (0, $2s69t.Div)("contact").Append(new (0, $2s69t.Div)("contact__header").Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)("Skontaktuj si\u0119 z nami", 1, "contact__title"), new (0, $2s69t.Span)("Jeste\u015Bmy tutaj, aby Ci pom\xf3c").Italic()), new (0, $2s69t.Div)("contact__section").Append(new (0, $2s69t.Div)("contact-info").Append(new (0, $988daec5f9f5ceb4$export$edd98d03726b2474)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Phone, "Telefon", "+48 507 293 714"), new (0, $988daec5f9f5ceb4$export$edd98d03726b2474)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Mail, "E-mail", "specteam@specteam.pl"))), new (0, $2s69t.Div)("contact__section").Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)("Odbi\xf3r osobisty", 2, "contact__section-title"), new (0, $d08803de9f8654e5$export$7460c8b7e4ce9582)(`- Pragniemy zaznaczy\u{107} i\u{17C} **miejsce odbioru** jest **zale\u{17C}ne od dost\u{119}pno\u{15B}ci** danego przedmiotu w wybranym terminie!
- Po zam\xf3wienie mo\u{17C}na si\u{119} zg\u{142}osi\u{107} **dopiero po** jego **potwierdzeniu** w systemie zam\xf3wie\u{144},
                    
- Pojawienie si\u{119} na miejscu bez uprzednio potwierdzonego zam\xf3wienia skutkowa\u{107} b\u{119}dzie najpewniej *poca\u{142}owaniem klamki ;)*
                    
- Przed przyj\u{15B}ciem na spotkanie nale\u{17C}y zawsze wcze\u{15B}niej **um\xf3wi\u{107} si\u{119} telefonicznie**`).MarginBottom(16).DisplayBlock(), new (0, $2s69t.Div)("contact-info").MarginTop(32).Append(new (0, $988daec5f9f5ceb4$export$edd98d03726b2474)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Pin, "Warszawa Wola", "ul. Cz\u0142uchowska"), new (0, $988daec5f9f5ceb4$export$edd98d03726b2474)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Pin, "Warszawa S\u0142u\u017Cew", "ul. Mozarta"), new (0, $988daec5f9f5ceb4$export$edd98d03726b2474)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Pin, "Warszawa Bemowo", "ul. Syn\xf3w Pu\u0142ku"))), new (0, $2s69t.Div)("contact__section").Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)("Godziny pracy", 2, "contact__section-title"), new (0, $2s69t.Div)("hours").Append(new (0, $2s69t.Div)("hours__item").Append(new (0, $2s69t.Span)("Poniedzia\u0142ek - Pi\u0105tek"), new (0, $2s69t.Span)("10:00 - 18:00")), new (0, $2s69t.Div)("hours__item").Append(new (0, $2s69t.Span)("Sobota"), new (0, $2s69t.Span)("11:00 - 16:00")), new (0, $2s69t.Div)("hours__item hours__item--closed").Append(new (0, $2s69t.Span)("Niedziele i \u015Bwi\u0119ta"), new (0, $2s69t.Span)("W miar\u0119 potrzeb")))), new (0, $2s69t.Div)("contact__section").Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)("Komunikatory", 2, "contact__section-title"), new (0, $2s69t.Div)("messengers").Append(new (0, $988daec5f9f5ceb4$export$edd98d03726b2474)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Telegram, "Telegram", "507293714"), new (0, $988daec5f9f5ceb4$export$edd98d03726b2474)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Messenger, "Messenger", "facebook.com/specteamwypozyczalnia#"))), new (0, $2s69t.Div)("contact__section").Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)("Nasze social media", 2, "contact__section-title"), new (0, $2s69t.Div)("hours").Append(new (0, $2s69t.Div)("hours__item").Append(new (0, $2s69t.Div)().Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Facebook).Style("transform: translateY(6px);"), new (0, $2s69t.Span)("Facebook").MarginLeft(10)), new (0, $2s69t.Link)("https://facebook.com/specteamwypozyczalnia#").OpenInNewCard().Color("#aaa")), new (0, $2s69t.Div)("hours__item").Append(new (0, $2s69t.Div)().Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Instagram).Style("transform: translateY(6px);"), new (0, $2s69t.Span)("Instagram").MarginLeft(10)), new (0, $2s69t.Link)("https://www.instagram.com/specteam.pl/").OpenInNewCard().Color("#aaa")), new (0, $2s69t.Div)("hours__item").Append(new (0, $2s69t.Div)().Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Youtube).Style("transform: translateY(6px);"), new (0, $2s69t.Span)("Youtube").MarginLeft(10)), new (0, $2s69t.Link)("https://www.youtube.com/@specteam-pl").OpenInNewCard().Color("#aaa")))), new (0, $2s69t.Div)("contact__section").Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)("Zwroty", 2, "contact__section-title"), new (0, $2s69t.Div)("hours").Append(new (0, $2s69t.Div)("hours__item").Append(new (0, $2s69t.Span)("Inpost"), new (0, $2s69t.Span)(`Paczkomat WAW02H
Cz\u{142}uchowska 2A
01-100 Warszawa
specTeam
507-293-714
specteam@specteam.pl`)), new (0, $2s69t.Div)("hours__item").Append(new (0, $2s69t.Span)("Osobiste"), new (0, $2s69t.Span)(`Warszawa
Wola, Bemowo lub S\u{142}u\u{17C}ew - zale\u{17C}nie od dost\u{119}pno\u{15B}ci`))))));
        });
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $9c46704f4b215e0d$export$ae821caa125e0b14 extends (0, $2s69t.Div) {
    constructor(icon){
        super();
        this.Style(`display: inline-block; text-align: justify`);
        const svg = new (0, $2s69t.Div)().Html(icon.value).Width(32).DisplayInlineBlock().MarginLeft(12);
        icon.OnChange((v)=>svg.Html(v));
        this.Append(new (0, $2s69t.TextInput)(icon).Placeholder("SVG").Width(100).DisplayInlineBlock(), svg);
    }
}



var $2s69t = parcelRequire("2s69t");


class $934b709391c6fc20$export$456217d34aa2a0fc extends (0, $4cabb9c17fd0d780$export$e17b9c1182212c96) {
    constructor(svgAsText, onClick){
        super(svgAsText);
        this.Class("SvgButton");
        if (onClick) this.OnClick(onClick);
    }
}




var $2s69t = parcelRequire("2s69t");


class $efd93adb863870b8$export$933c143cd6f3ab66 extends (0, $934b709391c6fc20$export$456217d34aa2a0fc) {
    constructor(isFolded){
        const icon = new (0, $2s69t.Ref)(isFolded ? (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).ChevronUp : (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).ChevronDown);
        super(icon, ()=>isFolded.Toggle());
        isFolded.OnChange((v)=>icon.value = v ? (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).ChevronDown : (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).ChevronUp);
    }
}


class $5bec8a7602f95794$export$63a5581f40eaf4c2 extends (0, $2s69t.Div) {
    constructor(item, collection, titleContent){
        super("SwapableEntryEdit");
        this.foldBtnVisible = new (0, $2s69t.RefBool)();
        this.contentVisible = new (0, $2s69t.RefBool)();
        this.Content = new (0, $2s69t.Div)("");
        const entryControlSection = new (0, $2s69t.Div)() //.FloatRight()
        .Append(new (0, $efd93adb863870b8$export$933c143cd6f3ab66)(this.contentVisible).Visible(this.foldBtnVisible), collection.CanSwapUp(item) && new (0, $934b709391c6fc20$export$456217d34aa2a0fc)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).ArrowUp, ()=>collection.SwapUp(item)), collection.CanSwapDown(item) && new (0, $934b709391c6fc20$export$456217d34aa2a0fc)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).ArrowDown, ()=>collection.SwapDown(item)), new (0, $934b709391c6fc20$export$456217d34aa2a0fc)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).X, ()=>{
            if (confirm(`Usun\u{105}\u{107} te sekcje?`)) collection.Remove(item);
        }));
        this.Append(new (0, $2s69t.Div)("header").Append(titleContent && new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(...titleContent).OnClick(()=>this.contentVisible.Toggle()).Class("title"), entryControlSection), this.Content.Visible(this.contentVisible, "block"));
    }
    AddContent(...content) {
        this.Content.Append(...content);
        this.foldBtnVisible.value = this.Content.Children.Count > 0;
        return this;
    }
}



var $2s69t = parcelRequire("2s69t");
class $7727c235b6336caa$export$b534bc812df080fd extends (0, $2s69t.Div) {
    constructor(label, input){
        super("table-row");
        this.Append(new (0, $2s69t.Label)(label).Class("label-cell"), new (0, $2s69t.Div)().Append(input).Class("input-cell"));
    }
}
class $7727c235b6336caa$export$78d5a44323dda815 extends (0, $2s69t.Div) {
    constructor(rows){
        super("table-container");
        this.Append(...rows);
    }
}


class $8007b5f083de7735$export$87e08c64618fdbe0 extends (0, $5bec8a7602f95794$export$63a5581f40eaf4c2) {
    constructor(type, field, allFields, tabs, content = []){
        super(field, allFields, [
            new (0, $2s69t.Span)(type).Class("badge"),
            new (0, $2s69t.Text)(field.Header).MarginLeft(8)
        ]);
        this.AddContent(new (0, $7727c235b6336caa$export$78d5a44323dda815)([
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Widoczny na stronie", new (0, $2s69t.Checkbox)(field.Visible)),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Tab", new (0, $2s69t.Select)(field.Tab, tabs.Items.map((x)=>new (0, $2s69t.SelectOption)(x.Label.value, x.Id.value)))),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Ikona", new (0, $9c46704f4b215e0d$export$ae821caa125e0b14)(field.Icon)),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Tytu\u0142", new (0, $2s69t.TextInput)(field.Header).Placeholder("Tytu\u0142 sekcji")),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Widoczny tytu\u0142", new (0, $2s69t.Checkbox)(field.VisibleHeader)),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Dodatkowe stylowanie", new (0, $2s69t.TextInput)(field.Style).Placeholder("Styl elementu (CSS)"))
        ]), ...content);
    }
}


class $e750f25064e471a2$export$3e10f1206980ab22 extends (0, $8007b5f083de7735$export$87e08c64618fdbe0) {
    constructor(description, descriptions, tabs){
        super("Text", description, descriptions, tabs, [
            new (0, $2s69t.MultilineInput)(description.Text).Rows(8).TextAlignLeft().Padding(12).Placeholder("Czysty tekst")
        ]);
    }
}




var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

class $950fc3779b032b5b$export$37fdb62285484f9 extends (0, $5bec8a7602f95794$export$63a5581f40eaf4c2) {
    constructor(faq, faqs){
        super(faq, faqs);
        this.Append(new (0, $2s69t.TextInput)(faq.Question).Placeholder("Pytanie").WidthPercent(85), new (0, $2s69t.MultilineInput)(faq.Answer).Rows(3).Placeholder("Odpowied\u017A").WidthPercent(85).MarginTop(4));
    }
}





var $2s69t = parcelRequire("2s69t");
class $3cb9aba0dc8d12e9$export$8f661afcc1fc1840 extends (0, $2s69t.Div) {
    constructor(entries){
        super("add-field-box");
        this.Append(new (0, $2s69t.Span)("Dodaj: ").MarginRight(8), ...Object.entries(entries).map(([label, onClick])=>new (0, $2s69t.Link)(label).Style(`white-space: nowrap;`).OnClick(onClick)));
    }
}


class $542dabccf2b905a2$export$3a28f5ef39e1d629 extends (0, $8007b5f083de7735$export$87e08c64618fdbe0) {
    constructor(field, fields, tabs){
        super("FAQ", field, fields, tabs, [
            new (0, $2s69t.CollectionPrinter)(field.Questions, (x)=>new (0, $950fc3779b032b5b$export$37fdb62285484f9)(x, field.Questions)),
            new (0, $3cb9aba0dc8d12e9$export$8f661afcc1fc1840)({
                "\u2795 Q&A": ()=>field.Questions.Add(new (0, $1cc7232b5fe1e570$export$7562e752e5ef1fad)({
                        Question: "",
                        Answer: ""
                    }))
            })
        ]);
    }
}
class $542dabccf2b905a2$export$ce2a3f9829f800ae extends (0, $2s69t.Div) {
    constructor(fields){
        super();
        this.Append(new (0, $2s69t.CollectionPrinter)(fields, (x)=>new (0, $950fc3779b032b5b$export$37fdb62285484f9)(x, fields)), new (0, $3cb9aba0dc8d12e9$export$8f661afcc1fc1840)({
            "\u2795 Q&A": ()=>fields.Add(new (0, $1cc7232b5fe1e570$export$7562e752e5ef1fad)({
                    Question: "",
                    Answer: ""
                }))
        }));
    }
}




var $2s69t = parcelRequire("2s69t");



var $2s69t = parcelRequire("2s69t");
class $c6096eb82f4c4ef4$export$b59bdbef9ce70de2 extends (0, $2s69t.Div) {
    constructor(...components){
        super("row");
        this.Append(...components);
    }
}



class $7ccc7cb0f80551d0$export$18a9461578883ec4 extends (0, $8007b5f083de7735$export$87e08c64618fdbe0) {
    constructor(description, descriptions, tabs){
        super("Markdown", description, descriptions, tabs, [
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Tre\u015B\u0107", new (0, $c6096eb82f4c4ef4$export$b59bdbef9ce70de2)(new (0, $2s69t.MultilineInput)(description.Markdown).Rows(12).Placeholder("Tre\u015B\u0107 (jako Markdown)").Class("markdown-edit"), new (0, $d08803de9f8654e5$export$7460c8b7e4ce9582)(description.Markdown).Class("markdown-edit-preview")))
        ]);
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");


class $6950618a584e8d22$export$415b6ad9114b658b extends (0, $5bec8a7602f95794$export$63a5581f40eaf4c2) {
    constructor(row, rows){
        super(row, rows, [
            row.Left.value
        ]);
        this.AddContent(new (0, $c6096eb82f4c4ef4$export$b59bdbef9ce70de2)(new (0, $2s69t.MultilineInput)(row.Left).Placeholder("Lewa kolumna (markdown)"), new (0, $2s69t.MultilineInput)(row.Right).Placeholder("Prawa kolumna (markdown)")));
    }
}





var $2s69t = parcelRequire("2s69t");
class $d9e7e018ba2723f3$export$f861551692d63a2e extends (0, $2s69t.Button) {
    constructor(label, action){
        super(label, action);
        this.Class("button secondary");
    }
}


class $1dfcfef3a224c8f2$export$12371f542d3f68aa extends (0, $8007b5f083de7735$export$87e08c64618fdbe0) {
    constructor(field, fields, tabs){
        super("Tabela", field, fields, tabs, [
            new (0, $2s69t.CollectionPrinter)(field.Rows, (x)=>new (0, $6950618a584e8d22$export$415b6ad9114b658b)(x, field.Rows)),
            new (0, $d9e7e018ba2723f3$export$f861551692d63a2e)("\u2795 Dodaj wiersz").OnClick(()=>field.Rows.Add(new (0, $0a4cb42aecdf8db9$export$8b0036ef4f4ccb34)({
                    Left: "",
                    Right: ""
                })))
        ]);
    }
}



var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");



class $5e98481b0ad5cf66$export$6992e9b152509c51 extends (0, $5bec8a7602f95794$export$63a5581f40eaf4c2) {
    constructor(image, images){
        super(image, images, [
            new (0, $2s69t.Image)(image.ThumbnailUrl).MaxHeight(180).ObjectFit("cover")
        ]);
        this.AddContent(new (0, $7727c235b6336caa$export$78d5a44323dda815)([
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Znormalizowany obraz", new (0, $2s69t.TextInput)(image.NormalizedUrl).Placeholder("Znormalizowany obraz").WidthPercent(100)),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Miniatura", new (0, $2s69t.TextInput)(image.ThumbnailUrl).Placeholder("Miniatura").WidthPercent(100)),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Mikro", new (0, $2s69t.TextInput)(image.MiniUrl).Placeholder("Mikro").WidthPercent(100)),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Offset (x/y)", new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(new (0, $2s69t.NumberInput)(image.XOffset).Step(10).WidthPercent(50), new (0, $2s69t.NumberInput)(image.YOffset).Step(10).WidthPercent(49).MarginLeft(1, "%"))),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Opis", new (0, $2s69t.MultilineInput)(image.Description).Rows(2).Placeholder("Opis").WidthPercent(100))
        ]));
    }
}



var $2s69t = parcelRequire("2s69t");
class $00489b63301df19e$export$89c98a865287563c {
    constructor(IsSuccess = false, PicturesPacks = [], ErrorMessage = ""){
        this.IsSuccess = IsSuccess;
        this.PicturesPacks = PicturesPacks;
        this.ErrorMessage = ErrorMessage;
    }
    static Success(packs) {
        return new $00489b63301df19e$export$89c98a865287563c(true, packs, "");
    }
    static Failure(reason) {
        return new $00489b63301df19e$export$89c98a865287563c(false, [], reason);
    }
}


class $ec89dd71dd5d6a0f$export$5d991cdc62928edb {
    constructor(url){
        this.url = url;
    }
    async UploadManyFiles(files, dir = "") {
        try {
            if (!files) return (0, $00489b63301df19e$export$89c98a865287563c).Failure("No files provided");
            const formData = new FormData();
            for(let i = 0; i < files.length; i++)formData.append("files[]", files[i]); // Tak, te [] w nazwie zmiennej są konieczne! bez tego php (mimo że odbiera przez $_FILES["files"]) nie jest w stanie odebrać wielu plików xd
            formData.append("folder", dir.trim());
            const response = await fetch(this.url + "/multiupload", {
                method: "POST",
                body: formData
            });
            if (!response.ok) return (0, $00489b63301df19e$export$89c98a865287563c).Failure(`Request failed with status ${response.status}`);
            const filesNames = await response.json();
            return (0, $00489b63301df19e$export$89c98a865287563c).Success(filesNames);
        } catch (ex) {
            return (0, $00489b63301df19e$export$89c98a865287563c).Failure(`Can not upload: ${ex.message}`);
        }
    }
}



var $2s69t = parcelRequire("2s69t");

class $04739df90be3396b$export$14834abbfce3b8cd extends (0, $2s69t.Snack) {
    constructor(title, content, autoCloseTimeout = 3500){
        super(new (0, $2s69t.Div)("cart-notification").Style("will-change: transform, opacity; opacity: 1; transform: none;").Append(new (0, $2s69t.Div)("cart-notification__header").Append(new (0, $2s69t.Div)("cart-notification__header-content").Append(new (0, $2s69t.Span)(title).Class("cart-notification__header-title")), new (0, $2s69t.Button)("").Class("cart-notification__close").Append(new (0, $7269e6995a56846d$export$cae179f078f4b4a4)()).OnClick(()=>this.Close())), new (0, $2s69t.Div)("cart-notification__body").Append(new (0, $2s69t.Div)("cart-notification__item-details").Append(content && new (0, $2s69t.Div)().Text(content)))), "", {
            clickAnywhereToClose: true,
            autoCloseTimeout: autoCloseTimeout
        });
    }
}



class $e7c25e1e4636c45c$export$5262858c2300edc1 extends (0, $2s69t.Div) {
    constructor(onSuccessfulUpload){
        super("add-field-box");
        this.Append(new (0, $2s69t.Div)().Append(new (0, $2s69t.Span)("Dodaj wiele zdj\u0119\u0107").FloatLeft(), new (0, $2s69t.Link)("\u2716\uFE0F").FloatRight().CursorPointer().OnClick(()=>this.Hide()), new (0, $2s69t.Div)().ClearBoth()).Margin(8), new (0, $2s69t.MultipleFilesInput)(async (files)=>{
            new (0, $04739df90be3396b$export$14834abbfce3b8cd)(`\u{141}adowanie ${files.length} zdj\u{119}\u{107}`, "W toku...");
            const storage = new (0, $ec89dd71dd5d6a0f$export$5d991cdc62928edb)("https://photos.specteam.pl");
            const dir = "specteam";
            const uploadResult = await storage.UploadManyFiles(files, dir);
            new (0, $04739df90be3396b$export$14834abbfce3b8cd)(uploadResult.IsSuccess ? `\u{2705} Za\u{142}adowano ${uploadResult.PicturesPacks.length} zdj\u{119}\u{107}` : "\uD83D\uDD34 B\u0142\u0105d \u0142adowania", uploadResult.ErrorMessage);
            if (uploadResult.IsSuccess) onSuccessfulUpload?.(uploadResult.PicturesPacks);
        }));
    }
}
class $e7c25e1e4636c45c$export$e226901e54f8bcc extends (0, $2s69t.Div) {
    constructor(onSuccessfulUpload){
        super("entry");
        this.Append(new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(new (0, $2s69t.Span)("Dodaj zdj\u0119cie").FloatLeft(), new (0, $2s69t.Link)("\u2716\uFE0F").FloatRight().CursorPointer().OnClick(()=>this.Hide()), new (0, $2s69t.Div)().ClearBoth()).Margin(8), new (0, $2s69t.MultipleFilesInput)(async (files)=>{
            new (0, $04739df90be3396b$export$14834abbfce3b8cd)(`\u{141}adowanie zdj\u{119}cia`, "W toku...");
            const storage = new (0, $ec89dd71dd5d6a0f$export$5d991cdc62928edb)("https://photos.specteam.pl");
            const dir = "specteam";
            const uploadResult = await storage.UploadManyFiles(files, dir);
            new (0, $04739df90be3396b$export$14834abbfce3b8cd)(uploadResult.IsSuccess ? `\u{2705} Plik za\u{142}adowany` : "\uD83D\uDD34 Upload error", uploadResult.ErrorMessage);
            if (uploadResult.IsSuccess) onSuccessfulUpload?.(uploadResult.PicturesPacks[0]);
        }));
    }
}




var $2s69t = parcelRequire("2s69t");
class $514335b6e811f7d2$export$ac16a6a04d9b7c84 extends (0, $2s69t.Button) {
    constructor(label, action){
        super(label, action);
        this.Class("button primary2");
    }
}


class $eefa7505f4d3bee4$export$4c63e8615aac1b66 extends (0, $8007b5f083de7735$export$87e08c64618fdbe0) {
    constructor(field, fields, tabs){
        super("Galeria", field, fields, tabs, [
            new (0, $2s69t.CollectionPrinter)(field.Images, (x)=>new (0, $5e98481b0ad5cf66$export$6992e9b152509c51)(x, field.Images)),
            // new AddFieldBox({
            //     "➕ Obraz": () => field.Images.Add(new GalleryItem({})),
            //     "➕ Obrazy": () =>
            //         this.Append(
            //             new PicsUploader((images) =>
            //                 field.Images.Add(
            //                     ...images.map(x => new GalleryItem({ NormalizedUrl: x.Normalized, ThumbnailUrl: x.Thumbnail, MiniUrl: x.Mini }))))
            //         ),
            // }),
            new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("\u2795 Dodaj zdj\u0119cia").OnClick(()=>this.Append(new (0, $e7c25e1e4636c45c$export$5262858c2300edc1)((images)=>field.Images.Add(...images.map((x)=>new (0, $b74f7a0e2f20ee26$export$48e30329ded2268e)({
                            NormalizedUrl: x.Normalized,
                            ThumbnailUrl: x.Thumbnail,
                            MiniUrl: x.Mini
                        }))))))
        ]);
    }
}






var $2s69t = parcelRequire("2s69t");



var $2s69t = parcelRequire("2s69t");


class $a7ac15570d4e0ee0$export$3850266e6979aa8a extends (0, $5bec8a7602f95794$export$63a5581f40eaf4c2) {
    constructor(opinion, opinions){
        super(opinion, opinions);
        this.AddContent(new (0, $7727c235b6336caa$export$78d5a44323dda815)([
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Autor", new (0, $2s69t.TextInput)(opinion.Author).Placeholder("Autor").WidthPercent(40).FloatLeft()),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Ocena", new (0, $2s69t.Rate)(opinion.Rate, {
                SelectedSymbol: "\u2B50",
                DeselectedSymbol: "\u2B50",
                DeselectedStyle: "opacity: 0.4"
            }).FloatLeft()),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Komentarz", new (0, $2s69t.MultilineInput)(opinion.Comment).Rows(4).Placeholder("Komentarz")),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Zalety", new (0, $2s69t.TextInput)(opinion.Advantages).Placeholder("Zalety")),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Wady", new (0, $2s69t.TextInput)(opinion.Disadvantages).Placeholder("Wady"))
        ]));
    }
}



class $0826d49edfdd569a$export$5bab1b96c7edcbd5 extends (0, $8007b5f083de7735$export$87e08c64618fdbe0) {
    constructor(field, fields, tabs){
        super("Opinie", field, fields, tabs, [
            new (0, $2s69t.CollectionPrinter)(field.Opinions, (x)=>new (0, $a7ac15570d4e0ee0$export$3850266e6979aa8a)(x, field.Opinions)),
            new (0, $d9e7e018ba2723f3$export$f861551692d63a2e)("\u2795 Dodaj opini\u0119").OnClick(()=>field.Opinions.Add(new (0, $596f68690e85a4b5$export$9ad530ff9b116248)({
                    Author: "Anonim",
                    Rate: 5
                })))
        ]);
    }
}




var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");
class $1c5579cee988b0d0$export$3b92dabad355f5d4 extends (0, $2s69t.Button) {
    constructor(label, action){
        super(label, action);
        this.Class("button danger");
    }
}
class $1c5579cee988b0d0$export$b7c3a2f69225ecf extends (0, $2s69t.Button) {
    constructor(label, action){
        super(label, action);
        this.Class("button default");
    }
}



class $56ed97d50ee4c1b6$export$e07ccc7fa9d78a9b extends (0, $2s69t.Div) {
    constructor(imageUrl){
        super("");
        let deleted = "";
        this.Append(new (0, $2s69t.TextInput)(imageUrl).Placeholder("Url do miniaturki obrazka"), new (0, $2s69t.Image)(imageUrl).Height(220).Margin(8).DisplayInlineBlock(), new (0, $2s69t.Div)().Style("margin: 8px; display: flex; flex-direction: row; gap: 8px;").Append(new (0, $1c5579cee988b0d0$export$3b92dabad355f5d4)("Usu\u0144").OnClick((_)=>{
            if (deleted == "") {
                deleted = imageUrl.value;
                imageUrl.value = "";
                _.Label("Cofnij");
            } else {
                imageUrl.value = deleted;
                deleted = "";
                _.Label("Usu\u0144");
            }
        }), new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)(imageUrl.value ? "Zmie\u0144" : "Dodaj").OnClick((_)=>{
            _.RemoveSelf();
            this.Append(new (0, $e7c25e1e4636c45c$export$e226901e54f8bcc)((image)=>{
                if (image.Extension == "gif") imageUrl.value = image.Original;
                else imageUrl.value = image.Thumbnail;
            }).Width(320));
        })));
    }
}




class $c0eabf0319869950$export$a42cbc0189c00141 extends (0, $8007b5f083de7735$export$87e08c64618fdbe0) {
    constructor(description, descriptions, tabs){
        super("TextWithPicture", description, descriptions, tabs, [
            new (0, $7727c235b6336caa$export$78d5a44323dda815)([
                new (0, $7727c235b6336caa$export$b534bc812df080fd)("Tekst", new (0, $2s69t.MultilineInput)(description.Text).Rows(8).TextAlignLeft().Padding(12).Placeholder("Markdown")),
                new (0, $7727c235b6336caa$export$b534bc812df080fd)("Pozycja zdj\u0119cia", new (0, $2s69t.Radio)(description.PicturePosition, {
                    "Po lewej": "left",
                    "Po prawej": "right"
                }).Class("radio")),
                new (0, $7727c235b6336caa$export$b534bc812df080fd)("Zdj\u0119cie", new (0, $56ed97d50ee4c1b6$export$e07ccc7fa9d78a9b)(description.PictureUrl))
            ])
        ]);
    }
}



class $371dc6981361d493$export$aa74ad0b78023f22 extends (0, $2s69t.Div) {
    constructor(collection, tabs){
        super();
        if (!tabs) tabs = new (0, $2s69t.Collection)();
        const newOption = new (0, $2s69t.RefString)();
        const options = {
            "Markdown": ()=>new (0, $2975f5418488deab$export$5af8b454cf0a55a9)({
                    Header: "Markdown"
                }),
            "Tekst": ()=>new (0, $36a5bd63b771eae9$export$2c73285ae9390cec)({
                    Header: "Tekst"
                }),
            "Tekst z obrazkiem": ()=>new (0, $09e9cef90667330f$export$227a61a47ffe47e1)({
                    Header: "Tekst z obrazkiem"
                }),
            "Faq": ()=>new (0, $70b813bec008bd3a$export$a5b263448200bf07)({
                    Header: "Pytania i odpowiedzi"
                }),
            "Galeria": ()=>new (0, $a30b994e6b93646a$export$f2577b57255d41)({
                    Header: "Galeria"
                }),
            "Tabela": ()=>new (0, $ccdc452b7ba9ee56$export$5cefce85eae032bb)({
                    Header: "Tabela"
                }),
            "Opinie": ()=>new (0, $f6b05669fb6fd6d2$export$c5ef935f3c05dffb)({
                    Header: "Opinie"
                })
        };
        this.Append(new (0, $2s69t.CollectionPrinter)(collection, (x)=>new (0, $2s69t.Switch)(x.Type).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).Markdown, ()=>new (0, $7ccc7cb0f80551d0$export$18a9461578883ec4)(x, collection, tabs)).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).Faq, ()=>new (0, $542dabccf2b905a2$export$3a28f5ef39e1d629)(x, collection, tabs)).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).Text, ()=>new (0, $e750f25064e471a2$export$3e10f1206980ab22)(x, collection, tabs)).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).TextWithPicture, ()=>new (0, $c0eabf0319869950$export$a42cbc0189c00141)(x, collection, tabs)).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).Gallery, ()=>new (0, $eefa7505f4d3bee4$export$4c63e8615aac1b66)(x, collection, tabs)).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).Table, ()=>new (0, $1dfcfef3a224c8f2$export$12371f542d3f68aa)(x, collection, tabs)).Case((0, $02db4fb745f57d51$export$ed12481c953b8653).Opinion, ()=>new (0, $0826d49edfdd569a$export$5bab1b96c7edcbd5)(x, collection, tabs)).Default(()=>new (0, $2s69t.Span)(`Unknown description field type "${x.Type}"`)).Execute()), new (0, $2s69t.Select)(newOption, Object.keys(options)).AddDefaultOption("\u2795 Dodaj").OnChange((v)=>{
            collection.Add(options[v]());
            newOption.value = "";
        }));
    }
}


















var $2s69t = parcelRequire("2s69t");
class $5ec1d4ffb607575d$export$2ddb90ad54e5f587 extends (0, $2s69t.Div) {
    constructor(header, body){
        super("panel");
        const isOpen = new (0, $2s69t.RefBool)(true).Storable("panel:is-open:" + header);
        this.Append(new (0, $2s69t.Div)("panel-header-container").OnClick(()=>isOpen.Toggle()).Append(new (0, $2s69t.Div)("panel-header").Append(header), body.length > 0 && new (0, $2s69t.Text)(isOpen, (v)=>v ? "\u25BC" : "\u25B2").CursorPointer()), new (0, $2s69t.Div)("panel-body-container").Visible(isOpen, "block").Append(...body));
    }
}



var $2s69t = parcelRequire("2s69t");
class $f76a264d489fedad$export$94ed20bd54fffa3b extends (0, $2s69t.Div) {
    constructor(collection, item){
        super();
        this.Style("display: flex; align-items: center; gap: 12px;");
        this.Append(collection.CanSwapUp(item) && new (0, $2s69t.Link)("\u25B2").OnClick(()=>collection.SwapUp(item)), collection.CanSwapDown(item) && new (0, $2s69t.Link)("\u25BC").OnClick(()=>collection.SwapDown(item)), new (0, $2s69t.Link)("\xd7").FontSize(28).OnClick(()=>collection.Remove(item)));
    }
}



var $2s69t = parcelRequire("2s69t");
class $6ddd8e7afe3ec9f1$export$c95ba4b54e392981 {
    constructor(Header, Mapping){
        this.Header = Header;
        this.Mapping = Mapping;
    }
}


class $17906d3be6ee15d8$export$a7de6293698509b0 extends (0, $2s69t.Div) {
    constructor(data){
        super("better-table");
        this.dataView = void 0;
        this.columns = [];
        this.body = new (0, $2s69t.Div)("");
        this.whenEmpty = new (0, $2s69t.Span)("No results").Style("display: block; margin: 48px 0; text-align: center; white-space: nowrap;");
        if (data && data instanceof Array) this.dataView = new (0, $2s69t.CollectionView)(new (0, $2s69t.Collection)(data)).Refresh();
        else if (data && data instanceof (0, $2s69t.Collection)) this.dataView = new (0, $2s69t.CollectionView)(data).Refresh();
        else if (data && data instanceof (0, $2s69t.CollectionView)) this.dataView = data;
        this.dataView?.AddSubscriber(this);
    }
    Reset() {
        this.columns = [];
        this.Clear();
        return this;
    }
    WhenEmpty(component) {
        this.whenEmpty = component;
        return this;
    }
    Refresh() {
        this.body.Clear();
        if (this.dataView?.Items?.length === 0) this.Append(this.whenEmpty);
        else {
            this.Clear();
            this?.dataView?.Items?.forEach((record)=>{
                const row = new (0, $2s69t.Div)("row");
                this.columns.forEach((c)=>{
                    const cell = new (0, $2s69t.Div)("cell");
                    const elem = c.Mapping(record, cell, row, this);
                    let m;
                    if (!Array.isArray(elem)) m = [
                        elem
                    ];
                    else m = elem;
                    m.forEach((e)=>{
                        cell.Append(new (0, $2s69t.Div)("cell-label").Append(...c.Header), e);
                    });
                    row.Append(cell);
                });
                this.Append(row);
            });
        }
    }
    Build() {
        this.Append(new (0, $2s69t.Div)("row header").Append(...this.columns.map((x)=>new (0, $2s69t.Div)("cell").Append(...x.Header))));
        this.Refresh();
        this.Append(this.body);
        return this;
    }
    AddColumn(header, mapping) {
        if (!Array.isArray(header)) // TODO: extension .ToArray ?
        header = [
            header
        ];
        this.columns.push(new (0, $6ddd8e7afe3ec9f1$export$c95ba4b54e392981)(header, mapping));
        return this;
    }
}
$17906d3be6ee15d8$export$a7de6293698509b0.Name = "TableViewer";
$17906d3be6ee15d8$export$a7de6293698509b0.DefaultCssClasses = "uk-table uk-table-small uk-table-divider uk-table-middle";




var $2s69t = parcelRequire("2s69t");
class $492b9a62b577ce0f$export$2fe4f0576c8a371 extends (0, $2s69t.Div) {
    constructor(label, ...content){
        super("InputRow");
        this.Style(`background-color: #172436; padding: 8px; border-radius: 8px; margin: 8px;`);
        if (!Array.isArray(content)) content = [
            content
        ];
        const labelPlace = new (0, $2s69t.Div)("fixed-width").Text(label).FontSize(18);
        if (content[0] instanceof (0, $2s69t.TextInput) || content[0] instanceof (0, $2s69t.Select)) labelPlace.Padding(8);
        this.Append(labelPlace, new (0, $2s69t.Div)("flexible-width").Append(...content));
    }
}



var $2s69t = parcelRequire("2s69t");
class $17dc641d9b3418f6$export$32a0ad71237b9760 extends (0, $2s69t.Div) {
    constructor(...content){
        super("");
        this.Style("display: flex; flex-direction: column; justify-content: space-between; gap: 12px");
        this.Append(...content);
    }
}


class $34aaf9c7d95b2660$export$c1579167726b9a9c extends (0, $341ff3746ff11fcf$export$b25f57c16f88d7e0) {
    constructor(_shop, productUrl){
        super("Edycja produktu");
        this._shop = _shop;
        this.productUrl = productUrl;
        this.Content(async (body)=>{
            await this._shop.Load();
            const product = this.productUrl ? this._shop.ProductByUrl(this.productUrl) : new (0, $c99eef43254dc902$export$264ad599d7cef668)({
                Id: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)()
            });
            this.SetTitle(product.Title.value + " - edycja");
            const uploader = new (0, $e7c25e1e4636c45c$export$5262858c2300edc1)((images)=>product.Images.Add(...images.map((x)=>new (0, $b74f7a0e2f20ee26$export$48e30329ded2268e)({
                        NormalizedUrl: x.Normalized,
                        ThumbnailUrl: x.Thumbnail,
                        MiniUrl: x.Mini
                    })))).Hide();
            body.Append(new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("\u2139\uFE0F Meta", [
                new (0, $7727c235b6336caa$export$78d5a44323dda815)([
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Id", new (0, $2s69t.Span)(product.Id || "(brak id)")),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Widoczny na stronie", new (0, $2s69t.Checkbox)(product.Visible)),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Status", new (0, $2s69t.TextInput)(product.StatusLabel)),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Kolor statusu", new (0, $2s69t.Select)(product.StatusColor, (0, $c99eef43254dc902$export$264ad599d7cef668).StatusColors)),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Poka\u017C zni\u017Cki", new (0, $2s69t.Checkbox)(product.ShowDiscounts)),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Poka\u017C dodatkowe informacje", new (0, $2s69t.Checkbox)(product.ShowExtraInfo)),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Ocena", new (0, $2s69t.NumberInput)(product.Rating).Step(0.01)),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Do wypo\u017Cyczenia", new (0, $2s69t.Checkbox)(product.Rentable)),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Na sprzeda\u017C", new (0, $2s69t.Checkbox)(product.Saleable)),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Dodaj do koszyka", new (0, $2s69t.Div)().Append(new (0, $2s69t.Checkbox)(product.Basketable).WidthAuto(), " jako ", new (0, $2s69t.Select)(product.AddToBasketAs, (0, $e97714b723cebee9$export$39b11636c68d48ec)).WidthAuto())),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Kategoria produktu", new (0, $2s69t.Select)(product.CategoryId, this._shop.ProductCategoriesAsTitleIdObject)),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Tytu\u0142", new (0, $2s69t.TextInput)(product.Title).Placeholder("Nazwa widoczna")),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Podpis", new (0, $2s69t.TextInput)(product.Subtitle).Placeholder("Podpis pod nazw\u0105")),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Url", new (0, $2s69t.TextInput)(product.Url).Placeholder("Nazwa w url (bez spacji i polskich znak\xf3w!)")),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Nazwa w koszyku", new (0, $2s69t.TextInput)(product.BasketName).Placeholder("Nazwa w koszyku klienta")),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Tagi (oddzielone spacj\u0105)", new (0, $2s69t.TextInput)(product.Tags).Placeholder("Lista tag\xf3w po spacji")),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Ficzery (od nowej linii)", new (0, $2s69t.MultilineInput)(product.Features).Rows(8)),
                    new (0, $492b9a62b577ce0f$export$2fe4f0576c8a371)("Link do instrukcji", new (0, $2s69t.TextInput)(product.TutorialLink).Placeholder("Link do tutoriala"))
                ])
            ]), new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("\uD83C\uDF5F Opcje produktu", [
                new (0, $17906d3be6ee15d8$export$a7de6293698509b0)(product.Options.List).AddColumn("Url & Id", (x)=>new (0, $2s69t.TextInput)(x.Url)).AddColumn("Labelka", (x)=>new (0, $2s69t.TextInput)(x.Label)).AddColumn("Opis", (x)=>new (0, $2s69t.MultilineInput)(x.Description).Rows(4)).AddColumn("Faktor ceny", (x)=>new (0, $2s69t.NumberInput)(x.PriceFactor).Step(0.01).Width(80)).AddColumn("Opcje", (x)=>new (0, $f76a264d489fedad$export$94ed20bd54fffa3b)(product.Options.List, x)).Build(),
                new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("\u2795 Dodaj opcje produktu").OnClick(()=>product.Options.List.Add(new (0, $e8b5a7f4c6d79c24$export$4d0262465775ab3)({
                        Label: "Opcja A",
                        Url: "opcja-a",
                        PriceFactor: 1,
                        Description: "Opis opcji"
                    })))
            ]), new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("\uD83D\uDCB0 Cennik", [
                new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("Ceny wynajmu", [
                    new (0, $17906d3be6ee15d8$export$a7de6293698509b0)(product.RentPrices).AddColumn("Cena brutto", (x)=>new (0, $2s69t.NumberInput)(x.Value)).AddColumn("Za ile dni", (x)=>new (0, $2s69t.NumberInput)(x.Days)).AddColumn("Widoczno\u015B\u0107", (x)=>new (0, $2s69t.Div)().Append(new (0, $2s69t.Checkbox)(x.Visible)).Width(100).Background("red")).AddColumn("Opcje", (x)=>new (0, $f76a264d489fedad$export$94ed20bd54fffa3b)(product.RentPrices, x)).Build(),
                    new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("\u2795 Dodaj cene wynajmu").OnClick(()=>product.RentPrices.Add(new (0, $a8dfaf8f7f447cba$export$b972827e986d3b65)({
                            Value: 1,
                            Days: 1
                        })))
                ]),
                new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("Cena zakupu", [
                    new (0, $2s69t.NumberInput)(product.SalePrice)
                ]),
                new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("Kaucja", [
                    new (0, $2s69t.NumberInput)(product.Deposit)
                ]),
                new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("Zni\u017Cki od ilo\u015Bci", [
                    new (0, $17906d3be6ee15d8$export$a7de6293698509b0)(product.Discounts).AddColumn("Ilo\u015B\u0107", (x)=>new (0, $2s69t.NumberInput)(x.Quantity)).AddColumn("Procent zni\u017Cki", (x)=>new (0, $2s69t.NumberInput)(x.Percent)).AddColumn("Opcje", (x)=>new (0, $f76a264d489fedad$export$94ed20bd54fffa3b)(product.Discounts, x)).Build(),
                    new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("\u2795 Dodaj zni\u017Cke").OnClick(()=>product.Discounts.Add(new (0, $f5599661752f7c8e$export$702c536c4b65a073)({
                            Quantity: 2,
                            Percent: 10
                        })))
                ]),
                new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("Cennik dedykowany", [
                    new (0, $17906d3be6ee15d8$export$a7de6293698509b0)(product.PriceFactor).AddColumn("Daty", (x)=>new (0, $2s69t.Div)().Append(new (0, $2s69t.DateInput)(x.Start).WidthAuto(), " - ", new (0, $2s69t.DateInput)(x.End).WidthAuto())).AddColumn("Tryb", (x)=>new (0, $2s69t.Select)(x.Mode, Object.values((0, $c99eef43254dc902$export$5c538aa0d3be3a90)))).AddColumn("Warto\u015B\u0107", (x)=>new (0, $2s69t.NumberInput)(x.Value)).AddColumn("Informacje", (x)=>new (0, $2s69t.MultilineInput)(x.Info).Rows(3)).AddColumn("Opcje", (x)=>new (0, $f76a264d489fedad$export$94ed20bd54fffa3b)(product.PriceFactor, x)).Build(),
                    new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("\u2795 Dodaj mno\u017Cnik").OnClick(()=>product.PriceFactor.Add(new (0, $c99eef43254dc902$export$60e1d7099065e3ef)()))
                ])
            ]), new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("\uD83D\uDCF7 Galeria", [
                new (0, $2s69t.CollectionPrinter)(product.Images, (x)=>new (0, $5e98481b0ad5cf66$export$6992e9b152509c51)(x, product.Images)),
                uploader,
                new (0, $2s69t.Div)().ClearBoth(),
                new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("\u2795 Dodaj zdj\u0119cia").OnClick(()=>uploader.Show())
            ]), new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("\uD83D\uDCDD Opis", [
                new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("Taby opisu", [
                    new (0, $17906d3be6ee15d8$export$a7de6293698509b0)(product.Tabs).AddColumn("Id", (x)=>new (0, $2s69t.TextInput)(x.Id)).AddColumn("Tytu\u0142 taba", (x)=>new (0, $2s69t.TextInput)(x.Label)).AddColumn("Ikona jako tekst", (x)=>new (0, $9c46704f4b215e0d$export$ae821caa125e0b14)(x.Icon)).AddColumn("Widoczno\u015B\u0107", (x)=>new (0, $2s69t.Checkbox)(x.IsVisible, "Widoczny na stronie")).AddColumn("", (x)=>new (0, $f76a264d489fedad$export$94ed20bd54fffa3b)(product.Tabs, x)).Build(),
                    new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("\u2795 Dodaj tab").OnClick(()=>product.Tabs.Add(new (0, $8ad605e7c4ec2669$export$3e41faf802a29e71)({
                            Label: "Tab A",
                            Icon: "",
                            IsVisible: true
                        })))
                ]),
                new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("Pola opisu", [
                    new (0, $371dc6981361d493$export$aa74ad0b78023f22)(product.Description, product.Tabs)
                ])
            ]), new (0, $17dc641d9b3418f6$export$32a0ad71237b9760)(new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Zapisz zmiany").OnClick(async (btn)=>await this.SaveChanges(btn, product)), this.productUrl && new (0, $1c5579cee988b0d0$export$3b92dabad355f5d4)("Usu\u0144 produkt").OnClick(async (btn)=>await this.DeleteProduct(btn, product)), new (0, $1c5579cee988b0d0$export$b7c3a2f69225ecf)("Duplikuj produkt").OnClick(async (btn)=>await this.DuplicateProduct(btn, product))));
        });
    }
    async SaveChanges(btn, product) {
        btn.Disabled();
        if (!this.productUrl) this._shop.Shop.Products.Add(product);
        const result = await this._shop.SaveChanges();
        new (0, $04739df90be3396b$export$14834abbfce3b8cd)(result.IsSuccess ? "Zmiany zapisane!" : "\u274C Problem z zapisaniem zmian", result.ErrorMessage || result.ContentSize.toFixed(2) + "kb");
        window.location.hash = `produkt/${product.Url.value}`;
        btn.Enabled();
    }
    async DeleteProduct(btn, product) {
        btn.Disabled();
        if (confirm("Czy na pewno chcesz usun\u0105\u0107 ten produkt? Mo\u017Cesz go te\u017C tylko ukry\u0107.")) {
            this._shop.Shop.Products.Remove(product);
            const result = await this._shop.SaveChanges();
            new (0, $04739df90be3396b$export$14834abbfce3b8cd)(result.IsSuccess ? "Zmiany zapisane!" : "\u274C Problem z usuni\u0119ciem", result.ErrorMessage || result.ContentSize.toFixed(2) + "kb");
            const category = this._shop.Shop.ProductCategories.Items.find((x)=>x.Id.value == product.CategoryId.value);
            window.location.hash = `kategoria/${category?.Url?.value}`;
        }
        btn.Enabled();
    }
    async DuplicateProduct(btn, product) {
        btn.Disabled();
        const newProduct = new (0, $c99eef43254dc902$export$264ad599d7cef668)((0, $2s69t.RefSerializer).Flatenize(product));
        newProduct.Id = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
        newProduct.Title.value += " (duplikat)";
        newProduct.Url.value += "-duplikat";
        this._shop.Shop.Products.Add(newProduct);
        const result = await this._shop.SaveChanges();
        new (0, $04739df90be3396b$export$14834abbfce3b8cd)(result.IsSuccess ? "Duplikat utworzony!" : "\u274C Problem z utworzeniem duplikatu", result.ErrorMessage || result.ContentSize.toFixed(2) + "kb");
        btn.Enabled();
    }
}





var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");

class $e9b4faf4de108f92$export$b47fdeacf57db0af extends (0, $2s69t.Div) {
    constructor(category, articles){
        super();
        const selectedArticle = new (0, $2s69t.Ref)("");
        const assignedArticles = articles.Items.filter((x)=>category.RelatedArticles.Items.includes(x.Id));
        const selectedArticles = new (0, $2s69t.Collection)(assignedArticles);
        this.Append(new (0, $2s69t.TableBuilder)(selectedArticles).AddColumn("Tytu\u0142", (article)=>article.Title.value).AddColumn("", (article)=>new (0, $2s69t.Link)("\u2716\uFE0F").OnClick(()=>selectedArticles.Remove(article))).Build(), new (0, $2s69t.Select)(selectedArticle, articles.Items.map((x)=>new (0, $2s69t.SelectOption)(x.Title.value, x.Id))).WidthAuto(), new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Dodaj").OnClick(()=>{
            const article = articles.Items.find((x)=>x.Id === selectedArticle.value);
            if (article) {
                selectedArticles.Add(article);
                category.RelatedArticles.Add(article.Id);
            }
        }));
    }
}



class $ec507bcb90069562$export$44a09bc8106befd4 extends (0, $7727c235b6336caa$export$78d5a44323dda815) {
    constructor(category, articles){
        super([
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Id", new (0, $2s69t.TextInput)(category.Id).Placeholder("Id (musi by\u0107 unikalne)")),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Url", new (0, $2s69t.TextInput)(category.Url).Placeholder("Url (ten w pasku przegl\u0105darki)")),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Widoczny na stronie", new (0, $2s69t.Checkbox)(category.Visible)),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Tytu\u0142", new (0, $2s69t.TextInput)(category.Title).Placeholder("")),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Pod tytu\u0142em", new (0, $2s69t.TextInput)(category.Subtitle).Placeholder("")),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Obrazek", new (0, $56ed97d50ee4c1b6$export$e07ccc7fa9d78a9b)(category.Image)),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Opis (przy li\u015Bcie produkt\xf3w)", new (0, $2s69t.MultilineInput)(category.Description).Rows(4).Placeholder("Markdown")),
            new (0, $7727c235b6336caa$export$b534bc812df080fd)("Powi\u0105zane artyku\u0142y", new (0, $e9b4faf4de108f92$export$b47fdeacf57db0af)(category, articles))
        ]);
    }
}




var $2s69t = parcelRequire("2s69t");

class $82a0c55c8a7fb08a$export$c9a854809812a31b extends (0, $dca4a10ada8bf906$export$e71c4d32a2263218) {
    constructor(x){
        super(new (0, $2s69t.Image)(x.Image).Class("category-edit-box-image"), new (0, $2s69t.Text)(x.Title).Class("category-edit-box-title"));
    }
}



var $2s69t = parcelRequire("2s69t");

class $0794a96d495e20e3$export$6a610848446a2d94 extends (0, $2s69t.Div) {
    constructor(collection, title, content){
        super();
        this.Append(new (0, $2s69t.CollectionPrinter)(collection, (x)=>new (0, $5bec8a7602f95794$export$63a5581f40eaf4c2)(x, collection, title(x)).AddContent(...content(x))));
    }
}



class $3dfef36daba7a2c5$export$a1bfb6492ac56b0f extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_shop, _blog){
        super("specTeam.pl - Zarz\u0105dzanie kategoriami produkt\xf3w", "admin-page");
        this._shop = _shop;
        this._blog = _blog;
        this.Content(async (body)=>{
            await this._shop.Load();
            await this._blog.Load();
            body.Append(new (0, $0794a96d495e20e3$export$6a610848446a2d94)(this._shop.Shop.ProductCategories, (category)=>[
                    new (0, $82a0c55c8a7fb08a$export$c9a854809812a31b)(category)
                ], (category)=>[
                    new (0, $ec507bcb90069562$export$44a09bc8106befd4)(category, this._blog.Blog.Articles)
                ]), new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("\u2795 Dodaj kategori\u0119").OnClick(()=>this._shop.Shop.ProductCategories.Add(new (0, $39a2fd1d77a5883f$export$81fb35662c98d436)({
                    Id: "XXX"
                }))), new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("\uD83D\uDCBE Zapisz zmiany").OnClick(async ()=>{
                const result = await this._shop.SaveChanges();
                new (0, $04739df90be3396b$export$14834abbfce3b8cd)(result.IsSuccess ? "Zmiany zapisane!" : "\u274C Problem z zapisaniem zmian", result.ErrorMessage || result.ContentSize.toFixed(2) + "kb");
                window.location.hash = "/";
            }));
        });
    }
}



var $2s69t = parcelRequire("2s69t");



class $3c1170f05ebea6bd$export$acf7db3140935c5d extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_shop, categoryUrl){
        super("specTeam.pl - Zarz\u0105dzanie kolejno\u015Bci\u0105 produkt\xf3w w kategorii", "admin-page");
        this._shop = _shop;
        this.categoryUrl = categoryUrl;
        this.Content(async (body)=>{
            await this._shop.Load();
            const shop = this._shop.Shop;
            const categories = shop.ProductCategories;
            const categoryId = categories.Items.find((x)=>x.Url.value == this.categoryUrl)?.Id?.value;
            const categoryTitle = categories.Items.find((x)=>x.Url.value == this.categoryUrl)?.Title?.value;
            const productsInCategory = new (0, $2s69t.Collection)(shop.Products.Items.filter((x)=>x.Category.Id.value == categoryId));
            const otherProducts = shop.Products.Items.filter((x)=>x.CategoryId.value != categoryId);
            body.Append("Zarz\u0105dzanie kolejno\u015Bci\u0105 produkt\xf3w w kategorii ", new (0, $2s69t.Span)(categoryTitle ?? "(kategoria bez nazwy)").Bold(), new (0, $2s69t.TableBuilder)(productsInCategory).AddColumn("", (product)=>product.Images.Items?.[0]?.MiniUrl ? new (0, $2s69t.Image)(product.Images.Items[0]?.MiniUrl).Height(32).DisplayInlineBlock().MarginRight(8).BorderRadius(4) : new (0, $2s69t.Div)().Height(32).DisplayInlineBlock().MarginRight(8).BorderRadius(4).Text("no pic").Background("#888").FontSize(10).Width(48).TextAlignCenter()).AddColumn("", (product)=>new (0, $2s69t.Link)(product.Title.value).OnClick(()=>window.location.hash = `product/edit/${product.Url.value}`).FontSize(12)).AddColumn("", (product)=>new (0, $2s69t.Span)(product.Visible.value ? "widoczny" : "ukryty").Class("badge")).AddColumn("", (product)=>[
                    productsInCategory.CanSwapUp(product) && new (0, $2s69t.Link)("\u2B06\uFE0F").OnClick(()=>productsInCategory.SwapUp(product)),
                    productsInCategory.CanSwapDown(product) && new (0, $2s69t.Link)("\u2B07\uFE0F").OnClick(()=>productsInCategory.SwapDown(product))
                ]).Build(), new (0, $2s69t.Line)().Margin(32), new (0, $1c5579cee988b0d0$export$3b92dabad355f5d4)("Zapisz zmiany").OnClick(async ()=>{
                const allProductsAfterOrderChanges = [
                    ...productsInCategory.Items,
                    ...otherProducts
                ];
                shop.Products.Load(...allProductsAfterOrderChanges);
                console.table(shop.Products.Items.map((x)=>x.Title.value + " @ " + x.Category.Title.value));
                await this.SaveChanges();
            }));
        });
    }
    async SaveChanges() {
        const result = await this._shop.SaveChanges();
        new (0, $04739df90be3396b$export$14834abbfce3b8cd)(result.IsSuccess ? "\u2705 Zmiany zapisane" : "\u274C Problem z zapisaniem zmian", result.ErrorMessage || result.ContentSize.toFixed(2) + "kb");
        window.location.hash = `/`;
    }
}



var $2s69t = parcelRequire("2s69t");






var $2s69t = parcelRequire("2s69t");
var $b4c292586897f889$export$c20edc3521983dfc;
(function(DiscountType) {
    DiscountType["Percent"] = "percent";
    DiscountType["LimitedPercent"] = "limited-percent";
    DiscountType["FixedPrice"] = "fixed-price";
})($b4c292586897f889$export$c20edc3521983dfc || ($b4c292586897f889$export$c20edc3521983dfc = {}));
var $b4c292586897f889$export$cf5ae448a4c90036;
(function(DiscountTarget) {
    DiscountTarget["WholeBasket"] = "whole-basket";
    DiscountTarget["RentalItems"] = "rental-items";
    DiscountTarget["SaleItems"] = "sale-items";
    DiscountTarget["SpecificItem"] = "specific-item";
})($b4c292586897f889$export$cf5ae448a4c90036 || ($b4c292586897f889$export$cf5ae448a4c90036 = {}));


class $3b7fdc6bbc3f7560$export$5ee97a12e4b944d9 {
    // Max value in PLN when DiscountType.LimitedPercent is used
    constructor(raw){
        this.Type = new (0, $2s69t.Ref)((0, $b4c292586897f889$export$c20edc3521983dfc).Percent);
        this.Target = new (0, $2s69t.Ref)((0, $b4c292586897f889$export$cf5ae448a4c90036).WholeBasket);
        this.Code = new (0, $2s69t.RefString)();
        this.Value = new (0, $2s69t.RefNumber)(0);
        // Percent or fixed price
        this.IsOn = new (0, $2s69t.RefBool)(false);
        this.IsVisible = new (0, $2s69t.RefBool)(true);
        this.Name = new (0, $2s69t.RefString)();
        this.Description = new (0, $2s69t.RefString)();
        this.Limit = new (0, $2s69t.RefNumber)(0);
        this.Type.value = raw?.Type || (0, $b4c292586897f889$export$c20edc3521983dfc).Percent;
        this.Target.value = raw?.Target || (0, $b4c292586897f889$export$cf5ae448a4c90036).WholeBasket;
        this.Name.value = raw?.Name || "";
        this.Code.value = raw?.Code || "";
        this.Value.value = raw?.Value || 0;
        this.IsVisible.value = raw?.IsVisible || false;
        this.Description.value = raw?.Description || "";
        this.Limit.value = raw?.Limit || 0;
    }
    get AsRaw() {
        return {
            Name: this.Name.value,
            Code: this.Code.value,
            Value: this.Value.value,
            Type: this.Type.value,
            Target: this.Target.value,
            IsVisible: this.IsVisible.value,
            Description: this.Description.value,
            Limit: this.Limit.value
        };
    }
}
class $3b7fdc6bbc3f7560$export$5f0fddd75cd8dcd7 extends $3b7fdc6bbc3f7560$export$5ee97a12e4b944d9 {
    constructor(raw){
        super(raw);
    }
    CalcValue(price) {
        switch(this.Type.value){
            case (0, $b4c292586897f889$export$c20edc3521983dfc).Percent:
                return Math.round(price * (this.Value.value / 100));
            case (0, $b4c292586897f889$export$c20edc3521983dfc).LimitedPercent:
                const percentValue = Math.round(price * (this.Value.value / 100));
                if (percentValue > this.Limit.value) return this.Limit.value;
                return percentValue;
            case (0, $b4c292586897f889$export$c20edc3521983dfc).FixedPrice:
                return this.Value.value;
        }
    }
    AsString(price) {
        if (price == 0) return `${this.Value.value}% zni\u{17C}ki za ${this.Name.value}`;
        const discount = this.CalcValue(price).toFixed(0);
        return `${discount}z\u{142} zni\u{17C}ki za ${this.Name.value}`;
    }
}



var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");


class $c8568303bba72886$export$c2a14f8ac04cd6c extends (0, $3b7fdc6bbc3f7560$export$5f0fddd75cd8dcd7) {
    constructor(){
        super({
            Target: (0, $b4c292586897f889$export$cf5ae448a4c90036).RentalItems,
            Type: (0, $b4c292586897f889$export$c20edc3521983dfc).LimitedPercent,
            Name: "samodzielne szkolenie",
            Code: "self-training",
            Value: 10,
            IsVisible: true,
            Limit: 50
        });
    }
}




class $a0a4f85bb6e72409$export$cece99472bd696fe extends (0, $3b7fdc6bbc3f7560$export$5f0fddd75cd8dcd7) {
    constructor(){
        super({
            Target: (0, $b4c292586897f889$export$cf5ae448a4c90036).WholeBasket,
            Type: (0, $b4c292586897f889$export$c20edc3521983dfc).LimitedPercent,
            Name: "p\u0142atno\u015B\u0107 w Bitcoin",
            Code: "crypto",
            Value: 15,
            Limit: 300,
            IsVisible: true
        });
    }
}




class $e8068f2a396ec1a8$export$c05a38326dfe9b6a extends (0, $3b7fdc6bbc3f7560$export$5f0fddd75cd8dcd7) {
    constructor(){
        super({
            Target: (0, $b4c292586897f889$export$cf5ae448a4c90036).WholeBasket,
            Type: (0, $b4c292586897f889$export$c20edc3521983dfc).LimitedPercent,
            Name: "ponowne zakupy",
            Code: "returning-client",
            Value: 10,
            Limit: 500,
            IsVisible: true
        });
    }
}


class $7892497523110089$export$2ecad7aad28ac73b {
    constructor(){
        this.GeneralPriceFactor = new (0, $2s69t.RefNumber)(1);
        this.DeliveryCostForPriceAbove300 = new (0, $2s69t.RefNumber)(25);
        this.DeliveryCostForPriceBelow300 = new (0, $2s69t.RefNumber)(1);
        this.Discounts = new (0, $2s69t.Collection)([
            new (0, $a0a4f85bb6e72409$export$cece99472bd696fe)(),
            new (0, $e8068f2a396ec1a8$export$c05a38326dfe9b6a)(),
            new (0, $c8568303bba72886$export$c2a14f8ac04cd6c)()
        ]);
    }
}


class $1a784100733b5566$export$9dd8876539768efc {
    constructor(){
        this.Id = "Shop";
        this.Logo = new (0, $2s69t.RefString)();
        this.AboutUsText = new (0, $2s69t.RefString)();
        this.AboutUsFaq = new (0, $2s69t.Collection)();
        this.ProductCategories = new (0, $2s69t.Collection)();
        this.Products = new (0, $2s69t.Collection)();
        this.BasketOptions = new (0, $7892497523110089$export$2ecad7aad28ac73b)();
        this.ContactTabs = new (0, $2s69t.Collection)();
        this.Contact = new (0, $2s69t.Collection)();
        this.RentalPageContentTabs = new (0, $2s69t.Collection)();
        this.RentalPageContent = new (0, $2s69t.Collection)();
    }
    get AvailableProducts() {
        return this.Products.Items.filter((x)=>x.Visible.value);
    }
    PrepareProducts() {
        // Set Category for each product
        this.Products.Items.forEach((product)=>{
            const category = this.ProductCategories.Items.find((x)=>x.Id.value == product.CategoryId.value);
            product.Category = category ?? (0, $39a2fd1d77a5883f$export$81fb35662c98d436).NotFound();
        });
    }
}






















class $b216b0eb7439fe32$export$f69c19e57285b83a {
    Name;
    Body;
    constructor(Name, Body){
        this.Name = Name;
        this.Body = Body;
    }
}


class $5c97da8b615e66f9$export$44b688a57c0ea831 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("GetMetadata", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $45a158b08e11d32b$export$7ce83225b1a2ab35 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("DropDataset", {
            Database: Database,
            Dataset: Dataset
        });
    }
}


class $6afb9edbb9c148cf$export$a9076aff4a6d0070 {
    _db;
    dataset;
    constructor(_db, dataset){
        this._db = _db;
        this.dataset = dataset;
    }
    get Name() {
        return this.dataset;
    }
    get Database() {
        return this._db;
    }
    get DatasetPath() {
        return this._db.DatabaseDir + "/Datasets/" + this.dataset;
    }
    async GetMetadata() {
        const response = await this._db.Send(new (0, $5c97da8b615e66f9$export$44b688a57c0ea831)(this._db.DatabaseDir, this.dataset));
        if (!response.IsSuccess) throw new Error("Failed to get metadata: " + response.ErrorMessage);
        return response.Result;
    }
    CanUserDo(action) {
        if (!this._db.User.Privileges) return false;
        if (this._db.User.Privileges?.[action] && typeof this._db.User.Privileges[action] === "object") return (this._db.User.Privileges[action].Datasets == "all" || this._db.User.Privileges[action].Datasets?.includes(this.dataset)) ?? false;
        if (this._db.User.Privileges?.[action] && typeof this._db.User.Privileges[action] === "boolean") return this._db.User.Privileges[action];
        return false;
    }
    Log(message) {
        this._db.Log(message);
    }
    async Drop() {
        this.Log(`Dropping "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $45a158b08e11d32b$export$7ce83225b1a2ab35)(this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to drop dataset: " + result.ErrorMessage);
        this.Log(`"${this.DatasetPath}" dropped successfully.`);
    }
}


var $d83b6b847cfe9f3e$export$69e133a2b31764a9;
(function(DatasetType) {
    DatasetType["Unknown"] = "Unknown";
    DatasetType["Object"] = "Object";
    DatasetType["Text"] = "Text";
    DatasetType["Picture"] = "Picture";
    DatasetType["File"] = "File";
})($d83b6b847cfe9f3e$export$69e133a2b31764a9 || ($d83b6b847cfe9f3e$export$69e133a2b31764a9 = {}));




class $e4e5ebdfac92419f$export$c8c5e7182924d536 {
    ToRaw(target) {
        try {
            return this.ConvertToRaw(target);
        } catch (ex) {
            console.error(`Conversion from object to raw problem: ${ex.message}\n\nStack trace: ${ex.stack}\n\nObject:`, target);
            throw ex;
        }
    }
    FromRaw(raw) {
        try {
            return this.ConvertFromRaw(raw);
        } catch (ex) {
            console.error(`Conversion from raw to object problem: ${ex.message}\n\nStack trace: ${ex.stack}\n\nRaw:`, raw);
            throw ex;
        }
    }
    GetArray(value, creator) {
        const items = value?.map((x)=>creator(x));
        return items || [];
    }
    GetString(value) {
        return value || "";
    }
    GetNumber(value) {
        return +value || 0;
    }
    GetBool(value) {
        return !!value || false;
    }
    GetDate(date) {
        return date ? new Date(date) : new Date(0);
    }
}



class $ce85a2da75640367$export$c12b8c1beca20106 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, ObjectId, Content){
        super("AddObject", {
            Database: Database,
            Dataset: Dataset,
            ObjectId: ObjectId,
            Content: Content
        });
    }
}



class $804cc7411a7d35d9$export$4df9e803b7373792 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("ListObjects", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $096817e3afb8207a$export$c63583173c519c11 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, ObjectId, Content){
        super("UpdateObject", {
            Database: Database,
            Dataset: Dataset,
            ObjectId: ObjectId,
            Content: Content
        });
    }
}



class $c88a2226128c76ac$export$909394e50a5801cc extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("ListObjectsIds", {
            Database: Database,
            Dataset: Dataset
        });
    }
}




class $e3183d94f6dbf053$export$1d3bda4c95d1bbeb {
    FromRaw(raw) {
        return raw;
    }
    ToRaw(item) {
        return item;
    }
}



class $cf2760f70c387ac3$export$7e9a3988c01bcb96 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, ObjectId){
        super("GetObject", {
            Database: Database,
            Dataset: Dataset,
            ObjectId: ObjectId
        });
    }
}



class $fab5932668ba36df$export$d60592d05571c4ef extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, ObjectId){
        super("DeleteObject", {
            Database: Database,
            Dataset: Dataset,
            ObjectId: ObjectId
        });
    }
}


class $75f1f7875a1df277$export$627789366574b89f extends (0, $6afb9edbb9c148cf$export$a9076aff4a6d0070) {
    _db;
    dataset;
    _converter;
    Type = (0, $d83b6b847cfe9f3e$export$69e133a2b31764a9).Object;
    constructor(_db, dataset, _converter = new (0, $e3183d94f6dbf053$export$1d3bda4c95d1bbeb)()){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
        this._converter = _converter;
    }
    async GetOne(id) {
        this.Log(`Fetching "${id}"...`);
        const queryResult = await this._db.Send(new (0, $cf2760f70c387ac3$export$7e9a3988c01bcb96)(this._db.DatabaseDir, this.dataset, id));
        if (!queryResult.IsSuccess) throw new Error("Failed to get one object: " + queryResult.ErrorMessage);
        const rawItem = queryResult.Result;
        const item = this._converter.FromRaw(rawItem);
        this.Log(`Fetched "${id}" from "${this.DatasetPath}".`);
        return item;
    }
    async GetAll() {
        this.Log(`Fetching all from "${this.DatasetPath}"...`);
        const queryResult = await this._db.Send(new (0, $804cc7411a7d35d9$export$4df9e803b7373792)(this._db.DatabaseDir, this.dataset));
        if (!queryResult.IsSuccess) throw new Error("Failed to fetch all items: " + queryResult.ErrorMessage);
        const rawItems = queryResult.Result;
        const items = rawItems.map((raw)=>this._converter.FromRaw(raw));
        this.Log(`Fetched ${items.length} items from "${this.DatasetPath}".`);
        return items;
    }
    async GetAllIds() {
        this.Log(`Fetching all objects IDs from "${this.DatasetPath}"...`);
        const queryResult = await this._db.Send(new (0, $c88a2226128c76ac$export$909394e50a5801cc)(this._db.DatabaseDir, this.dataset));
        if (!queryResult.IsSuccess) throw new Error("Failed to fetch all objects ids: " + queryResult.ErrorMessage);
        const ids = queryResult.Result;
        this.Log(`Found ${ids.length} objects in "${this.DatasetPath}".`);
        return ids;
    }
    async Add(id, item) {
        this.Log(`Adding "${id}" to "${this.DatasetPath}"...`);
        const rawItem = this._converter.ToRaw(item);
        const result = await this._db.Send(new (0, $ce85a2da75640367$export$c12b8c1beca20106)(this._db.DatabaseDir, this.dataset, id, rawItem));
        if (!result.IsSuccess) throw new Error("Failed to add item: " + result.ErrorMessage);
        this.Log(`"${id}" added to "${this.DatasetPath}".`);
    }
    async Update(id, item) {
        this.Log(`Updating "${id}"...`);
        const rawItem = this._converter.ToRaw(item);
        const result = await this._db.Send(new (0, $096817e3afb8207a$export$c63583173c519c11)(this._db.DatabaseDir, this.dataset, id, rawItem));
        if (!result.IsSuccess) throw new Error("Failed to update item: " + result.ErrorMessage);
        this.Log(`"${id}" updated in "${this.DatasetPath}".`);
    }
    async Delete(id) {
        this.Log(`Deleting "${id}" from "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $fab5932668ba36df$export$d60592d05571c4ef)(this._db.DatabaseDir, this.dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to delete object: " + result.ErrorMessage);
        this.Log(`Deleted "${id}" from "${this.DatasetPath}".`);
    }
}





class $a13627770c0f1192$export$2be762ff71c7d52d extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId, Content){
        super("AppendText", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId,
            Content: Content
        });
    }
}



class $03370006e4ef8576$export$3ce67f7a974b3d12 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId){
        super("Clear", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}



class $8e38a36ab188b89f$export$7a284a805e14b0be extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId){
        super("CreateFile", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}



class $7d97c736d7152af0$export$2ba25239d87f5d44 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId){
        super("DeleteFile", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}




class $62e770cff444bee8$export$6eb5d27576a6f8ce extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId, Offset = 0, Limit = 0){
        super("ReadText", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId,
            Offset: Offset,
            Limit: Limit
        });
    }
}



class $183ec87bb4e7b569$export$b76e0450f5b20591 extends (0, $6afb9edbb9c148cf$export$a9076aff4a6d0070) {
    _db;
    dataset;
    Type = (0, $d83b6b847cfe9f3e$export$69e133a2b31764a9).Text;
    constructor(_db, dataset){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
    }
    async Read(id, offset = 0, limit = 0) {
        this.Log(`Reading "${id}" from "${this.DatasetPath}"...`);
        if (limit < 0) throw new Error("Limit cannot be negative number. 0 = no limit.");
        const queryResult = await this._db.Send(new (0, $62e770cff444bee8$export$6eb5d27576a6f8ce)(this._db.DatabaseDir, this.dataset, id, offset, limit));
        if (!queryResult.IsSuccess) throw new Error("Failed to read: " + queryResult.ErrorMessage);
        const content = queryResult.Result;
        this.Log(`Read ${content.length} characters from "${id}" in "${this.DatasetPath}".`);
        return content;
    }
    async GetAllIds() {
        this.Log(`Fetching all files IDs from "${this.DatasetPath}"...`);
        const queryResult = await this._db.Send(new (0, $c88a2226128c76ac$export$909394e50a5801cc)(this._db.DatabaseDir, this.dataset));
        if (!queryResult.IsSuccess) throw new Error("Failed to fetch all items ids: " + queryResult.ErrorMessage);
        const ids = queryResult.Result;
        this.Log(`Found ${ids.length} files in "${this.DatasetPath}".`);
        return ids;
    }
    async Create(id) {
        this.Log(`Creating "${id}" in "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $8e38a36ab188b89f$export$7a284a805e14b0be)(this._db.DatabaseDir, this.dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to create item: " + result.ErrorMessage);
        this.Log(`"${id}" created in "${this.DatasetPath}".`);
    }
    async AppendText(id, text) {
        this.Log(`Appending ${text.length} characters to "${id}" in "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $a13627770c0f1192$export$2be762ff71c7d52d)(this._db.DatabaseDir, this.dataset, id, text));
        if (!result.IsSuccess) throw new Error("Failed to append: " + result.ErrorMessage);
        this.Log(`${text.length} characters appended to "${id}" in "${this.DatasetPath}".`);
    }
    async Clear(id) {
        this.Log(`Clearing "${id}" in "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $03370006e4ef8576$export$3ce67f7a974b3d12)(this._db.DatabaseDir, this.dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to clear text file: " + result.ErrorMessage);
        this.Log(`"${id}" cleared in "${this.DatasetPath}".`);
    }
    async ReplaceText(id, text) {
        this.Log(`Replacing text in "${id}" in "${this.DatasetPath}"...`);
        await this.Clear(id);
        await this.AppendText(id, text);
        this.Log(`"${id}" replaced in "${this.DatasetPath}".`);
    }
    async AppendLine(id, line) {
        await this.AppendText(id, line + "\n");
    }
    async Delete(id) {
        this.Log(`Deleting "${id}" from "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $7d97c736d7152af0$export$2ba25239d87f5d44)(this._db.DatabaseDir, this.dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to delete item: " + result.ErrorMessage);
        this.Log(`Deleted "${id}" from "${this.DatasetPath}".`);
    }
}


class $4d2da659f2458bd1$export$dc7fb1eb9fb3a3bd {
    ToLine(entry) {
        return JSON.stringify(entry);
    }
    ToEntry(line) {
        return JSON.parse(line);
    }
}



class $5a11653556197b99$export$b381a9c9206415ff extends (0, $183ec87bb4e7b569$export$b76e0450f5b20591) {
    _db;
    dataset;
    _converter;
    constructor(_db, dataset, _converter = new (0, $4d2da659f2458bd1$export$dc7fb1eb9fb3a3bd)()){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
        this._converter = _converter;
    }
    async Load(id, offset = 0, limit = 0) {
        const lines = await super.Read(id, offset, limit);
        return lines.map((line)=>this._converter.ToEntry(line));
    }
    async Append(id, entry) {
        const line = this._converter.ToLine(entry);
        await super.AppendLine(id, line);
    }
}






class $a9292ba8af43c41c$export$9e95ed3bd9bab7b0 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, PictureDir){
        super("DeletePicture", {
            Database: Database,
            Dataset: Dataset,
            PictureDir: PictureDir
        });
    }
}



class $be72006e758513b6$export$a5b3af442ea466b6 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Server, Database, Dataset){
        super("ListPictures", {
            Server: Server,
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $fac5005b6116fcf9$export$205686f7b10194b7 {
    KeepSource = true;
    Sizes = {};
}




class $42b5462dd7f06646$export$7afdc3bd517797d extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("ListPicturesIds", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $02741148466c919f$export$a6fb71614acfa923 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Server, Database, Dataset, FileId){
        super("GetPicture", {
            Server: Server,
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}


class $5640e2e8de6d5b79$export$47f3bf415b3a0f78 extends (0, $6afb9edbb9c148cf$export$a9076aff4a6d0070) {
    _db;
    dataset;
    Type = (0, $d83b6b847cfe9f3e$export$69e133a2b31764a9).Picture;
    picsConfig = new (0, $fac5005b6116fcf9$export$205686f7b10194b7)();
    constructor(_db, dataset, config){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
        if (config) this.picsConfig = {
            ...this.picsConfig,
            ...config
        };
    }
    SetConfig(config) {
        this.picsConfig = {
            ...this.picsConfig,
            ...config
        };
    }
    GetConfig() {
        return this.picsConfig;
    }
    async GetAllIds() {
        const result = await this._db.Send(new (0, $42b5462dd7f06646$export$7afdc3bd517797d)(this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to list pictures ids: " + result.ErrorMessage);
        return result.Result;
    }
    async GetOne(pictureDir) {
        const result = await this._db.Send(new (0, $02741148466c919f$export$a6fb71614acfa923)(this._db.Server, this._db.DatabaseDir, this.dataset, pictureDir));
        if (!result.IsSuccess) throw new Error("Failed to get picture: " + result.ErrorMessage);
        return result.Result;
    }
    async GetAll() {
        const result = await this._db.Send(new (0, $be72006e758513b6$export$a5b3af442ea466b6)(this._db.Server, this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to list picture packs: " + result.ErrorMessage);
        return result.Result;
    }
    async Add(files) {
        try {
            if (!files) throw new Error("No files provided");
            const formData = new FormData();
            for(let i = 0; i < files.length; i++)formData.append("files[]", files[i]); // Tak, te [] w nazwie zmiennej są konieczne! bez tego php (mimo że odbiera przez $_FILES["files"]) nie jest w stanie odebrać wielu plików xd
            formData.append("server", this._db.Server);
            formData.append("database", this._db.DatabaseDir);
            formData.append("dataset", this.dataset);
            formData.append("config", JSON.stringify(this.picsConfig));
            formData.append("userId", this._db.User.Id);
            let serverUrl = this._db.Server;
            if (serverUrl.endsWith("/")) serverUrl = serverUrl.slice(0, -1);
            const response = await fetch(serverUrl + "/pictures-upload", {
                method: "POST",
                body: formData
            });
            if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
            const result = await response.json();
            if (!result.IsSuccess) throw new Error("Failed to upload pictures: " + result.ErrorMessage);
            return result.Result ?? [];
        } catch (ex) {
            throw new Error(`Can not upload: ${ex.message}`);
        }
    }
    async Delete(pictureDir) {
        const result = await this._db.Send(new (0, $a9292ba8af43c41c$export$9e95ed3bd9bab7b0)(this._db.DatabaseDir, this.dataset, pictureDir));
        if (!result.IsSuccess) throw new Error("Failed to delete picture: " + result.ErrorMessage);
    }
}













class $5ef429f262eed9ae$export$9537075280f3c140 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Server, Database, Dataset){
        super("ListFiles", {
            Server: Server,
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $ccf5f2a8c816a8d6$export$222972f50ef41123 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("ListFilesIds", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $407007f4e8a9cc47$export$47a715c3138de013 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Server, Database, Dataset, FileId){
        super("GetFile", {
            Server: Server,
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}



class $4b8a13f98b39bd48$export$3e5661d9f1dcca0e {
    MaxDatasetSize = 1073741824;
    SingleFileMaxSize = 104857600;
    AllowedExtensions = "any";
}


class $73db00c56adeadd0$export$30ac9230346b066 extends (0, $6afb9edbb9c148cf$export$a9076aff4a6d0070) {
    _db;
    dataset;
    Type = (0, $d83b6b847cfe9f3e$export$69e133a2b31764a9).File;
    config = new (0, $4b8a13f98b39bd48$export$3e5661d9f1dcca0e)();
    constructor(_db, dataset, config){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
        if (config) this.config = {
            ...this.config,
            ...config
        };
    }
    SetConfig(config) {
        this.config = {
            ...this.config,
            ...config
        };
    }
    GetConfig() {
        return this.config;
    }
    async GetAllIds() {
        const result = await this._db.Send(new (0, $ccf5f2a8c816a8d6$export$222972f50ef41123)(this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to list files ids: " + result.ErrorMessage);
        return result.Result;
    }
    async GetOne(fileId) {
        const result = await this._db.Send(new (0, $407007f4e8a9cc47$export$47a715c3138de013)(this._db.Server, this._db.DatabaseDir, this.dataset, fileId));
        if (!result.IsSuccess) throw new Error("Failed to get picture: " + result.ErrorMessage);
        return result.Result;
    }
    async GetAll() {
        const result = await this._db.Send(new (0, $5ef429f262eed9ae$export$9537075280f3c140)(this._db.Server, this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to list file packs: " + result.ErrorMessage);
        return result.Result;
    }
    async Add(files) {
        try {
            if (!files) throw new Error("No files provided");
            const formData = new FormData();
            for(let i = 0; i < files.length; i++)formData.append("files[]", files[i]); // Tak, te [] w nazwie zmiennej są konieczne! bez tego php (mimo że odbiera przez $_FILES["files"]) nie jest w stanie odebrać wielu plików xd
            formData.append("server", this._db.Server);
            formData.append("database", this._db.DatabaseDir);
            formData.append("dataset", this.dataset);
            formData.append("userId", this._db.User.Id);
            formData.append("config", JSON.stringify(this.config));
            let serverUrl = this._db.Server;
            if (serverUrl.endsWith("/")) serverUrl = serverUrl.slice(0, -1);
            const response = await fetch(serverUrl + "/files-upload", {
                method: "POST",
                body: formData
            });
            if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
            const result = await response.json();
            if (!result.IsSuccess) throw new Error("Failed to upload files: " + result.ErrorMessage);
            return result.Result ?? [];
        } catch (ex) {
            throw new Error(`Can not upload file: ${ex.message}`);
        }
    }
    async Delete(fileId) {
        const result = await this._db.Send(new (0, $7d97c736d7152af0$export$2ba25239d87f5d44)(this._db.DatabaseDir, this.dataset, fileId));
        if (!result.IsSuccess) throw new Error("Failed to delete file: " + result.ErrorMessage);
    }
}







class $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d {
    IsSuccess = false;
    ErrorMessage = "";
    ErrorCode = -1;
    Result = undefined;
    static Success(result) {
        const response = new $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d();
        response.IsSuccess = true;
        response.Result = result;
        return response;
    }
    static Fault(errorCode, errorMessage) {
        const response = new $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d();
        response.IsSuccess = false;
        response.Result = undefined;
        response.ErrorCode = errorCode || -1;
        response.ErrorMessage = errorMessage;
        return response;
    }
}


class $0ebd3f586870c7e9$export$fe2589e86ee56365 {
    serverUrl;
    sender;
    constructor(serverUrl, sender){
        this.serverUrl = serverUrl;
        this.sender = sender;
    }
    get Sender() {
        return this.sender;
    }
    SetSender(sender) {
        this.sender = sender;
        return this;
    }
    SetServer(server) {
        this.serverUrl = server;
        return this;
    }
    async SendMessage(message) {
        let messagePackage = {
            Sender: this.sender || {
                Id: "Anonymous"
            },
            Message: message
        };
        return await this.SendMessagePackage(messagePackage);
    }
    async PostJSON(data) {
        let httpResponse = {
            status: 0,
            data: undefined
        };
        const dataAsString = JSON.stringify(data);
        const response = await fetch(this.serverUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: dataAsString
        });
        httpResponse.status = response.status;
        const json = await response.json();
        httpResponse.data = json;
        return httpResponse;
    }
    async Ping() {
        try {
            const response = await fetch(this.serverUrl + "/ping", {
                method: "GET"
            });
            if (response.status != 200) return false;
            const body = await response.text();
            return body == "pong";
        } catch (ex) {
            return false;
        }
    }
    async SendMessagePackage(messagePackage) {
        try {
            const response = await this.PostJSON(messagePackage);
            if (response.status == 200 && response.data.IsSuccess == true) {
                const result = response.data;
                return (0, $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d).Success(result.Result);
            } else if (response.status == 200 && response.data.IsSuccess == false) return (0, $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d).Fault(response.status, response.data.ErrorMessage);
            return (0, $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d).Fault(response.status, "Non-200 status");
        } catch (ex) {
            return (0, $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d).Fault(ex.response?.status, ex.message);
        }
    }
}



class $01c7686b748260ee$export$9ab52704d0773c02 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Type, Dataset){
        super("CreateDataset", {
            Database: Database,
            Type: Type,
            Dataset: Dataset
        });
    }
}



class $1e9c1748f4e80b89$export$3771dfdca41a73cb extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("DatasetExists", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $c69a319b14a3f741$export$fbcbdb743352704d extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("RemoveDataset", {
            Database: Database,
            Dataset: Dataset
        });
    }
}




class $85b2ca0db3fcf386$export$c68a8fe67ac55f0a extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, ObjectId, Source, Target){
        super("MoveObject", {
            Database: Database,
            ObjectId: ObjectId,
            Source: Source,
            Target: Target
        });
    }
}



class $c7a20a66c26cd9cc$export$438b9770139752e8 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Password, Login){
        super("LoginUser", {
            Database: Database,
            Password: Password,
            Login: Login
        });
    }
}



class $e6a3009419252341$export$e8eea69f349ac16b extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("ListUsers", {
            Database: Database
        });
    }
}



class $d1217b689949d4b5$export$2fcccd4a7b9ac845 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, User){
        super("UpdateUser", {
            Database: Database,
            User: User
        });
    }
}



class $d53b721476fd0e13$export$daebbca9d9338bc extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, User){
        super("AddUser", {
            Database: Database,
            User: User
        });
    }
}



class $49ebf2e3c9d0414c$export$16745b1b4cbcf131 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, UserId){
        super("DeleteUser", {
            Database: Database,
            UserId: UserId
        });
    }
}



class $341fd7216a697b68$export$2c2cfb7ca1cbc644 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, UserId){
        super("GetUser", {
            Database: Database,
            UserId: UserId
        });
    }
}



class $017449eabfa9cc97$export$54e721faba08510a extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Id){
        super("GetLog", {
            Database: Database,
            Id: Id
        });
    }
}



class $0b12de66db7fc647$export$f4bc86deee9ad8c extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("ListLogsIds", {
            Database: Database
        });
    }
}



class $bfea829df9966a60$export$8306c05e5eceab13 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(){
        super("ListDatabases", {});
    }
}



class $8cd99d2756d53677$export$75790cd217c136b7 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("CreateDatabase", {
            Database: Database
        });
    }
}



class $9e5c29a9040d7100$export$532f827abef81411 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("ListDatasets", {
            Database: Database
        });
    }
}



class $1150d16d79392866$export$ae7689aec281aea8 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("DeleteDatabase", {
            Database: Database
        });
    }
}






class $ae1a5cf54ffb33b6$export$5d991cdc62928edb {
    server;
    database;
    sender;
    ANONYMOUS_USER = {
        Id: "Anonymous"
    };
    user = this.ANONYMOUS_USER;
    logEnabled = false;
    _bus;
    onUserChange = [];
    USER_LOCAL_STORAGE_KEY_PREFIX = "OnlineStorage:User:";
    userLocalStorageKey = "";
    get Server() {
        return this.server;
    }
    get DatabaseDir() {
        return this.database;
    }
    get User() {
        return this.user;
    }
    constructor(server, database, sender = this.ANONYMOUS_USER, bus){
        this.server = server;
        this.database = database;
        this.sender = sender;
        this._bus = bus || new (0, $0ebd3f586870c7e9$export$fe2589e86ee56365)(server, sender);
        this.userLocalStorageKey = this.USER_LOCAL_STORAGE_KEY_PREFIX + this.database;
        if (this.LoadUserFromLocalStorage()) this.CallOnUserChanged(true);
    }
    SetServer(server) {
        this.server = server;
        this._bus.SetServer(server);
        return this;
    }
    SetDatabase(database) {
        this.database = database;
        this.userLocalStorageKey = this.USER_LOCAL_STORAGE_KEY_PREFIX + this.database;
        return this;
    }
    async ListDatasets() {
        const result = await this._bus.SendMessage(new (0, $9e5c29a9040d7100$export$532f827abef81411)(this.DatabaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to list datasets: ${result.ErrorMessage}`);
        return result.Result;
    }
    async ListUsers() {
        const result = await this._bus.SendMessage(new (0, $e6a3009419252341$export$e8eea69f349ac16b)(this.DatabaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to list users: ${result.ErrorMessage}`);
        return result.Result;
    }
    async GetUser(userId) {
        const result = await this._bus.SendMessage(new (0, $341fd7216a697b68$export$2c2cfb7ca1cbc644)(this.DatabaseDir, userId));
        if (!result.IsSuccess) throw new Error(`Failed to get user: ${result.ErrorMessage}`);
        return result.Result;
    }
    async AddUser(user) {
        this.Log(`Adding user "${user.Id}"...`);
        const result = await this._bus.SendMessage(new (0, $d53b721476fd0e13$export$daebbca9d9338bc)(this.DatabaseDir, user));
        if (!result.IsSuccess) throw new Error("Failed to add user: " + result.ErrorMessage);
        this.Log(`User "${user.Id}" added.`);
    }
    async UpdateUser(user) {
        this.Log(`Updating user "${user.Id}"...`);
        const result = await this._bus.SendMessage(new (0, $d1217b689949d4b5$export$2fcccd4a7b9ac845)(this.DatabaseDir, user));
        if (!result.IsSuccess) throw new Error("Failed to update user: " + result.ErrorMessage);
        this.Log(`User "${user.Id}" updated.`);
    }
    async DeleteUser(user) {
        this.Log(`Deleting user "${user.Id}"...`);
        const result = await this._bus.SendMessage(new (0, $49ebf2e3c9d0414c$export$16745b1b4cbcf131)(this.DatabaseDir, user.Id));
        if (!result.IsSuccess) throw new Error("Failed to delete user: " + result.ErrorMessage);
        this.Log(`User "${user.Id}" deleted.`);
    }
    GetObjectDataset(datasetName, converter) {
        return new (0, $75f1f7875a1df277$export$627789366574b89f)(this, datasetName, converter);
    }
    GetTextDataset(datasetName, converter) {
        return converter ? new (0, $5a11653556197b99$export$b381a9c9206415ff)(this, datasetName, converter) : new (0, $183ec87bb4e7b569$export$b76e0450f5b20591)(this, datasetName);
    }
    GetPictureDataset(datasetName, picsConfig) {
        return new (0, $5640e2e8de6d5b79$export$47f3bf415b3a0f78)(this, datasetName, picsConfig);
    }
    GetFileDataset(datasetName, config) {
        return new (0, $73db00c56adeadd0$export$30ac9230346b066)(this, datasetName, config);
    }
    IsBrowserEnvironment() {
        return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
    }
    LoadUserFromLocalStorage() {
        if (this.IsBrowserEnvironment()) {
            const user = window.localStorage.getItem(this.userLocalStorageKey);
            if (user) {
                this.user = JSON.parse(user);
                this.SetUser(this.user || this.ANONYMOUS_USER);
                return true;
            }
        }
        return false;
    }
    async Login(password, login) {
        const result = await this._bus.SendMessage(new (0, $c7a20a66c26cd9cc$export$438b9770139752e8)(this.DatabaseDir, password, login));
        if (!result.IsSuccess) throw new Error("Failed to login: " + result.ErrorMessage);
        this.user = result.Result || this.ANONYMOUS_USER;
        this.SetUser(this.user);
        this.SaveUserInLocalStorage();
        this.CallOnUserChanged(false);
        return this.user;
    }
    SaveUserInLocalStorage() {
        if (this.IsBrowserEnvironment()) window.localStorage.setItem(this.userLocalStorageKey, JSON.stringify(this.user));
    }
    OnUserChange(handler) {
        this.onUserChange.push(handler);
        handler(this.user, this.IsAuthorized, true);
        return this;
    }
    //
    // UWAGA!!!!!!!!!! TAK NIE MOŻNA REJESTROWAĆ Privileges!!!!!! TO MUSI SIĘ ODBYWAĆ PRZEZ INNĄ METODE ALBO INNY MECHANIZM!!!!!!!
    // Użytkownik nie może sam sobie nadawać uprawnień xddd
    //
    //
    // public async Register(id: string, role: string, name: string,
    // 	login: string, password: string, email: string,
    // 	privileges: IStorageUserPrivileges,
    // 	icon?: string, tags?: string[]): Promise<IStorageUser>
    // {
    // 	const createdAt = new Date();
    // 	const result = await this._bus.SendMessage(new RegisterCommand(this.DatabaseDir, id, role, name, login, password, email, privileges, icon, tags, createdAt));
    // 	if (!result.IsSuccess)
    // 	{
    // 		throw new Error(`Could not register: ${result.ErrorMessage}`);
    // 	}
    // 	const user = result.Result as IStorageUser;
    // 	return user;
    // }
    Logout() {
        this.SetUser(this.ANONYMOUS_USER);
        this.SaveUserInLocalStorage();
        this.CallOnUserChanged(false);
        return this;
    }
    CallOnUserChanged(appStart) {
        this.onUserChange.forEach((handler)=>handler(this.user, this.IsAuthorized, appStart));
    }
    get IsAuthorized() {
        return this.user && this.user.Id !== this.ANONYMOUS_USER.Id;
    }
    get IsNotLoggedIn() {
        return !this.user || this.user.Id === this.ANONYMOUS_USER.Id;
    }
    SetUser(user) {
        this.user = user;
        this._bus.SetSender({
            Id: user.Id
        });
        return this;
    }
    EnableLog() {
        this.logEnabled = true;
        return this;
    }
    DisableLog() {
        this.logEnabled = false;
        return this;
    }
    Log(...message) {
        if (this.logEnabled) console.log("[OnlineStorage]", ...message);
    }
    async Ping() {
        return await this._bus.Ping();
    }
    async Send(message) {
        const result = await this._bus.SendMessage(message);
        if (!result.IsSuccess) throw new Error(`Message resulted with error: ${result.ErrorMessage}`);
        return result;
    }
    async CreateDataset(type, datasetName) {
        this.Log(`Creating dataset "${datasetName}" of ${type} type...`);
        const result = await this._bus.SendMessage(new (0, $01c7686b748260ee$export$9ab52704d0773c02)(this.DatabaseDir, type, datasetName));
        if (!result.IsSuccess) throw new Error(`Failed to add dataset: ${result.ErrorMessage}`);
        this.Log(`Dataset "${datasetName}" created.`);
    }
    async DatasetExists(datasetName) {
        this.Log(`Checking if dataset "${datasetName}" exists...`);
        const result = await this._bus.SendMessage(new (0, $1e9c1748f4e80b89$export$3771dfdca41a73cb)(this.DatabaseDir, datasetName));
        if (!result.IsSuccess) throw new Error(`Failed to check if dataset exists: ${result.ErrorMessage}`);
        this.Log(`Dataset "${datasetName}" ${result.Result ? "exists" : "does not exist"}.`);
        return result.Result;
    }
    async RemoveDataset(datasetName) {
        this.Log(`Removing dataset "${datasetName}"...`);
        const result = await this._bus.SendMessage(new (0, $c69a319b14a3f741$export$fbcbdb743352704d)(this.DatabaseDir, datasetName));
        if (!result.IsSuccess) throw new Error(`Failed to remove dataset: ${result.ErrorMessage}`);
        this.Log(`Dataset "${datasetName}" removed.`);
    }
    async Move(fileId, sourceDataset, targetDataset) {
        this.Log(`Moving "${fileId}" from "${sourceDataset.Name}" to "${targetDataset.Name}"...`);
        const result = await this._bus.SendMessage(new (0, $85b2ca0db3fcf386$export$c68a8fe67ac55f0a)(this.DatabaseDir, fileId, sourceDataset.Name, targetDataset.Name));
        if (!result.IsSuccess) throw new Error(`Failed to move "${fileId}" from "${sourceDataset.Name}" to "${targetDataset.Name}": ${result.ErrorMessage}`);
        this.Log(`"${fileId}" moved from "${sourceDataset.Name}" to "${targetDataset.Name}".`);
    }
    async GetLogsList() {
        const result = await this._bus.SendMessage(new (0, $0b12de66db7fc647$export$f4bc86deee9ad8c)(this.DatabaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to get logs list: ${result.ErrorMessage}`);
        return result.Result;
    }
    async GetLog(id) {
        const result = await this._bus.SendMessage(new (0, $017449eabfa9cc97$export$54e721faba08510a)(this.DatabaseDir, id));
        if (!result.IsSuccess) throw new Error(`Failed to get log '${id}': ${result.ErrorMessage}`);
        return result.Result;
    }
    /*
        Search() USAGE:

        datasetId = storage.Search(fileId)
        file = dataset.GetOne(fileId)

        ;/   to jest bardziej problematyczne niż myślałem.....
        bo gdzieś przecież trzeba konwersji typu dokonać a sam search odbywa się na całej bazie
    */ // public async Search<T extends object>(fileId: string): Promise<Dataset<T>>
    // {
    // 	this.Log(`Searching for "${fileId}" in entire database...`);
    // 	const result = await this._bus.SendMessage(new SearchQuery(this.DatabaseDir, fileId));
    // 	if (!result.IsSuccess)
    // 	{
    // 		throw new Error(`Failed to find "${fileId}": ${result.ErrorMessage}`);
    // 	}
    // 	const datasetName = result.Result.Dataset;
    // 	const dataset = this.GetDataset<T>(datasetName, converter); ?????????
    // 	this.Log(`"${fileId}" found in "${dataset} dataset".`);
    // 	return result.Result;
    // }
    async ListDatabases() {
        const result = await this._bus.SendMessage(new (0, $bfea829df9966a60$export$8306c05e5eceab13)());
        if (!result.IsSuccess) throw new Error(`Failed to list databases: ${result.ErrorMessage}`);
        return result.Result;
    }
    async CreateDatabase(databaseDir) {
        const result = await this._bus.SendMessage(new (0, $8cd99d2756d53677$export$75790cd217c136b7)(databaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to create database: ${result.ErrorMessage}`);
    }
    async DeleteDatabase(databaseDir) {
        const result = await this._bus.SendMessage(new (0, $1150d16d79392866$export$ae7689aec281aea8)(databaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to delete database: ${result.ErrorMessage}`);
    }
    CanUser(action) {
        if (!this.User.Privileges) return false;
        if (typeof this.User.Privileges[action] === "boolean" && this.User.Privileges[action]) return !!this.User.Privileges[action];
        return false;
    }
}




class $2fa3c38e0a9d1556$export$29701ae0a05ea4be extends (0, $e4e5ebdfac92419f$export$c8c5e7182924d536) {
    ConvertToRaw(content) {
        return (0, $2s69t.RefSerializer).Flatenize(content);
    }
    ConvertFromRaw(raw) {
        const content = new (0, $1a784100733b5566$export$9dd8876539768efc)();
        content.AboutUsText.value = this.GetString(raw.AboutUsText);
        content.AboutUsFaq.Load(...this.GetArray(raw.AboutUsFaq, (x)=>new (0, $1cc7232b5fe1e570$export$7562e752e5ef1fad)(x)));
        content.ProductCategories.Load(...this.GetArray(raw.ProductCategories, (x)=>new (0, $39a2fd1d77a5883f$export$81fb35662c98d436)(x)));
        content.Products.Load(...this.GetArray(raw.Products, (x)=>new (0, $c99eef43254dc902$export$264ad599d7cef668)(x)));
        content.ContactTabs.Load(...this.GetArray(raw.ContactTabs, (raw)=>new (0, $8ad605e7c4ec2669$export$3e41faf802a29e71)(raw)));
        content.Contact.Load(...this.GetArray(raw.Contact, (raw)=>(0, $4dd618a9878588eb$export$f6d490d3b7c1d484).ToClass(raw)));
        content.RentalPageContentTabs.Load(...this.GetArray(raw.RentalPageContentTabs, (raw)=>new (0, $8ad605e7c4ec2669$export$3e41faf802a29e71)(raw)));
        content.RentalPageContent.Load(...this.GetArray(raw.RentalPageContent, (raw)=>(0, $4dd618a9878588eb$export$f6d490d3b7c1d484).ToClass(raw)));
        content.BasketOptions.GeneralPriceFactor.value = this.GetNumber(raw?.BasketOptions?.GeneralPriceFactor);
        content.BasketOptions.DeliveryCostForPriceAbove300.value = this.GetNumber(raw?.BasketOptions?.DeliveryCostForPriceAbove300);
        content.BasketOptions.DeliveryCostForPriceBelow300.value = this.GetNumber(raw?.BasketOptions?.DeliveryCostForPriceBelow300);
        content.BasketOptions.Discounts.Load(...this.GetArray(raw.BasketOptions?.Discounts, (raw)=>new (0, $3b7fdc6bbc3f7560$export$5f0fddd75cd8dcd7)(raw)));
        content.Logo.value = this.GetString(raw?.Logo);
        return content;
    }
}




var $45fvw = parcelRequire("45fvw");
class $a00782db1156a738$export$51168f2ab199f068 {
    constructor(isSuccess, contentSize, errorMessage, backupDirectory){
        this.IsSuccess = false;
        this.ContentSize = -1;
        this.ErrorMessage = "";
        this.BackupDirectory = void 0;
        this.IsSuccess = isSuccess;
        this.ContentSize = contentSize;
        this.ErrorMessage = errorMessage;
        this.BackupDirectory = backupDirectory;
    }
    static Success(contentSize, backupDirectory) {
        return new $a00782db1156a738$export$51168f2ab199f068(true, contentSize, "", backupDirectory);
    }
    static Error(errorMessage) {
        return new $a00782db1156a738$export$51168f2ab199f068(false, -1, errorMessage);
    }
}


class $7721465ba5d77c54$export$8d1295068e1f830d {
    constructor(_repo){
        this._repo = _repo;
        this.content = void 0;
    }
    get IsAuthorized() {
        // console.log(this._repo.Database.User, this._repo.Database.IsAuthorized);
        return this._repo.Database.IsAuthorized;
    }
    get User() {
        return this._repo.Database.User;
    }
    get Content() {
        if (!this.content) throw new Error("Content not loaded");
        return this.content;
    }
    Log(...args) {
    // console.log('[ContentProvider]', ...args);
    }
    async Load() {
        if (this.content) {
            this.Log("Content loaded from in-memory cache.");
            return;
        } else {
            this.Log("Loading content from storage...");
            this.content = await this._repo.GetOne(this._repo.Name);
            if (this.content) this.Log("Content loaded from storage.");
            else throw new Error(`Could not get content`);
        }
    }
    async Save(as) {
        try {
            const id = as;
            const size = JSON.stringify(this.Content).length / 1024;
            await this._repo.Update(id, this.Content);
            return (0, $a00782db1156a738$export$51168f2ab199f068).Success(size, id);
        } catch (error) {
            return (0, $a00782db1156a738$export$51168f2ab199f068).Error(`Failed to save content: ${error.message}`);
        }
    }
    async Add(id) {
        try {
            const size = JSON.stringify(this.Content).length / 1024;
            await this._repo.Add(id, this.Content);
            return (0, $a00782db1156a738$export$51168f2ab199f068).Success(size, id);
        } catch (error) {
            return (0, $a00782db1156a738$export$51168f2ab199f068).Error(`Failed to save content: ${error.message}`);
        }
    }
    async SaveChanges() {
        return await this.Save(this._repo.Name);
    }
    async Backup() {
        const id = this._repo.Name + "___" + (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("YYYY_MM_DD__HH_mm_ss");
        return await this.Add(id);
    }
}


class $084c1558f6075ac9$export$75386813cdced9dd extends (0, $7721465ba5d77c54$export$8d1295068e1f830d) {
    get Shop() {
        return this.Content;
    }
    constructor(_repo){
        super(_repo);
    }
    CategoryByUrl(url) {
        const category = this.Shop.ProductCategories.Items.find((x)=>x.Url.value == url);
        if (!category) return (0, $39a2fd1d77a5883f$export$81fb35662c98d436).NotFound();
        return category;
    }
    ProductsByCategory(category) {
        return this.Shop.Products.Items.filter((x)=>x.CategoryId.value == category?.Id.value);
    }
    GetLowestPriceForProductFromCategory(category) {
        const allProductsFromCategory = this.ProductsByCategory(category);
        let productWithLowestPrice;
        allProductsFromCategory.forEach((product)=>{
            if (!productWithLowestPrice || product.GetPrice() < productWithLowestPrice.GetPrice()) productWithLowestPrice = product;
        });
        if (!productWithLowestPrice) return "brak produkt\xf3w";
        return productWithLowestPrice.GetPriceAsText();
    }
    ProductByUrl(productUrl) {
        const product = this.Shop.Products.Items.find((x)=>x.Url.value == productUrl);
        if (!product) throw new Error(`Product not found`);
        return product;
    }
    get ProductCategoriesAsTitleIdObject() {
        return this.Shop.ProductCategories.Items.reduce((prev, curr)=>({
                ...prev,
                [curr.Title.value]: curr.Id.value
            }), {});
    }
}



var $2s69t = parcelRequire("2s69t");



class $ffbca1ce464625c0$export$f14c0e3f98d164c0 extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_formLogic){
        super("Logowanie", "admin-page");
        this._formLogic = _formLogic;
        this.body.Style(`margin-top: 64px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;`);
    }
    async OnAppend() {
        if (this._formLogic.IsAuthorized) {
            this.body.Append(new (0, $653a908f0842fe90$export$aff4fc93593c3bcf)("Jeste\u015B ju\u017C zalogowany", `Jako ${this._formLogic.User.Name}`), new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Wyloguj").WidthAuto().OnClick(()=>this._formLogic.Logout()));
            return;
        }
        const loginInput = new (0, $2s69t.TextInput)(this._formLogic.LoginInput).Color("#fff").WidthAuto().BorderRadius(4).Placeholder("Login").OnEnterKeyPressed(async ()=>await this._formLogic.TryLogin());
        const passwordInput = new (0, $2s69t.PasswordInput)(this._formLogic.PasswordInput).Color("#fff").StyleInput(`border-radius: 4px;`).TogglePasswordView().Placeholder("Has\u0142o").OnEnterKeyPressed(async ()=>await this._formLogic.TryLogin());
        const loginButton = new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Zaloguj").WidthAuto().Padding(8, 24).FontNormal().BorderRadius(4).FontSize(16).Disable(this._formLogic.LoginInProgress).OnClick(async ()=>await this._formLogic.TryLogin());
        this.body.Append(loginInput, passwordInput, loginButton, new (0, $653a908f0842fe90$export$aff4fc93593c3bcf)("B\u0142\u0105d", this._formLogic.ErrorMessage).Visible(this._formLogic.ErrorMessageVisible));
    }
}



var $2s69t = parcelRequire("2s69t");
class $3055e7e52e29e391$export$ef5f0cf0168d8c43 {
    constructor(_storage){
        this._storage = _storage;
        this.onLogin = new (0, $2s69t.HandlersCollection)();
        this.onLogout = new (0, $2s69t.HandlersCollection)();
        this.LoginInput = new (0, $2s69t.RefString)().Storable("auth-form:login-input");
        this.PasswordInput = new (0, $2s69t.RefString)().Storable("auth-form:password-input");
        this.ErrorMessageVisible = new (0, $2s69t.RefBool)();
        this.LoginInProgress = new (0, $2s69t.RefBool)();
        this.ErrorMessage = new (0, $2s69t.RefString)();
        this.autologinSnack = void 0;
        this.autologinFailedSnack = void 0;
        this.PasswordInput.OnChange(()=>{
            this.ErrorMessageVisible.False();
        });
        this._storage.OnUserChange((user, isAuthorized)=>{
            if (!isAuthorized) this.onLogout.Call();
        });
    }
    get User() {
        return this._storage.User;
    }
    get IsAuthorized() {
        return this._storage.IsAuthorized;
    }
    ClearForm() {
        this.LoginInput.value = "";
        this.PasswordInput.value = "";
        this.ErrorMessageVisible.False();
        this.LoginInProgress.False();
        this.ErrorMessage.value = "";
    }
    ClearLoginInfo() {
        this.LoginInput.value = "";
        this.PasswordInput.value = "";
    }
    OnLogin(handler) {
        this.onLogin.Add(handler);
        return this;
    }
    OnLogout(handler) {
        this.onLogout.Add(handler);
        return this;
    }
    CleanUp() {
        this.autologinFailedSnack?.Close();
        this.autologinFailedSnack = undefined;
        this.autologinSnack?.Close();
        this.autologinSnack = undefined;
    }
    Logout() {
        this._storage.Logout();
    }
    async TryAutoLogin() {
        try {
            if (this._storage.IsNotLoggedIn) // Autologujemy tylko kogoś kto jest w pamięci przeglądarki
            {
                await this._storage.Login(this.PasswordInput.value, this.LoginInput.value);
                this.onLogin.Call(this._storage.User, true);
            }
        } catch (ex) {
            const msg = ex.message.toLowerCase();
            let message;
            if (msg.includes("unauthorized")) message = "Unauthorized";
            else if (msg.includes("failed to fetch")) message = "Connection problem";
            else message = ex.message;
            this.autologinFailedSnack = new (0, $2s69t.Snack)("\u274C Autologin failed", message, {
                autoCloseTimeout: 0,
                clickAnywhereToClose: true
            });
        } finally{
            this.autologinSnack?.Close();
            this.autologinSnack = undefined;
        }
    }
    async TryLogin() {
        if (this.LoginInProgress.value) return false;
        if (!this.PasswordInput.value) {
            this.ShowErrorMessage("No password provided");
            return false;
        }
        this.ErrorMessageVisible.False();
        this.LoginInProgress.True();
        try {
            await this._storage.Login(this.PasswordInput.value, this.LoginInput.value);
            this.LoginInProgress.False();
            this.CleanUp();
            this.onLogin.Call(this._storage.User, false);
            return true;
        } catch (ex) {
            this.LoginInProgress.False();
            this.ShowErrorMessage("Failed to login");
            return false;
        }
    }
    ShowErrorMessage(message) {
        this.ErrorMessage.value = message;
        this.ErrorMessageVisible.True();
    }
}



var $2s69t = parcelRequire("2s69t");






var $2s69t = parcelRequire("2s69t");



class $8149bba78b996651$export$8523f2549f55e863 extends (0, $2s69t.Div) {
    constructor(discounts){
        super();
        this.Append(new (0, $2s69t.TableBuilder)(discounts).AddColumn("Typ i cel", (x)=>[
                new (0, $2s69t.Select)(x.Type, [
                    (0, $b4c292586897f889$export$c20edc3521983dfc).Percent,
                    (0, $b4c292586897f889$export$c20edc3521983dfc).LimitedPercent,
                    (0, $b4c292586897f889$export$c20edc3521983dfc).FixedPrice
                ]),
                new (0, $2s69t.Select)(x.Target, [
                    (0, $b4c292586897f889$export$cf5ae448a4c90036).WholeBasket,
                    (0, $b4c292586897f889$export$cf5ae448a4c90036).RentalItems,
                    (0, $b4c292586897f889$export$cf5ae448a4c90036).SaleItems,
                    (0, $b4c292586897f889$export$cf5ae448a4c90036).SpecificItem
                ]).MarginTop(4)
            ]).AddColumn("Nazwa i opis", (x)=>[
                new (0, $2s69t.TextInput)(x.Name),
                new (0, $2s69t.TextInput)(x.Description).MarginTop(4)
            ]).AddColumn("Kod i widoczno\u015B\u0107", (x)=>[
                new (0, $2s69t.TextInput)(x.Code),
                new (0, $2s69t.Checkbox)(x.IsVisible, "Poka\u017C na stronie").MarginTop(4)
            ]).AddColumn("% lub warto\u015B\u0107 oraz limit", (x)=>[
                new (0, $2s69t.NumberInput)(x.Value).Step(1).Min(1).Max(100).WidthPercent(80).MarginLeft(4),
                new (0, $2s69t.Text)(x.Type, (v)=>v == (0, $b4c292586897f889$export$c20edc3521983dfc).FixedPrice ? " z\u0142" : " %"),
                new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)("max ", new (0, $2s69t.NumberInput)(x.Limit).Step(1).Min(0).MarginTop(4).WidthPercent(60), " z\u0142").VisibleWhen(x.Type, (v)=>v == (0, $b4c292586897f889$export$c20edc3521983dfc).LimitedPercent)
            ]).AddColumn("", (x)=>new (0, $2s69t.Link)("\u2716\uFE0F").OnClick(()=>discounts.Remove(x))).Build(), new (0, $2s69t.Link)("\u2795 Dodaj").OnClick(()=>discounts.Add(new (0, $3b7fdc6bbc3f7560$export$5f0fddd75cd8dcd7)({
                Name: "nowa zni\u017Cka",
                Code: Math.random().toString(16).substring(2, 6).toUpperCase(),
                Value: 10,
                IsVisible: true,
                Target: (0, $b4c292586897f889$export$cf5ae448a4c90036).WholeBasket,
                Type: (0, $b4c292586897f889$export$c20edc3521983dfc).Percent,
                Limit: 300
            }))));
    }
}







class $67ee60d8e117348b$export$2040235b62c36804 extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_shop){
        super("specTeam.pl - Edycja strony g\u0142\xf3wnej", "admin-page");
        this._shop = _shop;
        this.Content(async (body)=>{
            await this._shop.Load();
            const web = this._shop.Shop;
            body.Append(new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("Ustawienia cennika", [
                new (0, $7727c235b6336caa$export$78d5a44323dda815)([
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Og\xf3lny mno\u017Cnik ceny", new (0, $2s69t.NumberInput)(web.BasketOptions.GeneralPriceFactor).Step(0.01).Min(0)),
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Koszt dostawy przy cenie powy\u017Cej 300z\u0142", new (0, $2s69t.NumberInput)(web.BasketOptions.DeliveryCostForPriceAbove300).Step(1).Min(0)),
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Koszt dostawy przy cenie poni\u017Cej 300z\u0142", new (0, $2s69t.NumberInput)(web.BasketOptions.DeliveryCostForPriceBelow300).Step(1).Min(0)),
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Kody rabatowe", new (0, $8149bba78b996651$export$8523f2549f55e863)(web.BasketOptions.Discounts))
                ])
            ]), new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("Elementy na stronie", [
                new (0, $7727c235b6336caa$export$78d5a44323dda815)([
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Logo", new (0, $56ed97d50ee4c1b6$export$e07ccc7fa9d78a9b)(web.Logo))
                ])
            ]), new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)(`Sekcja "O nas"`, [
                new (0, $7727c235b6336caa$export$78d5a44323dda815)([
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Tekst", new (0, $2s69t.MultilineInput)(web.AboutUsText).Rows(12)),
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Q&A", new (0, $542dabccf2b905a2$export$ce2a3f9829f800ae)(web.AboutUsFaq))
                ])
            ]), new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)(`Podstrona "Wypo\u{17C}yczalnia"`, [
                new (0, $371dc6981361d493$export$aa74ad0b78023f22)(web.RentalPageContent, web.RentalPageContentTabs)
            ]), new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)(`Podstrona "Kontakt"`, [
                new (0, $371dc6981361d493$export$aa74ad0b78023f22)(web.Contact, web.ContactTabs)
            ]), // new FoldableSection("Kontakt", [
            //     new DescriptionEditor(web.Contact),
            // ]),
            // new FoldableSection("Blog", [
            //     new CollectionPrinter(content.Blog, x => new BlogEntry(x, content.Blog)),
            //     new AddFieldBox(
            //         new Link("➕ Artykuł").OnClick(() => content.Blog.Add(new BlogArticle({})))
            //     ),
            // ]),
            new (0, $17dc641d9b3418f6$export$32a0ad71237b9760)(new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Zapisz i wr\xf3\u0107 na stron\u0119 g\u0142\xf3wn\u0105").OnClick(async ()=>{
                await this.SaveChanges();
                history.back();
            }), new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Tylko zapisz").OnClick(async ()=>{
                await this.SaveChanges();
            }), new (0, $1c5579cee988b0d0$export$b7c3a2f69225ecf)("Wykonaj backup").OnClick(async ()=>{
                const result = await this._shop.Backup();
                new (0, $04739df90be3396b$export$14834abbfce3b8cd)(result.IsSuccess ? "\u2705 Backup wykonany!" : "\u274C Problem z wykonaniem backupu", result.ErrorMessage || "Saved at: " + result.BackupDirectory, result.IsSuccess ? 3500 : 0);
            })));
        });
    }
    async SaveChanges() {
        const result = await this._shop.SaveChanges();
        new (0, $04739df90be3396b$export$14834abbfce3b8cd)(result.IsSuccess ? "\u2705 Zmiany zapisane!" : "\u274C Problem z zapisaniem zmian", result.ErrorMessage || result.ContentSize.toFixed(2) + "kb");
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $a37527350ba7e333$export$887967f05dc521ae extends (0, $2s69t.Div) {
    constructor(){
        super("hero-content");
        this.Html(`
            <div class="hero__content">
                <div class="hero__text">
                    <h1 class="hero__title">Wypo\u{17C}yczalnia Sprz\u{119}tu Detektywistycznego</h1>
                    <p class="hero__subtitle">Sprz\u{119}t, kt\xf3ry zdaje egzamin!</p>
                    <div class="hero__buttons">
                        <a href="#kategorie-produktow" class="button primary">Zobacz nasz sprz\u{119}t</a>
                        <a href="#kontakt" class="button secondary">Skontaktuj si\u{119} z nami</a>
                    </div>
                </div>
            </div>
            <div class="hero__features">
                <div class="hero__features-root">
                    <div class="hero__features-background" aria-hidden="true"></div>
                    <div class="hero__features-grid">
                        <a href="#blog/nasze-zasady" class="hero__features-row">
                            <div class="hero__feature group" tabindex="0">
                                <div class="hero__feature-inner">
                                    <div class="hero__feature-icon-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-heart-handshake hero__feature-icon">
                                            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                                            <path d="M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08v0c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66"></path>
                                            <path d="m18 15-2-2"></path>
                                            <path d="m15 18-2-2"></path>
                                        </svg>
                                    </div>
                                    <h3 class="hero__feature-title">BEZ UMOWY<br>BEZ DOKUMENT\xd3W</h3>
                                </div>
                            </div>
                            <div class="hero__feature group" tabindex="0">
                                <div class="hero__feature-inner">
                                    <div class="hero__feature-icon-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield hero__feature-icon">
                                            <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                                        </svg>
                                    </div>
                                    <h3 class="hero__feature-title">UBEZPIECZENIE<br>OD USZKODZE\u{143}</h3>
                                </div>
                            </div>
                            <div class="hero__feature group" tabindex="0">
                                <div class="hero__feature-inner">
                                    <div class="hero__feature-icon-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone hero__feature-icon">
                                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                        </svg>
                                    </div>
                                    <h3 class="hero__feature-title">WSPARCIE SPECJALIST\xd3W</h3>
                                </div>
                            </div>
                            <div class="hero__feature group" tabindex="0">
                                <div class="hero__feature-inner">
                                    <div class="hero__feature-icon-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-truck hero__feature-icon">
                                            <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path>
                                            <path d="M15 18H9"></path>
                                            <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                                            <circle cx="17" cy="18" r="2"></circle>
                                            <circle cx="7" cy="18" r="2"></circle>
                                        </svg>
                                    </div>
                                    <h3 class="hero__feature-title">PRZESY\u{141}KA<br>W 24H</h3>
                                </div>
                            </div>
                            <div class="hero__feature group" tabindex="0">
                                <div class="hero__feature-inner">
                                    <div class="hero__feature-icon-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock hero__feature-icon">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <polyline points="12 6 12 12 16 14"></polyline>
                                        </svg>
                                    </div>
                                    <h3 class="hero__feature-title">MINIMUM 3 DNI<br>W CENIE</h3>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        `);
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $13e60ce2513b1641$export$42a852a2b6b56249 extends (0, $2s69t.ComponentBase) {
    constructor(...inside){
        super("div");
        this.Class("container");
        this.Append(...inside);
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $ef29181fd0b43e31$export$746be9e3a3dfff1f extends (0, $2s69t.ComponentBase) {
    constructor(text, className){
        super("h3");
        this.Class(className);
        this.Text(text);
    }
}



var $2s69t = parcelRequire("2s69t");
class $900dde5917220838$export$358a232cca1ab2ac extends (0, $2s69t.ComponentBase) {
    constructor(text, klass){
        super("p");
        this.Class(klass);
        this.Text(text);
    }
}


class $5304653e0b63587f$export$eb463a824a473e05 extends (0, $2s69t.Div) {
    constructor(question, answer){
        super("card faq__item");
        this.Append(new (0, $ef29181fd0b43e31$export$746be9e3a3dfff1f)(question).Class("faq__question"), new (0, $900dde5917220838$export$358a232cca1ab2ac)(answer).Class("faq__answer"));
    }
}



var $2s69t = parcelRequire("2s69t");
class $03767e10487bd93d$export$cb94397127ac9363 extends (0, $2s69t.ComponentBase) {
    constructor(text, klass){
        super("h2");
        this.Class(klass);
        this.Text(text);
    }
}



var $2s69t = parcelRequire("2s69t");
class $8df2f264a10115af$export$6e2c8f0811a474ce extends (0, $2s69t.ComponentBase) {
    constructor(klass){
        super("section");
        this.Class(klass);
    }
}


class $6955d782a24e5d01$export$c3ca2226861c22d6 extends (0, $13e60ce2513b1641$export$42a852a2b6b56249) {
    constructor(_shop){
        super(new (0, $8df2f264a10115af$export$6e2c8f0811a474ce)("faq").Append(new (0, $03767e10487bd93d$export$cb94397127ac9363)("Cz\u0119sto zadawane pytania").Class("section-title"), new (0, $2s69t.Div)("faq__list").Append(..._shop.Shop.AboutUsFaq.Items.map((x)=>new (0, $5304653e0b63587f$export$eb463a824a473e05)(x.Question.value, x.Answer.value)))));
    }
}



var $2s69t = parcelRequire("2s69t");


class $161ae9db660af13b$export$cb244715883117d2 extends (0, $2s69t.Div) {
    constructor(_shop){
        super("container");
        this._shop = _shop;
        this.Append(new (0, $2s69t.Div)("about").Id("o-nas").Append(new (0, $03767e10487bd93d$export$cb94397127ac9363)("O nas").Class("section-title ml-60 text-slate-100 sr-only"), new (0, $2s69t.Div)("about__content").Append(new (0, $2s69t.Image)(this._shop.Shop.Logo.value).Class("about__logo"), new (0, $900dde5917220838$export$358a232cca1ab2ac)(this._shop.Shop.AboutUsText.value).Class("about__text"))));
    }
}



var $2s69t = parcelRequire("2s69t");




class $69ee8deb2c882b5d$export$39ef66da89e445d7 extends (0, $8df2f264a10115af$export$6e2c8f0811a474ce) {
    constructor(){
        super("contact");
        this.Id("formularz-kontaktowy");
        this.Append(new (0, $13e60ce2513b1641$export$42a852a2b6b56249)().Append(new (0, $03767e10487bd93d$export$cb94397127ac9363)("Kontakt").Class("contact__title"), new (0, $2s69t.Div)("contact__grid").Append(new (0, $2s69t.Div)("contact__info").Append(new (0, $2s69t.Div)("contact__info-item").Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone icon"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>`), new (0, $2s69t.Span)("+48 507 293 714")), new (0, $2s69t.Div)("contact__info-item").Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin icon"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>`), new (0, $2s69t.Span)("Warszawa, Polska")), new (0, $2s69t.Div)("contact__info-item").Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock icon"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>`), new (0, $2s69t.Span)("Pon-Pt: 10:00 - 17:00\nSob: 11:00 - 16:00")), new (0, $2s69t.Div)("contact__info-item").Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plug-icon lucide-plug icon"><path d="M12 22v-5"/><path d="M9 8V2"/><path d="M15 8V2"/><path d="M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z"/></svg>`), new (0, $2s69t.Link)("Inne formy kontaktu...", "#kontakt"))))));
    }
}



var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");



class $fb2fcec0dfd2e1c5$export$54e766b7cb211733 extends (0, $b654a702b809d076$export$81a299892cc9479c) {
    constructor(category, _shop){
        super("product-card group");
        this.OnClick(()=>window.location.hash = "kategoria/" + category.Url.value);
        const pricePerDay = _shop.GetLowestPriceForProductFromCategory(category);
        this.Append(new (0, $2s69t.Link)("", category.Url.value).Class("product-card__link").Append(new (0, $3bb00af81c679004$export$448e687a629d6c89)(category.Image.value), new (0, $2s69t.Div)("product-card__content").Append(new (0, $2s69t.Div)("product-card__title").Id(`product-${category.Title.value.toLowerCase()}`).Text(category.Title.value), new (0, $2s69t.Paragraph)("product-card__description").Text(category.Subtitle.value), new (0, $2s69t.Div)("product-card__footer").Append(pricePerDay && new (0, $2s69t.Paragraph)("product-card__price").Text(pricePerDay), new (0, $2s69t.Div)("product-card__button").Attribute("aria-hidden", "true").Append(new (0, $2s69t.Span)("Zobacz wi\u0119cej"), new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).ArrowRight))) // product-card__footer
        ) // product-card__content
        ));
    }
}



var $2s69t = parcelRequire("2s69t");


class $f02674697c9a874a$export$82eafebb825fc23f extends (0, $4cabb9c17fd0d780$export$e17b9c1182212c96) {
    constructor(){
        super((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Search);
    }
}



var $2s69t = parcelRequire("2s69t");
class $69bbbc84725754cb$export$56e008c8bd1ccf7c extends (0, $2s69t.Div) {
    constructor(product){
        super("");
        this.Append(new (0, $2s69t.Image)(product.Images.First()?.MiniUrl?.value ?? "").Height(32).Width(48).ObjectFit("cover").DisplayInlineBlock().MarginRight(8).BorderRadius(4), product.Title.value);
    }
}


class $459e4a23d07c7029$export$5a58787633b0b5d8 extends (0, $2s69t.Div) {
    constructor(products){
        super("search");
        const data = products.map((product)=>new (0, $2s69t.SearchableItem)(product.Title.value + " " + product.Tags.value, ()=>new (0, $69bbbc84725754cb$export$56e008c8bd1ccf7c)(product), ()=>window.location.hash = `produkt/${product.Url.value}`));
        const search = new (0, $2s69t.RefString)();
        const searchInput = new (0, $2s69t.TextCombo)(search, data).Placeholder("Szukaj produktu...").FullWidth().NoResultsText("Nie znaleziono produkt\xf3w");
        searchInput.SearchInput.TextInput.Class("search__input");
        this.Append(new (0, $f02674697c9a874a$export$82eafebb825fc23f)(), searchInput);
    }
}


class $adc40cb1b33b0a2d$export$92e1465e7e0741d extends (0, $2s69t.Div) {
    constructor(_shop){
        super("container");
        this.Id("kategorie-produktow");
        let categories = _shop.Shop.ProductCategories.Items;
        if (!_shop.IsAuthorized) categories = categories.filter((x)=>x.Visible.value);
        const availableProducts = _shop.Shop.AvailableProducts;
        this.Append(new (0, $459e4a23d07c7029$export$5a58787633b0b5d8)(availableProducts), new (0, $2s69t.Div)("products").Id("products").Append(...categories.map((x)=>new (0, $fb2fcec0dfd2e1c5$export$54e766b7cb211733)(x, _shop).Style(x.Visible.IsTrue() ? "" : "opacity: 0.5;"))));
    }
}




class $ae46d60fa2abd195$export$ceaf35c25d4b1fe2 extends (0, $2s69t.Div) {
    constructor(_shop){
        super();
        this._shop = _shop;
    }
    async OnAppend() {
        await this._shop.Load();
        this.Append(new (0, $a37527350ba7e333$export$887967f05dc521ae)(), this._shop.IsAuthorized && new (0, $fff8cccdab1195b8$export$fd88fd0f00d26ab7)({
            "Edytuj stron\u0119": "page/edit",
            "Edytuj kategorie": "categories/edit"
        }), new (0, $adc40cb1b33b0a2d$export$92e1465e7e0741d)(this._shop), new (0, $161ae9db660af13b$export$cb244715883117d2)(this._shop), new (0, $6955d782a24e5d01$export$c3ca2226861c22d6)(this._shop), new (0, $69ee8deb2c882b5d$export$39ef66da89e445d7)(), new (0, $73730ebfabef2c36$export$1b198b648cc5b0ce)(this._shop));
    }
}



var $2s69t = parcelRequire("2s69t");
class $513038a04253d1df$export$861edd1ccea2f746 extends (0, $2s69t.ComponentBase) {
    constructor(className){
        super("main");
        this.Class(className);
    }
}



var $2s69t = parcelRequire("2s69t");



var $2s69t = parcelRequire("2s69t");

class $d86dfec8d7ed6456$export$55517cf8c7658dfc extends (0, $2s69t.Button) {
    constructor(showMiniBasket){
        super("");
        this.Class("cart-summary__close").Attribute("aria-label", "Zamknij koszyk").Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x cart-summary__close-icon">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
        </svg>`)).OnClick(()=>showMiniBasket.False());
    }
}




var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $80c83edeb0d3a683$export$ef107534c54a938 extends (0, $2s69t.Div) {
    constructor(quantity){
        super("cart-summary__item-row-qty-controls");
        this.Append(new (0, $2s69t.Button)().Class("cart-summary__quantity-btn").Attribute("aria-label", "Zmniejsz ilo\u015B\u0107").Text("-").OnClick(()=>quantity.value > 1 ? quantity.value-- : 1), new (0, $2s69t.Text)(quantity).Class("cart-summary__quantity-value"), new (0, $2s69t.Button)().Class("cart-summary__quantity-btn").Attribute("aria-label", "Zwi\u0119ksz ilo\u015B\u0107").Text("+").OnClick(()=>quantity.value++), new (0, $2s69t.Span)("cart-summary__item-unit").Text("szt."));
    }
}



var $2s69t = parcelRequire("2s69t");

class $532e2c62c1f3d09e$export$3b3a689a381aaa8e extends (0, $2s69t.Button) {
    constructor(){
        super("");
        this.Class("cart-summary__item-remove cart-summary__item-remove--absolute").Attribute("title", "Usu\u0144 z koszyka").Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash2"><path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line x1="10" x2="10" y1="11" y2="17"></line><line x1="14" x2="14" y1="11" y2="17"></line></svg>`));
    }
}


class $6fcce1d42eff89e4$export$70f2c65ae0f01b26 extends (0, $2s69t.ListItem) {
    constructor(item, basket){
        super("");
        const productUrl = "#produkt/" + (item.Product?.Url?.value ?? "") + "/" + item.ProductOptionId.value;
        this.Class("cart-summary__item").Append(new (0, $2s69t.Div)("cart-summary__item-row cart-summary__item-row--name").Append(new (0, $2s69t.Div)("cart-summary__item-name-columns").Append(new (0, $2s69t.Image)(item.Product?.Images.Items[0]?.MiniUrl).Class("cart-summary__item-thumbnail").OnClick(()=>window.location.href = productUrl).CursorPointer(), new (0, $2s69t.Div)("cart-summary__item-title-details").Append(new (0, $2s69t.Span)(item.Product?.BasketName.value || "Produkt ju\u017C niedost\u0119pny").Class("text-label-lg").OnClick(()=>window.location.href = productUrl).CursorPointer(), new (0, $2s69t.Div)("cart-summary__item-meta text-meta").Text(item.Label.value))), new (0, $532e2c62c1f3d09e$export$3b3a689a381aaa8e)().OnClick(()=>basket.Remove(item))), new (0, $2s69t.Div)("cart-summary__item-row cart-summary__item-row--qty").Append(new (0, $2s69t.Div)("cart-summary__item-row-qty-inner").Append(new (0, $80c83edeb0d3a683$export$ef107534c54a938)(item.Quantity), new (0, $2s69t.Div)("cart-summary__item-row-qty-right").Append(new (0, $2s69t.Text)(item.FinalPriceAfterDiscount, (v)=>v + " z\u0142").Class("cart-summary__item-price")))));
    }
}


class $83efcc6b4949daa5$export$9a47600fadb2ee41 extends (0, $2s69t.Div) {
    constructor(_basket, showMiniBasket){
        super("MiniBasketBox");
        this._basket = _basket;
        this.showMiniBasket = showMiniBasket;
        this.Visible(showMiniBasket);
    }
    async OnAppend() {
        const basket = this._basket.Basket;
        this.Append(new (0, $2s69t.Div)("cart-summary__overlay cart-summary__overlay--fade-in").OnClick(()=>this.showMiniBasket.False()), new (0, $2s69t.Div)("cart-summary cart-summary--drawer").Attribute("role", "dialog").Attribute("aria-modal", "true").Style("opacity: 1; transform: none;").Append(new (0, $d86dfec8d7ed6456$export$55517cf8c7658dfc)(this.showMiniBasket), new (0, $6d7758add37969e7$export$a8a3e93435678ff9)("Tw\xf3j koszyk", 2, "cart-summary__title"), new (0, $2s69t.Div)("cart-summary__content").Append(new (0, $2s69t.Div)("cart-summary__sections").Append(// TODO: tu był podział na kategorie ale jest problem przy usuwaniu i odświeżaniu listy. fajnie by było jakby CollectionView miało jakiś filtr (metoda Take(predicate) lub coś taiego)
        // new MiniBasketSection("Wypożyczenie", _basket.GetItemsByType(BasketItemType.Rent)),
        // new MiniBasketSection("Zakup", _basket.GetItemsByType(BasketItemType.Sale)),
        // TODO: więc póki co będzie tak: bez bajerów, tylko wszystkie produkty w jednej liście
        new (0, $2s69t.CollectionPrinter)(basket.Items, (item)=>new (0, $6fcce1d42eff89e4$export$70f2c65ae0f01b26)(item, basket)).VisibleWhen(basket.Items.CountRef, (v)=>v > 0), new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)("Jest pusty").MarginTop(32).VisibleWhen(basket.Items.CountRef, (v)=>v == 0))), new (0, $611594d53b375bda$export$1e9a924d4716f24c)(basket, basket.TotalPriceBeforeDiscounts), new (0, $2s69t.Div)("cart-summary__actions").Append(new (0, $2s69t.Div)("cart-summary__total").Append(new (0, $2s69t.Span)("Suma:").Class("text-label-lg"), new (0, $2s69t.Text)(basket.TotalPriceAfterDiscounts, (v)=>v + " z\u0142").Class("text-value-xl-bold")), new (0, $2s69t.Button)("Przejd\u017A do kasy").Class("btn-action-primary").EnableWhen(basket.Items.CountRef, (v)=>+v > 0).OnClick(()=>{
            this.showMiniBasket.False();
            window.location.hash = "koszyk";
        }))));
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

class $7e6875d28a433270$export$f8ce5655707bc4f7 extends (0, $2s69t.Button) {
    constructor(_basket){
        super("");
        this.Class("navbar__cart");
        this.Attribute("aria-label", "Poka\u017C koszyk");
        this.Attribute("data-testid", "basket-button");
        // _basket.Items.OnChange(() => {
        //     console.log("Basket items changed", _basket.Items.CountRef.value);
        // },true);
        // console.log("BasketButton constructor", _basket.Items.CountRef.value);
        this.Append(new (0, $2ea0c1e897d25bae$export$3be1b3e65dfde8c8)(), new (0, $2s69t.Text)(_basket.Items.CountRef).Class("navbar__cart-badge").TestAttr("basket-count").VisibleWhen(_basket.Items.CountRef, (v)=>v > 0));
    }
}



var $2s69t = parcelRequire("2s69t");

class $1e3dc62d9ba01a68$export$25f8594d307e7452 extends (0, $2s69t.Button) {
    constructor(){
        super("");
        this.Class("navbar__mobile-close");
        this.Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x navbar__mobile-close-icon">
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>`));
    }
}



var $2s69t = parcelRequire("2s69t");

class $a666bf28b335b8e1$export$921ad596e95157d extends (0, $ae55eced3e9efe6f$export$e71c4d32a2263218) {
    constructor(logo){
        super("navbar__logo", [
            new (0, $2s69t.Image)(logo).FloatLeft().CursorPointer().OnClick(()=>window.location.hash = "/")
        ]);
    }
}





var $2s69t = parcelRequire("2s69t");

class $015fd824577734c8$export$266a769812832828 extends (0, $2s69t.Button) {
    constructor(){
        super("");
        this.Class("navbar__mobile-button");
        this.Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-menu "><line x1="4" x2="20" y1="12" y2="12"></line><line x1="4" x2="20" y1="6" y2="6"></line><line x1="4" x2="20" y1="18" y2="18"></line></svg>`));
    }
}



var $2s69t = parcelRequire("2s69t");

class $71fbc3d5e9ce871b$export$690bcf3a1f1e9f2f extends (0, $2s69t.Button) {
    constructor(){
        super("");
        this.OnClick(()=>window.location.hash = "kategorie-produktow");
        this.Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search navbar__icon navbar__search"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>`));
    }
}



var $2s69t = parcelRequire("2s69t");

class $6394732e25a4101d$export$c43bfb5198aa7b21 extends (0, $2s69t.Button) {
    constructor(){
        super("");
        this.Class("navbar__cart");
        this.Attribute("aria-label", "Zaloguj si\u0119");
        this.Attribute("data-testid", "auth-button");
        this.OnClick(()=>window.location.hash = "login");
        this.Append(new (0, $4cabb9c17fd0d780$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-cart navbar__icon"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="10" r="3"/><path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"/></svg>`));
    }
}


class $752f83cdc8b5dc57$export$c290038290a18370 extends (0, $ae55eced3e9efe6f$export$e71c4d32a2263218) {
    constructor(_basket, showMenu, showMiniBasket){
        super("navbar__right", [
            new (0, $71fbc3d5e9ce871b$export$690bcf3a1f1e9f2f)(),
            new (0, $7e6875d28a433270$export$f8ce5655707bc4f7)(_basket).OnClick(()=>showMiniBasket.True()),
            new (0, $6394732e25a4101d$export$c43bfb5198aa7b21)(),
            new (0, $015fd824577734c8$export$266a769812832828)().OnClick(()=>showMenu.True())
        ]);
    }
}




var $2s69t = parcelRequire("2s69t");

class $b5befd1bcb905536$export$a6396481c702c575 extends (0, $ae55eced3e9efe6f$export$e71c4d32a2263218) {
    constructor(menu){
        super("navbar__menu", [
            new (0, $ae55eced3e9efe6f$export$e71c4d32a2263218)("navbar__links", [
                ...Object.entries(menu).map(([key, value])=>new (0, $2s69t.Link)(key, "#" + value).Class("navbar__link"))
            ])
        ]);
    }
}




var $2s69t = parcelRequire("2s69t");
class $e1db23a98df7b81b$export$39140c7d8b0ba7b3 extends (0, $2s69t.ComponentBase) {
    constructor(className){
        super("nav");
        this.Class(className);
    }
}



class $29ae33a0f81b62a5$export$ef8da11641c635de extends (0, $e1db23a98df7b81b$export$39140c7d8b0ba7b3) {
    constructor(_shop, _basket, _showMiniBasket){
        super("navbar navbar--fixed");
        this._shop = _shop;
        this._basket = _basket;
        this._showMiniBasket = _showMiniBasket;
    }
    async OnAppend() {
        await this._shop.Load();
        // await this._basket.Load();
        const showMenu = new (0, $2s69t.RefBool)(false);
        const menu = {
            "Sprz\u0119t": "kategorie-produktow",
            // idzie do: strona główna > sekcja kategorii (pod hero)
            "Wypo\u017Cyczalnia": "wypozyczalnia",
            // osobna podstrona
            "Kontakt": "kontakt",
            // osobna podstrona
            "Blog": "blog"
        };
        this.Append(new (0, $ae55eced3e9efe6f$export$e71c4d32a2263218)("navbar__container", [
            new (0, $ae55eced3e9efe6f$export$e71c4d32a2263218)("navbar__content", [
                new (0, $a666bf28b335b8e1$export$921ad596e95157d)(this._shop.Shop.Logo),
                new (0, $b5befd1bcb905536$export$a6396481c702c575)(menu),
                new (0, $752f83cdc8b5dc57$export$c290038290a18370)(this._basket.Basket, showMenu, this._showMiniBasket)
            ]) // navbar__content
        ]), // navbar__container
        new (0, $ae55eced3e9efe6f$export$e71c4d32a2263218)("navbar__mobile-overlay", [
            new (0, $1e3dc62d9ba01a68$export$25f8594d307e7452)().OnClick(()=>showMenu.False()),
            new (0, $ae55eced3e9efe6f$export$e71c4d32a2263218)("navbar__mobile-content", [
                new (0, $ae55eced3e9efe6f$export$e71c4d32a2263218)("navbar__mobile-links", [
                    ...Object.entries(menu).map(([key, value])=>new (0, $2s69t.Link)(key, "#" + value).OnClick(()=>{
                            showMenu.False();
                            window.location.hash = value;
                        }).Class("navbar__mobile-link"))
                ]),
                new (0, $ae55eced3e9efe6f$export$e71c4d32a2263218)("navbar__mobile-actions", [
                    new (0, $71fbc3d5e9ce871b$export$690bcf3a1f1e9f2f)(),
                    new (0, $7e6875d28a433270$export$f8ce5655707bc4f7)(this._basket.Basket).OnClick(()=>this._showMiniBasket.True()),
                    new (0, $6394732e25a4101d$export$c43bfb5198aa7b21)()
                ]) //.Style("opacity: 0; transform: translateY(10px);"),
            ]) //.Style("opacity: 0; transform: translateY(20px);"), // navbar__mobile-content
        ]) //.Style(`opacity: 0; display: none;`), // navbar__mobile-overlay
        .Visible(showMenu, "flex"));
    }
}



var $1lG8E = parcelRequire("1lG8E");
var $8308f40ff17673d2$export$6c0517834721cef7;
(function(Env) {
    Env["Local"] = "local";
    Env["Stage"] = "stage";
    Env["Prod"] = "prod";
})($8308f40ff17673d2$export$6c0517834721cef7 || ($8308f40ff17673d2$export$6c0517834721cef7 = {}));


class $80a54c3933dac597$export$7bc334c5772eb68c {
    get Env() {
        // return Env.Prod;
        if (window.location.origin.includes("localhost")) return (0, $8308f40ff17673d2$export$6c0517834721cef7).Local;
        else if (window.location.origin.includes("stage")) return (0, $8308f40ff17673d2$export$6c0517834721cef7).Stage;
        else return (0, $8308f40ff17673d2$export$6c0517834721cef7).Prod;
    }
    constructor(){
        console.log(`Assuming environment is ${this.Env}`);
    }
}



var $2s69t = parcelRequire("2s69t");
var $bc17843b7314027e$export$a8f34b9af2eae872;
(function(DeliveryForm) {
    DeliveryForm["Unset"] = "Unset";
    DeliveryForm["Package"] = "Package";
    DeliveryForm["Personal"] = "Personal";
    DeliveryForm["Inpost"] = "Inpost";
})($bc17843b7314027e$export$a8f34b9af2eae872 || ($bc17843b7314027e$export$a8f34b9af2eae872 = {}));
const $bc17843b7314027e$export$685987655bf8bf6d = {
    ["Unset"]: "(forma dostawy nieokre\u015Blona)",
    ["Package"]: "Paczka (kurier Pocztex)",
    ["Personal"]: "Odbi\xf3r osobisty",
    ["Inpost"]: "Paczkomat Inpost"
};


// SYNC TO specTeam.Shop!
var $72784bc9224b1849$export$ff0fe1ce2347cbc0;
(function(PaymentPresets) {
    PaymentPresets["Unset"] = "Unset";
    PaymentPresets["AllWithCash"] = "AllWithCash";
    // 💰+💰
    PaymentPresets["CashAtDelivery"] = "CashAtDelivery";
    // Only for sale, not for rent
    PaymentPresets["AllWithBankTransfer"] = "AllWithBankTransfer";
    // 💳+💳
    PaymentPresets["AllWithCrypto"] = "AllWithCrypto";
    // 🪙+🪙
    PaymentPresets["DepositWithBankTransfer_ServiceWithCash"] = "DepositPrepaidServicePostpaid";
    // 💳+💰
    PaymentPresets["DepositWithBlik_ServiceWithCash"] = "DepositPrepaidWithBlikServicePostpaid"; // ☎️+💰
})($72784bc9224b1849$export$ff0fe1ce2347cbc0 || ($72784bc9224b1849$export$ff0fe1ce2347cbc0 = {}));
const $72784bc9224b1849$export$936d443709843e47 = {
    ["AllWithCash"]: "Got\xf3wka (ca\u0142a op\u0142ata przy odbiorze)",
    ["DepositPrepaidServicePostpaid"]: "Przedp\u0142ata kaucji przelewem, reszta got\xf3wk\u0105 przy odbiorze",
    ["DepositPrepaidWithBlikServicePostpaid"]: "Przedp\u0142ata kaucji Blikiem, reszta got\xf3wk\u0105 przy odbiorze",
    ["AllWithBankTransfer"]: "Przelew (ca\u0142o\u015B\u0107 z g\xf3ry)",
    ["AllWithCrypto"]: "Bitcoin (ca\u0142o\u015B\u0107 z g\xf3ry, % zni\u017Cki)",
    ["CashAtDelivery"]: "Pobranie"
};
const $72784bc9224b1849$export$7ec426f30d9142a8 = {
    ["AllWithCash"]: "Got\xf3wka",
    ["DepositPrepaidServicePostpaid"]: "Got\xf3wka przy odbiorze",
    ["DepositPrepaidWithBlikServicePostpaid"]: "Got\xf3wka przy odbiorze",
    ["AllWithBankTransfer"]: "Przelew",
    ["AllWithCrypto"]: "Bitcoin",
    ["CashAtDelivery"]: "Pobranie (p\u0142atne u kuriera)"
};


var $4a790d24d0ec0c46$export$dbf30556f6a9efbf;
(function(ReturnForm) {
    ReturnForm["Unset"] = "Unset";
    ReturnForm["Package"] = "Package";
    ReturnForm["Inpost"] = "Inpost";
    ReturnForm["Personal"] = "Personal";
})($4a790d24d0ec0c46$export$dbf30556f6a9efbf || ($4a790d24d0ec0c46$export$dbf30556f6a9efbf = {}));
const $4a790d24d0ec0c46$export$191fda72f1834eff = {
    ["Unset"]: "(nie wybrano formy zwrotu)",
    ["Package"]: "Paczka",
    ["Personal"]: "Zwrot osobisty",
    ["Inpost"]: "Paczkomat Inpost"
};



var $2s69t = parcelRequire("2s69t");
class $01aad7721541750a$export$83a1b8e4fcf0dd8e extends (0, $2s69t.RefComponentBase) {
    constructor(ref, value, uniqueId){
        super("input", ref);
        this.value = value;
        this.Attribute("type", "radio");
        this.Attribute("name", uniqueId);
        this.Attribute("value", value.toString());
        this.On("input", ()=>{
            this.ref.value = value;
            this.Refresh();
        });
        this.Refresh();
    }
    Refresh() {
        const checked = this.ref.value == this.value;
        this.element.checked = checked;
    }
}
class $01aad7721541750a$export$7ffb0f7a358b8916 extends (0, $2s69t.Label) {
    constructor(group, ref, activator, title, description, price, testId){
        super();
        this.group = group;
        this.ref = ref;
        this.activator = activator;
        this.input = new $01aad7721541750a$export$83a1b8e4fcf0dd8e(this.ref, this.activator, this.group);
        if (testId) this.Attribute("data-testid", testId);
        this.Append(this.input, new (0, $2s69t.Span)().Class("radio-option__indicator"), new (0, $2s69t.Div)("radio-option__content").Append(new (0, $2s69t.Span)(title).Class("radio-option__title"), new (0, $2s69t.Span)(description).Class("radio-option__description"), price && (price instanceof (0, $2s69t.Ref) ? new (0, $2s69t.Text)(price, (v)=>v + " z\u0142").Class("radio-option__price") : new (0, $2s69t.Span)(price).Class("radio-option__price"))));
        this.Class("radio-option");
    }
    Disabled() {
        this.input.Disabled();
        this.Opacity(0.20);
        return this;
    }
    Enable(v) {
        v.OnChange((x)=>{
            this.Opacity(x ? 1 : 0.20);
            this.input.Enable(x);
        }, true);
        return this;
    }
}



var $2s69t = parcelRequire("2s69t");

class $009c3035d1c2d8a3$export$b5ff61ac8b0a660f extends (0, $2s69t.Div) {
    constructor(title, content){
        super("order__section");
        this.Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)(title, 2, "order__section-title"), new (0, $2s69t.Div)("radio-group").Append(...content));
    }
}



var $2s69t = parcelRequire("2s69t");
class $39fd4620bc947191$export$4487e951660df42f extends (0, $2s69t.Div) {
    constructor(label, input){
        super("form__group");
        this.Append(new (0, $2s69t.Label)(label).Class("form__label"), new (0, $2s69t.TextInput)(input).Class("form__input") //.Attribute("data-testid", label)
        .ApplyClass(input, (v)=>v == "", "form__input--invalid", false));
    }
}
class $39fd4620bc947191$export$37ef812cf930f51f extends (0, $2s69t.Div) {
    constructor(label, input, placeholder){
        super("form__group form__group--full");
        this.Append(new (0, $2s69t.Label)(label).Class("form__label"), new (0, $2s69t.TextInput)(input).Class("form__input") //.Attribute("data-testid", label)
        .Placeholder(placeholder).ApplyClass(input, (v)=>v == "", "form__input--invalid", false));
    }
}
class $39fd4620bc947191$export$88cf4062ed495305 extends (0, $2s69t.Div) {
    constructor(label, input, placeholder){
        super("form__group form__group--full");
        this.Append(new (0, $2s69t.Label)(label).Class("form__label"), new (0, $2s69t.MultilineInput)(input).Rows(4).Class("form__input") //.Attribute("data-testid", label)
        .Placeholder(placeholder).ApplyClass(input, (v)=>v == "", "form__input--invalid", false));
    }
}
class $39fd4620bc947191$export$214f080bd721df50 extends (0, $2s69t.Div) {
    constructor(label, input, options){
        super("form__group");
        const firstOptionKey = Object.keys(options)[0];
        if (!input.value) input.value = options[firstOptionKey];
        this.Append(new (0, $2s69t.Label)(label).Class("form__label"), new (0, $2s69t.Select)(input, options).Class("form__input form__input-select") //.Attribute("data-testid", label)
        );
    }
}
class $39fd4620bc947191$export$2c14bad7c2f2bc42 extends (0, $2s69t.Div) {
    constructor(label, input, options){
        super("form__group form__group--full");
        const firstOptionValue = Object.keys(options)[0];
        if (!input.value) input.value = options[firstOptionValue];
        this.Append(new (0, $2s69t.Label)(label).Class("form__label"), new (0, $2s69t.Select)(input, options).Class("form__input form__input-select"));
    }
}










var $2s69t = parcelRequire("2s69t");
class $1e2125584e24c526$export$ac16a6a04d9b7c84 extends (0, $2s69t.Button) {
    constructor(text, action){
        super(text, action);
        this.Class("btn-action-primary");
        this.WidthAuto();
    }
}



class $8d953d5fd82be81a$export$f427e181024ba0a4 extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_basket, _shop){
        super("Koszyk");
        this.Class("summary-box");
        this.Content(async (body)=>{
            const basket = _basket.Basket;
            const basketBrain = _basket.BasketBrain;
            const cryptoDiscountValue = new (0, $a0a4f85bb6e72409$export$cece99472bd696fe)().Value.value;
            body.Append(new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $653a908f0842fe90$export$aff4fc93593c3bcf)("Koszyk jest pusty", "Nie ma \u017Cadnych produkt\xf3w w koszyku.\nDodaj produkty, aby kontynuowa\u0107."), new (0, $1e2125584e24c526$export$ac16a6a04d9b7c84)("Dodaj produkty", ()=>window.location.hash = "/"))).Visible(basket.WhenEmpty, "block"), new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(new (0, $009c3035d1c2d8a3$export$b5ff61ac8b0a660f)("Tw\xf3j koszyk", [
                new (0, $2s69t.CollectionPrinter)(basket.Items, (item)=>new (0, $6fcce1d42eff89e4$export$70f2c65ae0f01b26)(item, basket).Background("#1e293b"))
            ]), new (0, $009c3035d1c2d8a3$export$b5ff61ac8b0a660f)("Spos\xf3b odbioru", [
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("DeliveryForm", basketBrain.DeliveryForm, (0, $bc17843b7314027e$export$a8f34b9af2eae872).Personal, "Odbi\xf3r osobisty", "Odbi\xf3r w Warszawie na Woli lub S\u0142u\u017Cewiu", "Bezp\u0142atnie"),
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("DeliveryForm", basketBrain.DeliveryForm, (0, $bc17843b7314027e$export$a8f34b9af2eae872).Package, "Kurier", "Dostawa pod wskazany adres (1-2 dni robocze)", basket.DeliveryCost),
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("DeliveryForm", basketBrain.DeliveryForm, (0, $bc17843b7314027e$export$a8f34b9af2eae872).Inpost, "Paczkomat [CHWILOWO NIEDOST\u0118PNE]", "Dostawa na wskazany paczkomat", "1z\u0142").Disabled()
            ]), new (0, $009c3035d1c2d8a3$export$b5ff61ac8b0a660f)("Zwrot", [
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("ReturnForm", basketBrain.ReturnForm, (0, $4a790d24d0ec0c46$export$dbf30556f6a9efbf).Personal, "Zwrot osobisty", "Zwrot w Warszawie", "Bezp\u0142atnie"),
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("ReturnForm", basketBrain.ReturnForm, (0, $4a790d24d0ec0c46$export$dbf30556f6a9efbf).Package, "Paczkomat Inpost", "Zwrot do wybranego paczkomatu", "Na koszt nadawcy")
            ]).Visible(basket.IsAnythingToRent, "grid"), new (0, $009c3035d1c2d8a3$export$b5ff61ac8b0a660f)("P\u0142atno\u015B\u0107", [
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("PaymentGroup1", basketBrain.PaymentForm, (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCash, "Got\xf3wka", "Ca\u0142o\u015B\u0107 p\u0142atna got\xf3wk\u0105 przy odbiorze", undefined, "payment-option-cash").Enable(basketBrain.AllowCashPayment),
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("PaymentGroup1", basketBrain.PaymentForm, (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).DepositWithBankTransfer_ServiceWithCash, "Przelew + got\xf3wka", "Kaucja p\u0142atna przelewem, reszta p\u0142atna przy odbiorze", undefined, "payment-option-transfer-and-cash").Enable(basketBrain.AllowMixedPayment).Visible(basket.IsAnythingToRent, "flex"),
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("PaymentGroup1", basketBrain.PaymentForm, (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).DepositWithBlik_ServiceWithCash, "Blik + got\xf3wka", "Kaucja p\u0142atna Blikiem, reszta p\u0142atna przy odbiorze", undefined, "payment-option-transfer-and-cash").Enable(basketBrain.AllowMixedPayment).Visible(basket.IsAnythingToRent, "flex"),
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("PaymentGroup1", basketBrain.PaymentForm, (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCrypto, "Bitcoin", "Ca\u0142o\u015B\u0107 p\u0142atna z g\xf3ry", cryptoDiscountValue + "% zni\u017Cki", "payment-option-crypto").Enable(basketBrain.AllowCryptoPayment),
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("PaymentGroup1", basketBrain.PaymentForm, (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithBankTransfer, "Przelew [OPCJA TYMCZASOWO NIEDOST\u0118PNA]", "P\u0142atno\u015B\u0107 ca\u0142o\u015Bci przelewem", undefined, "payment-option-bank-transfer").Enable(new (0, $2s69t.RefBool)(false))
            ]).Visible(basket.IsAnythingToRent, "grid"), new (0, $009c3035d1c2d8a3$export$b5ff61ac8b0a660f)("P\u0142atno\u015B\u0107", [
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("PaymentGroup2", basketBrain.PaymentForm, (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCash, "Got\xf3wka", "Ca\u0142o\u015B\u0107 p\u0142atna got\xf3wk\u0105 przy odbiorze", undefined, "payment-option-cash").Enable(basketBrain.AllowCashPayment),
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("PaymentGroup2", basketBrain.PaymentForm, (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).CashAtDelivery, "Pobranie", "Ca\u0142o\u015B\u0107 p\u0142atna przy odbiorze", undefined, "cash-at-delivery").Enable(basketBrain.AllowCashAtDelivery),
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("PaymentGroup2", basketBrain.PaymentForm, (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCrypto, "Bitcoin", "Ca\u0142o\u015B\u0107 p\u0142atna z g\xf3ry", cryptoDiscountValue + "% zni\u017Cki", "payment-option-crypto").Enable(basketBrain.AllowCryptoPayment),
                new (0, $01aad7721541750a$export$7ffb0f7a358b8916)("PaymentGroup2", basketBrain.PaymentForm, (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithBankTransfer, "Przelew [OPCJA TYMCZASOWO NIEDOST\u0118PNA]", "P\u0142atno\u015B\u0107 ca\u0142o\u015Bci przelewem", undefined, "payment-option-bank-transfer").Enable(new (0, $2s69t.RefBool)(false))
            ]).Invisible(basket.IsAnythingToRent, "grid"), new (0, $009c3035d1c2d8a3$export$b5ff61ac8b0a660f)("Dane do wysy\u0142ki", [
                new (0, $2s69t.Div)("form").Append(new (0, $39fd4620bc947191$export$37ef812cf930f51f)("Imi\u0119 i nazwisko", basketBrain.Customer.Name), new (0, $39fd4620bc947191$export$37ef812cf930f51f)("Adres", basketBrain.Customer.Address.Street), new (0, $39fd4620bc947191$export$4487e951660df42f)("Miasto", basketBrain.Customer.Address.City), new (0, $39fd4620bc947191$export$4487e951660df42f)("Kod pocztowy", basketBrain.Customer.Address.PostalCode), new (0, $39fd4620bc947191$export$4487e951660df42f)("Telefon", basketBrain.Customer.Phone), new (0, $39fd4620bc947191$export$4487e951660df42f)("E-mail", basketBrain.Customer.Email), new (0, $39fd4620bc947191$export$37ef812cf930f51f)("Numer konta do zwrotu kaucji", basketBrain.Customer.DepositAccount, "Bez niego nie b\u0119dziemy w stanie jej zwr\xf3ci\u0107!").Visible(basketBrain.ShowCustomerDepositAccountInput, "flex"), new (0, $39fd4620bc947191$export$214f080bd721df50)("Do\u015Bwiadczenie", basketBrain.Customer.Experience, {
                    "\uD83E\uDD54 Jestem osob\u0105 totalnie atechniczn\u0105": 1,
                    "\uD83E\uDD49 Radz\u0119 sobie z technologi\u0105": 2,
                    "\uD83E\uDD48 Znam podobny sprz\u0119t": 3,
                    "\uD83E\uDD47 Znam Wasz sprz\u0119t": 4
                }), new (0, $39fd4620bc947191$export$214f080bd721df50)("Sk\u0105d o nas wiesz?", basketBrain.Customer.Origin, {
                    "Prosz\u0119 co\u015B wybra\u0107...": "brak informacji",
                    "Od znajomych": "Od znajomych",
                    "Facebook": "Facebook",
                    "Instagram": "Instagram",
                    "Google": "Google",
                    "Youtube": "Youtube",
                    "OLX": "OLX",
                    "Allegro": "Allegro",
                    "Ulotki": "Ulotki",
                    "TikTok": "TikTok",
                    "Inne": "Inne"
                }), new (0, $39fd4620bc947191$export$88cf4062ed495305)("Uwagi do zam\xf3wienia", basketBrain.Notes, "Je\u015Bli potrzebujesz dodatkowej pomocy, wpisz szczeg\xf3\u0142y tutaj"))
            ]), new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $1e2125584e24c526$export$ac16a6a04d9b7c84)("Przejd\u017A do podsumowania").Enable(basketBrain.IsValid).OnClick(()=>{
                if (basketBrain.Customer.IsValid) window.location.hash = "koszyk/podsumowanie";
                else new (0, $04739df90be3396b$export$14834abbfce3b8cd)("Wype\u0142nij wszystkie pola", "Aby przej\u015B\u0107 do podsumowania nale\u017Cy wype\u0142ni\u0107 wszystkie pola");
            })).MarginTop(16)).VisibleWhen(basket.WhenEmpty, (v)=>!v, "block"));
        });
        this.Append(new (0, $73730ebfabef2c36$export$1b198b648cc5b0ce)(_shop));
    }
}


class $f5b7e39314fbd69b$export$c962982833242e24 {
    constructor(_emailSender, _appConfig){
        this._emailSender = _emailSender;
        this._appConfig = _appConfig;
    }
    async OrderCreated(ticket) {
        if (!ticket) return;
        const customerEmail = ticket.Customer.Email;
        if (customerEmail) {
            const orderUrl = this._appConfig.GetOrderUrl(ticket.Id);
            const shortOrderId = ticket.Id.slice(-5);
            await this.Notify(customerEmail, `specTeam.pl - zam\xf3wienie #${shortOrderId}`, `Dzi\u{119}kujemy za za\u{142}o\u{17C}enie zam\xf3wienia #${shortOrderId} w naszej <b>wypo\u{17C}yczalni sprz\u{119}tu detektywistycznego <a href="https://specTeam.pl" target="_blank">specTeam.pl</a></b> <br><br>Jego aktualny stan mo\u{17C}esz sprawdzi\u{107} tutaj: <br><a href="${orderUrl}" target="_blank">${orderUrl}</a>`);
        }
    }
    async Notify(email, title, message) {
        await this._emailSender.SendEmail(email, title, message);
    }
}


class $cf738602a5ebbb7f$export$1d94dfe0d9d1f1e7 {
    constructor(){
        this.status = void 0;
        this.data = void 0;
    }
}


class $ddd3270a0c5ca78c$export$9b9bb80223f42bd1 {
    constructor(){
        this.serverUrl = "https://email.specteam.pl";
    }
    async SendEmail(targetEmail, subject, message) {
        try {
            if (!targetEmail?.trim()) throw new Error(`No email address provided`);
            const postPackage = {
                Target: targetEmail.trim(),
                Subject: subject,
                Message: message
            };
            const result = await this.PostJSON(postPackage);
            return result.data == "SENT";
        } catch (ex) {
            return false;
        }
    }
    async PostJSON(data) {
        const httpResponse = new (0, $cf738602a5ebbb7f$export$1d94dfe0d9d1f1e7)();
        const dataAsString = JSON.stringify(data);
        const response = await fetch(this.serverUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: dataAsString
        });
        httpResponse.status = response.status;
        const json = await response.text();
        httpResponse.data = json;
        return httpResponse;
    }
}



var $45fvw = parcelRequire("45fvw");

var $2s69t = parcelRequire("2s69t");




var $2s69t = parcelRequire("2s69t");

var $1lG8E = parcelRequire("1lG8E");
class $f0204792912b48a9$export$b402f8259a8a1e87 extends (0, $1lG8E.Table) {
    constructor(info){
        const totalDeposits = info.basket.TotalDeposits.value;
        const discounts = info.basket.TotalPriceBeforeDiscounts.value - info.basket.TotalPriceAfterDiscounts.value;
        super([], [
            // ["Suma usług przed rabatami", info.basket.TotalPriceBeforeDiscounts.value + " zł brutto"],
            [
                "Suma zakup\xf3w",
                new (0, $2s69t.Span)(info.basket.TotalPriceAfterDiscounts.value + " z\u0142 wraz z uwzgl\u0119dnionymi rabatami")
            ],
            [
                "Suma rabat\xf3w",
                discounts + " z\u0142"
            ],
            [
                "Suma kaucji",
                totalDeposits + " z\u0142"
            ]
        ]); //.Class("uk-table").WidthPercent(100).WidthAuto().MarginAuto().TextAlignLeft(),
    // ,new Div().TextAlignLeft().PaddingLeft(16).Append(
    //     // new Markdown(`Łącznie do wpłaty: **${info.costs.GetNonReturnableCostsSum().toFixed(2)} zł**`).DisplayInlineBlock(),
    //     // info.basket.IsAnythingToRent.value && new Markdown(`(w tym **${info.costs.GetReturnableCostsSum().toFixed(2)} zł** kaucji zwrotnej)`)
    //     //     .MarginLeft(8).MarginTop(24).DisplayInlineBlock(),
    //     // info.basket.IsAnythingToRent.value && new Markdown(`Do zwrotu po oddaniu sprzętu: **${info.costs.GetReturnableCostsSum().toFixed(2)} zł**`)
    //     //     .DisplayBlock().Margin(0),
    //     info.paymentForm.Is(FormPaymentForm.AllWithCrypto) && new Span(`Wybrano płatność w Bitcoin. Złotówki zostaną przeliczone na kryptowalutę w kolejnym kroku`).MarginLeft(32).Italic()
    // ),
    // )
    }
}



var $45fvw = parcelRequire("45fvw");
class $c4f3860668cb2871$export$6116c50c11a0d9a0 {
    static Calc(deliverAt, threshold = 4) {
        if (!deliverAt) return new Date(0);
        let whenSend = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(deliverAt);
        while(threshold > 0){
            const dayOfWeek = whenSend.day();
            // Is weekend
            if ([
                6,
                0
            ].includes(dayOfWeek)) whenSend.subtract(1, "day");
            whenSend.subtract(1, "day");
            threshold -= 1;
        }
        if (whenSend.isBefore((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))())) whenSend = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))();
        return whenSend.toDate();
    }
}



var $1lG8E = parcelRequire("1lG8E");










class $5b38cf7bc2078bfa$export$ed698f445107ad5d extends (0, $d5372390156ec6d7$export$1f54913ccc4368b1) {
    constructor(_basket){
        super();
        this._basket = _basket;
    }
    async OnAppend() {
        await this.TrySend();
    }
    async TrySend() {
        this.Clear();
        this.Append(new (0, $6fc67b0c57e6c65f$export$3b0d6d7590275603)("Wysy\u0142anie zam\xf3wienia... Prosz\u0119 czeka\u0107"));
        try {
            const orderUrl = await this._basket.Send();
            this.Clear().Append(new (0, $653a908f0842fe90$export$7715d6c0b6e4e443)("Zg\u0142oszenie zosta\u0142o wys\u0142ane", "Potwierdzimy je najszybciej jak to mo\u017Cliwe"), new (0, $1e2125584e24c526$export$ac16a6a04d9b7c84)("\u015Aled\u017A swoje zam\xf3wienie", ()=>window.open(orderUrl, "_blank")?.focus()));
        } catch (error) {
            console.error(error);
            this.Clear().Append(new (0, $653a908f0842fe90$export$f04a3ea04edc0e04)("Nie uda\u0142o si\u0119 wys\u0142a\u0107 zg\u0142oszenia", "Spr\xf3buj ponownie za chwil\u0119"), new (0, $1e2125584e24c526$export$ac16a6a04d9b7c84)("Spr\xf3buj ponownie", ()=>this.TrySend()));
        }
    }
}


class $4e1e861cbbf4a6c4$export$9bad5322d066b32c extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_basket, _shop){
        super("Podsumowanie zam\xf3wienia");
        this.Class("summary-box");
        this.Content(async (body)=>{
            const basket = _basket.Basket;
            const brain = _basket.BasketBrain;
            const returnToEditBtn = new (0, $2s69t.Button)("Wr\xf3\u0107 do edycji").OnClick(()=>window.location.hash = "koszyk");
            body.Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)("Podsumowanie zam\xf3wienia", 1).MarginTopBottom(16).Bold().FontSize(22));
            if (basket.IsEmpty) {
                body.Append(new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $653a908f0842fe90$export$aff4fc93593c3bcf)("Koszyk jest pusty", "Nie ma \u017Cadnych produkt\xf3w w koszyku.\nDodaj produkty, aby kontynuowa\u0107."), new (0, $1e2125584e24c526$export$ac16a6a04d9b7c84)("Wr\xf3\u0107 do strony g\u0142\xf3wnej", ()=>window.location.hash = "/")));
                return;
            }
            body.Append(new (0, $1lG8E.Table)([], [
                [
                    "Zam\xf3wienie",
                    new (0, $2s69t.UnorderedList)(basket.Items.Items.map((item, index)=>item.Product?.BasketName.value + " (" + item.Quantity.value + " szt.)")).Style("list-style: disc; padding-left: 16px;")
                ]
            ]), new (0, $f0204792912b48a9$export$b402f8259a8a1e87)(brain));
            if (basket.IsAnythingToRent.value) {
                const deliveryTime = brain.IsPackageDelivery ? (0, $c4f3860668cb2871$export$6116c50c11a0d9a0).Calc(basket.RentTime?.Start?.value) : basket.RentTime?.Start.value;
                const deliveryTimeAsString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(deliveryTime).format("dddd DD.MM.YYYY");
                body.Append(new (0, $1lG8E.Table)([], [
                    [
                        "Odbi\xf3r",
                        `${(0, $bc17843b7314027e$export$685987655bf8bf6d)[brain.DeliveryForm.value]}, wst\u{119}pnie ${deliveryTimeAsString}. Data zosta\u{142}a obliczona automatycznie i mo\u{17C}e ulec zmianie po akceptacji zam\xf3wienia`
                    ],
                    [
                        "Zwrot",
                        `${(0, $4a790d24d0ec0c46$export$191fda72f1834eff)[brain.ReturnForm.value]}, wst\u{119}pnie ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(basket.RentTime?.End?.value).format("dddd DD.MM.YYYY")}. Data zosta\u{142}a obliczona automatycznie i mo\u{17C}e ulec zmianie po akceptacji zam\xf3wienia`
                    ]
                ]), new (0, $1lG8E.Table)([], [
                    [
                        "Wp\u0142ata kaucji",
                        brain.DepositPaymentInfo.value
                    ],
                    [
                        "Zwrot kaucji",
                        brain.DepositReturnInfo.value
                    ]
                ]));
            } else body.Append(new (0, $1lG8E.Table)([], [
                [
                    "Dostawa",
                    (0, $bc17843b7314027e$export$685987655bf8bf6d)[brain.DeliveryForm.value]
                ]
            ]));
            body.Append(new (0, $1lG8E.Table)([], [
                [
                    "P\u0142atno\u015B\u0107",
                    (0, $72784bc9224b1849$export$7ec426f30d9142a8)[brain.PaymentForm.value]
                ]
            ]), new (0, $1lG8E.Table)([], [
                [
                    "Szkolenie",
                    brain.TrainingInfo.value
                ]
            ]), new (0, $1lG8E.Table)([], [
                [
                    "Odbiorca",
                    brain.Customer.Name.value
                ],
                [
                    "Adres",
                    brain.Customer.Address.AsString
                ],
                [
                    "Kontakt",
                    `${brain.Customer.Phone.value}, ${brain.Customer.Email.value}`
                ],
                [
                    "Notatka",
                    brain.Notes.value || "(brak)"
                ]
            ]), new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $1e2125584e24c526$export$ac16a6a04d9b7c84)("Z\u0142\xf3\u017C bezp\u0142atn\u0105 rezerwacj\u0119").OnClick(()=>{
                body.Clear().Append(new (0, $5b38cf7bc2078bfa$export$ed698f445107ad5d)(_basket));
            }), new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(returnToEditBtn).MarginTop(16)).MarginTopBottom(16));
        });
        this.Append(new (0, $73730ebfabef2c36$export$1b198b648cc5b0ce)(_shop));
    }
}



class $2e533a115e0465ba$export$d67e1898834e3885 {
    constructor(_env){
        this._env = _env;
        this.CONFIG = {
            [(0, $8308f40ff17673d2$export$6c0517834721cef7).Local]: {
                storageUrl: "http://localhost/storageV5/src/",
                databaseName: "Specteam",
                ordersSystemUrl: "http://localhost:4999/#order/{id}"
            },
            [(0, $8308f40ff17673d2$export$6c0517834721cef7).Stage]: {
                storageUrl: "https://stage.storage.specteam.pl/v5/",
                databaseName: "Specteam",
                ordersSystemUrl: "https://stage.shop.specteam.pl/#order/{id}"
            },
            [(0, $8308f40ff17673d2$export$6c0517834721cef7).Prod]: {
                storageUrl: "https://storage.specteam.pl/v5/",
                databaseName: "Specteam",
                ordersSystemUrl: "https://shop.specteam.pl/#order/{id}"
            }
        };
    }
    get OrdersSystemUrl() {
        return this.CONFIG[this._env.Env].ordersSystemUrl;
    }
    GetOrderUrl(orderId) {
        return this.OrdersSystemUrl.replace("{id}", orderId);
    }
    get StorageUrl() {
        return this.CONFIG[this._env.Env].storageUrl;
    }
    get DatabaseName() {
        return this.CONFIG[this._env.Env].databaseName;
    }
}





var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");


class $099f46eb3f7fa1db$export$83aec88f37150bd6 {
    constructor(raw){
        this.Id = "";
        this.Visible = new (0, $2s69t.RefBool)(true);
        this.Category = new (0, $2s69t.RefString)();
        this.Title = new (0, $2s69t.RefString)();
        this.Subtitle = new (0, $2s69t.RefString)();
        this.Url = new (0, $2s69t.RefString)();
        this.PublishDate = new (0, $2s69t.RefDate)();
        this.Content = new (0, $2s69t.Collection)();
        this.Images = new (0, $2s69t.Collection)();
        this.Id = raw.Id || "";
        this.Visible.value = raw.Visible ?? true;
        this.Category.value = raw.Category || "";
        this.Title.value = raw.Title || "";
        this.Subtitle.value = raw.Subtitle || "";
        this.Url.value = raw.Url || "";
        this.PublishDate.value = new Date(raw.PublishDate || 0);
        this.Content.Load(...raw?.Content?.map((x)=>(0, $4dd618a9878588eb$export$f6d490d3b7c1d484).ToClass(x)) || []);
        this.Images.Load(...raw?.Images?.map((x)=>new (0, $b74f7a0e2f20ee26$export$48e30329ded2268e)(x)) || []);
    }
    get IsNew() {
        return !!!+this.PublishDate.value;
    }
}



var $2s69t = parcelRequire("2s69t");
class $2e747261823b948f$export$1fb01df0aac0194c {
    constructor(){
        this.Id = "";
        this.Articles = new (0, $2s69t.Collection)();
    }
    ArticleByUrl(url) {
        const article = this.Articles.Items.find((x)=>x.Url.value == url);
        if (!article) throw new Error(`Nie znaleziono artyku\u{142}u pod wskazanym adresem. To oznacza jak\u{105}\u{15B} awarie albo b\u{142}\u{119}dny link...`);
        return article;
    }
}



class $8587a9a4e3bd770f$export$bae257537df98821 extends (0, $e4e5ebdfac92419f$export$c8c5e7182924d536) {
    ConvertToRaw(content) {
        return (0, $2s69t.RefSerializer).Flatenize(content);
    }
    ConvertFromRaw(raw) {
        const content = new (0, $2e747261823b948f$export$1fb01df0aac0194c)();
        content.Articles.Load(...this.GetArray(raw.Articles, (raw)=>new (0, $099f46eb3f7fa1db$export$83aec88f37150bd6)(raw)));
        return content;
    }
}



class $2ae4beae5f762f8a$export$1faabc01b6552100 extends (0, $7721465ba5d77c54$export$8d1295068e1f830d) {
    get Blog() {
        return this.Content;
    }
    constructor(_repo){
        super(_repo);
    }
    async GetPublicCategories() {
        const categories = await this.GetByCategory();
        return [
            ...categories.map((x)=>({
                    ...x,
                    Articles: x.Articles.filter((y)=>y.Visible.value)
                }))
        ];
    }
    async GetByCategory() {
        const articlesByCategory = [];
        for (const article of this.Blog.Articles.Items){
            const categoryName = article.Category.value || "Inne";
            const category = articlesByCategory.find((x)=>x.Name === categoryName);
            if (!category) {
                const newCategory = {
                    Name: categoryName,
                    Articles: [
                        article
                    ]
                };
                articlesByCategory.push(newCategory);
            }
            category?.Articles?.push(article);
        }
        return articlesByCategory;
    }
    ArticlesRelatedToCategory(category) {
        const articles = this.Blog.Articles?.Items.filter((x)=>category?.RelatedArticles.Items.includes(x.Id));
        return articles || [];
    }
}




var $2s69t = parcelRequire("2s69t");













class $a6b2122df2317a99$export$84d636268484d04a extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_blog, articleUrl){
        super("Edycja artyku\u0142u", "admin-page");
        this._blog = _blog;
        this.articleUrl = articleUrl;
        this.Content(async (body)=>{
            await this._blog.Load();
            const blog = this._blog.Blog;
            const newArticleId = this.articleUrl || (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
            const article = blog.Articles.Items.find((x)=>x.Url.value == this.articleUrl) || new (0, $099f46eb3f7fa1db$export$83aec88f37150bd6)({
                Id: newArticleId,
                Url: newArticleId,
                Title: "Artyku\u0142-" + newArticleId.slice(-8).toUpperCase()
            });
            this.SetTitle(article.Title.value + " - edycja");
            if (article.IsNew) body.Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)("Tworzenie nowego artyku\u0142u", 1));
            else body.Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)("Edycja artyku\u0142u #" + article.Url.value.toUpperCase(), 1));
            const uploader = new (0, $e7c25e1e4636c45c$export$5262858c2300edc1)((images)=>article.Images.Add(...images.map((x)=>new (0, $b74f7a0e2f20ee26$export$48e30329ded2268e)({
                        NormalizedUrl: x.Normalized,
                        ThumbnailUrl: x.Thumbnail,
                        MiniUrl: x.Mini
                    })))).Hide();
            body.Append(new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("Meta", [
                new (0, $7727c235b6336caa$export$78d5a44323dda815)([
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Id", new (0, $2s69t.Span)(article.Id || "(puste pole id)")),
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Kategoria", new (0, $2s69t.TextInput)(article.Category).Placeholder("Kategoria artyku\u0142u")),
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Widoczny na stronie", new (0, $2s69t.Checkbox)(article.Visible)),
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Tytu\u0142", new (0, $2s69t.TextInput)(article.Title).Placeholder("Nazwa widoczna")),
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Podpis", new (0, $2s69t.TextInput)(article.Subtitle).Placeholder("Podpis pod nazw\u0105")),
                    new (0, $7727c235b6336caa$export$b534bc812df080fd)("Url", new (0, $2s69t.TextInput)(article.Url).Placeholder("Tekst w url (bez spacji i polskich znak\xf3w!)"))
                ])
            ]), new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("Zdj\u0119cia", [
                "Pierwsze zdj\u0119cie to miniatura artyku\u0142u",
                new (0, $2s69t.CollectionPrinter)(article.Images, (x)=>new (0, $5e98481b0ad5cf66$export$6992e9b152509c51)(x, article.Images)),
                new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("\u2795 Dodaj zdj\u0119cia").OnClick(()=>uploader.Show()),
                uploader
            ]), new (0, $5ec1d4ffb607575d$export$2ddb90ad54e5f587)("Opis", [
                new (0, $371dc6981361d493$export$aa74ad0b78023f22)(article.Content)
            ]), new (0, $17dc641d9b3418f6$export$32a0ad71237b9760)(new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Zapisz i otw\xf3rz podgl\u0105d").OnClick(async ()=>{
                if (article.IsNew) {
                    article.PublishDate.value = new Date();
                    blog.Articles.Add(article);
                }
                await this.Save();
                window.location.hash = `blog/${article.Url.value}`;
            }), !article.IsNew && new (0, $1c5579cee988b0d0$export$3b92dabad355f5d4)("Usu\u0144").OnClick(async ()=>{
                if (confirm("Czy na pewno chcesz usun\u0105\u0107 ten artyku\u0142? Mo\u017Cesz go te\u017C tylko ukry\u0107.")) {
                    blog.Articles.Remove(article);
                    await this.Save();
                    window.location.hash = `blog`;
                } else new (0, $04739df90be3396b$export$14834abbfce3b8cd)("Anulowano usuwanie artyku\u0142u");
            })));
        });
    }
    async Save() {
        const result = await this._blog.SaveChanges();
        new (0, $04739df90be3396b$export$14834abbfce3b8cd)(result.IsSuccess ? "Zmiany zapisane!" : "\u274C Problem z zapisaniem zmian", result.ErrorMessage || result.ContentSize.toFixed(2) + "kb");
    }
}



var $2s69t = parcelRequire("2s69t");





class $f313a4c08c489cc4$export$8353a350193a5d77 extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_blog, _shop){
        super("specTeam.pl - Nasze artyku\u0142y");
        this.Append(new (0, $73730ebfabef2c36$export$1b198b648cc5b0ce)(_shop));
        this.Content(async (body)=>{
            await _blog.Load();
            await _shop.Load();
            const categories = await _blog.GetPublicCategories();
            body.Append(new (0, $2s69t.Div)("container").Append(_blog.IsAuthorized && new (0, $fff8cccdab1195b8$export$fd88fd0f00d26ab7)({
                "Dodaj artyku\u0142": "blog/add",
                "Zarz\u0105dzaj kolejno\u015Bci\u0105": "blog/edit"
            }), ...categories.flatMap((group)=>[
                    new (0, $6d7758add37969e7$export$a8a3e93435678ff9)(group.Name, 5).Class("section-title").Color("#ccc"),
                    new (0, $2s69t.Div)("products").Append(...group.Articles.map((x)=>new (0, $2f2cbdbc856cdc57$export$51f830f4e6416fad)(x).ApplyStyle(x.Visible, false, "opacity", "0.3", "1")))
                ])));
        });
    }
}






var $2s69t = parcelRequire("2s69t");

var $1lG8E = parcelRequire("1lG8E");


class $76444b9cdf40b2b8$export$294905d487b53686 extends (0, $1lG8E.Table) {
    constructor(article){
        super([], [
            [
                "Opcje",
                new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Poka\u017C").OnClick(()=>window.location.hash = `blog/${article.Url.value}`), new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Edytuj").OnClick(()=>window.location.hash = `blog/${article.Url.value}/edit`))
            ],
            // ["Id", article.Id],
            [
                "Url",
                new (0, $2s69t.TextInput)(article.Url).Placeholder("Url (ten w pasku przegl\u0105darki)")
            ],
            [
                "Widoczny na stronie",
                new (0, $2s69t.Checkbox)(article.Visible)
            ],
            [
                "Tytu\u0142",
                new (0, $2s69t.TextInput)(article.Title).Placeholder("")
            ],
            [
                "Kategoria",
                new (0, $2s69t.TextInput)(article.Category).Placeholder("")
            ],
            [
                "Pod tytu\u0142em",
                new (0, $2s69t.TextInput)(article.Subtitle).Placeholder("")
            ]
        ]);
    }
}



var $2s69t = parcelRequire("2s69t");

class $b4183b1b88519875$export$2d55053946d3b1be extends (0, $dca4a10ada8bf906$export$e71c4d32a2263218) {
    constructor(article){
        super(new (0, $2s69t.Image)(article.Images.First()?.ThumbnailUrl).Class("category-edit-box-image"), new (0, $2s69t.Text)(article.Title).Class("category-edit-box-title"), new (0, $2s69t.Text)(article.PublishDate.value.toLocaleDateString()).MarginLeft(24).Color("#888"));
    }
}





class $7826829e596d0bae$export$51e9da478dd153ca extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_blog){
        super("Edycja bloga", "admin-page");
        this._blog = _blog;
        this.Content(async (body)=>{
            await this._blog.Load();
            const blog = this._blog.Blog;
            body.Append(new (0, $6d7758add37969e7$export$a8a3e93435678ff9)("Kolejno\u015B\u0107 artyku\u0142\xf3w", 5).Class("section-title"), new (0, $0794a96d495e20e3$export$6a610848446a2d94)(blog.Articles, (article)=>[
                    new (0, $b4183b1b88519875$export$2d55053946d3b1be)(article)
                ], (article)=>[
                    new (0, $76444b9cdf40b2b8$export$294905d487b53686)(article)
                ]), new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("\u2795 Dodaj artyku\u0142").OnClick(()=>window.location.hash = "blog/add"), new (0, $1c5579cee988b0d0$export$3b92dabad355f5d4)("\uD83D\uDCBE Zapisz zmiany").OnClick(async ()=>{
                const result = await this._blog.SaveChanges();
                new (0, $04739df90be3396b$export$14834abbfce3b8cd)(result.IsSuccess ? "Zmiany zapisane!" : "\u274C Problem z zapisaniem zmian");
                window.location.hash = "/";
            }), new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Wykonaj backup").OnClick(async ()=>{
                const re = await this._blog.Backup();
                new (0, $04739df90be3396b$export$14834abbfce3b8cd)(re.IsSuccess ? "\u2705 Backup wykonany!" : "\u274C Problem z wykonaniem backupu", re.ErrorMessage);
            }));
        });
    }
}



var $2s69t = parcelRequire("2s69t");



class $e56475cd7a3a9f31$export$1b223953d03745a3 extends (0, $341ff3746ff11fcf$export$6955bcca4cd3539f) {
    constructor(_blog, articleUrl){
        super("specTeam.pl - Blog");
        this._blog = _blog;
        this.articleUrl = articleUrl;
        this.PaddingTop(32);
        this.Content(async (body)=>{
            await this._blog.Load();
            const article = this._blog.Blog.ArticleByUrl(this.articleUrl);
            this.SetTitle(article.Title);
            body.Append(this._blog.IsAuthorized && new (0, $29090c12eed7b0cf$export$70620985e9db1652)(`blog/${article.Url.value}/edit`, "Edytuj artyku\u0142"), new (0, $2s69t.Div)("container").Append(new (0, $9d11ccb715f9b5f8$export$db66bbe0229adb7a)(article.Content)));
        });
    }
}





var $2s69t = parcelRequire("2s69t");



class $945bc1ca93d5494d$export$335929d85f6a1686 {
    static Watch(refs, doWhenAnyRefChange) {
        refs.forEach((ref)=>{
            ref.OnChange((v)=>{
                doWhenAnyRefChange();
            });
        });
        doWhenAnyRefChange();
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $0fa6007b8752f092$export$906eafc247f6d612 {
    constructor(){
        this.Street = new (0, $2s69t.Ref)("").Storable("customer-address-street");
        this.PostalCode = new (0, $2s69t.Ref)("").Storable("customer-address-postal-code");
        this.City = new (0, $2s69t.Ref)("").Storable("customer-address-city");
    }
    get AsString() {
        return this.PostalCode.value + " " + this.City.value + ", " + this.Street.value;
    }
}


class $fe157ce44ff4f4b3$export$a392ed80e0c48a7d {
    constructor(){
        this.Name = new (0, $2s69t.Ref)("").Storable("customer-name");
        this.Address = new (0, $0fa6007b8752f092$export$906eafc247f6d612)();
        this.Email = new (0, $2s69t.Ref)("").Storable("customer-email");
        this.Phone = new (0, $2s69t.Ref)("").Storable("customer-phone");
        this.Experience = new (0, $2s69t.Ref)(0).Storable("customer-experience");
        this.DepositAccount = new (0, $2s69t.Ref)("").Storable("customer-deposit-account");
        this.Origin = new (0, $2s69t.Ref)("").Storable("customer-origin");
    }
    get IsValid() {
        return this.Name.value.length > 0 && this.Address.AsString.length > 0 && this.Email.value.length > 0 && this.Phone.value.length > 0;
    }
}




class $37c8938ef27c4e32$export$71aaa21fef7aad64 {
    Clear() {
        this.Customer.Name.value = "";
        this.Customer.Address.Street.value = "";
        this.Customer.Address.PostalCode.value = "";
        this.Customer.Address.City.value = "";
        this.Customer.Email.value = "";
        this.Customer.Phone.value = "";
        this.Customer.Experience.value = 0;
        this.Customer.DepositAccount.value = "";
        window.localStorage.removeItem("customer-name");
        window.localStorage.removeItem("customer-email");
        window.localStorage.removeItem("customer-phone");
        window.localStorage.removeItem("customer-experience");
        window.localStorage.removeItem("customer-address-street");
        window.localStorage.removeItem("customer-address-postal-code");
        window.localStorage.removeItem("customer-address-city");
        window.localStorage.removeItem("customer-deposit-account");
        this.PaymentForm.value = (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).Unset;
        this.DeliveryForm.value = (0, $bc17843b7314027e$export$a8f34b9af2eae872).Unset;
        this.ReturnForm.value = (0, $4a790d24d0ec0c46$export$dbf30556f6a9efbf).Unset;
        this.DepositPaymentInfo.value = "";
        this.DepositReturnInfo.value = "";
        this.TrainingInfo.value = "";
        this.WithTraining.value = false;
        this.AllowCashPayment.value = false;
    }
    constructor(basket){
        this.basket = basket;
        this.Customer = new (0, $fe157ce44ff4f4b3$export$a392ed80e0c48a7d)();
        this.PaymentForm = new (0, $2s69t.Ref)((0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).DepositWithBankTransfer_ServiceWithCash).Storable("payment-form");
        this.DeliveryForm = new (0, $2s69t.Ref)((0, $bc17843b7314027e$export$a8f34b9af2eae872).Package).Storable("delivery-form");
        this.ReturnForm = new (0, $2s69t.Ref)((0, $4a790d24d0ec0c46$export$dbf30556f6a9efbf).Package).Storable("return-form");
        this.DepositPaymentInfo = new (0, $2s69t.RefString)();
        this.DepositReturnInfo = new (0, $2s69t.RefString)();
        this.TrainingInfo = new (0, $2s69t.RefString)();
        this.WithTraining = new (0, $2s69t.RefBool)();
        this.AllowCashPayment = new (0, $2s69t.RefBool)();
        this.AllowCashAtDelivery = new (0, $2s69t.RefBool)();
        this.ShowCustomerDepositAccountInput = new (0, $2s69t.RefBool)();
        this.PickupSpot = new (0, $2s69t.RefString)("Warszawa Wola");
        // NOT USED YET
        this.IsValid = new (0, $2s69t.RefBool)();
        this.AllowCryptoPayment = new (0, $2s69t.RefBool)();
        this.AllowMixedPayment = new (0, $2s69t.RefBool)();
        this.Notes = new (0, $2s69t.RefString)().Storable("customer-notes");
        (0, $945bc1ca93d5494d$export$335929d85f6a1686).Watch([
            this.basket.Discounter.Discounts,
            ...this.basket.Discounter.Discounts.Map((x)=>x.IsOn),
            this.DeliveryForm,
            this.PaymentForm,
            this.ReturnForm,
            basket.Items
        ], ()=>{
            // 🪙 Crypto
            const cryptoDiscountCode = new (0, $a0a4f85bb6e72409$export$cece99472bd696fe)().Code.value;
            this.AllowCryptoPayment.value = this.basket.Discounter.IsOn(cryptoDiscountCode);
            // 🎓 Training
            const selfTrainingDiscountCode = new (0, $c8568303bba72886$export$c2a14f8ac04cd6c)().Code.value;
            this.WithTraining.value = !basket.Discounter.IsOn(selfTrainingDiscountCode);
            this.TrainingInfo.value = this.IsPersonalDelivery ? this.WithTraining.value ? "Szkolenie odb\u0119dzie si\u0119 na miejscu podczas odbioru sprz\u0119tu. Otrzymasz tak\u017Ce materia\u0142y do samodzielnej nauki w formie samouczka online" : "Zamiast szkolenia na miejscu otrzymasz materia\u0142y do samodzielnej nauki w formie samouczka online" : this.WithTraining.value ? "Szkolenie odb\u0119dzie si\u0119 przez telefon. Otrzymasz tak\u017Ce materia\u0142y do samodzielnej nauki w formie samouczka online" : "Zamiast szkolenia przez telefon otrzymasz materia\u0142y do samodzielnej nauki w formie samouczka. Otrzymasz tak\u017Ce dost\u0119p do infolinii technicznej";
            // Package + Cash is not possible, so switch to the next available option
            if (this.IsPackageDelivery && this.PaymentForm.Is((0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCash)) this.PaymentForm.value = (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).DepositWithBankTransfer_ServiceWithCash;
            // Nothing to rent + Personal delivery + Cash at delivery is not possible, so switch to the next available option
            // if (!basket.IsAnythingToRent && !this.deliveryForm.Is(DeliveryForm.Pocztex) && this.paymentForm.Is(FormPaymentForm.CashAtDelivery))
            // this.paymentForm.value = FormPaymentForm.AllWithCash;
            // 💳 Payment
            if (this.basket.AnythingToRent) {
                if (this.AllowCryptoPayment.value) {
                    this.PaymentForm.value = (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCrypto;
                    this.AllowCashPayment.value = false;
                    this.AllowMixedPayment.value = false;
                } else {
                    this.AllowCashPayment.value = this.IsPersonalDelivery;
                    this.AllowMixedPayment.value = true;
                }
            } else // Nothing to rent
            {
                this.AllowCryptoPayment.value = true;
                this.AllowCashPayment.value = this.IsPersonalDelivery;
                this.AllowCashAtDelivery.value = this.IsPackageDelivery;
            }
            // 💰 Deposit
            this.DepositPaymentInfo.value = ({
                [(0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCash]: `Kaucja zostanie pobrana got\xf3wk\u{105} podczas odbioru sprz\u{119}tu`,
                [(0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).DepositWithBankTransfer_ServiceWithCash]: `\u{141}\u{105}czna suma kaucji wynosi ${basket.GetDepositsSum()}z\u{142}. P\u{142}atne z g\xf3ry przelewem. Szczeg\xf3\u{142}y p\u{142}atno\u{15B}ci b\u{119}d\u{105} widoczne w kolejnym kroku`,
                [(0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).DepositWithBlik_ServiceWithCash]: `\u{141}\u{105}czna suma kaucji wynosi ${basket.GetDepositsSum()}z\u{142}. P\u{142}atne z g\xf3ry Blikiem. Szczeg\xf3\u{142}y p\u{142}atno\u{15B}ci b\u{119}d\u{105} widoczne w kolejnym kroku`,
                [(0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithBankTransfer]: `Kwota kaucji zostanie doliczona do kwoty przelewu`,
                [(0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCrypto]: `Kaucja b\u{119}dzie p\u{142}atna Bitcoinem wraz z ca\u{142}o\u{15B}ci\u{105} zam\xf3wienia`
            })[this.PaymentForm.value] || "...";
            // 💰 Deposit return 
            this.DepositReturnInfo.value = ({
                [(0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCash]: this.IsPackageReturn ? `Kaucja zostanie zwr\xf3cona na konto wskazane w formularzu` : `Kaucja zostanie zwr\xf3cona na miejscu w got\xf3wce`,
                [(0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithBankTransfer]: `Kaucja zostanie zwr\xf3cona na konto, z kt\xf3rego przysz\u{142}a`,
                [(0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).DepositWithBankTransfer_ServiceWithCash]: `Kaucja zostanie odes\u{142}ana na konto, z kt\xf3rego przysz\u{142}a`,
                [(0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).DepositWithBlik_ServiceWithCash]: `Kaucja zostanie odes\u{142}ana na numer telefonu, z kt\xf3rego przysz\u{142}a`,
                [(0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCrypto]: `Kaucja zostanie zwr\xf3cona na wskazany portfel (wyliczona z proporcji)`
            })[this.PaymentForm.value] || "...";
            this.ShowCustomerDepositAccountInput.value = this.IsPersonalDelivery && !this.IsPersonalReturn && this.PaymentForm.IsIn([
                (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCash,
                (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCrypto
            ]);
            this.IsValid.value = this.basket.Items.IsNotEmpty && this.DeliveryForm.IsNot((0, $bc17843b7314027e$export$a8f34b9af2eae872).Unset) && this.ReturnForm.IsNot((0, $4a790d24d0ec0c46$export$dbf30556f6a9efbf).Unset) && this.PaymentForm.IsNot((0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).Unset);
        });
    }
    get IsPersonalDelivery() {
        return this.DeliveryForm.Is((0, $bc17843b7314027e$export$a8f34b9af2eae872).Personal);
    }
    get IsPackageDelivery() {
        return this.DeliveryForm.Is((0, $bc17843b7314027e$export$a8f34b9af2eae872).Package);
    }
    get IsPackageReturn() {
        return this.ReturnForm.Is((0, $4a790d24d0ec0c46$export$dbf30556f6a9efbf).Package);
    }
    get IsPersonalReturn() {
        return this.ReturnForm.Is((0, $4a790d24d0ec0c46$export$dbf30556f6a9efbf).Personal);
    }
}



var $2s69t = parcelRequire("2s69t");




class $d726679d717d4ea1$export$9b886c3342be06c4 {
    get AnythingToRent() {
        return this.Items.Items.some((x)=>x.Type == (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent);
    }
    get RentTime() {
        return this.Items.Items.find((x)=>x instanceof (0, $93d220080a99fbe4$export$865a56617b7eaf36))?.Dates;
    }
    get Config() {
        return this._basketConfig;
    }
    get Discounter() {
        return this._discounter;
    }
    constructor(_storage, _products, _basketConfig, _discounter){
        this._storage = _storage;
        this._products = _products;
        this._basketConfig = _basketConfig;
        this._discounter = _discounter;
        this.Items = new (0, $2s69t.Collection)();
        this.TotalPriceBeforeDiscounts = new (0, $2s69t.RefNumber)();
        this.TotalPriceAfterDiscounts = new (0, $2s69t.RefNumber)();
        this.TotalDeposits = new (0, $2s69t.RefNumber)();
        this.IsAnythingToRent = new (0, $2s69t.RefBool)();
        this.DeliveryCost = new (0, $2s69t.RefNumber)();
        this.Items.OnChange((items)=>{
            // console.log("[Basket] items changed", items.length);
            this.Update();
            const raws = items.map((x)=>x.AsRaw()).filter((x)=>x !== undefined);
            _storage.Update(raws);
        });
        const storedItems = _storage.Get();
        try {
            if (storedItems.length > 0) storedItems.forEach((raw)=>{
                const item = this.CreateItem(raw);
                if (item) this.Add(item);
            });
        } catch (e) {
            console.error(e);
            _storage.Clear();
        }
    }
    CreateItem(raw) {
        const product = this._products.find((x)=>x.Id == raw.ProductId);
        const productOptionId = new (0, $2s69t.RefString)(raw.ProductOptionId);
        const quantity = new (0, $2s69t.RefNumber)(raw.Quantity || 1);
        switch(raw.Type){
            case (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent:
                const rawRent = raw;
                const dates = new (0, $8d21273b49376a6d$export$8cb450ce50b94421)(rawRent.RentTime.Start, rawRent.RentTime.End);
                return new (0, $93d220080a99fbe4$export$865a56617b7eaf36)(this, product, productOptionId, quantity, dates);
            case (0, $e97714b723cebee9$export$39b11636c68d48ec).Sale:
                return new (0, $18c93729b54ca65e$export$ff28d6513ec20674)(this, product, productOptionId, quantity);
            default:
                console.error("Invalid basket item type. Clearing basket.");
                this.Clear();
        }
    }
    Add(item) {
        if (this.IsAlreadyIn(item)) return false;
        item.OnChange(()=>this.Update());
        this.Items.Add(item);
        return true;
    }
    UpdateItem(item) {
        this.Remove(item);
        return this.Add(item);
    }
    IsAlreadyIn(item) {
        return this.Items.Items.find((x)=>x.Type == item.Type && x.Product?.Id == item.Product?.Id && x.ProductOptionId.value == item.ProductOptionId.value) !== undefined;
    }
    GetItemBy(type, productId, optionId) {
        if (!optionId) return this.Items.Items.find((x)=>x.Type == type && x.Product?.Id == productId);
        return this.Items.Items.find((x)=>x.Type == type && x.Product?.Id == productId && x.ProductOptionId.value == optionId);
    }
    Remove(item) {
        this.Items.Remove(item);
    }
    GetDepositsSum() {
        return this.TotalDeposits.value;
    }
    Clear() {
        this.Items.Clear();
        this.Update();
    }
    Update() {
        this.IsAnythingToRent.value = this.Items.Items.some((x)=>x.Type == (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent);
        this.TotalPriceBeforeDiscounts.value = this.Items.Items.reduce((prev, cur)=>prev + cur.FinalPriceBeforeDiscount.value, 0);
        this.TotalPriceAfterDiscounts.value = this.Items.Items.reduce((prev, cur)=>prev + cur.FinalPriceAfterDiscount.value, 0);
        this.TotalDeposits.value = this.Items.Items.filter((x)=>x instanceof (0, $93d220080a99fbe4$export$865a56617b7eaf36)).reduce((prev, cur)=>prev + cur.FinalDeposit.value, 0);
        this.DeliveryCost.value = this.TotalPriceAfterDiscounts.value >= 299 ? this.Config.DeliveryCostForPriceAbove300.value : this.Config.DeliveryCostForPriceBelow300.value;
        const rawBasketItems = this.Items.Items.map((x)=>x.AsRaw()).filter((x)=>x !== undefined);
        this._storage.Update(rawBasketItems);
    }
    get IsEmpty() {
        return this.Items.Count == 0;
    }
    get WhenEmpty() {
        const ref = new (0, $2s69t.RefBool)(this.IsEmpty);
        this.Items.OnChange(()=>ref.value = this.IsEmpty);
        return ref;
    }
}



var $2s69t = parcelRequire("2s69t");
class $1a430c1689e9b0f0$export$6bdc82afc096a4dc {
    // public Extras = new Collection<ExtraCost>();
    constructor(_basketConfig){
        this._basketConfig = _basketConfig;
        this.Discounts = new (0, $2s69t.Collection)();
        this.onChange = new (0, $2s69t.HandlersCollection)();
        const predefinedDiscounts = _basketConfig.Discounts.Items;
        // const predefinedExtras = _basketConfig.Extras.Items;
        predefinedDiscounts.filter((x)=>x.IsVisible.value).forEach((discount)=>this.AddDiscount(discount));
        // predefinedExtras.filter(x => x.IsVisible.value).forEach(extra => this.AddExtra(extra));
        this.Discounts.OnChange((list)=>{
            this.onChange.Call();
        });
    // this.Extras.OnChange(list =>
    // {
    //     this.onChange.Call();
    // });
    }
    GetActiveCosts() {
        const discounts = this.Discounts.Items.filter((x)=>x.IsOn.IsTrue());
        // const extras = this.Extras.Items.filter(x => x.IsOn.IsTrue());
        // return [...discounts, ...extras];
        return [
            ...discounts
        ];
    }
    Has(discount) {
        return this.Discounts.Find((x)=>x.Code.value == discount.Code.value) !== undefined;
    }
    IsOn(code) {
        return this.Discounts.Items.some((x)=>x.Code.value == code && x.IsOn.IsTrue());
    }
    Remove(discount) {
        this.Discounts.Remove(discount);
    }
    AddDiscount(discount) {
        if (!this.Has(discount)) {
            discount.IsOn.OnChange((v)=>this.onChange.Call());
            this.Discounts.Add(discount);
        }
    }
    // public AddExtra(extra: ExtraCost): void
    // {
    //     if (!this.Has(extra))
    //     {
    //         extra.IsOn.OnChange(v => this.onChange.Call());
    //         this.Extras.Add(extra);
    //     }
    // }
    FindByCode(code) {
        const sanitizedCode = code.trim().toUpperCase();
        const discount = this._basketConfig.Discounts.Find((x)=>x.Code.value.toUpperCase() == sanitizedCode);
        return discount || null;
    }
    // public GetTotalPercent(): number
    // {
    //     const discountsTotalPercent = this.Discounts.Items
    //         .filter(x => x.IsOn.value)
    //         .reduce((prev, cur) => {
    //             if (cur.Type.value == DiscountType.Percent)
    //             {
    //                 return prev + cur.Value.value;
    //             }
    //             else if (cur.Type.value == DiscountType.LimitedPercent)
    //             {
    //                 const limit
    //                 return prev + cur.Value.value;
    //             }
    //             return prev;
    //             return prev + cur.Value.value;
    //         }, 0);
    //     if (discountsTotalPercent > 100)
    //         return 100;
    //     return discountsTotalPercent;
    // }
    GetTotalValue(price) {
        const totalValue = this.Discounts.Filter((x)=>x.IsOn.IsTrue()).reduce((prev, cur)=>prev + cur.CalcValue(price), 0);
        return totalValue;
    }
    OnChange(handler) {
        this.onChange.Add(handler);
    }
}


class $3c2269db0dc985f4$export$48f5a6f645a872b1 {
    constructor(){
        this.KEY = "basket";
    }
    Update(items) {
        localStorage.setItem(this.KEY, JSON.stringify(items));
    }
    Clear() {
        localStorage.removeItem(this.KEY);
    }
    Get() {
        return JSON.parse(localStorage.getItem(this.KEY) ?? "[]");
    }
}



var $afb2d9a6655f04c7$export$b6ded7c5f3fd9245;
(function(PaymentForm) {
    PaymentForm["Unset"] = "Unset";
    PaymentForm["Cash"] = "Cash";
    PaymentForm["BankTransfer"] = "BankTransfer";
    PaymentForm["CashAtDelivery"] = "CashAtDelivery";
    PaymentForm["TransferAtDelivery"] = "TransferAtDelivery";
    // Przelew wykonany przez kuriera w momencie odbioru paczki
    PaymentForm["PostalTransfer"] = "PostalTransfer";
    // Kasa nadana na poczcie w formie przelewu
    PaymentForm["Crypto"] = "Crypto";
    PaymentForm["Blik"] = "Blik";
})($afb2d9a6655f04c7$export$b6ded7c5f3fd9245 || ($afb2d9a6655f04c7$export$b6ded7c5f3fd9245 = {}));




var $3e48e7a92e2e3c64$export$8304886b7201d6ae;
(function(HumanType) {
    HumanType["Unset"] = "Unset";
    HumanType["Customer"] = "Customer";
    HumanType["Curier"] = "Curier";
    HumanType["Friend"] = "Friend";
    HumanType["Family"] = "Family";
    HumanType["Driver"] = "Driver";
})($3e48e7a92e2e3c64$export$8304886b7201d6ae || ($3e48e7a92e2e3c64$export$8304886b7201d6ae = {}));


class $c00946da5c1a8346$export$6a194cfeca7f0d7a {
    constructor(){
        this.CreatedAt = new Date(0);
        this.CreatedBy = "";
    }
}


class $9a5304d6477abd19$export$ed207b05bbcf0a37 {
    constructor(){
        this.Id = "";
        this.Meta = new (0, $c00946da5c1a8346$export$6a194cfeca7f0d7a)();
        this.BasketList = [];
        this.BasketInfo = {
            PriceBeforeDiscount: 0,
            PriceAfterDiscount: 0,
            Discounts: []
        };
        this.Customer = {
            Type: (0, $3e48e7a92e2e3c64$export$8304886b7201d6ae).Customer,
            Name: "",
            Phone: "",
            Email: "",
            Address: "",
            Experience: -1,
            Description: "",
            BankAccountNumber: "",
            Origin: ""
        };
        this.Delivery = (0, $bc17843b7314027e$export$a8f34b9af2eae872).Unset;
        this.Return = (0, $4a790d24d0ec0c46$export$dbf30556f6a9efbf).Unset;
        this.DepositPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).Unset;
        this.BasketPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).Unset;
        this.WithTraining = false;
        this.PickupPlace = "";
        this.Notes = "";
    }
}





class $1d15b482168394c1$export$6efd809663400745 {
    Convert(info) {
        const ticket = new (0, $9a5304d6477abd19$export$ed207b05bbcf0a37)();
        ticket.Id = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)().toUpperCase();
        ticket.Meta.CreatedAt = new Date();
        ticket.Meta.CreatedBy = window.location.hostname;
        ticket.BasketList = this.MakeBasket(info.basket.Items);
        ticket.BasketInfo.PriceBeforeDiscount = info.basket.TotalPriceBeforeDiscounts.value;
        ticket.BasketInfo.PriceAfterDiscount = info.basket.TotalPriceAfterDiscounts.value;
        ticket.BasketInfo.Discounts = info.basket.Discounter.GetActiveCosts().map((x)=>x.AsRaw);
        ticket.Customer.Name = info.Customer.Name.value;
        ticket.Customer.Phone = info.Customer.Phone.value;
        ticket.Customer.Email = info.Customer.Email.value;
        ticket.Customer.Address = info.Customer.Address.AsString;
        ticket.Customer.Experience = info.Customer.Experience.value;
        ticket.Customer.BankAccountNumber = info.Customer.DepositAccount.value;
        ticket.Customer.Origin = info.Customer.Origin.value;
        ticket.Delivery = info.DeliveryForm.value;
        ticket.Return = info.ReturnForm.value;
        ticket.WithTraining = info.WithTraining.value;
        ticket.PickupPlace = info.PickupSpot.value;
        ticket.Notes = info.Notes.value;
        switch(info.PaymentForm.value){
            case (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCash:
                ticket.DepositPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).Cash;
                ticket.BasketPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).Cash;
                break;
            case (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).DepositWithBankTransfer_ServiceWithCash:
                ticket.DepositPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).BankTransfer;
                ticket.BasketPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).Cash;
                break;
            case (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).DepositWithBlik_ServiceWithCash:
                ticket.DepositPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).Blik;
                ticket.BasketPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).Cash;
                break;
            case (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithBankTransfer:
                ticket.DepositPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).BankTransfer;
                ticket.BasketPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).BankTransfer;
                break;
            case (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).AllWithCrypto:
                ticket.DepositPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).Crypto;
                ticket.BasketPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).Crypto;
                break;
            case (0, $72784bc9224b1849$export$ff0fe1ce2347cbc0).CashAtDelivery:
                ticket.DepositPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).CashAtDelivery; // NOT USED ANYWAY
                ticket.BasketPaymentForm = (0, $afb2d9a6655f04c7$export$b6ded7c5f3fd9245).CashAtDelivery;
                break;
        }
        return ticket;
    }
    MakeBasket(basketItems) {
        return basketItems.Items.map((item)=>{
            switch(item.Type){
                case (0, $e97714b723cebee9$export$39b11636c68d48ec).Sale:
                    const saleItem = item;
                    return {
                        Type: saleItem.Type,
                        ProductInfo: this.MakeProductInfo(saleItem),
                        TotalPrice: saleItem.FinalPriceAfterDiscount.value,
                        Quantity: saleItem.Quantity.value
                    };
                case (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent:
                    const rentItem = item;
                    return {
                        Type: rentItem.Type,
                        Quantity: rentItem.Quantity.value,
                        TotalPrice: rentItem.FinalPriceAfterDiscount.value,
                        ProductInfo: this.MakeProductInfo(rentItem),
                        Option: {
                            Id: rentItem.ProductOptionId.value,
                            Name: rentItem.Product?.Options.GetById(rentItem.ProductOptionId.value).Label.value ?? ""
                        },
                        From: rentItem.Dates.Start.value,
                        To: rentItem.Dates.End.value,
                        Deposit: rentItem.FinalDeposit.value
                    };
                default:
                    throw new Error(`Unhandled basket item type: ${item.Type}`);
            }
        });
    }
    MakeProductInfo(x) {
        return {
            Origin: window.location.origin,
            Id: x.Product?.Id ?? "",
            Name: x.Product?.BasketName.value ?? "",
            Link: `${window.location.origin}#produkt/${x.Product?.Url.value}/${x.ProductOptionId.value}`,
            Category: x.Product?.Category.Id.value ?? "",
            Picture: x.Product?.Images?.Items[0]?.ThumbnailUrl?.value ?? "",
            Tutorial: x.Product?.TutorialLink.value ?? "",
            Prices: x.Product?.RentPrices.Items.map((x)=>`${x.Value.value}z\u{142}/${x.Days.value}dni`).join(" ; ") + " ; " + x.Product?.SalePrice.value + "z\u0142/szt"
        };
    }
}


class $cbac634cc2755121$export$95672d9f6bce06eb {
    constructor(_shop, _tickets, _notifier, _appConfig){
        this._shop = _shop;
        this._tickets = _tickets;
        this._notifier = _notifier;
        this._appConfig = _appConfig;
        this.basket = void 0;
        this.basketBrain = void 0;
    }
    get Basket() {
        if (!this.basket) throw new Error("Basket not loaded");
        return this.basket;
    }
    get BasketBrain() {
        if (!this.basketBrain) throw new Error("Basket brain not loaded");
        return this.basketBrain;
    }
    async Send() {
        const converter = new (0, $1d15b482168394c1$export$6efd809663400745)();
        const ticket = converter.Convert(this.BasketBrain);
        await this._tickets.Add(ticket.Id, ticket);
        await this._notifier.OrderCreated(ticket);
        this.basket?.Clear();
        const orderUrl = this._appConfig.GetOrderUrl(ticket.Id);
        return orderUrl;
    }
    async Load() {
        if (this.basket) return;
        const basketStorage = new (0, $3c2269db0dc985f4$export$48f5a6f645a872b1)();
        const basketConfig = this._shop.Shop.BasketOptions;
        const discounter = new (0, $1a430c1689e9b0f0$export$6bdc82afc096a4dc)(basketConfig);
        const products = this._shop.Shop.Products.Items;
        this.basket = new (0, $d726679d717d4ea1$export$9b886c3342be06c4)(basketStorage, products, basketConfig, discounter);
        this.basketBrain = new (0, $37c8938ef27c4e32$export$71aaa21fef7aad64)(this.basket);
    }
}





(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))?.locale("pl");
(0, $2s69t.NumberInput).DefaultCssClasses = "";
(0, $2s69t.TextInput).DefaultCssClasses = "";
(0, $2s69t.Button).DefaultCssClasses = "";
(0, $2s69t.Select).DefaultCssClasses = "";
(0, $2s69t.ModalWindow).DefaultCssClasses = "";
(0, $2s69t.ModalWindow).Hook = (0, $2s69t.Root).Hook;
(0, $2s69t.MultilineInput).DefaultCssClasses = "";
(0, $1lG8E.Table).DefaultCssClasses = "";
(0, $2s69t.HandlersCollection).MANY_HANDLERS_LIMIT = 10;
(async ()=>{
    const root = new (0, $2s69t.Root)("body").Id("root");
    const loader = new (0, $6fc67b0c57e6c65f$export$3b0d6d7590275603)("\u0141adowanie strony...").Margin(32);
    root.Append(new (0, $2s69t.Div)("app").Append(new (0, $513038a04253d1df$export$861edd1ccea2f746)("app__main").Append(new (0, $2s69t.Div)("app__layout").Append(new (0, $a37527350ba7e333$export$887967f05dc521ae)(), loader))));
    try {
        const _env = new (0, $80a54c3933dac597$export$7bc334c5772eb68c)();
        const _appConfig = new (0, $2e533a115e0465ba$export$d67e1898834e3885)(_env);
        const _emailSender = new (0, $ddd3270a0c5ca78c$export$9b9bb80223f42bd1)();
        const _notifier = new (0, $f5b7e39314fbd69b$export$c962982833242e24)(_emailSender, _appConfig);
        const _storage = new (0, $ae1a5cf54ffb33b6$export$5d991cdc62928edb)(_appConfig.StorageUrl, _appConfig.DatabaseName);
        const _shopConverter = new (0, $2fa3c38e0a9d1556$export$29701ae0a05ea4be)();
        const shopDataset = _storage.GetObjectDataset("Shop", _shopConverter);
        const _shop = new (0, $084c1558f6075ac9$export$75386813cdced9dd)(shopDataset);
        const _blogConverter = new (0, $8587a9a4e3bd770f$export$bae257537df98821)();
        const blogDataset = _storage.GetObjectDataset("Blog", _blogConverter);
        const _blog = new (0, $2ae4beae5f762f8a$export$1faabc01b6552100)(blogDataset);
        const _ticketsDataset = _storage.GetObjectDataset("Tickets");
        await _shop.Load(); // Lepiej to zrobić tutaj bo inaczej każdy komponent który to woła zaciąga sobie asynchronicznie kontent i w efekcie idzie 5 strzałów zamiast jednego
        _shop.Shop.PrepareProducts();
        const _basket = new (0, $cbac634cc2755121$export$95672d9f6bce06eb)(_shop, _ticketsDataset, _notifier, _appConfig);
        await _basket.Load();
        const _loginLogic = new (0, $3055e7e52e29e391$export$ef5f0cf0168d8c43)(_storage).OnLogin((user, autologin)=>{
            window.location.hash = "/";
        }).OnLogout(()=>{
            _loginLogic.ClearLoginInfo();
            window.location.hash = "/";
        });
        if (_env.Env != (0, $8308f40ff17673d2$export$6c0517834721cef7).Prod) await _loginLogic.TryAutoLogin();
        const hash = new (0, $2s69t.HashRef)().OnChange(()=>window.scrollTo(0, 0));
        const content = new (0, $2s69t.DestroyingPatternContentSwitcher)(hash).AddContent("product/edit/:productUrl", ({ productUrl: productUrl })=>new (0, $34aaf9c7d95b2660$export$c1579167726b9a9c)(_shop, productUrl)).AddContent("product/add", ()=>new (0, $34aaf9c7d95b2660$export$c1579167726b9a9c)(_shop)).AddContent("categories/edit", ()=>new (0, $3dfef36daba7a2c5$export$a1bfb6492ac56b0f)(_shop, _blog)).AddContent("category/edit/:categoryUrl", ({ categoryUrl: categoryUrl })=>new (0, $3c1170f05ebea6bd$export$acf7db3140935c5d)(_shop, categoryUrl)).AddContent("page/edit", ()=>new (0, $67ee60d8e117348b$export$2040235b62c36804)(_shop)).AddContent("blog/add", ()=>new (0, $a6b2122df2317a99$export$84d636268484d04a)(_blog, (0, $3fa3ae484854b431$export$2e2bcd8739ae039)())).AddContent("blog/edit", ()=>new (0, $7826829e596d0bae$export$51e9da478dd153ca)(_blog)).AddContent("blog/:articleUrl/edit", ({ articleUrl: articleUrl })=>new (0, $a6b2122df2317a99$export$84d636268484d04a)(_blog, articleUrl)).AddContent("kontakt", ()=>new (0, $d5b706b524502b9c$export$27dfd9e9bbc44937)(_shop)).AddContent("wypozyczalnia", ()=>new (0, $b2471328be470b31$export$50f4e97f6a438a13)(_shop)).AddContent("blog", ()=>new (0, $f313a4c08c489cc4$export$8353a350193a5d77)(_blog, _shop)).AddContent("blog/:url", ({ url: url })=>new (0, $e56475cd7a3a9f31$export$1b223953d03745a3)(_blog, url)).AddContent("kategoria/:categoryName", ({ categoryName: categoryName })=>new (0, $d86f1adc95b0751d$export$5a5b9651d5b3445d)(_shop, _blog, categoryName)).AddContent("produkt/:prod", ({ prod: prod })=>new (0, $29e5eeb0f023c5ef$export$b49abe999dec25ce)(_shop, _basket, prod)).AddContent("produkt/:prod/:option", ({ prod: prod, option: option })=>new (0, $29e5eeb0f023c5ef$export$b49abe999dec25ce)(_shop, _basket, prod, option)).AddContent("koszyk", ()=>new (0, $8d953d5fd82be81a$export$f427e181024ba0a4)(_basket, _shop)).AddContent("koszyk/podsumowanie", ()=>new (0, $4e1e861cbbf4a6c4$export$9bad5322d066b32c)(_basket, _shop)).AddContent("login", ()=>new (0, $ffbca1ce464625c0$export$f14c0e3f98d164c0)(_loginLogic)).AddDefaultContent(()=>new (0, $ae46d60fa2abd195$export$ceaf35c25d4b1fe2)(_shop)).Refresh();
        const showMiniBasket = new (0, $2s69t.RefBool)(false);
        root.Clear().Append(new (0, $2s69t.Div)("app").Append(new (0, $513038a04253d1df$export$861edd1ccea2f746)("app__main").Append(new (0, $2s69t.Div)("app__layout").Append(new (0, $29ae33a0f81b62a5$export$ef8da11641c635de)(_shop, _basket, showMiniBasket), new (0, $83efcc6b4949daa5$export$9a47600fadb2ee41)(_basket, showMiniBasket), content))), _shop.IsAuthorized && new (0, $2s69t.Div)("admin-info").Text("ADMIN MODE @ " + _env.Env));
    } catch (error) {
        console.error(error);
        root.Clear().Append(new (0, $2s69t.Div)("app").Append(new (0, $513038a04253d1df$export$861edd1ccea2f746)("app__main").Append(new (0, $2s69t.Div)("app__layout").Append(new (0, $a37527350ba7e333$export$887967f05dc521ae)().Opacity(0.5).Blur(3), new (0, $653a908f0842fe90$export$f04a3ea04edc0e04)("B\u0142\u0105d \u0142adowania strony", error.message), new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $2s69t.Line)().Margin(32), new (0, $2s69t.Span)("\u260E\uFE0F Skontaktuj si\u0119 z nami telefonicznie: +48 507 293 714").FontSize(18).Color("#f2f2f2")).MarginTopBottom(64)))));
    } finally{
        loader.RemoveSelf();
    }
})();


//# sourceMappingURL=index.766a199b.js.map
